import React from 'react';
import PropTypes from 'prop-types';
import '@mds/web/bundle/elements-core';
import '@mds/web/bundle/elements-common';
import { jsx } from 'react/jsx-runtime';
import '@mds/web/bundle/elements-chart';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var MdsAccordionItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsAccordionItem, _React$Component);

  var _super = _createSuper(MdsAccordionItem);

  function MdsAccordionItem() {
    _classCallCheck(this, MdsAccordionItem);

    return _super.apply(this, arguments);
  }

  _createClass(MdsAccordionItem, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-accordion-item", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        expanded: Array.isArray(this.props.expanded) || this.props.expanded === Object(this.props.expanded) ? JSON.stringify(this.props.expanded) : this.props.expanded,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "secondary-text": Array.isArray(this.props.secondaryText) || this.props.secondaryText === Object(this.props.secondaryText) ? JSON.stringify(this.props.secondaryText) : this.props.secondaryText,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        "icon-color": Array.isArray(this.props.iconColor) || this.props.iconColor === Object(this.props.iconColor) ? JSON.stringify(this.props.iconColor) : this.props.iconColor,
        "leading-image": Array.isArray(this.props.leadingImage) || this.props.leadingImage === Object(this.props.leadingImage) ? JSON.stringify(this.props.leadingImage) : this.props.leadingImage,
        "leading-image-width": Array.isArray(this.props.leadingImageWidth) || this.props.leadingImageWidth === Object(this.props.leadingImageWidth) ? JSON.stringify(this.props.leadingImageWidth) : this.props.leadingImageWidth,
        "leading-icon": Array.isArray(this.props.leadingIcon) || this.props.leadingIcon === Object(this.props.leadingIcon) ? JSON.stringify(this.props.leadingIcon) : this.props.leadingIcon,
        "icon-accessible-description": Array.isArray(this.props.iconAccessibleDescription) || this.props.iconAccessibleDescription === Object(this.props.iconAccessibleDescription) ? JSON.stringify(this.props.iconAccessibleDescription) : this.props.iconAccessibleDescription,
        "accessible-text-leading-icon": Array.isArray(this.props.accessibleTextLeadingIcon) || this.props.accessibleTextLeadingIcon === Object(this.props.accessibleTextLeadingIcon) ? JSON.stringify(this.props.accessibleTextLeadingIcon) : this.props.accessibleTextLeadingIcon,
        "accessible-text-leading-image": Array.isArray(this.props.accessibleTextLeadingImage) || this.props.accessibleTextLeadingImage === Object(this.props.accessibleTextLeadingImage) ? JSON.stringify(this.props.accessibleTextLeadingImage) : this.props.accessibleTextLeadingImage,
        "accessible-text-alert-icon": Array.isArray(this.props.accessibleTextAlertIcon) || this.props.accessibleTextAlertIcon === Object(this.props.accessibleTextAlertIcon) ? JSON.stringify(this.props.accessibleTextAlertIcon) : this.props.accessibleTextAlertIcon,
        "alert-variant": Array.isArray(this.props.alertVariant) || this.props.alertVariant === Object(this.props.alertVariant) ? JSON.stringify(this.props.alertVariant) : this.props.alertVariant,
        "alert-title": Array.isArray(this.props.alertTitle) || this.props.alertTitle === Object(this.props.alertTitle) ? JSON.stringify(this.props.alertTitle) : this.props.alertTitle,
        size: Array.isArray(this.props.size) || this.props.size === Object(this.props.size) ? JSON.stringify(this.props.size) : this.props.size,
        lock: Array.isArray(this.props.lock) || this.props.lock === Object(this.props.lock) ? JSON.stringify(this.props.lock) : this.props.lock,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        "secondary-text-alignment": Array.isArray(this.props.secondaryTextAlignment) || this.props.secondaryTextAlignment === Object(this.props.secondaryTextAlignment) ? JSON.stringify(this.props.secondaryTextAlignment) : this.props.secondaryTextAlignment,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsAccordionItem;
}(React.Component);
MdsAccordionItem.propTypes = {
  // Values
  expanded: PropTypes.bool,
  headingLevel: PropTypes.number,
  label: PropTypes.string,
  secondaryText: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  leadingImage: PropTypes.string,
  leadingImageWidth: PropTypes.string,
  leadingIcon: PropTypes.string,
  iconAccessibleDescription: PropTypes.string,
  accessibleTextLeadingIcon: PropTypes.string,
  accessibleTextLeadingImage: PropTypes.string,
  accessibleTextAlertIcon: PropTypes.string,
  alertVariant: PropTypes.oneOf(["error", "soft", "success", "informational"]),
  alertTitle: PropTypes.string,
  size: PropTypes.string,
  lock: PropTypes.bool,
  name: PropTypes.string,
  secondaryTextAlignment: PropTypes.string,
  inactive: PropTypes.bool,
  variant: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["disabled", "focused"])
};
MdsAccordionItem.defaultProps = {
  expanded: false,
  headingLevel: 2,
  lock: false,
  inactive: false
};

/**
 *  file      : CustomProps.jsx
 *  summary   : Custom PropTypes validation for components.
 *  author    : Charles Best <charles.jl.best@chase.com>
 *  date      : 08/09/2021
 *  copyright : 2021 JP Morgan Chase & Co. All rights reserved.
 *  exports   : CustomPropTypes
 */

/**
 * All custom validations for component PropTypes. These are
 *
 * 1. all methods that should only be called by the PropTypes validation engine or
 * 2. PropTypes.shape structures.
 *
 */
var CustomPropTypes = {
  integer: function integer(props, propName, componentName) {
    /**
     * @function integerProp
     *
     * PropTypes.integer is not defined, so this method validates for integer input.
     */
    if (props[propName] !== undefined && props[propName] !== null && !Number.isInteger(props[propName])) {
      return new Error('Invalid prop:value `' + propName + ':' + props[propName] + '` supplied to' + ' `' + componentName + '`. Must be an integer. Validation failed.');
    }
  },
  slot: function slot(props, propName, componentName) {
    /**
     * @function slot
     *
     * PropTypes.integer is not defined, so this method validates for integer input.
     */

    /* Commented out until further investigation*/
    //  if ( props[propName] !== undefined && (!props[propName].name || !props[propName].label) ) {
    //     return new Error(
    //         'Invalid prop `' + propName + '` supplied to' +
    //         ' `' + componentName + '`. Must be an integer. Validation failed.'
    //     );
    // }
  }
};

var MdsAccordion = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsAccordion, _React$Component);

  var _super = _createSuper(MdsAccordion);

  function MdsAccordion(props) {
    var _this;

    _classCallCheck(this, MdsAccordion);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClickExpand", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClickExpand) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClickExpand(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickCollapse", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClickCollapse) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClickCollapse(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onTouchend) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeyup) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseout) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onKeydown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseover) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseup) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onFocus) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onClick) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClickExpand = _this._onClickExpand.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onClickCollapse = _this._onClickCollapse.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsAccordion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click-expand", this._onClickExpand);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("click-collapse", this._onClickCollapse);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click-expand", this._onClickExpand);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("click-collapse", this._onClickCollapse);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-accordion", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        size: Array.isArray(this.props.size) || this.props.size === Object(this.props.size) ? JSON.stringify(this.props.size) : this.props.size,
        "secondary-text-alignment": Array.isArray(this.props.secondaryTextAlignment) || this.props.secondaryTextAlignment === Object(this.props.secondaryTextAlignment) ? JSON.stringify(this.props.secondaryTextAlignment) : this.props.secondaryTextAlignment,
        lock: Array.isArray(this.props.lock) || this.props.lock === Object(this.props.lock) ? JSON.stringify(this.props.lock) : this.props.lock,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "accordion-items": Array.isArray(this.props.accordionItems) || this.props.accordionItems === Object(this.props.accordionItems) ? JSON.stringify(this.props.accordionItems) : this.props.accordionItems // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsAccordion;
}(React.Component);
MdsAccordion.propTypes = {
  // Values
  variant: PropTypes.oneOf(["borderless", "openBorder", "fullBorder"]),
  size: PropTypes.oneOf(["14px", "18px"]),
  secondaryTextAlignment: PropTypes.oneOf(["left", "right", "below"]),
  lock: PropTypes.bool,
  headingLevel: PropTypes.number,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  accordionItems: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onClickExpand: PropTypes.func,
  onMousedown: PropTypes.func,
  onClickCollapse: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsAccordion.defaultProps = {
  variant: "borderless",
  size: "14px",
  secondaryTextAlignment: "left",
  lock: false,
  headingLevel: 2,
  // Events
  onClickExpand: null,
  onMousedown: null,
  onClickCollapse: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsAlert = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsAlert, _React$Component);

  var _super = _createSuper(MdsAlert);

  function MdsAlert(props) {
    var _this;

    _classCallCheck(this, MdsAlert);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickLink", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClickLink) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClickLink(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClose) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onFocus) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeyup) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeydown) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMousedown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseup) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseover) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseout) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onTouchend) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onClickLink = _this._onClickLink.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsAlert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("click-link", this._onClickLink);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("click-link", this._onClickLink);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-alert", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        size: Array.isArray(this.props.size) || this.props.size === Object(this.props.size) ? JSON.stringify(this.props.size) : this.props.size,
        "full-width": Array.isArray(this.props.fullWidth) || this.props.fullWidth === Object(this.props.fullWidth) ? JSON.stringify(this.props.fullWidth) : this.props.fullWidth,
        background: Array.isArray(this.props.background) || this.props.background === Object(this.props.background) ? JSON.stringify(this.props.background) : this.props.background,
        "leading-padding": Array.isArray(this.props.leadingPadding) || this.props.leadingPadding === Object(this.props.leadingPadding) ? JSON.stringify(this.props.leadingPadding) : this.props.leadingPadding,
        "trailing-padding": Array.isArray(this.props.trailingPadding) || this.props.trailingPadding === Object(this.props.trailingPadding) ? JSON.stringify(this.props.trailingPadding) : this.props.trailingPadding,
        "alert-title": Array.isArray(this.props.alertTitle) || this.props.alertTitle === Object(this.props.alertTitle) ? JSON.stringify(this.props.alertTitle) : this.props.alertTitle,
        message: Array.isArray(this.props.message) || this.props.message === Object(this.props.message) ? JSON.stringify(this.props.message) : this.props.message,
        inverse: Array.isArray(this.props.inverse) || this.props.inverse === Object(this.props.inverse) ? JSON.stringify(this.props.inverse) : this.props.inverse,
        "shows-close-button": Array.isArray(this.props.showsCloseButton) || this.props.showsCloseButton === Object(this.props.showsCloseButton) ? JSON.stringify(this.props.showsCloseButton) : this.props.showsCloseButton,
        "accessible-text-icon": Array.isArray(this.props.accessibleTextIcon) || this.props.accessibleTextIcon === Object(this.props.accessibleTextIcon) ? JSON.stringify(this.props.accessibleTextIcon) : this.props.accessibleTextIcon,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        "close-button-accessible-text": Array.isArray(this.props.closeButtonAccessibleText) || this.props.closeButtonAccessibleText === Object(this.props.closeButtonAccessibleText) ? JSON.stringify(this.props.closeButtonAccessibleText) : this.props.closeButtonAccessibleText,
        focusable: Array.isArray(this.props.focusable) || this.props.focusable === Object(this.props.focusable) ? JSON.stringify(this.props.focusable) : this.props.focusable,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "read-accessible-text-on-focus": Array.isArray(this.props.readAccessibleTextOnFocus) || this.props.readAccessibleTextOnFocus === Object(this.props.readAccessibleTextOnFocus) ? JSON.stringify(this.props.readAccessibleTextOnFocus) : this.props.readAccessibleTextOnFocus,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsAlert;
}(React.Component);
MdsAlert.propTypes = {
  // Values
  variant: PropTypes.oneOf(["error", "soft", "success", "informational"]),
  size: PropTypes.oneOf(["mini", "small", "base"]),
  fullWidth: PropTypes.bool,
  background: PropTypes.bool,
  leadingPadding: CustomPropTypes.integer,
  trailingPadding: CustomPropTypes.integer,
  alertTitle: PropTypes.string,
  message: PropTypes.string,
  inverse: PropTypes.bool,
  showsCloseButton: PropTypes.bool,
  accessibleTextIcon: PropTypes.string,
  headingLevel: PropTypes.number,
  closeButtonAccessibleText: PropTypes.string,
  focusable: PropTypes.bool,
  brand: PropTypes.string,
  readAccessibleTextOnFocus: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onClickLink: PropTypes.func,
  onClose: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsAlert.defaultProps = {
  size: "base",
  fullWidth: false,
  background: false,
  leadingPadding: 0,
  trailingPadding: 0,
  inverse: false,
  showsCloseButton: false,
  headingLevel: 2,
  closeButtonAccessibleText: "Dismiss alert",
  focusable: true,
  // Events
  onClick: null,
  onClickLink: null,
  onClose: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsBadge = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBadge, _React$Component);

  var _super = _createSuper(MdsBadge);

  function MdsBadge(props) {
    var _this;

    _classCallCheck(this, MdsBadge);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onTouchstart) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onTouchend) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBadge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-badge", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "label-value": Array.isArray(this.props.labelValue) || this.props.labelValue === Object(this.props.labelValue) ? JSON.stringify(this.props.labelValue) : this.props.labelValue,
        "is-animated": Array.isArray(this.props.isAnimated) || this.props.isAnimated === Object(this.props.isAnimated) ? JSON.stringify(this.props.isAnimated) : this.props.isAnimated,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBadge;
}(React.Component);
MdsBadge.propTypes = {
  // Values
  labelValue: PropTypes.number,
  isAnimated: PropTypes.bool,
  accessibleName: PropTypes.string,
  icon: PropTypes.oneOf(["ico_star_filled"]),
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsBadge.defaultProps = {
  isAnimated: false,
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBanner, _React$Component);

  var _super = _createSuper(MdsBanner);

  function MdsBanner(props) {
    var _this;

    _classCallCheck(this, MdsBanner);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickLink", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClickLink) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClickLink(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClose) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onFocus) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeyup) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeydown) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMousedown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseup) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseover) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseout) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onTouchend) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onClickLink = _this._onClickLink.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("click-link", this._onClickLink);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("click-link", this._onClickLink);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-banner", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "banner-title": Array.isArray(this.props.bannerTitle) || this.props.bannerTitle === Object(this.props.bannerTitle) ? JSON.stringify(this.props.bannerTitle) : this.props.bannerTitle,
        "banner-message": Array.isArray(this.props.bannerMessage) || this.props.bannerMessage === Object(this.props.bannerMessage) ? JSON.stringify(this.props.bannerMessage) : this.props.bannerMessage,
        background: Array.isArray(this.props.background) || this.props.background === Object(this.props.background) ? JSON.stringify(this.props.background) : this.props.background,
        "show-close-button": Array.isArray(this.props.showCloseButton) || this.props.showCloseButton === Object(this.props.showCloseButton) ? JSON.stringify(this.props.showCloseButton) : this.props.showCloseButton,
        "accessible-text-close-button": Array.isArray(this.props.accessibleTextCloseButton) || this.props.accessibleTextCloseButton === Object(this.props.accessibleTextCloseButton) ? JSON.stringify(this.props.accessibleTextCloseButton) : this.props.accessibleTextCloseButton,
        "accessible-text-icon": Array.isArray(this.props.accessibleTextIcon) || this.props.accessibleTextIcon === Object(this.props.accessibleTextIcon) ? JSON.stringify(this.props.accessibleTextIcon) : this.props.accessibleTextIcon,
        "accessible-text-region-name": Array.isArray(this.props.accessibleTextRegionName) || this.props.accessibleTextRegionName === Object(this.props.accessibleTextRegionName) ? JSON.stringify(this.props.accessibleTextRegionName) : this.props.accessibleTextRegionName,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBanner;
}(React.Component);
MdsBanner.propTypes = {
  // Values
  variant: PropTypes.oneOf(["critical", "warning", "informational", "soft"]),
  bannerTitle: PropTypes.string,
  bannerMessage: PropTypes.string,
  background: PropTypes.oneOf(["themed", "primary"]),
  showCloseButton: PropTypes.bool,
  accessibleTextCloseButton: PropTypes.string,
  accessibleTextIcon: PropTypes.string,
  accessibleTextRegionName: PropTypes.string,
  brand: PropTypes.string,
  headingLevel: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onClickLink: PropTypes.func,
  onClose: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsBanner.defaultProps = {
  background: "themed",
  showCloseButton: true,
  // Events
  onClick: null,
  onClickLink: null,
  onClose: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsBannerForEmployeeMessaging = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBannerForEmployeeMessaging, _React$Component);

  var _super = _createSuper(MdsBannerForEmployeeMessaging);

  function MdsBannerForEmployeeMessaging(props) {
    var _this;

    _classCallCheck(this, MdsBannerForEmployeeMessaging);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickTranslateButton", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClickTranslateButton) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClickTranslateButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickLink", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClickLink) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClickLink(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onFocus) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeyup) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeydown) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMousedown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseup) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseover) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseout) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onTouchend) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onClickTranslateButton = _this._onClickTranslateButton.bind(_assertThisInitialized(_this));
    _this._onClickLink = _this._onClickLink.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBannerForEmployeeMessaging, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("click-translate-button", this._onClickTranslateButton);

      this._ref.current.addEventListener("click-link", this._onClickLink);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("click-translate-button", this._onClickTranslateButton);

      this._ref.current.removeEventListener("click-link", this._onClickLink);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-banner-for-employee-messaging", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "banner-title": Array.isArray(this.props.bannerTitle) || this.props.bannerTitle === Object(this.props.bannerTitle) ? JSON.stringify(this.props.bannerTitle) : this.props.bannerTitle,
        "banner-message": Array.isArray(this.props.bannerMessage) || this.props.bannerMessage === Object(this.props.bannerMessage) ? JSON.stringify(this.props.bannerMessage) : this.props.bannerMessage,
        "translate-button-text": Array.isArray(this.props.translateButtonText) || this.props.translateButtonText === Object(this.props.translateButtonText) ? JSON.stringify(this.props.translateButtonText) : this.props.translateButtonText,
        "accessible-text-icon": Array.isArray(this.props.accessibleTextIcon) || this.props.accessibleTextIcon === Object(this.props.accessibleTextIcon) ? JSON.stringify(this.props.accessibleTextIcon) : this.props.accessibleTextIcon,
        "accessible-text-region-name": Array.isArray(this.props.accessibleTextRegionName) || this.props.accessibleTextRegionName === Object(this.props.accessibleTextRegionName) ? JSON.stringify(this.props.accessibleTextRegionName) : this.props.accessibleTextRegionName,
        "link-text": Array.isArray(this.props.linkText) || this.props.linkText === Object(this.props.linkText) ? JSON.stringify(this.props.linkText) : this.props.linkText,
        outline: Array.isArray(this.props.outline) || this.props.outline === Object(this.props.outline) ? JSON.stringify(this.props.outline) : this.props.outline,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        "link-href": Array.isArray(this.props.linkHref) || this.props.linkHref === Object(this.props.linkHref) ? JSON.stringify(this.props.linkHref) : this.props.linkHref,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBannerForEmployeeMessaging;
}(React.Component);
MdsBannerForEmployeeMessaging.propTypes = {
  // Values
  variant: PropTypes.oneOf(["optional", "required", "requiredVerbatim"]),
  bannerTitle: PropTypes.string,
  bannerMessage: PropTypes.string,
  translateButtonText: PropTypes.string,
  accessibleTextIcon: PropTypes.string,
  accessibleTextRegionName: PropTypes.string,
  linkText: PropTypes.string,
  outline: PropTypes.bool,
  brand: PropTypes.string,
  headingLevel: PropTypes.string,
  linkHref: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onClickTranslateButton: PropTypes.func,
  onClickLink: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsBannerForEmployeeMessaging.defaultProps = {
  variant: "optional",
  outline: false,
  // Events
  onClick: null,
  onClickTranslateButton: null,
  onClickLink: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsBottomSheet = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBottomSheet, _React$Component);

  var _super = _createSuper(MdsBottomSheet);

  function MdsBottomSheet(props) {
    var _this;

    _classCallCheck(this, MdsBottomSheet);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onButtonPress", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onButtonPress) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onOpen) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onDismiss", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onDismiss) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onDismiss(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickPrimaryButton", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onClickPrimaryButton) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onClickPrimaryButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickBackButton", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onClickBackButton) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onClickBackButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onClose) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onClose(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onButtonPress = _this._onButtonPress.bind(_assertThisInitialized(_this));
    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onDismiss = _this._onDismiss.bind(_assertThisInitialized(_this));
    _this._onClickPrimaryButton = _this._onClickPrimaryButton.bind(_assertThisInitialized(_this));
    _this._onClickBackButton = _this._onClickBackButton.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBottomSheet, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("buttonPress", this._onButtonPress);

      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("dismiss", this._onDismiss);

      this._ref.current.addEventListener("click-primary-button", this._onClickPrimaryButton);

      this._ref.current.addEventListener("click-back-button", this._onClickBackButton);

      this._ref.current.addEventListener("close", this._onClose); // Imperative Actions

    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("buttonPress", this._onButtonPress);

      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("dismiss", this._onDismiss);

      this._ref.current.removeEventListener("click-primary-button", this._onClickPrimaryButton);

      this._ref.current.removeEventListener("click-back-button", this._onClickBackButton);

      this._ref.current.removeEventListener("close", this._onClose);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
      // Imperative Actions
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-bottom-sheet", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        heading: Array.isArray(this.props.heading) || this.props.heading === Object(this.props.heading) ? JSON.stringify(this.props.heading) : this.props.heading,
        "back-button-accessible-text": Array.isArray(this.props.backButtonAccessibleText) || this.props.backButtonAccessibleText === Object(this.props.backButtonAccessibleText) ? JSON.stringify(this.props.backButtonAccessibleText) : this.props.backButtonAccessibleText,
        "content-area": Array.isArray(this.props.contentArea) || this.props.contentArea === Object(this.props.contentArea) ? JSON.stringify(this.props.contentArea) : this.props.contentArea,
        "content-area-height": Array.isArray(this.props.contentAreaHeight) || this.props.contentAreaHeight === Object(this.props.contentAreaHeight) ? JSON.stringify(this.props.contentAreaHeight) : this.props.contentAreaHeight,
        "supress-button": Array.isArray(this.props.supressButton) || this.props.supressButton === Object(this.props.supressButton) ? JSON.stringify(this.props.supressButton) : this.props.supressButton,
        "primary-button-text": Array.isArray(this.props.primaryButtonText) || this.props.primaryButtonText === Object(this.props.primaryButtonText) ? JSON.stringify(this.props.primaryButtonText) : this.props.primaryButtonText,
        "tier-two": Array.isArray(this.props.tierTwo) || this.props.tierTwo === Object(this.props.tierTwo) ? JSON.stringify(this.props.tierTwo) : this.props.tierTwo,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "primary-button-accessible-text": Array.isArray(this.props.primaryButtonAccessibleText) || this.props.primaryButtonAccessibleText === Object(this.props.primaryButtonAccessibleText) ? JSON.stringify(this.props.primaryButtonAccessibleText) : this.props.primaryButtonAccessibleText,
        "close-button-accessible-text": Array.isArray(this.props.closeButtonAccessibleText) || this.props.closeButtonAccessibleText === Object(this.props.closeButtonAccessibleText) ? JSON.stringify(this.props.closeButtonAccessibleText) : this.props.closeButtonAccessibleText,
        "header-text": Array.isArray(this.props.headerText) || this.props.headerText === Object(this.props.headerText) ? JSON.stringify(this.props.headerText) : this.props.headerText,
        "bottom-sheet-content": Array.isArray(this.props.bottomSheetContent) || this.props.bottomSheetContent === Object(this.props.bottomSheetContent) ? JSON.stringify(this.props.bottomSheetContent) : this.props.bottomSheetContent,
        open: Array.isArray(this.props.open) || this.props.open === Object(this.props.open) ? JSON.stringify(this.props.open) : this.props.open,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBottomSheet;
}(React.Component);
MdsBottomSheet.propTypes = {
  // Values
  heading: PropTypes.string,
  backButtonAccessibleText: PropTypes.string,
  contentArea: PropTypes.string,
  contentAreaHeight: PropTypes.number,
  supressButton: PropTypes.bool,
  primaryButtonText: PropTypes.string,
  tierTwo: PropTypes.bool,
  brand: PropTypes.string,
  primaryButtonAccessibleText: PropTypes.string,
  closeButtonAccessibleText: PropTypes.string,
  headerText: PropTypes.string,
  bottomSheetContent: PropTypes.string,
  open: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onButtonPress: PropTypes.func,
  onOpen: PropTypes.func,
  onDismiss: PropTypes.func,
  onClickPrimaryButton: PropTypes.func,
  onClickBackButton: PropTypes.func,
  onClose: PropTypes.func
};
MdsBottomSheet.defaultProps = {
  supressButton: false,
  tierTwo: false,
  // Events
  onButtonPress: null,
  onOpen: null,
  onDismiss: null,
  onClickPrimaryButton: null,
  onClickBackButton: null,
  onClose: null
};

var MdsBottomSheetDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBottomSheetDialog, _React$Component);

  var _super = _createSuper(MdsBottomSheetDialog);

  function MdsBottomSheetDialog(props) {
    var _this;

    _classCallCheck(this, MdsBottomSheetDialog);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onButtonPress", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onButtonPress) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onOpen) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onDismiss", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onDismiss) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onDismiss(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onClick) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onButtonPress = _this._onButtonPress.bind(_assertThisInitialized(_this));
    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onDismiss = _this._onDismiss.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBottomSheetDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("buttonPress", this._onButtonPress);

      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("dismiss", this._onDismiss);

      this._ref.current.addEventListener("click", this._onClick); // Imperative Actions

    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("buttonPress", this._onButtonPress);

      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("dismiss", this._onDismiss);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
      // Imperative Actions
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-bottom-sheet-dialog", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "button-labels": Array.isArray(this.props.buttonLabels) || this.props.buttonLabels === Object(this.props.buttonLabels) ? JSON.stringify(this.props.buttonLabels) : this.props.buttonLabels,
        "button-orientation": Array.isArray(this.props.buttonOrientation) || this.props.buttonOrientation === Object(this.props.buttonOrientation) ? JSON.stringify(this.props.buttonOrientation) : this.props.buttonOrientation,
        title: Array.isArray(this.props.title) || this.props.title === Object(this.props.title) ? JSON.stringify(this.props.title) : this.props.title,
        "bottom-sheet-dialog-title": Array.isArray(this.props.bottomSheetDialogTitle) || this.props.bottomSheetDialogTitle === Object(this.props.bottomSheetDialogTitle) ? JSON.stringify(this.props.bottomSheetDialogTitle) : this.props.bottomSheetDialogTitle,
        message: Array.isArray(this.props.message) || this.props.message === Object(this.props.message) ? JSON.stringify(this.props.message) : this.props.message,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "first-button-text": Array.isArray(this.props.firstButtonText) || this.props.firstButtonText === Object(this.props.firstButtonText) ? JSON.stringify(this.props.firstButtonText) : this.props.firstButtonText,
        "dialog-content": Array.isArray(this.props.dialogContent) || this.props.dialogContent === Object(this.props.dialogContent) ? JSON.stringify(this.props.dialogContent) : this.props.dialogContent,
        "dialog-width": Array.isArray(this.props.dialogWidth) || this.props.dialogWidth === Object(this.props.dialogWidth) ? JSON.stringify(this.props.dialogWidth) : this.props.dialogWidth,
        "id-role": Array.isArray(this.props.idRole) || this.props.idRole === Object(this.props.idRole) ? JSON.stringify(this.props.idRole) : this.props.idRole,
        "second-button-text": Array.isArray(this.props.secondButtonText) || this.props.secondButtonText === Object(this.props.secondButtonText) ? JSON.stringify(this.props.secondButtonText) : this.props.secondButtonText,
        open: Array.isArray(this.props.open) || this.props.open === Object(this.props.open) ? JSON.stringify(this.props.open) : this.props.open,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        "header-text": Array.isArray(this.props.headerText) || this.props.headerText === Object(this.props.headerText) ? JSON.stringify(this.props.headerText) : this.props.headerText,
        "trigger-id": Array.isArray(this.props.triggerId) || this.props.triggerId === Object(this.props.triggerId) ? JSON.stringify(this.props.triggerId) : this.props.triggerId,
        "dialog-height": Array.isArray(this.props.dialogHeight) || this.props.dialogHeight === Object(this.props.dialogHeight) ? JSON.stringify(this.props.dialogHeight) : this.props.dialogHeight,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBottomSheetDialog;
}(React.Component);
MdsBottomSheetDialog.propTypes = {
  // Values
  buttonLabels: PropTypes.array,
  buttonOrientation: PropTypes.oneOf(["vertical", "horizontal"]),
  title: PropTypes.string,
  bottomSheetDialogTitle: PropTypes.string,
  message: PropTypes.string,
  image: PropTypes.string,
  brand: PropTypes.string,
  firstButtonText: PropTypes.string,
  dialogContent: PropTypes.string,
  dialogWidth: PropTypes.string,
  idRole: PropTypes.string,
  secondButtonText: PropTypes.string,
  open: PropTypes.string,
  headingLevel: PropTypes.string,
  headerText: PropTypes.string,
  triggerId: PropTypes.string,
  dialogHeight: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onButtonPress: PropTypes.func,
  onOpen: PropTypes.func,
  onDismiss: PropTypes.func,
  onClick: PropTypes.func
};
MdsBottomSheetDialog.defaultProps = {
  buttonOrientation: "horizontal",
  // Events
  onButtonPress: null,
  onOpen: null,
  onDismiss: null,
  onClick: null
};

var MdsBrandBar = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBrandBar, _React$Component);

  var _super = _createSuper(MdsBrandBar);

  function MdsBrandBar(props) {
    var _this;

    _classCallCheck(this, MdsBrandBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onMenuButtonPress", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onMenuButtonPress) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onMenuButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSignInButtonPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onSignInButtonPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onSignInButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSignOutButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onSignOutButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onSignOutButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onControlsPress", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onControlsPress) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onControlsPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMousedown) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickBrand_bar_sign_in_out", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onClickBrand_bar_sign_in_out) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onClickBrand_bar_sign_in_out(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onBlur) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickBrand_bar_hamburger_menu", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onClickBrand_bar_hamburger_menu) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onClickBrand_bar_hamburger_menu(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyupSearchBox", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeyupSearchBox) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeyupSearchBox(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onOpenHamburger", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onOpenHamburger) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onOpenHamburger(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onCloseProfileAndSettings", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onCloseProfileAndSettings) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onCloseProfileAndSettings(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseout) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickBrand_bar_conversation_deck_button", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onClickBrand_bar_conversation_deck_button) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onClickBrand_bar_conversation_deck_button(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onKeydown) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onMouseenter) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onOpenProfileAndSettings", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onOpenProfileAndSettings) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onOpenProfileAndSettings(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props33, _this$props34;

      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onTouchstart) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props35, _this$props36;

      ((_this$props35 = _this.props) === null || _this$props35 === void 0 ? void 0 : _this$props35.onFocus) && ((_this$props36 = _this.props) === null || _this$props36 === void 0 ? void 0 : _this$props36.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props37, _this$props38;

      ((_this$props37 = _this.props) === null || _this$props37 === void 0 ? void 0 : _this$props37.onClick) && ((_this$props38 = _this.props) === null || _this$props38 === void 0 ? void 0 : _this$props38.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInputSearchBox", function (event) {
      var _this$props39, _this$props40;

      ((_this$props39 = _this.props) === null || _this$props39 === void 0 ? void 0 : _this$props39.onInputSearchBox) && ((_this$props40 = _this.props) === null || _this$props40 === void 0 ? void 0 : _this$props40.onInputSearchBox(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickMenuHamburger", function (event) {
      var _this$props41, _this$props42;

      ((_this$props41 = _this.props) === null || _this$props41 === void 0 ? void 0 : _this$props41.onClickMenuHamburger) && ((_this$props42 = _this.props) === null || _this$props42 === void 0 ? void 0 : _this$props42.onClickMenuHamburger(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props43, _this$props44;

      ((_this$props43 = _this.props) === null || _this$props43 === void 0 ? void 0 : _this$props43.onTouchend) && ((_this$props44 = _this.props) === null || _this$props44 === void 0 ? void 0 : _this$props44.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onCloseHamburger", function (event) {
      var _this$props45, _this$props46;

      ((_this$props45 = _this.props) === null || _this$props45 === void 0 ? void 0 : _this$props45.onCloseHamburger) && ((_this$props46 = _this.props) === null || _this$props46 === void 0 ? void 0 : _this$props46.onCloseHamburger(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props47, _this$props48;

      ((_this$props47 = _this.props) === null || _this$props47 === void 0 ? void 0 : _this$props47.onKeyup) && ((_this$props48 = _this.props) === null || _this$props48 === void 0 ? void 0 : _this$props48.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickBrand_bar_search_button", function (event) {
      var _this$props49, _this$props50;

      ((_this$props49 = _this.props) === null || _this$props49 === void 0 ? void 0 : _this$props49.onClickBrand_bar_search_button) && ((_this$props50 = _this.props) === null || _this$props50 === void 0 ? void 0 : _this$props50.onClickBrand_bar_search_button(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickMenuProfileAndSettings", function (event) {
      var _this$props51, _this$props52;

      ((_this$props51 = _this.props) === null || _this$props51 === void 0 ? void 0 : _this$props51.onClickMenuProfileAndSettings) && ((_this$props52 = _this.props) === null || _this$props52 === void 0 ? void 0 : _this$props52.onClickMenuProfileAndSettings(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickBrand_bar_logo", function (event) {
      var _this$props53, _this$props54;

      ((_this$props53 = _this.props) === null || _this$props53 === void 0 ? void 0 : _this$props53.onClickBrand_bar_logo) && ((_this$props54 = _this.props) === null || _this$props54 === void 0 ? void 0 : _this$props54.onClickBrand_bar_logo(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickBrand_bar__open_account_button", function (event) {
      var _this$props55, _this$props56;

      ((_this$props55 = _this.props) === null || _this$props55 === void 0 ? void 0 : _this$props55.onClickBrand_bar__open_account_button) && ((_this$props56 = _this.props) === null || _this$props56 === void 0 ? void 0 : _this$props56.onClickBrand_bar__open_account_button(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickBrand_bar_profile_and_settings_button", function (event) {
      var _this$props57, _this$props58;

      ((_this$props57 = _this.props) === null || _this$props57 === void 0 ? void 0 : _this$props57.onClickBrand_bar_profile_and_settings_button) && ((_this$props58 = _this.props) === null || _this$props58 === void 0 ? void 0 : _this$props58.onClickBrand_bar_profile_and_settings_button(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props59, _this$props60;

      ((_this$props59 = _this.props) === null || _this$props59 === void 0 ? void 0 : _this$props59.onMouseover) && ((_this$props60 = _this.props) === null || _this$props60 === void 0 ? void 0 : _this$props60.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props61, _this$props62;

      ((_this$props61 = _this.props) === null || _this$props61 === void 0 ? void 0 : _this$props61.onMouseup) && ((_this$props62 = _this.props) === null || _this$props62 === void 0 ? void 0 : _this$props62.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props63, _this$props64;

      ((_this$props63 = _this.props) === null || _this$props63 === void 0 ? void 0 : _this$props63.onChange) && ((_this$props64 = _this.props) === null || _this$props64 === void 0 ? void 0 : _this$props64.onChange(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onMenuButtonPress = _this._onMenuButtonPress.bind(_assertThisInitialized(_this));
    _this._onSignInButtonPress = _this._onSignInButtonPress.bind(_assertThisInitialized(_this));
    _this._onSignOutButtonPress = _this._onSignOutButtonPress.bind(_assertThisInitialized(_this));
    _this._onControlsPress = _this._onControlsPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onClickBrand_bar_sign_in_out = _this._onClickBrand_bar_sign_in_out.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onClickBrand_bar_hamburger_menu = _this._onClickBrand_bar_hamburger_menu.bind(_assertThisInitialized(_this));
    _this._onKeyupSearchBox = _this._onKeyupSearchBox.bind(_assertThisInitialized(_this));
    _this._onOpenHamburger = _this._onOpenHamburger.bind(_assertThisInitialized(_this));
    _this._onCloseProfileAndSettings = _this._onCloseProfileAndSettings.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onClickBrand_bar_conversation_deck_button = _this._onClickBrand_bar_conversation_deck_button.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onOpenProfileAndSettings = _this._onOpenProfileAndSettings.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onInputSearchBox = _this._onInputSearchBox.bind(_assertThisInitialized(_this));
    _this._onClickMenuHamburger = _this._onClickMenuHamburger.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onCloseHamburger = _this._onCloseHamburger.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onClickBrand_bar_search_button = _this._onClickBrand_bar_search_button.bind(_assertThisInitialized(_this));
    _this._onClickMenuProfileAndSettings = _this._onClickMenuProfileAndSettings.bind(_assertThisInitialized(_this));
    _this._onClickBrand_bar_logo = _this._onClickBrand_bar_logo.bind(_assertThisInitialized(_this));
    _this._onClickBrand_bar__open_account_button = _this._onClickBrand_bar__open_account_button.bind(_assertThisInitialized(_this));
    _this._onClickBrand_bar_profile_and_settings_button = _this._onClickBrand_bar_profile_and_settings_button.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBrandBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("menuButtonPress", this._onMenuButtonPress);

      this._ref.current.addEventListener("signInButtonPress", this._onSignInButtonPress);

      this._ref.current.addEventListener("signOutButtonPress", this._onSignOutButtonPress);

      this._ref.current.addEventListener("controlsPress", this._onControlsPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("click-brand_bar_sign_in_out", this._onClickBrand_bar_sign_in_out);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("click-brand_bar_hamburger_menu", this._onClickBrand_bar_hamburger_menu);

      this._ref.current.addEventListener("keyup-search-box", this._onKeyupSearchBox);

      this._ref.current.addEventListener("open-hamburger", this._onOpenHamburger);

      this._ref.current.addEventListener("close-profile-and-settings", this._onCloseProfileAndSettings);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("click-brand_bar_conversation_deck_button", this._onClickBrand_bar_conversation_deck_button);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("open-profile-and-settings", this._onOpenProfileAndSettings);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("input-search-box", this._onInputSearchBox);

      this._ref.current.addEventListener("click-menu-hamburger", this._onClickMenuHamburger);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("close-hamburger", this._onCloseHamburger);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("click-brand_bar_search_button", this._onClickBrand_bar_search_button);

      this._ref.current.addEventListener("click-menu-profile-and-settings", this._onClickMenuProfileAndSettings);

      this._ref.current.addEventListener("click-brand_bar_logo", this._onClickBrand_bar_logo);

      this._ref.current.addEventListener("click-brand_bar__open_account_button", this._onClickBrand_bar__open_account_button);

      this._ref.current.addEventListener("click-brand_bar_profile_and_settings_button", this._onClickBrand_bar_profile_and_settings_button);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("change", this._onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("menuButtonPress", this._onMenuButtonPress);

      this._ref.current.removeEventListener("signInButtonPress", this._onSignInButtonPress);

      this._ref.current.removeEventListener("signOutButtonPress", this._onSignOutButtonPress);

      this._ref.current.removeEventListener("controlsPress", this._onControlsPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("click-brand_bar_sign_in_out", this._onClickBrand_bar_sign_in_out);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("click-brand_bar_hamburger_menu", this._onClickBrand_bar_hamburger_menu);

      this._ref.current.removeEventListener("keyup-search-box", this._onKeyupSearchBox);

      this._ref.current.removeEventListener("open-hamburger", this._onOpenHamburger);

      this._ref.current.removeEventListener("close-profile-and-settings", this._onCloseProfileAndSettings);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("click-brand_bar_conversation_deck_button", this._onClickBrand_bar_conversation_deck_button);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("open-profile-and-settings", this._onOpenProfileAndSettings);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("input-search-box", this._onInputSearchBox);

      this._ref.current.removeEventListener("click-menu-hamburger", this._onClickMenuHamburger);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("close-hamburger", this._onCloseHamburger);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("click-brand_bar_search_button", this._onClickBrand_bar_search_button);

      this._ref.current.removeEventListener("click-menu-profile-and-settings", this._onClickMenuProfileAndSettings);

      this._ref.current.removeEventListener("click-brand_bar_logo", this._onClickBrand_bar_logo);

      this._ref.current.removeEventListener("click-brand_bar__open_account_button", this._onClickBrand_bar__open_account_button);

      this._ref.current.removeEventListener("click-brand_bar_profile_and_settings_button", this._onClickBrand_bar_profile_and_settings_button);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("change", this._onChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-brand-bar", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        logo: Array.isArray(this.props.logo) || this.props.logo === Object(this.props.logo) ? JSON.stringify(this.props.logo) : this.props.logo,
        "logo-mobile": Array.isArray(this.props.logoMobile) || this.props.logoMobile === Object(this.props.logoMobile) ? JSON.stringify(this.props.logoMobile) : this.props.logoMobile,
        "logo-destination": Array.isArray(this.props.logoDestination) || this.props.logoDestination === Object(this.props.logoDestination) ? JSON.stringify(this.props.logoDestination) : this.props.logoDestination,
        "logo-accessible-text": Array.isArray(this.props.logoAccessibleText) || this.props.logoAccessibleText === Object(this.props.logoAccessibleText) ? JSON.stringify(this.props.logoAccessibleText) : this.props.logoAccessibleText,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        "menu-button": Array.isArray(this.props.menuButton) || this.props.menuButton === Object(this.props.menuButton) ? JSON.stringify(this.props.menuButton) : this.props.menuButton,
        "menu-button-inactive": Array.isArray(this.props.menuButtonInactive) || this.props.menuButtonInactive === Object(this.props.menuButtonInactive) ? JSON.stringify(this.props.menuButtonInactive) : this.props.menuButtonInactive,
        "search-enabled": Array.isArray(this.props.searchEnabled) || this.props.searchEnabled === Object(this.props.searchEnabled) ? JSON.stringify(this.props.searchEnabled) : this.props.searchEnabled,
        "conversation-deck-button": Array.isArray(this.props.conversationDeckButton) || this.props.conversationDeckButton === Object(this.props.conversationDeckButton) ? JSON.stringify(this.props.conversationDeckButton) : this.props.conversationDeckButton,
        "conversation-deck-button-inactive": Array.isArray(this.props.conversationDeckButtonInactive) || this.props.conversationDeckButtonInactive === Object(this.props.conversationDeckButtonInactive) ? JSON.stringify(this.props.conversationDeckButtonInactive) : this.props.conversationDeckButtonInactive,
        "conversation-deck-number": Array.isArray(this.props.conversationDeckNumber) || this.props.conversationDeckNumber === Object(this.props.conversationDeckNumber) ? JSON.stringify(this.props.conversationDeckNumber) : this.props.conversationDeckNumber,
        "conversation-deck-button-accessible-text": Array.isArray(this.props.conversationDeckButtonAccessibleText) || this.props.conversationDeckButtonAccessibleText === Object(this.props.conversationDeckButtonAccessibleText) ? JSON.stringify(this.props.conversationDeckButtonAccessibleText) : this.props.conversationDeckButtonAccessibleText,
        "search-button-accessible-text": Array.isArray(this.props.searchButtonAccessibleText) || this.props.searchButtonAccessibleText === Object(this.props.searchButtonAccessibleText) ? JSON.stringify(this.props.searchButtonAccessibleText) : this.props.searchButtonAccessibleText,
        "search-button-inactive": Array.isArray(this.props.searchButtonInactive) || this.props.searchButtonInactive === Object(this.props.searchButtonInactive) ? JSON.stringify(this.props.searchButtonInactive) : this.props.searchButtonInactive,
        "accessible-hamburger-menu-name": Array.isArray(this.props.accessibleHamburgerMenuName) || this.props.accessibleHamburgerMenuName === Object(this.props.accessibleHamburgerMenuName) ? JSON.stringify(this.props.accessibleHamburgerMenuName) : this.props.accessibleHamburgerMenuName,
        "accessible-hamburger-menu-button-name": Array.isArray(this.props.accessibleHamburgerMenuButtonName) || this.props.accessibleHamburgerMenuButtonName === Object(this.props.accessibleHamburgerMenuButtonName) ? JSON.stringify(this.props.accessibleHamburgerMenuButtonName) : this.props.accessibleHamburgerMenuButtonName,
        "container-accessible-role-flag": Array.isArray(this.props.containerAccessibleRoleFlag) || this.props.containerAccessibleRoleFlag === Object(this.props.containerAccessibleRoleFlag) ? JSON.stringify(this.props.containerAccessibleRoleFlag) : this.props.containerAccessibleRoleFlag,
        "container-accessible-role": Array.isArray(this.props.containerAccessibleRole) || this.props.containerAccessibleRole === Object(this.props.containerAccessibleRole) ? JSON.stringify(this.props.containerAccessibleRole) : this.props.containerAccessibleRole,
        "max-width": Array.isArray(this.props.maxWidth) || this.props.maxWidth === Object(this.props.maxWidth) ? JSON.stringify(this.props.maxWidth) : this.props.maxWidth,
        "security-button": Array.isArray(this.props.securityButton) || this.props.securityButton === Object(this.props.securityButton) ? JSON.stringify(this.props.securityButton) : this.props.securityButton,
        "security-button-inactive": Array.isArray(this.props.securityButtonInactive) || this.props.securityButtonInactive === Object(this.props.securityButtonInactive) ? JSON.stringify(this.props.securityButtonInactive) : this.props.securityButtonInactive,
        "security-button-accessible-text": Array.isArray(this.props.securityButtonAccessibleText) || this.props.securityButtonAccessibleText === Object(this.props.securityButtonAccessibleText) ? JSON.stringify(this.props.securityButtonAccessibleText) : this.props.securityButtonAccessibleText,
        "profile-and-settings-button": Array.isArray(this.props.profileAndSettingsButton) || this.props.profileAndSettingsButton === Object(this.props.profileAndSettingsButton) ? JSON.stringify(this.props.profileAndSettingsButton) : this.props.profileAndSettingsButton,
        "profile-and-settings-button-inactive": Array.isArray(this.props.profileAndSettingsButtonInactive) || this.props.profileAndSettingsButtonInactive === Object(this.props.profileAndSettingsButtonInactive) ? JSON.stringify(this.props.profileAndSettingsButtonInactive) : this.props.profileAndSettingsButtonInactive,
        "profile-and-settings-button-accessible-text": Array.isArray(this.props.profileAndSettingsButtonAccessibleText) || this.props.profileAndSettingsButtonAccessibleText === Object(this.props.profileAndSettingsButtonAccessibleText) ? JSON.stringify(this.props.profileAndSettingsButtonAccessibleText) : this.props.profileAndSettingsButtonAccessibleText,
        "open-account-button-text": Array.isArray(this.props.openAccountButtonText) || this.props.openAccountButtonText === Object(this.props.openAccountButtonText) ? JSON.stringify(this.props.openAccountButtonText) : this.props.openAccountButtonText,
        "open-account-button-inactive": Array.isArray(this.props.openAccountButtonInactive) || this.props.openAccountButtonInactive === Object(this.props.openAccountButtonInactive) ? JSON.stringify(this.props.openAccountButtonInactive) : this.props.openAccountButtonInactive,
        "open-account-button-accessible-text": Array.isArray(this.props.openAccountButtonAccessibleText) || this.props.openAccountButtonAccessibleText === Object(this.props.openAccountButtonAccessibleText) ? JSON.stringify(this.props.openAccountButtonAccessibleText) : this.props.openAccountButtonAccessibleText,
        "sign-in-out-button-text": Array.isArray(this.props.signInOutButtonText) || this.props.signInOutButtonText === Object(this.props.signInOutButtonText) ? JSON.stringify(this.props.signInOutButtonText) : this.props.signInOutButtonText,
        "sign-in-out-button-accessible-text": Array.isArray(this.props.signInOutButtonAccessibleText) || this.props.signInOutButtonAccessibleText === Object(this.props.signInOutButtonAccessibleText) ? JSON.stringify(this.props.signInOutButtonAccessibleText) : this.props.signInOutButtonAccessibleText,
        "search-box-cancel-button-text": Array.isArray(this.props.searchBoxCancelButtonText) || this.props.searchBoxCancelButtonText === Object(this.props.searchBoxCancelButtonText) ? JSON.stringify(this.props.searchBoxCancelButtonText) : this.props.searchBoxCancelButtonText,
        "search-box-cancel-button-accessible-text": Array.isArray(this.props.searchBoxCancelButtonAccessibleText) || this.props.searchBoxCancelButtonAccessibleText === Object(this.props.searchBoxCancelButtonAccessibleText) ? JSON.stringify(this.props.searchBoxCancelButtonAccessibleText) : this.props.searchBoxCancelButtonAccessibleText,
        opaque: Array.isArray(this.props.opaque) || this.props.opaque === Object(this.props.opaque) ? JSON.stringify(this.props.opaque) : this.props.opaque,
        "logo-text": Array.isArray(this.props.logoText) || this.props.logoText === Object(this.props.logoText) ? JSON.stringify(this.props.logoText) : this.props.logoText,
        expanded: Array.isArray(this.props.expanded) || this.props.expanded === Object(this.props.expanded) ? JSON.stringify(this.props.expanded) : this.props.expanded,
        opacity: Array.isArray(this.props.opacity) || this.props.opacity === Object(this.props.opacity) ? JSON.stringify(this.props.opacity) : this.props.opacity,
        "search-box-slot": Array.isArray(this.props.searchBoxSlot) || this.props.searchBoxSlot === Object(this.props.searchBoxSlot) ? JSON.stringify(this.props.searchBoxSlot) : this.props.searchBoxSlot,
        "sign-in-out-button-acccessible-text": Array.isArray(this.props.signInOutButtonAcccessibleText) || this.props.signInOutButtonAcccessibleText === Object(this.props.signInOutButtonAcccessibleText) ? JSON.stringify(this.props.signInOutButtonAcccessibleText) : this.props.signInOutButtonAcccessibleText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "right-controls": Array.isArray(this.props.rightControls) || this.props.rightControls === Object(this.props.rightControls) ? JSON.stringify(this.props.rightControls) : this.props.rightControls,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "search-box-data": Array.isArray(this.props.searchBoxData) || this.props.searchBoxData === Object(this.props.searchBoxData) ? JSON.stringify(this.props.searchBoxData) : this.props.searchBoxData,
        "menu-button-data": Array.isArray(this.props.menuButtonData) || this.props.menuButtonData === Object(this.props.menuButtonData) ? JSON.stringify(this.props.menuButtonData) : this.props.menuButtonData,
        "profile-and-settings-data": Array.isArray(this.props.profileAndSettingsData) || this.props.profileAndSettingsData === Object(this.props.profileAndSettingsData) ? JSON.stringify(this.props.profileAndSettingsData) : this.props.profileAndSettingsData,
        "left-controls": Array.isArray(this.props.leftControls) || this.props.leftControls === Object(this.props.leftControls) ? JSON.stringify(this.props.leftControls) : this.props.leftControls // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBrandBar;
}(React.Component);
MdsBrandBar.propTypes = {
  // Values
  variant: PropTypes.oneOf(["default", "custom"]),
  logo: PropTypes.string,
  logoMobile: PropTypes.string,
  logoDestination: PropTypes.string,
  logoAccessibleText: PropTypes.string,
  headingLevel: PropTypes.number,
  menuButton: PropTypes.bool,
  menuButtonInactive: PropTypes.bool,
  searchEnabled: PropTypes.bool,
  conversationDeckButton: PropTypes.bool,
  conversationDeckButtonInactive: PropTypes.bool,
  conversationDeckNumber: PropTypes.number,
  conversationDeckButtonAccessibleText: PropTypes.string,
  searchButtonAccessibleText: PropTypes.string,
  searchButtonInactive: PropTypes.bool,
  accessibleHamburgerMenuName: PropTypes.string,
  accessibleHamburgerMenuButtonName: PropTypes.string,
  containerAccessibleRoleFlag: PropTypes.bool,
  containerAccessibleRole: PropTypes.string,
  maxWidth: PropTypes.string,
  securityButton: PropTypes.bool,
  securityButtonInactive: PropTypes.bool,
  securityButtonAccessibleText: PropTypes.string,
  profileAndSettingsButton: PropTypes.bool,
  profileAndSettingsButtonInactive: PropTypes.bool,
  profileAndSettingsButtonAccessibleText: PropTypes.string,
  openAccountButtonText: PropTypes.string,
  openAccountButtonInactive: PropTypes.bool,
  openAccountButtonAccessibleText: PropTypes.string,
  signInOutButtonText: PropTypes.string,
  signInOutButtonAccessibleText: PropTypes.string,
  searchBoxCancelButtonText: PropTypes.string,
  searchBoxCancelButtonAccessibleText: PropTypes.string,
  opaque: PropTypes.bool,
  logoText: PropTypes.string,
  expanded: PropTypes.bool,
  opacity: PropTypes.oneOf(["full", "high"]),
  searchBoxSlot: PropTypes.bool,
  signInOutButtonAcccessibleText: PropTypes.string,
  brand: PropTypes.string,
  rightControls: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  searchBoxData: CustomPropTypes.slot,
  menuButtonData: CustomPropTypes.slot,
  profileAndSettingsData: CustomPropTypes.slot,
  leftControls: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onMenuButtonPress: PropTypes.func,
  onSignInButtonPress: PropTypes.func,
  onSignOutButtonPress: PropTypes.func,
  onControlsPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onClickBrand_bar_sign_in_out: PropTypes.func,
  onBlur: PropTypes.func,
  onClickBrand_bar_hamburger_menu: PropTypes.func,
  onKeyupSearchBox: PropTypes.func,
  onOpenHamburger: PropTypes.func,
  onCloseProfileAndSettings: PropTypes.func,
  onMouseout: PropTypes.func,
  onClickBrand_bar_conversation_deck_button: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onOpenProfileAndSettings: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  onInputSearchBox: PropTypes.func,
  onClickMenuHamburger: PropTypes.func,
  onTouchend: PropTypes.func,
  onCloseHamburger: PropTypes.func,
  onKeyup: PropTypes.func,
  onClickBrand_bar_search_button: PropTypes.func,
  onClickMenuProfileAndSettings: PropTypes.func,
  onClickBrand_bar_logo: PropTypes.func,
  onClickBrand_bar__open_account_button: PropTypes.func,
  onClickBrand_bar_profile_and_settings_button: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseup: PropTypes.func,
  onChange: PropTypes.func
};
MdsBrandBar.defaultProps = {
  variant: "default",
  menuButton: false,
  menuButtonInactive: false,
  conversationDeckButton: false,
  conversationDeckButtonInactive: false,
  searchButtonInactive: false,
  accessibleHamburgerMenuName: "Menu",
  containerAccessibleRoleFlag: true,
  containerAccessibleRole: "banner",
  securityButton: false,
  securityButtonInactive: false,
  profileAndSettingsButton: false,
  profileAndSettingsButtonInactive: false,
  openAccountButtonInactive: false,
  opaque: true,
  expanded: false,
  opacity: "full",
  // Events
  onMenuButtonPress: null,
  onSignInButtonPress: null,
  onSignOutButtonPress: null,
  onControlsPress: null,
  onMousedown: null,
  onClickBrand_bar_sign_in_out: null,
  onBlur: null,
  onClickBrand_bar_hamburger_menu: null,
  onKeyupSearchBox: null,
  onOpenHamburger: null,
  onCloseProfileAndSettings: null,
  onMouseout: null,
  onClickBrand_bar_conversation_deck_button: null,
  onKeydown: null,
  onMouseenter: null,
  onOpenProfileAndSettings: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null,
  onInputSearchBox: null,
  onClickMenuHamburger: null,
  onTouchend: null,
  onCloseHamburger: null,
  onKeyup: null,
  onClickBrand_bar_search_button: null,
  onClickMenuProfileAndSettings: null,
  onClickBrand_bar_logo: null,
  onClickBrand_bar__open_account_button: null,
  onClickBrand_bar_profile_and_settings_button: null,
  onMouseover: null,
  onMouseup: null,
  onChange: null
};

var MdsBreadcrumb = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBreadcrumb, _React$Component);

  var _super = _createSuper(MdsBreadcrumb);

  function MdsBreadcrumb(props) {
    var _this;

    _classCallCheck(this, MdsBreadcrumb);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onSelectChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onSelectChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onSelectChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickLink", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClickLink) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClickLink(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onTouchend) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeyup) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseout) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onKeydown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseover) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseup) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onFocus) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onClick) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onSelectChange = _this._onSelectChange.bind(_assertThisInitialized(_this));
    _this._onClickLink = _this._onClickLink.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBreadcrumb, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("selectChange", this._onSelectChange);

      this._ref.current.addEventListener("click-link", this._onClickLink);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("selectChange", this._onSelectChange);

      this._ref.current.removeEventListener("click-link", this._onClickLink);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-breadcrumb", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "current-page": Array.isArray(this.props.currentPage) || this.props.currentPage === Object(this.props.currentPage) ? JSON.stringify(this.props.currentPage) : this.props.currentPage,
        "accessible-breadcrumb-name": Array.isArray(this.props.accessibleBreadcrumbName) || this.props.accessibleBreadcrumbName === Object(this.props.accessibleBreadcrumbName) ? JSON.stringify(this.props.accessibleBreadcrumbName) : this.props.accessibleBreadcrumbName,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        links: Array.isArray(this.props.links) || this.props.links === Object(this.props.links) ? JSON.stringify(this.props.links) : this.props.links,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBreadcrumb;
}(React.Component);
MdsBreadcrumb.propTypes = {
  // Values
  currentPage: PropTypes.string,
  accessibleBreadcrumbName: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  links: PropTypes.arrayOf(CustomPropTypes.slot),
  state: PropTypes.oneOf(["disabled"]),
  // Events
  onSelectChange: PropTypes.func,
  onClickLink: PropTypes.func,
  onMousedown: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsBreadcrumb.defaultProps = {
  accessibleBreadcrumbName: "breadcrumb",
  // Events
  onSelectChange: null,
  onClickLink: null,
  onMousedown: null,
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsButton = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsButton, _React$Component);

  var _super = _createSuper(MdsButton);

  function MdsButton(props) {
    var _this;

    _classCallCheck(this, MdsButton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onPress", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onPress) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onTouchend) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeyup) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseover) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseenter) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onClick) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onPress = _this._onPress.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("press", this._onPress);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("press", this._onPress);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-button", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "width-type": Array.isArray(this.props.widthType) || this.props.widthType === Object(this.props.widthType) ? JSON.stringify(this.props.widthType) : this.props.widthType,
        text: Array.isArray(this.props.text) || this.props.text === Object(this.props.text) ? JSON.stringify(this.props.text) : this.props.text,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        "icon-position": Array.isArray(this.props.iconPosition) || this.props.iconPosition === Object(this.props.iconPosition) ? JSON.stringify(this.props.iconPosition) : this.props.iconPosition,
        "ada-text": Array.isArray(this.props.adaText) || this.props.adaText === Object(this.props.adaText) ? JSON.stringify(this.props.adaText) : this.props.adaText,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        small: Array.isArray(this.props.small) || this.props.small === Object(this.props.small) ? JSON.stringify(this.props.small) : this.props.small,
        inverse: Array.isArray(this.props.inverse) || this.props.inverse === Object(this.props.inverse) ? JSON.stringify(this.props.inverse) : this.props.inverse,
        "tooltip-alignment": Array.isArray(this.props.tooltipAlignment) || this.props.tooltipAlignment === Object(this.props.tooltipAlignment) ? JSON.stringify(this.props.tooltipAlignment) : this.props.tooltipAlignment,
        "tooltip-pointer-placement": Array.isArray(this.props.tooltipPointerPlacement) || this.props.tooltipPointerPlacement === Object(this.props.tooltipPointerPlacement) ? JSON.stringify(this.props.tooltipPointerPlacement) : this.props.tooltipPointerPlacement,
        "tooltip-placement": Array.isArray(this.props.tooltipPlacement) || this.props.tooltipPlacement === Object(this.props.tooltipPlacement) ? JSON.stringify(this.props.tooltipPlacement) : this.props.tooltipPlacement,
        "tooltip-message": Array.isArray(this.props.tooltipMessage) || this.props.tooltipMessage === Object(this.props.tooltipMessage) ? JSON.stringify(this.props.tooltipMessage) : this.props.tooltipMessage,
        "icon-type": Array.isArray(this.props.iconType) || this.props.iconType === Object(this.props.iconType) ? JSON.stringify(this.props.iconType) : this.props.iconType,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        "icon-accessible-description": Array.isArray(this.props.iconAccessibleDescription) || this.props.iconAccessibleDescription === Object(this.props.iconAccessibleDescription) ? JSON.stringify(this.props.iconAccessibleDescription) : this.props.iconAccessibleDescription,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        "tab-focusable": Array.isArray(this.props.tabFocusable) || this.props.tabFocusable === Object(this.props.tabFocusable) ? JSON.stringify(this.props.tabFocusable) : this.props.tabFocusable,
        type: Array.isArray(this.props.type) || this.props.type === Object(this.props.type) ? JSON.stringify(this.props.type) : this.props.type,
        "is-loading": Array.isArray(this.props.isLoading) || this.props.isLoading === Object(this.props.isLoading) ? JSON.stringify(this.props.isLoading) : this.props.isLoading,
        "spinner-accessible-text": Array.isArray(this.props.spinnerAccessibleText) || this.props.spinnerAccessibleText === Object(this.props.spinnerAccessibleText) ? JSON.stringify(this.props.spinnerAccessibleText) : this.props.spinnerAccessibleText,
        "status-accessible-text": Array.isArray(this.props.statusAccessibleText) || this.props.statusAccessibleText === Object(this.props.statusAccessibleText) ? JSON.stringify(this.props.statusAccessibleText) : this.props.statusAccessibleText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        badge: Array.isArray(this.props.badge) || this.props.badge === Object(this.props.badge) ? JSON.stringify(this.props.badge) : this.props.badge,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsButton;
}(React.Component);
MdsButton.propTypes = {
  // Values
  widthType: PropTypes.oneOf(["content", "layout"]),
  text: PropTypes.string,
  icon: PropTypes.string,
  iconPosition: PropTypes.oneOf(["leading", "trailing", "icon_only"]),
  adaText: PropTypes.string,
  variant: PropTypes.oneOf(["primary", "secondary", "tertiary"]),
  small: PropTypes.bool,
  inverse: PropTypes.bool,
  tooltipAlignment: PropTypes.oneOf(["left", "right", "center"]),
  tooltipPointerPlacement: PropTypes.number,
  tooltipPlacement: PropTypes.oneOf(["above", "below"]),
  tooltipMessage: PropTypes.string,
  iconType: PropTypes.string,
  inactive: PropTypes.bool,
  iconAccessibleDescription: PropTypes.string,
  accessibleText: PropTypes.string,
  value: PropTypes.string,
  tabFocusable: PropTypes.bool,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
  spinnerAccessibleText: PropTypes.string,
  statusAccessibleText: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  badge: CustomPropTypes.slot,
  state: PropTypes.oneOf(["pressed", "disabled", "hovered", "focused"]),
  // Events
  onPress: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsButton.defaultProps = {
  widthType: "content",
  iconPosition: "leading",
  variant: "primary",
  small: false,
  inverse: false,
  tooltipAlignment: "center",
  tooltipPointerPlacement: 8,
  tooltipPlacement: "below",
  inactive: false,
  tabFocusable: true,
  type: "button",
  isLoading: false,
  // Events
  onPress: null,
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsCalendar = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsCalendar, _React$Component);

  var _super = _createSuper(MdsCalendar);

  function MdsCalendar() {
    _classCallCheck(this, MdsCalendar);

    return _super.apply(this, arguments);
  }

  _createClass(MdsCalendar, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-calendar", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "view-type": Array.isArray(this.props.viewType) || this.props.viewType === Object(this.props.viewType) ? JSON.stringify(this.props.viewType) : this.props.viewType,
        "start-date": Array.isArray(this.props.startDate) || this.props.startDate === Object(this.props.startDate) ? JSON.stringify(this.props.startDate) : this.props.startDate,
        "end-date": Array.isArray(this.props.endDate) || this.props.endDate === Object(this.props.endDate) ? JSON.stringify(this.props.endDate) : this.props.endDate,
        locale: Array.isArray(this.props.locale) || this.props.locale === Object(this.props.locale) ? JSON.stringify(this.props.locale) : this.props.locale,
        "time-zone": Array.isArray(this.props.timeZone) || this.props.timeZone === Object(this.props.timeZone) ? JSON.stringify(this.props.timeZone) : this.props.timeZone,
        "current-date-marker": Array.isArray(this.props.currentDateMarker) || this.props.currentDateMarker === Object(this.props.currentDateMarker) ? JSON.stringify(this.props.currentDateMarker) : this.props.currentDateMarker,
        "activity-indicator": Array.isArray(this.props.activityIndicator) || this.props.activityIndicator === Object(this.props.activityIndicator) ? JSON.stringify(this.props.activityIndicator) : this.props.activityIndicator,
        "active-dates": Array.isArray(this.props.activeDates) || this.props.activeDates === Object(this.props.activeDates) ? JSON.stringify(this.props.activeDates) : this.props.activeDates,
        "accessible-current-date-text": Array.isArray(this.props.accessibleCurrentDateText) || this.props.accessibleCurrentDateText === Object(this.props.accessibleCurrentDateText) ? JSON.stringify(this.props.accessibleCurrentDateText) : this.props.accessibleCurrentDateText,
        "accessible-activity-date-text": Array.isArray(this.props.accessibleActivityDateText) || this.props.accessibleActivityDateText === Object(this.props.accessibleActivityDateText) ? JSON.stringify(this.props.accessibleActivityDateText) : this.props.accessibleActivityDateText,
        "accessible-past-date-text": Array.isArray(this.props.accessiblePastDateText) || this.props.accessiblePastDateText === Object(this.props.accessiblePastDateText) ? JSON.stringify(this.props.accessiblePastDateText) : this.props.accessiblePastDateText,
        "todays-date-label": Array.isArray(this.props.todaysDateLabel) || this.props.todaysDateLabel === Object(this.props.todaysDateLabel) ? JSON.stringify(this.props.todaysDateLabel) : this.props.todaysDateLabel,
        "upcoming-activity-label": Array.isArray(this.props.upcomingActivityLabel) || this.props.upcomingActivityLabel === Object(this.props.upcomingActivityLabel) ? JSON.stringify(this.props.upcomingActivityLabel) : this.props.upcomingActivityLabel,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsCalendar;
}(React.Component);
MdsCalendar.propTypes = {
  // Values
  viewType: PropTypes.oneOf(["month", "rolling"]),
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  locale: PropTypes.string,
  timeZone: PropTypes.string,
  currentDateMarker: PropTypes.bool,
  activityIndicator: PropTypes.bool,
  activeDates: PropTypes.array,
  accessibleCurrentDateText: PropTypes.string,
  accessibleActivityDateText: PropTypes.string,
  accessiblePastDateText: PropTypes.string,
  todaysDateLabel: PropTypes.string,
  upcomingActivityLabel: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string
};
MdsCalendar.defaultProps = {
  viewType: "month",
  currentDateMarker: false,
  activityIndicator: false
};

var MdsCallout = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsCallout, _React$Component);

  var _super = _createSuper(MdsCallout);

  function MdsCallout(props) {
    var _this;

    _classCallCheck(this, MdsCallout);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onControlPress", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onControlPress) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onControlPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onOpen) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onDismiss", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onDismiss) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onDismiss(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onClose) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onClick) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onControlPress = _this._onControlPress.bind(_assertThisInitialized(_this));
    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onDismiss = _this._onDismiss.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsCallout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("controlPress", this._onControlPress);

      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("dismiss", this._onDismiss);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("controlPress", this._onControlPress);

      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("dismiss", this._onDismiss);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-callout", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "callout-placement": Array.isArray(this.props.calloutPlacement) || this.props.calloutPlacement === Object(this.props.calloutPlacement) ? JSON.stringify(this.props.calloutPlacement) : this.props.calloutPlacement,
        "pointer-placement": Array.isArray(this.props.pointerPlacement) || this.props.pointerPlacement === Object(this.props.pointerPlacement) ? JSON.stringify(this.props.pointerPlacement) : this.props.pointerPlacement,
        "link-text": Array.isArray(this.props.linkText) || this.props.linkText === Object(this.props.linkText) ? JSON.stringify(this.props.linkText) : this.props.linkText,
        message: Array.isArray(this.props.message) || this.props.message === Object(this.props.message) ? JSON.stringify(this.props.message) : this.props.message,
        title: Array.isArray(this.props.title) || this.props.title === Object(this.props.title) ? JSON.stringify(this.props.title) : this.props.title,
        "callout-title": Array.isArray(this.props.calloutTitle) || this.props.calloutTitle === Object(this.props.calloutTitle) ? JSON.stringify(this.props.calloutTitle) : this.props.calloutTitle,
        "button-text": Array.isArray(this.props.buttonText) || this.props.buttonText === Object(this.props.buttonText) ? JSON.stringify(this.props.buttonText) : this.props.buttonText,
        "button-titles": Array.isArray(this.props.buttonTitles) || this.props.buttonTitles === Object(this.props.buttonTitles) ? JSON.stringify(this.props.buttonTitles) : this.props.buttonTitles,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        "top-image": Array.isArray(this.props.topImage) || this.props.topImage === Object(this.props.topImage) ? JSON.stringify(this.props.topImage) : this.props.topImage,
        "leading-image": Array.isArray(this.props.leadingImage) || this.props.leadingImage === Object(this.props.leadingImage) ? JSON.stringify(this.props.leadingImage) : this.props.leadingImage,
        "enter-announcement": Array.isArray(this.props.enterAnnouncement) || this.props.enterAnnouncement === Object(this.props.enterAnnouncement) ? JSON.stringify(this.props.enterAnnouncement) : this.props.enterAnnouncement,
        "exit-announcement": Array.isArray(this.props.exitAnnouncement) || this.props.exitAnnouncement === Object(this.props.exitAnnouncement) ? JSON.stringify(this.props.exitAnnouncement) : this.props.exitAnnouncement,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "close-accessiblity-text": Array.isArray(this.props.closeAccessiblityText) || this.props.closeAccessiblityText === Object(this.props.closeAccessiblityText) ? JSON.stringify(this.props.closeAccessiblityText) : this.props.closeAccessiblityText,
        alignment: Array.isArray(this.props.alignment) || this.props.alignment === Object(this.props.alignment) ? JSON.stringify(this.props.alignment) : this.props.alignment,
        "detect-trigger-wrap": Array.isArray(this.props.detectTriggerWrap) || this.props.detectTriggerWrap === Object(this.props.detectTriggerWrap) ? JSON.stringify(this.props.detectTriggerWrap) : this.props.detectTriggerWrap,
        "tooltip-placement": Array.isArray(this.props.tooltipPlacement) || this.props.tooltipPlacement === Object(this.props.tooltipPlacement) ? JSON.stringify(this.props.tooltipPlacement) : this.props.tooltipPlacement,
        "edge-detection-container-id": Array.isArray(this.props.edgeDetectionContainerId) || this.props.edgeDetectionContainerId === Object(this.props.edgeDetectionContainerId) ? JSON.stringify(this.props.edgeDetectionContainerId) : this.props.edgeDetectionContainerId,
        "header-text": Array.isArray(this.props.headerText) || this.props.headerText === Object(this.props.headerText) ? JSON.stringify(this.props.headerText) : this.props.headerText,
        visible: Array.isArray(this.props.visible) || this.props.visible === Object(this.props.visible) ? JSON.stringify(this.props.visible) : this.props.visible,
        "edge-detection": Array.isArray(this.props.edgeDetection) || this.props.edgeDetection === Object(this.props.edgeDetection) ? JSON.stringify(this.props.edgeDetection) : this.props.edgeDetection,
        "manual-control": Array.isArray(this.props.manualControl) || this.props.manualControl === Object(this.props.manualControl) ? JSON.stringify(this.props.manualControl) : this.props.manualControl,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsCallout;
}(React.Component);
MdsCallout.propTypes = {
  // Values
  variant: PropTypes.oneOf(["inline", "web", "overlay", "contextual"]),
  calloutPlacement: PropTypes.oneOf(["above", "below", "left", "right"]),
  pointerPlacement: PropTypes.number,
  linkText: PropTypes.string,
  message: PropTypes.string,
  title: PropTypes.string,
  calloutTitle: PropTypes.string,
  buttonText: PropTypes.string,
  buttonTitles: PropTypes.array,
  image: PropTypes.string,
  topImage: PropTypes.string,
  leadingImage: PropTypes.string,
  enterAnnouncement: PropTypes.string,
  exitAnnouncement: PropTypes.string,
  brand: PropTypes.string,
  closeAccessiblityText: PropTypes.string,
  alignment: PropTypes.string,
  detectTriggerWrap: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  edgeDetectionContainerId: PropTypes.string,
  headerText: PropTypes.string,
  visible: PropTypes.bool,
  edgeDetection: PropTypes.string,
  manualControl: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onControlPress: PropTypes.func,
  onOpen: PropTypes.func,
  onDismiss: PropTypes.func,
  onClose: PropTypes.func,
  onClick: PropTypes.func
};
MdsCallout.defaultProps = {
  variant: "overlay",
  pointerPlacement: 32,
  enterAnnouncement: "popup content start",
  exitAnnouncement: "popup content end",
  visible: true,
  // Events
  onControlPress: null,
  onOpen: null,
  onDismiss: null,
  onClose: null,
  onClick: null
};

var MdsCarousel = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsCarousel, _React$Component);

  var _super = _createSuper(MdsCarousel);

  function MdsCarousel(props) {
    var _this;

    _classCallCheck(this, MdsCarousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onSlideChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onSlideChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onSlideChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onControlPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onControlPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onControlPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChangeSlide", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onChangeSlide) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onChangeSlide(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickNavArrow", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onClickNavArrow) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onClickNavArrow(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onKeydown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseenter) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchstart) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickCta", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onClickCta) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onClickCta(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onFocus) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onClick) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurCta", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onBlurCta) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onBlurCta(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onTouchend) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickNavDot", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onClickNavDot) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onClickNavDot(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusCta", function (event) {
      var _this$props33, _this$props34;

      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onFocusCta) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onFocusCta(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props35, _this$props36;

      ((_this$props35 = _this.props) === null || _this$props35 === void 0 ? void 0 : _this$props35.onKeyup) && ((_this$props36 = _this.props) === null || _this$props36 === void 0 ? void 0 : _this$props36.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props37, _this$props38;

      ((_this$props37 = _this.props) === null || _this$props37 === void 0 ? void 0 : _this$props37.onMouseover) && ((_this$props38 = _this.props) === null || _this$props38 === void 0 ? void 0 : _this$props38.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props39, _this$props40;

      ((_this$props39 = _this.props) === null || _this$props39 === void 0 ? void 0 : _this$props39.onMouseup) && ((_this$props40 = _this.props) === null || _this$props40 === void 0 ? void 0 : _this$props40.onMouseup(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onSlideChange = _this._onSlideChange.bind(_assertThisInitialized(_this));
    _this._onControlPress = _this._onControlPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onChangeSlide = _this._onChangeSlide.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onClickNavArrow = _this._onClickNavArrow.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClickCta = _this._onClickCta.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onBlurCta = _this._onBlurCta.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onClickNavDot = _this._onClickNavDot.bind(_assertThisInitialized(_this));
    _this._onFocusCta = _this._onFocusCta.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("slideChange", this._onSlideChange);

      this._ref.current.addEventListener("controlPress", this._onControlPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("change-slide", this._onChangeSlide);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("click-nav-arrow", this._onClickNavArrow);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click-cta", this._onClickCta);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("blur-cta", this._onBlurCta);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("click-nav-dot", this._onClickNavDot);

      this._ref.current.addEventListener("focus-cta", this._onFocusCta);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseup", this._onMouseup);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("slideChange", this._onSlideChange);

      this._ref.current.removeEventListener("controlPress", this._onControlPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("change-slide", this._onChangeSlide);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("click-nav-arrow", this._onClickNavArrow);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click-cta", this._onClickCta);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("blur-cta", this._onBlurCta);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("click-nav-dot", this._onClickNavDot);

      this._ref.current.removeEventListener("focus-cta", this._onFocusCta);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-carousel", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        slideshow: Array.isArray(this.props.slideshow) || this.props.slideshow === Object(this.props.slideshow) ? JSON.stringify(this.props.slideshow) : this.props.slideshow,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "active-slide-index": Array.isArray(this.props.activeSlideIndex) || this.props.activeSlideIndex === Object(this.props.activeSlideIndex) ? JSON.stringify(this.props.activeSlideIndex) : this.props.activeSlideIndex,
        "accessible-text-carousel-title": Array.isArray(this.props.accessibleTextCarouselTitle) || this.props.accessibleTextCarouselTitle === Object(this.props.accessibleTextCarouselTitle) ? JSON.stringify(this.props.accessibleTextCarouselTitle) : this.props.accessibleTextCarouselTitle,
        "image-height": Array.isArray(this.props.imageHeight) || this.props.imageHeight === Object(this.props.imageHeight) ? JSON.stringify(this.props.imageHeight) : this.props.imageHeight,
        "hero-image-position": Array.isArray(this.props.heroImagePosition) || this.props.heroImagePosition === Object(this.props.heroImagePosition) ? JSON.stringify(this.props.heroImagePosition) : this.props.heroImagePosition,
        "hero-image-width": Array.isArray(this.props.heroImageWidth) || this.props.heroImageWidth === Object(this.props.heroImageWidth) ? JSON.stringify(this.props.heroImageWidth) : this.props.heroImageWidth,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        slides: Array.isArray(this.props.slides) || this.props.slides === Object(this.props.slides) ? JSON.stringify(this.props.slides) : this.props.slides // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsCarousel;
}(React.Component);
MdsCarousel.propTypes = {
  // Values
  slideshow: PropTypes.bool,
  variant: PropTypes.oneOf(["default", "slideshow", "hero"]),
  activeSlideIndex: PropTypes.number,
  accessibleTextCarouselTitle: PropTypes.string,
  imageHeight: PropTypes.number,
  heroImagePosition: PropTypes.oneOf(["left", "right"]),
  heroImageWidth: CustomPropTypes.integer,
  headingLevel: CustomPropTypes.integer,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  slides: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onSlideChange: PropTypes.func,
  onControlPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onBlur: PropTypes.func,
  onChangeSlide: PropTypes.func,
  onMouseout: PropTypes.func,
  onClickNavArrow: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClickCta: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  onBlurCta: PropTypes.func,
  onTouchend: PropTypes.func,
  onClickNavDot: PropTypes.func,
  onFocusCta: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseup: PropTypes.func
};
MdsCarousel.defaultProps = {
  slideshow: false,
  variant: "default",
  heroImagePosition: "left",
  heroImageWidth: 40,
  headingLevel: 2,
  // Events
  onSlideChange: null,
  onControlPress: null,
  onMousedown: null,
  onBlur: null,
  onChangeSlide: null,
  onMouseout: null,
  onClickNavArrow: null,
  onKeydown: null,
  onMouseenter: null,
  onTouchstart: null,
  onClickCta: null,
  onFocus: null,
  onClick: null,
  onBlurCta: null,
  onTouchend: null,
  onClickNavDot: null,
  onFocusCta: null,
  onKeyup: null,
  onMouseover: null,
  onMouseup: null
};

var MdsCheckbox = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsCheckbox, _React$Component);

  var _super = _createSuper(MdsCheckbox);

  function MdsCheckbox(props) {
    var _this;

    _classCallCheck(this, MdsCheckbox);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFocus) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onChange) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeyup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseup) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onClick) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsCheckbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-checkbox", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "secondary-label": Array.isArray(this.props.secondaryLabel) || this.props.secondaryLabel === Object(this.props.secondaryLabel) ? JSON.stringify(this.props.secondaryLabel) : this.props.secondaryLabel,
        "hide-label": Array.isArray(this.props.hideLabel) || this.props.hideLabel === Object(this.props.hideLabel) ? JSON.stringify(this.props.hideLabel) : this.props.hideLabel,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        error: Array.isArray(this.props.error) || this.props.error === Object(this.props.error) ? JSON.stringify(this.props.error) : this.props.error,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "accessible-description": Array.isArray(this.props.accessibleDescription) || this.props.accessibleDescription === Object(this.props.accessibleDescription) ? JSON.stringify(this.props.accessibleDescription) : this.props.accessibleDescription,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        "image-height": Array.isArray(this.props.imageHeight) || this.props.imageHeight === Object(this.props.imageHeight) ? JSON.stringify(this.props.imageHeight) : this.props.imageHeight,
        "image-width": Array.isArray(this.props.imageWidth) || this.props.imageWidth === Object(this.props.imageWidth) ? JSON.stringify(this.props.imageWidth) : this.props.imageWidth,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        "decorator-accessible-text": Array.isArray(this.props.decoratorAccessibleText) || this.props.decoratorAccessibleText === Object(this.props.decoratorAccessibleText) ? JSON.stringify(this.props.decoratorAccessibleText) : this.props.decoratorAccessibleText,
        "remove-bottom-margin": Array.isArray(this.props.removeBottomMargin) || this.props.removeBottomMargin === Object(this.props.removeBottomMargin) ? JSON.stringify(this.props.removeBottomMargin) : this.props.removeBottomMargin,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsCheckbox;
}(React.Component);
MdsCheckbox.propTypes = {
  // Values
  layout: PropTypes.oneOf(["horizontal", "vertical"]),
  label: PropTypes.string,
  secondaryLabel: PropTypes.string,
  hideLabel: PropTypes.bool,
  inactive: PropTypes.bool,
  name: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  accessibleText: PropTypes.string,
  accessibleDescription: PropTypes.string,
  brand: PropTypes.string,
  image: PropTypes.string,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  icon: PropTypes.string,
  decoratorAccessibleText: PropTypes.string,
  removeBottomMargin: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["checked", "focused", "mixed", "disabled", "true", "false"]),
  // Events
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func
};
MdsCheckbox.defaultProps = {
  layout: "horizontal",
  hideLabel: false,
  inactive: false,
  error: false,
  imageHeight: 32,
  imageWidth: 32,
  removeBottomMargin: false,
  // Events
  onFocus: null,
  onChange: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onClick: null
};

var MdsComboButton = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsComboButton, _React$Component);

  var _super = _createSuper(MdsComboButton);

  function MdsComboButton(props) {
    var _this;

    _classCallCheck(this, MdsComboButton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onMousedown) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onTouchend) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeyup) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseover) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseenter) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseup) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchstart) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onFocus) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onClick) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsComboButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-combo-button", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        size: Array.isArray(this.props.size) || this.props.size === Object(this.props.size) ? JSON.stringify(this.props.size) : this.props.size,
        text: Array.isArray(this.props.text) || this.props.text === Object(this.props.text) ? JSON.stringify(this.props.text) : this.props.text,
        "icon-type": Array.isArray(this.props.iconType) || this.props.iconType === Object(this.props.iconType) ? JSON.stringify(this.props.iconType) : this.props.iconType,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        "menu-button-accessible-text": Array.isArray(this.props.menuButtonAccessibleText) || this.props.menuButtonAccessibleText === Object(this.props.menuButtonAccessibleText) ? JSON.stringify(this.props.menuButtonAccessibleText) : this.props.menuButtonAccessibleText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "menu-items": Array.isArray(this.props.menuItems) || this.props.menuItems === Object(this.props.menuItems) ? JSON.stringify(this.props.menuItems) : this.props.menuItems,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsComboButton;
}(React.Component);
MdsComboButton.propTypes = {
  // Values
  variant: PropTypes.oneOf(["primary", "secondary", "tertiary"]),
  size: PropTypes.oneOf(["regular", "small"]),
  text: PropTypes.string,
  iconType: PropTypes.string,
  brand: PropTypes.string,
  inactive: PropTypes.string,
  menuButtonAccessibleText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  menuItems: PropTypes.arrayOf(CustomPropTypes.slot),
  state: PropTypes.oneOf(["disabled"]),
  // Events
  onMousedown: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsComboButton.defaultProps = {
  variant: "primary",
  size: "regular",
  text: "",
  // Events
  onMousedown: null,
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsCommerceTile = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsCommerceTile, _React$Component);

  var _super = _createSuper(MdsCommerceTile);

  function MdsCommerceTile(props) {
    var _this;

    _classCallCheck(this, MdsCommerceTile);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onOpen) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClose) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onFocus) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMousedown) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseover) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseout) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchend) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsCommerceTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-commerce-tile", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "tile-width": Array.isArray(this.props.tileWidth) || this.props.tileWidth === Object(this.props.tileWidth) ? JSON.stringify(this.props.tileWidth) : this.props.tileWidth,
        "content-area-height": Array.isArray(this.props.contentAreaHeight) || this.props.contentAreaHeight === Object(this.props.contentAreaHeight) ? JSON.stringify(this.props.contentAreaHeight) : this.props.contentAreaHeight,
        "image-container-height": Array.isArray(this.props.imageContainerHeight) || this.props.imageContainerHeight === Object(this.props.imageContainerHeight) ? JSON.stringify(this.props.imageContainerHeight) : this.props.imageContainerHeight,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        "image-horizontal-alignment": Array.isArray(this.props.imageHorizontalAlignment) || this.props.imageHorizontalAlignment === Object(this.props.imageHorizontalAlignment) ? JSON.stringify(this.props.imageHorizontalAlignment) : this.props.imageHorizontalAlignment,
        "image-vertical-alignment": Array.isArray(this.props.imageVerticalAlignment) || this.props.imageVerticalAlignment === Object(this.props.imageVerticalAlignment) ? JSON.stringify(this.props.imageVerticalAlignment) : this.props.imageVerticalAlignment,
        "content-size": Array.isArray(this.props.contentSize) || this.props.contentSize === Object(this.props.contentSize) ? JSON.stringify(this.props.contentSize) : this.props.contentSize,
        "title-prominent": Array.isArray(this.props.titleProminent) || this.props.titleProminent === Object(this.props.titleProminent) ? JSON.stringify(this.props.titleProminent) : this.props.titleProminent,
        subtitle: Array.isArray(this.props.subtitle) || this.props.subtitle === Object(this.props.subtitle) ? JSON.stringify(this.props.subtitle) : this.props.subtitle,
        "title-text": Array.isArray(this.props.titleText) || this.props.titleText === Object(this.props.titleText) ? JSON.stringify(this.props.titleText) : this.props.titleText,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        logo: Array.isArray(this.props.logo) || this.props.logo === Object(this.props.logo) ? JSON.stringify(this.props.logo) : this.props.logo,
        "logo-spacing": Array.isArray(this.props.logoSpacing) || this.props.logoSpacing === Object(this.props.logoSpacing) ? JSON.stringify(this.props.logoSpacing) : this.props.logoSpacing,
        "tag-placement": Array.isArray(this.props.tagPlacement) || this.props.tagPlacement === Object(this.props.tagPlacement) ? JSON.stringify(this.props.tagPlacement) : this.props.tagPlacement,
        "gradient-height": Array.isArray(this.props.gradientHeight) || this.props.gradientHeight === Object(this.props.gradientHeight) ? JSON.stringify(this.props.gradientHeight) : this.props.gradientHeight,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "interactive-slot": Array.isArray(this.props.interactiveSlot) || this.props.interactiveSlot === Object(this.props.interactiveSlot) ? JSON.stringify(this.props.interactiveSlot) : this.props.interactiveSlot,
        "tile-accessible-text": Array.isArray(this.props.tileAccessibleText) || this.props.tileAccessibleText === Object(this.props.tileAccessibleText) ? JSON.stringify(this.props.tileAccessibleText) : this.props.tileAccessibleText,
        "logo-accessible-text": Array.isArray(this.props.logoAccessibleText) || this.props.logoAccessibleText === Object(this.props.logoAccessibleText) ? JSON.stringify(this.props.logoAccessibleText) : this.props.logoAccessibleText,
        "image-accessible-text": Array.isArray(this.props.imageAccessibleText) || this.props.imageAccessibleText === Object(this.props.imageAccessibleText) ? JSON.stringify(this.props.imageAccessibleText) : this.props.imageAccessibleText,
        "tag-text": Array.isArray(this.props.tagText) || this.props.tagText === Object(this.props.tagText) ? JSON.stringify(this.props.tagText) : this.props.tagText,
        "tag-color": Array.isArray(this.props.tagColor) || this.props.tagColor === Object(this.props.tagColor) ? JSON.stringify(this.props.tagColor) : this.props.tagColor,
        "tag-icon": Array.isArray(this.props.tagIcon) || this.props.tagIcon === Object(this.props.tagIcon) ? JSON.stringify(this.props.tagIcon) : this.props.tagIcon,
        "tag-accessible-text": Array.isArray(this.props.tagAccessibleText) || this.props.tagAccessibleText === Object(this.props.tagAccessibleText) ? JSON.stringify(this.props.tagAccessibleText) : this.props.tagAccessibleText,
        "title-line-truncation": Array.isArray(this.props.titleLineTruncation) || this.props.titleLineTruncation === Object(this.props.titleLineTruncation) ? JSON.stringify(this.props.titleLineTruncation) : this.props.titleLineTruncation,
        "subtitle-line-truncation": Array.isArray(this.props.subtitleLineTruncation) || this.props.subtitleLineTruncation === Object(this.props.subtitleLineTruncation) ? JSON.stringify(this.props.subtitleLineTruncation) : this.props.subtitleLineTruncation,
        "microcopy-line-truncation": Array.isArray(this.props.microcopyLineTruncation) || this.props.microcopyLineTruncation === Object(this.props.microcopyLineTruncation) ? JSON.stringify(this.props.microcopyLineTruncation) : this.props.microcopyLineTruncation,
        "title-character-truncation": Array.isArray(this.props.titleCharacterTruncation) || this.props.titleCharacterTruncation === Object(this.props.titleCharacterTruncation) ? JSON.stringify(this.props.titleCharacterTruncation) : this.props.titleCharacterTruncation,
        "subtitle-character-truncation": Array.isArray(this.props.subtitleCharacterTruncation) || this.props.subtitleCharacterTruncation === Object(this.props.subtitleCharacterTruncation) ? JSON.stringify(this.props.subtitleCharacterTruncation) : this.props.subtitleCharacterTruncation,
        "microcopy-character-truncation": Array.isArray(this.props.microcopyCharacterTruncation) || this.props.microcopyCharacterTruncation === Object(this.props.microcopyCharacterTruncation) ? JSON.stringify(this.props.microcopyCharacterTruncation) : this.props.microcopyCharacterTruncation,
        "remove-slot-bottom-padding": Array.isArray(this.props.removeSlotBottomPadding) || this.props.removeSlotBottomPadding === Object(this.props.removeSlotBottomPadding) ? JSON.stringify(this.props.removeSlotBottomPadding) : this.props.removeSlotBottomPadding,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        tag: Array.isArray(this.props.tag) || this.props.tag === Object(this.props.tag) ? JSON.stringify(this.props.tag) : this.props.tag // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsCommerceTile;
}(React.Component);
MdsCommerceTile.propTypes = {
  // Values
  variant: PropTypes.oneOf(["regular", "inverse"]),
  tileWidth: CustomPropTypes.integer,
  contentAreaHeight: PropTypes.number,
  imageContainerHeight: PropTypes.number,
  image: PropTypes.string,
  imageHorizontalAlignment: PropTypes.oneOf(["left", "center", "right"]),
  imageVerticalAlignment: PropTypes.oneOf(["top", "center", "bottom"]),
  contentSize: PropTypes.oneOf(["large", "medium", "small"]),
  titleProminent: PropTypes.bool,
  subtitle: PropTypes.string,
  titleText: PropTypes.string,
  microcopy: PropTypes.string,
  logo: PropTypes.string,
  logoSpacing: PropTypes.oneOf(["relaxed", "condensed"]),
  tagPlacement: PropTypes.oneOf(["top", "middle"]),
  gradientHeight: PropTypes.oneOf(["fill", "fixed"]),
  slot: PropTypes.string,
  interactiveSlot: PropTypes.bool,
  tileAccessibleText: PropTypes.string,
  logoAccessibleText: PropTypes.string,
  imageAccessibleText: PropTypes.string,
  tagText: PropTypes.string,
  tagColor: PropTypes.oneOf(["base", "accent"]),
  tagIcon: PropTypes.string,
  tagAccessibleText: PropTypes.string,
  titleLineTruncation: CustomPropTypes.integer,
  subtitleLineTruncation: CustomPropTypes.integer,
  microcopyLineTruncation: CustomPropTypes.integer,
  titleCharacterTruncation: CustomPropTypes.integer,
  subtitleCharacterTruncation: CustomPropTypes.integer,
  microcopyCharacterTruncation: CustomPropTypes.integer,
  removeSlotBottomPadding: PropTypes.bool,
  id: PropTypes.string,
  tag: CustomPropTypes.slot,
  // Events
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsCommerceTile.defaultProps = {
  variant: "regular",
  imageHorizontalAlignment: "center",
  imageVerticalAlignment: "center",
  contentSize: "small",
  titleProminent: true,
  logoSpacing: "condensed",
  tagPlacement: "top",
  gradientHeight: "fill",
  interactiveSlot: false,
  tagColor: "base",
  removeSlotBottomPadding: false,
  // Events
  onOpen: null,
  onClose: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsDateBadge = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDateBadge, _React$Component);

  var _super = _createSuper(MdsDateBadge);

  function MdsDateBadge(props) {
    var _this;

    _classCallCheck(this, MdsDateBadge);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onTouchstart) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onTouchend) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDateBadge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-date-badge", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        month: Array.isArray(this.props.month) || this.props.month === Object(this.props.month) ? JSON.stringify(this.props.month) : this.props.month,
        day: Array.isArray(this.props.day) || this.props.day === Object(this.props.day) ? JSON.stringify(this.props.day) : this.props.day,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        level: Array.isArray(this.props.level) || this.props.level === Object(this.props.level) ? JSON.stringify(this.props.level) : this.props.level,
        "status-label": Array.isArray(this.props.statusLabel) || this.props.statusLabel === Object(this.props.statusLabel) ? JSON.stringify(this.props.statusLabel) : this.props.statusLabel,
        "month-format": Array.isArray(this.props.monthFormat) || this.props.monthFormat === Object(this.props.monthFormat) ? JSON.stringify(this.props.monthFormat) : this.props.monthFormat,
        "accessible-icon-text": Array.isArray(this.props.accessibleIconText) || this.props.accessibleIconText === Object(this.props.accessibleIconText) ? JSON.stringify(this.props.accessibleIconText) : this.props.accessibleIconText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDateBadge;
}(React.Component);
MdsDateBadge.propTypes = {
  // Values
  month: CustomPropTypes.integer,
  day: CustomPropTypes.integer,
  layout: PropTypes.oneOf(["horizontal", "vertical"]),
  level: PropTypes.oneOf(["error", "soft", "success", "informational"]),
  statusLabel: PropTypes.string,
  monthFormat: PropTypes.oneOf(["short", "full"]),
  accessibleIconText: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsDateBadge.defaultProps = {
  month: 1,
  day: 1,
  layout: "vertical",
  level: "informational",
  monthFormat: "short",
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsDatepicker = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDatepicker, _React$Component);

  var _super = _createSuper(MdsDatepicker);

  function MdsDatepicker(props) {
    var _this;

    _classCallCheck(this, MdsDatepicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFocus) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onChange) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClose) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onValidate", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onValidate) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onValidate(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onOpen) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onDateClick", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onDateClick) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onDateClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onBlur) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onBlur(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onValidate = _this._onValidate.bind(_assertThisInitialized(_this));
    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onDateClick = _this._onDateClick.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDatepicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("validate", this._onValidate);

      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("date-click", this._onDateClick);

      this._ref.current.addEventListener("blur", this._onBlur);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("validate", this._onValidate);

      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("date-click", this._onDateClick);

      this._ref.current.removeEventListener("blur", this._onBlur);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-datepicker", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-text-this-month-button-available": Array.isArray(this.props.accessibleTextThisMonthButtonAvailable) || this.props.accessibleTextThisMonthButtonAvailable === Object(this.props.accessibleTextThisMonthButtonAvailable) ? JSON.stringify(this.props.accessibleTextThisMonthButtonAvailable) : this.props.accessibleTextThisMonthButtonAvailable,
        "accessible-text-this-month-button-unavailable": Array.isArray(this.props.accessibleTextThisMonthButtonUnavailable) || this.props.accessibleTextThisMonthButtonUnavailable === Object(this.props.accessibleTextThisMonthButtonUnavailable) ? JSON.stringify(this.props.accessibleTextThisMonthButtonUnavailable) : this.props.accessibleTextThisMonthButtonUnavailable,
        "accessible-text-today-button-available": Array.isArray(this.props.accessibleTextTodayButtonAvailable) || this.props.accessibleTextTodayButtonAvailable === Object(this.props.accessibleTextTodayButtonAvailable) ? JSON.stringify(this.props.accessibleTextTodayButtonAvailable) : this.props.accessibleTextTodayButtonAvailable,
        "accessible-text-today-button-unavailable": Array.isArray(this.props.accessibleTextTodayButtonUnavailable) || this.props.accessibleTextTodayButtonUnavailable === Object(this.props.accessibleTextTodayButtonUnavailable) ? JSON.stringify(this.props.accessibleTextTodayButtonUnavailable) : this.props.accessibleTextTodayButtonUnavailable,
        "accessible-text-unavailable-date": Array.isArray(this.props.accessibleTextUnavailableDate) || this.props.accessibleTextUnavailableDate === Object(this.props.accessibleTextUnavailableDate) ? JSON.stringify(this.props.accessibleTextUnavailableDate) : this.props.accessibleTextUnavailableDate,
        "accessible-text-due-date": Array.isArray(this.props.accessibleTextDueDate) || this.props.accessibleTextDueDate === Object(this.props.accessibleTextDueDate) ? JSON.stringify(this.props.accessibleTextDueDate) : this.props.accessibleTextDueDate,
        "accessible-text-today-date": Array.isArray(this.props.accessibleTextTodayDate) || this.props.accessibleTextTodayDate === Object(this.props.accessibleTextTodayDate) ? JSON.stringify(this.props.accessibleTextTodayDate) : this.props.accessibleTextTodayDate,
        "accessible-text-current-month": Array.isArray(this.props.accessibleTextCurrentMonth) || this.props.accessibleTextCurrentMonth === Object(this.props.accessibleTextCurrentMonth) ? JSON.stringify(this.props.accessibleTextCurrentMonth) : this.props.accessibleTextCurrentMonth,
        "accessible-text-next-day": Array.isArray(this.props.accessibleTextNextDay) || this.props.accessibleTextNextDay === Object(this.props.accessibleTextNextDay) ? JSON.stringify(this.props.accessibleTextNextDay) : this.props.accessibleTextNextDay,
        "accessible-text-next-month": Array.isArray(this.props.accessibleTextNextMonth) || this.props.accessibleTextNextMonth === Object(this.props.accessibleTextNextMonth) ? JSON.stringify(this.props.accessibleTextNextMonth) : this.props.accessibleTextNextMonth,
        "accessible-text-next-year": Array.isArray(this.props.accessibleTextNextYear) || this.props.accessibleTextNextYear === Object(this.props.accessibleTextNextYear) ? JSON.stringify(this.props.accessibleTextNextYear) : this.props.accessibleTextNextYear,
        "accessible-text-next-ten-year": Array.isArray(this.props.accessibleTextNextTenYear) || this.props.accessibleTextNextTenYear === Object(this.props.accessibleTextNextTenYear) ? JSON.stringify(this.props.accessibleTextNextTenYear) : this.props.accessibleTextNextTenYear,
        "accessible-text-no-text": Array.isArray(this.props.accessibleTextNoText) || this.props.accessibleTextNoText === Object(this.props.accessibleTextNoText) ? JSON.stringify(this.props.accessibleTextNoText) : this.props.accessibleTextNoText,
        "accessible-text-role-description": Array.isArray(this.props.accessibleTextRoleDescription) || this.props.accessibleTextRoleDescription === Object(this.props.accessibleTextRoleDescription) ? JSON.stringify(this.props.accessibleTextRoleDescription) : this.props.accessibleTextRoleDescription,
        "accessible-text-previous-day": Array.isArray(this.props.accessibleTextPreviousDay) || this.props.accessibleTextPreviousDay === Object(this.props.accessibleTextPreviousDay) ? JSON.stringify(this.props.accessibleTextPreviousDay) : this.props.accessibleTextPreviousDay,
        "accessible-text-previous-month": Array.isArray(this.props.accessibleTextPreviousMonth) || this.props.accessibleTextPreviousMonth === Object(this.props.accessibleTextPreviousMonth) ? JSON.stringify(this.props.accessibleTextPreviousMonth) : this.props.accessibleTextPreviousMonth,
        "accessible-text-previous-year": Array.isArray(this.props.accessibleTextPreviousYear) || this.props.accessibleTextPreviousYear === Object(this.props.accessibleTextPreviousYear) ? JSON.stringify(this.props.accessibleTextPreviousYear) : this.props.accessibleTextPreviousYear,
        "accessible-text-previous-ten-year": Array.isArray(this.props.accessibleTextPreviousTenYear) || this.props.accessibleTextPreviousTenYear === Object(this.props.accessibleTextPreviousTenYear) ? JSON.stringify(this.props.accessibleTextPreviousTenYear) : this.props.accessibleTextPreviousTenYear,
        "accessible-text-selected-date": Array.isArray(this.props.accessibleTextSelectedDate) || this.props.accessibleTextSelectedDate === Object(this.props.accessibleTextSelectedDate) ? JSON.stringify(this.props.accessibleTextSelectedDate) : this.props.accessibleTextSelectedDate,
        "accessible-text-icon-open": Array.isArray(this.props.accessibleTextIconOpen) || this.props.accessibleTextIconOpen === Object(this.props.accessibleTextIconOpen) ? JSON.stringify(this.props.accessibleTextIconOpen) : this.props.accessibleTextIconOpen,
        "accessible-text-icon-close": Array.isArray(this.props.accessibleTextIconClose) || this.props.accessibleTextIconClose === Object(this.props.accessibleTextIconClose) ? JSON.stringify(this.props.accessibleTextIconClose) : this.props.accessibleTextIconClose,
        "blackout-dates": Array.isArray(this.props.blackoutDates) || this.props.blackoutDates === Object(this.props.blackoutDates) ? JSON.stringify(this.props.blackoutDates) : this.props.blackoutDates,
        "block-dates": Array.isArray(this.props.blockDates) || this.props.blockDates === Object(this.props.blockDates) ? JSON.stringify(this.props.blockDates) : this.props.blockDates,
        "whiteout-dates": Array.isArray(this.props.whiteoutDates) || this.props.whiteoutDates === Object(this.props.whiteoutDates) ? JSON.stringify(this.props.whiteoutDates) : this.props.whiteoutDates,
        "allow-dates": Array.isArray(this.props.allowDates) || this.props.allowDates === Object(this.props.allowDates) ? JSON.stringify(this.props.allowDates) : this.props.allowDates,
        "min-date": Array.isArray(this.props.minDate) || this.props.minDate === Object(this.props.minDate) ? JSON.stringify(this.props.minDate) : this.props.minDate,
        "max-date": Array.isArray(this.props.maxDate) || this.props.maxDate === Object(this.props.maxDate) ? JSON.stringify(this.props.maxDate) : this.props.maxDate,
        "due-date": Array.isArray(this.props.dueDate) || this.props.dueDate === Object(this.props.dueDate) ? JSON.stringify(this.props.dueDate) : this.props.dueDate,
        "due-label": Array.isArray(this.props.dueLabel) || this.props.dueLabel === Object(this.props.dueLabel) ? JSON.stringify(this.props.dueLabel) : this.props.dueLabel,
        "today-label": Array.isArray(this.props.todayLabel) || this.props.todayLabel === Object(this.props.todayLabel) ? JSON.stringify(this.props.todayLabel) : this.props.todayLabel,
        "month-label": Array.isArray(this.props.monthLabel) || this.props.monthLabel === Object(this.props.monthLabel) ? JSON.stringify(this.props.monthLabel) : this.props.monthLabel,
        "exclude-weekends": Array.isArray(this.props.excludeWeekends) || this.props.excludeWeekends === Object(this.props.excludeWeekends) ? JSON.stringify(this.props.excludeWeekends) : this.props.excludeWeekends,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "label-style": Array.isArray(this.props.labelStyle) || this.props.labelStyle === Object(this.props.labelStyle) ? JSON.stringify(this.props.labelStyle) : this.props.labelStyle,
        placeholder: Array.isArray(this.props.placeholder) || this.props.placeholder === Object(this.props.placeholder) ? JSON.stringify(this.props.placeholder) : this.props.placeholder,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "calendar-type": Array.isArray(this.props.calendarType) || this.props.calendarType === Object(this.props.calendarType) ? JSON.stringify(this.props.calendarType) : this.props.calendarType,
        "selected-date": Array.isArray(this.props.selectedDate) || this.props.selectedDate === Object(this.props.selectedDate) ? JSON.stringify(this.props.selectedDate) : this.props.selectedDate,
        "selected-month": Array.isArray(this.props.selectedMonth) || this.props.selectedMonth === Object(this.props.selectedMonth) ? JSON.stringify(this.props.selectedMonth) : this.props.selectedMonth,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        "today-button-text": Array.isArray(this.props.todayButtonText) || this.props.todayButtonText === Object(this.props.todayButtonText) ? JSON.stringify(this.props.todayButtonText) : this.props.todayButtonText,
        "cancel-button-text": Array.isArray(this.props.cancelButtonText) || this.props.cancelButtonText === Object(this.props.cancelButtonText) ? JSON.stringify(this.props.cancelButtonText) : this.props.cancelButtonText,
        "month-button-text": Array.isArray(this.props.monthButtonText) || this.props.monthButtonText === Object(this.props.monthButtonText) ? JSON.stringify(this.props.monthButtonText) : this.props.monthButtonText,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        "error-message": Array.isArray(this.props.errorMessage) || this.props.errorMessage === Object(this.props.errorMessage) ? JSON.stringify(this.props.errorMessage) : this.props.errorMessage,
        "error-messages": Array.isArray(this.props.errorMessages) || this.props.errorMessages === Object(this.props.errorMessages) ? JSON.stringify(this.props.errorMessages) : this.props.errorMessages,
        "autocomplete-value": Array.isArray(this.props.autocompleteValue) || this.props.autocompleteValue === Object(this.props.autocompleteValue) ? JSON.stringify(this.props.autocompleteValue) : this.props.autocompleteValue,
        "disable-edge-detection": Array.isArray(this.props.disableEdgeDetection) || this.props.disableEdgeDetection === Object(this.props.disableEdgeDetection) ? JSON.stringify(this.props.disableEdgeDetection) : this.props.disableEdgeDetection,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "date-messages": Array.isArray(this.props.dateMessages) || this.props.dateMessages === Object(this.props.dateMessages) ? JSON.stringify(this.props.dateMessages) : this.props.dateMessages,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDatepicker;
}(React.Component);
MdsDatepicker.propTypes = {
  // Values
  accessibleTextThisMonthButtonAvailable: PropTypes.string,
  accessibleTextThisMonthButtonUnavailable: PropTypes.string,
  accessibleTextTodayButtonAvailable: PropTypes.string,
  accessibleTextTodayButtonUnavailable: PropTypes.string,
  accessibleTextUnavailableDate: PropTypes.string,
  accessibleTextDueDate: PropTypes.string,
  accessibleTextTodayDate: PropTypes.string,
  accessibleTextCurrentMonth: PropTypes.string,
  accessibleTextNextDay: PropTypes.string,
  accessibleTextNextMonth: PropTypes.string,
  accessibleTextNextYear: PropTypes.string,
  accessibleTextNextTenYear: PropTypes.string,
  accessibleTextNoText: PropTypes.string,
  accessibleTextRoleDescription: PropTypes.string,
  accessibleTextPreviousDay: PropTypes.string,
  accessibleTextPreviousMonth: PropTypes.string,
  accessibleTextPreviousYear: PropTypes.string,
  accessibleTextPreviousTenYear: PropTypes.string,
  accessibleTextSelectedDate: PropTypes.string,
  accessibleTextIconOpen: PropTypes.string,
  accessibleTextIconClose: PropTypes.string,
  blackoutDates: PropTypes.array,
  blockDates: PropTypes.array,
  whiteoutDates: PropTypes.array,
  allowDates: PropTypes.array,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  dueDate: PropTypes.string,
  dueLabel: PropTypes.string,
  todayLabel: PropTypes.string,
  monthLabel: PropTypes.string,
  excludeWeekends: PropTypes.bool,
  label: PropTypes.string,
  labelStyle: PropTypes.oneOf(["horizontal", "vertical"]),
  placeholder: PropTypes.string,
  variant: PropTypes.oneOf(["box", "line"]),
  calendarType: PropTypes.oneOf(["date", "month"]),
  selectedDate: PropTypes.string,
  selectedMonth: PropTypes.string,
  value: PropTypes.string,
  microcopy: PropTypes.string,
  todayButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  monthButtonText: PropTypes.string,
  inactive: PropTypes.bool,
  errorMessage: PropTypes.string,
  errorMessages: PropTypes.array,
  autocompleteValue: PropTypes.string,
  disableEdgeDetection: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  dateMessages: PropTypes.arrayOf(CustomPropTypes.slot),
  state: PropTypes.oneOf(["hovered", "pressed", "disabled", "selected"]),
  // Events
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onValidate: PropTypes.func,
  onOpen: PropTypes.func,
  onDateClick: PropTypes.func,
  onBlur: PropTypes.func
};
MdsDatepicker.defaultProps = {
  excludeWeekends: false,
  labelStyle: "vertical",
  variant: "box",
  calendarType: "date",
  inactive: false,
  autocompleteValue: "off",
  disableEdgeDetection: false,
  // Events
  onFocus: null,
  onChange: null,
  onClose: null,
  onValidate: null,
  onOpen: null,
  onDateClick: null,
  onBlur: null
};

var MdsDefinitionLink = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDefinitionLink, _React$Component);

  var _super = _createSuper(MdsDefinitionLink);

  function MdsDefinitionLink(props) {
    var _this;

    _classCallCheck(this, MdsDefinitionLink);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onDefinitionOpen", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onDefinitionOpen) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onDefinitionOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onDefinitionClose", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onDefinitionClose) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onDefinitionClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onTouchend) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseup) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeyup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseover) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onFocus) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onClick) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onDefinitionOpen = _this._onDefinitionOpen.bind(_assertThisInitialized(_this));
    _this._onDefinitionClose = _this._onDefinitionClose.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDefinitionLink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("definitionOpen", this._onDefinitionOpen);

      this._ref.current.addEventListener("definitionClose", this._onDefinitionClose);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("definitionOpen", this._onDefinitionOpen);

      this._ref.current.removeEventListener("definitionClose", this._onDefinitionClose);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-definition-link", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "definition-text": Array.isArray(this.props.definitionText) || this.props.definitionText === Object(this.props.definitionText) ? JSON.stringify(this.props.definitionText) : this.props.definitionText,
        "edge-detection": Array.isArray(this.props.edgeDetection) || this.props.edgeDetection === Object(this.props.edgeDetection) ? JSON.stringify(this.props.edgeDetection) : this.props.edgeDetection,
        "edge-detection-container-id": Array.isArray(this.props.edgeDetectionContainerId) || this.props.edgeDetectionContainerId === Object(this.props.edgeDetectionContainerId) ? JSON.stringify(this.props.edgeDetectionContainerId) : this.props.edgeDetectionContainerId,
        "start-icon": Array.isArray(this.props.startIcon) || this.props.startIcon === Object(this.props.startIcon) ? JSON.stringify(this.props.startIcon) : this.props.startIcon,
        "end-icon": Array.isArray(this.props.endIcon) || this.props.endIcon === Object(this.props.endIcon) ? JSON.stringify(this.props.endIcon) : this.props.endIcon,
        "tooltip-alignment": Array.isArray(this.props.tooltipAlignment) || this.props.tooltipAlignment === Object(this.props.tooltipAlignment) ? JSON.stringify(this.props.tooltipAlignment) : this.props.tooltipAlignment,
        "tooltip-pointer-placement": Array.isArray(this.props.tooltipPointerPlacement) || this.props.tooltipPointerPlacement === Object(this.props.tooltipPointerPlacement) ? JSON.stringify(this.props.tooltipPointerPlacement) : this.props.tooltipPointerPlacement,
        "tooltip-placement": Array.isArray(this.props.tooltipPlacement) || this.props.tooltipPlacement === Object(this.props.tooltipPlacement) ? JSON.stringify(this.props.tooltipPlacement) : this.props.tooltipPlacement,
        "tooltip-message": Array.isArray(this.props.tooltipMessage) || this.props.tooltipMessage === Object(this.props.tooltipMessage) ? JSON.stringify(this.props.tooltipMessage) : this.props.tooltipMessage,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        text: Array.isArray(this.props.text) || this.props.text === Object(this.props.text) ? JSON.stringify(this.props.text) : this.props.text,
        href: Array.isArray(this.props.href) || this.props.href === Object(this.props.href) ? JSON.stringify(this.props.href) : this.props.href,
        alignment: Array.isArray(this.props.alignment) || this.props.alignment === Object(this.props.alignment) ? JSON.stringify(this.props.alignment) : this.props.alignment,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "is-button": Array.isArray(this.props.isButton) || this.props.isButton === Object(this.props.isButton) ? JSON.stringify(this.props.isButton) : this.props.isButton,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDefinitionLink;
}(React.Component);
MdsDefinitionLink.propTypes = {
  // Values
  definitionText: PropTypes.string,
  edgeDetection: PropTypes.bool,
  edgeDetectionContainerId: PropTypes.oneOf(["above", "below"]),
  startIcon: PropTypes.string,
  endIcon: PropTypes.string,
  tooltipAlignment: PropTypes.oneOf(["left", "right", "center"]),
  tooltipPointerPlacement: PropTypes.number,
  tooltipPlacement: PropTypes.oneOf(["above", "below"]),
  tooltipMessage: PropTypes.string,
  brand: PropTypes.string,
  text: PropTypes.string,
  href: PropTypes.string,
  alignment: PropTypes.string,
  accessibleText: PropTypes.string,
  isButton: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "pressed", "hovered"]),
  // Events
  onDefinitionOpen: PropTypes.func,
  onDefinitionClose: PropTypes.func,
  onMousedown: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseup: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsDefinitionLink.defaultProps = {
  edgeDetection: false,
  edgeDetectionContainerId: "below",
  tooltipAlignment: "left",
  tooltipPointerPlacement: 8,
  tooltipPlacement: "below",
  // Events
  onDefinitionOpen: null,
  onDefinitionClose: null,
  onMousedown: null,
  onTouchend: null,
  onBlur: null,
  onMouseup: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsDescriptionList = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDescriptionList, _React$Component);

  var _super = _createSuper(MdsDescriptionList);

  function MdsDescriptionList(props) {
    var _this;

    _classCallCheck(this, MdsDescriptionList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickMaskingButton", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClickMaskingButton) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClickMaskingButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onFocus) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMousedown) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseover) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseout) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchend) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onClickMaskingButton = _this._onClickMaskingButton.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDescriptionList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("click-masking-button", this._onClickMaskingButton);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("click-masking-button", this._onClickMaskingButton);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-description-list", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "item-layout": Array.isArray(this.props.itemLayout) || this.props.itemLayout === Object(this.props.itemLayout) ? JSON.stringify(this.props.itemLayout) : this.props.itemLayout,
        "bold-description-all": Array.isArray(this.props.boldDescriptionAll) || this.props.boldDescriptionAll === Object(this.props.boldDescriptionAll) ? JSON.stringify(this.props.boldDescriptionAll) : this.props.boldDescriptionAll,
        "bold-term-all": Array.isArray(this.props.boldTermAll) || this.props.boldTermAll === Object(this.props.boldTermAll) ? JSON.stringify(this.props.boldTermAll) : this.props.boldTermAll,
        "horizontal-rule-all": Array.isArray(this.props.horizontalRuleAll) || this.props.horizontalRuleAll === Object(this.props.horizontalRuleAll) ? JSON.stringify(this.props.horizontalRuleAll) : this.props.horizontalRuleAll,
        mode: Array.isArray(this.props.mode) || this.props.mode === Object(this.props.mode) ? JSON.stringify(this.props.mode) : this.props.mode,
        "term-width": Array.isArray(this.props.termWidth) || this.props.termWidth === Object(this.props.termWidth) ? JSON.stringify(this.props.termWidth) : this.props.termWidth,
        "description-width": Array.isArray(this.props.descriptionWidth) || this.props.descriptionWidth === Object(this.props.descriptionWidth) ? JSON.stringify(this.props.descriptionWidth) : this.props.descriptionWidth,
        "description-alignment": Array.isArray(this.props.descriptionAlignment) || this.props.descriptionAlignment === Object(this.props.descriptionAlignment) ? JSON.stringify(this.props.descriptionAlignment) : this.props.descriptionAlignment,
        "accessible-single-value-negative": Array.isArray(this.props.accessibleSingleValueNegative) || this.props.accessibleSingleValueNegative === Object(this.props.accessibleSingleValueNegative) ? JSON.stringify(this.props.accessibleSingleValueNegative) : this.props.accessibleSingleValueNegative,
        "accessible-single-value-empty": Array.isArray(this.props.accessibleSingleValueEmpty) || this.props.accessibleSingleValueEmpty === Object(this.props.accessibleSingleValueEmpty) ? JSON.stringify(this.props.accessibleSingleValueEmpty) : this.props.accessibleSingleValueEmpty,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        items: Array.isArray(this.props.items) || this.props.items === Object(this.props.items) ? JSON.stringify(this.props.items) : this.props.items // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDescriptionList;
}(React.Component);
MdsDescriptionList.propTypes = {
  // Values
  itemLayout: PropTypes.oneOf(["horizontal", "vertical"]),
  boldDescriptionAll: PropTypes.bool,
  boldTermAll: PropTypes.bool,
  horizontalRuleAll: PropTypes.bool,
  mode: PropTypes.oneOf(["compact", "relaxed"]),
  termWidth: PropTypes.number,
  descriptionWidth: PropTypes.number,
  descriptionAlignment: PropTypes.oneOf(["left", "right"]),
  accessibleSingleValueNegative: PropTypes.string,
  accessibleSingleValueEmpty: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  items: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onClick: PropTypes.func,
  onClickMaskingButton: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsDescriptionList.defaultProps = {
  itemLayout: "horizontal",
  mode: "relaxed",
  termWidth: 50,
  descriptionWidth: 50,
  descriptionAlignment: "left",
  accessibleSingleValueNegative: "negative",
  accessibleSingleValueEmpty: "blank",
  // Events
  onClick: null,
  onClickMaskingButton: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDialog, _React$Component);

  var _super = _createSuper(MdsDialog);

  function MdsDialog(props) {
    var _this;

    _classCallCheck(this, MdsDialog);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onOpen) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClose) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onPrimaryButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onPrimaryButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onPrimaryButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSecondaryButtonPress", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onSecondaryButtonPress) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onSecondaryButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTertiaryButtonPress", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onTertiaryButtonPress) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onTertiaryButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickButton3", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onClickButton3) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onClickButton3(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickButton2", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onClickButton2) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onClickButton2(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickButton1", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onClickButton1) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onClickButton1(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onPrimaryButtonPress = _this._onPrimaryButtonPress.bind(_assertThisInitialized(_this));
    _this._onSecondaryButtonPress = _this._onSecondaryButtonPress.bind(_assertThisInitialized(_this));
    _this._onTertiaryButtonPress = _this._onTertiaryButtonPress.bind(_assertThisInitialized(_this));
    _this._onClickButton3 = _this._onClickButton3.bind(_assertThisInitialized(_this));
    _this._onClickButton2 = _this._onClickButton2.bind(_assertThisInitialized(_this));
    _this._onClickButton1 = _this._onClickButton1.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("primaryButtonPress", this._onPrimaryButtonPress);

      this._ref.current.addEventListener("secondaryButtonPress", this._onSecondaryButtonPress);

      this._ref.current.addEventListener("tertiaryButtonPress", this._onTertiaryButtonPress);

      this._ref.current.addEventListener("click-button3", this._onClickButton3);

      this._ref.current.addEventListener("click-button2", this._onClickButton2);

      this._ref.current.addEventListener("click-button1", this._onClickButton1); // Imperative Actions

    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("primaryButtonPress", this._onPrimaryButtonPress);

      this._ref.current.removeEventListener("secondaryButtonPress", this._onSecondaryButtonPress);

      this._ref.current.removeEventListener("tertiaryButtonPress", this._onTertiaryButtonPress);

      this._ref.current.removeEventListener("click-button3", this._onClickButton3);

      this._ref.current.removeEventListener("click-button2", this._onClickButton2);

      this._ref.current.removeEventListener("click-button1", this._onClickButton1);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
      // Imperative Actions
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-dialog", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        width: Array.isArray(this.props.width) || this.props.width === Object(this.props.width) ? JSON.stringify(this.props.width) : this.props.width,
        height: Array.isArray(this.props.height) || this.props.height === Object(this.props.height) ? JSON.stringify(this.props.height) : this.props.height,
        "height-type": Array.isArray(this.props.heightType) || this.props.heightType === Object(this.props.heightType) ? JSON.stringify(this.props.heightType) : this.props.heightType,
        "header-text": Array.isArray(this.props.headerText) || this.props.headerText === Object(this.props.headerText) ? JSON.stringify(this.props.headerText) : this.props.headerText,
        "content-horizontal-padding": Array.isArray(this.props.contentHorizontalPadding) || this.props.contentHorizontalPadding === Object(this.props.contentHorizontalPadding) ? JSON.stringify(this.props.contentHorizontalPadding) : this.props.contentHorizontalPadding,
        "primary-button-text": Array.isArray(this.props.primaryButtonText) || this.props.primaryButtonText === Object(this.props.primaryButtonText) ? JSON.stringify(this.props.primaryButtonText) : this.props.primaryButtonText,
        "secondary-button-one-text": Array.isArray(this.props.secondaryButtonOneText) || this.props.secondaryButtonOneText === Object(this.props.secondaryButtonOneText) ? JSON.stringify(this.props.secondaryButtonOneText) : this.props.secondaryButtonOneText,
        "secondary-button-two-text": Array.isArray(this.props.secondaryButtonTwoText) || this.props.secondaryButtonTwoText === Object(this.props.secondaryButtonTwoText) ? JSON.stringify(this.props.secondaryButtonTwoText) : this.props.secondaryButtonTwoText,
        "dialog-content": Array.isArray(this.props.dialogContent) || this.props.dialogContent === Object(this.props.dialogContent) ? JSON.stringify(this.props.dialogContent) : this.props.dialogContent,
        "dialog-footer-text": Array.isArray(this.props.dialogFooterText) || this.props.dialogFooterText === Object(this.props.dialogFooterText) ? JSON.stringify(this.props.dialogFooterText) : this.props.dialogFooterText,
        "dialog-header-icon-name": Array.isArray(this.props.dialogHeaderIconName) || this.props.dialogHeaderIconName === Object(this.props.dialogHeaderIconName) ? JSON.stringify(this.props.dialogHeaderIconName) : this.props.dialogHeaderIconName,
        "dialog-header-icon-accessible-name": Array.isArray(this.props.dialogHeaderIconAccessibleName) || this.props.dialogHeaderIconAccessibleName === Object(this.props.dialogHeaderIconAccessibleName) ? JSON.stringify(this.props.dialogHeaderIconAccessibleName) : this.props.dialogHeaderIconAccessibleName,
        "close-on-overlay-click": Array.isArray(this.props.closeOnOverlayClick) || this.props.closeOnOverlayClick === Object(this.props.closeOnOverlayClick) ? JSON.stringify(this.props.closeOnOverlayClick) : this.props.closeOnOverlayClick,
        "button-orientation": Array.isArray(this.props.buttonOrientation) || this.props.buttonOrientation === Object(this.props.buttonOrientation) ? JSON.stringify(this.props.buttonOrientation) : this.props.buttonOrientation,
        "hide-header": Array.isArray(this.props.hideHeader) || this.props.hideHeader === Object(this.props.hideHeader) ? JSON.stringify(this.props.hideHeader) : this.props.hideHeader,
        "secondary-button-text": Array.isArray(this.props.secondaryButtonText) || this.props.secondaryButtonText === Object(this.props.secondaryButtonText) ? JSON.stringify(this.props.secondaryButtonText) : this.props.secondaryButtonText,
        open: Array.isArray(this.props.open) || this.props.open === Object(this.props.open) ? JSON.stringify(this.props.open) : this.props.open,
        "dialog-width": Array.isArray(this.props.dialogWidth) || this.props.dialogWidth === Object(this.props.dialogWidth) ? JSON.stringify(this.props.dialogWidth) : this.props.dialogWidth,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        "tertiary-button-text": Array.isArray(this.props.tertiaryButtonText) || this.props.tertiaryButtonText === Object(this.props.tertiaryButtonText) ? JSON.stringify(this.props.tertiaryButtonText) : this.props.tertiaryButtonText,
        "dialog-height": Array.isArray(this.props.dialogHeight) || this.props.dialogHeight === Object(this.props.dialogHeight) ? JSON.stringify(this.props.dialogHeight) : this.props.dialogHeight,
        "trigger-id": Array.isArray(this.props.triggerId) || this.props.triggerId === Object(this.props.triggerId) ? JSON.stringify(this.props.triggerId) : this.props.triggerId,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDialog;
}(React.Component);
MdsDialog.propTypes = {
  // Values
  width: PropTypes.number,
  height: PropTypes.number,
  heightType: PropTypes.oneOf(["contentFit", "absolute"]),
  headerText: PropTypes.string,
  contentHorizontalPadding: CustomPropTypes.integer,
  primaryButtonText: PropTypes.string,
  secondaryButtonOneText: PropTypes.string,
  secondaryButtonTwoText: PropTypes.string,
  dialogContent: PropTypes.string,
  dialogFooterText: PropTypes.string,
  dialogHeaderIconName: PropTypes.string,
  dialogHeaderIconAccessibleName: PropTypes.string,
  closeOnOverlayClick: PropTypes.bool,
  buttonOrientation: PropTypes.oneOf(["vertical", "horizontal"]),
  hideHeader: PropTypes.bool,
  secondaryButtonText: PropTypes.string,
  open: PropTypes.bool,
  dialogWidth: CustomPropTypes.integer,
  headingLevel: PropTypes.number,
  tertiaryButtonText: PropTypes.string,
  dialogHeight: CustomPropTypes.integer,
  triggerId: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onPrimaryButtonPress: PropTypes.func,
  onSecondaryButtonPress: PropTypes.func,
  onTertiaryButtonPress: PropTypes.func,
  onClickButton3: PropTypes.func,
  onClickButton2: PropTypes.func,
  onClickButton1: PropTypes.func
};
MdsDialog.defaultProps = {
  heightType: "absolute",
  contentHorizontalPadding: 16,
  closeOnOverlayClick: false,
  buttonOrientation: "vertical",
  hideHeader: false,
  open: false,
  headingLevel: 2,
  // Events
  onOpen: null,
  onClose: null,
  onPrimaryButtonPress: null,
  onSecondaryButtonPress: null,
  onTertiaryButtonPress: null,
  onClickButton3: null,
  onClickButton2: null,
  onClickButton1: null
};

var MdsDocumentViewer = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDocumentViewer, _React$Component);

  var _super = _createSuper(MdsDocumentViewer);

  function MdsDocumentViewer(props) {
    var _this;

    _classCallCheck(this, MdsDocumentViewer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickActionButton", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClickActionButton) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClickActionButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickTab", function (event) {
      var _event$detail, _event$detail$target, _event$detail$target$, _this$props5, _this$props6;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : (_event$detail$target = _event$detail.target) === null || _event$detail$target === void 0 ? void 0 : (_event$detail$target$ = _event$detail$target.dataset) === null || _event$detail$target$ === void 0 ? void 0 : _event$detail$target$.index) + 1 || 1;
      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClickTab) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClickTab(event, eventIndex));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onFocus) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeyup) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeydown) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMousedown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseup) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseover) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseout) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onTouchend) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onClickActionButton = _this._onClickActionButton.bind(_assertThisInitialized(_this));
    _this._onClickTab = _this._onClickTab.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDocumentViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("click-action-button", this._onClickActionButton);

      this._ref.current.addEventListener("click-tab1", this._onClickTab);

      this._ref.current.addEventListener("click-tab2", this._onClickTab);

      this._ref.current.addEventListener("click-tab3", this._onClickTab);

      this._ref.current.addEventListener("click-tab4", this._onClickTab);

      this._ref.current.addEventListener("click-tab5", this._onClickTab);

      this._ref.current.addEventListener("click-tab6", this._onClickTab);

      this._ref.current.addEventListener("click-tab7", this._onClickTab);

      this._ref.current.addEventListener("click-tab8", this._onClickTab);

      this._ref.current.addEventListener("click-tab9", this._onClickTab);

      this._ref.current.addEventListener("click-tab10", this._onClickTab);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("click-action-button", this._onClickActionButton);

      this._ref.current.removeEventListener("click-tab1", this._onClickTab);

      this._ref.current.removeEventListener("click-tab2", this._onClickTab);

      this._ref.current.removeEventListener("click-tab3", this._onClickTab);

      this._ref.current.removeEventListener("click-tab4", this._onClickTab);

      this._ref.current.removeEventListener("click-tab5", this._onClickTab);

      this._ref.current.removeEventListener("click-tab6", this._onClickTab);

      this._ref.current.removeEventListener("click-tab7", this._onClickTab);

      this._ref.current.removeEventListener("click-tab8", this._onClickTab);

      this._ref.current.removeEventListener("click-tab9", this._onClickTab);

      this._ref.current.removeEventListener("click-tab10", this._onClickTab);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-document-viewer", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        description: Array.isArray(this.props.description) || this.props.description === Object(this.props.description) ? JSON.stringify(this.props.description) : this.props.description,
        "component-title": Array.isArray(this.props.componentTitle) || this.props.componentTitle === Object(this.props.componentTitle) ? JSON.stringify(this.props.componentTitle) : this.props.componentTitle,
        "content-type": Array.isArray(this.props.contentType) || this.props.contentType === Object(this.props.contentType) ? JSON.stringify(this.props.contentType) : this.props.contentType,
        content: Array.isArray(this.props.content) || this.props.content === Object(this.props.content) ? JSON.stringify(this.props.content) : this.props.content,
        "action-button-icon": Array.isArray(this.props.actionButtonIcon) || this.props.actionButtonIcon === Object(this.props.actionButtonIcon) ? JSON.stringify(this.props.actionButtonIcon) : this.props.actionButtonIcon,
        "action-button-accessible-text": Array.isArray(this.props.actionButtonAccessibleText) || this.props.actionButtonAccessibleText === Object(this.props.actionButtonAccessibleText) ? JSON.stringify(this.props.actionButtonAccessibleText) : this.props.actionButtonAccessibleText,
        "action-button-text": Array.isArray(this.props.actionButtonText) || this.props.actionButtonText === Object(this.props.actionButtonText) ? JSON.stringify(this.props.actionButtonText) : this.props.actionButtonText,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        "hide-title": Array.isArray(this.props.hideTitle) || this.props.hideTitle === Object(this.props.hideTitle) ? JSON.stringify(this.props.hideTitle) : this.props.hideTitle,
        languages: Array.isArray(this.props.languages) || this.props.languages === Object(this.props.languages) ? JSON.stringify(this.props.languages) : this.props.languages,
        "selected-tab": Array.isArray(this.props.selectedTab) || this.props.selectedTab === Object(this.props.selectedTab) ? JSON.stringify(this.props.selectedTab) : this.props.selectedTab,
        "viewer-accessible-name": Array.isArray(this.props.viewerAccessibleName) || this.props.viewerAccessibleName === Object(this.props.viewerAccessibleName) ? JSON.stringify(this.props.viewerAccessibleName) : this.props.viewerAccessibleName,
        "html-encoded": Array.isArray(this.props.htmlEncoded) || this.props.htmlEncoded === Object(this.props.htmlEncoded) ? JSON.stringify(this.props.htmlEncoded) : this.props.htmlEncoded,
        "viewer-height": Array.isArray(this.props.viewerHeight) || this.props.viewerHeight === Object(this.props.viewerHeight) ? JSON.stringify(this.props.viewerHeight) : this.props.viewerHeight,
        "byte-array": Array.isArray(this.props.byteArray) || this.props.byteArray === Object(this.props.byteArray) ? JSON.stringify(this.props.byteArray) : this.props.byteArray,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDocumentViewer;
}(React.Component);
MdsDocumentViewer.propTypes = {
  // Values
  description: PropTypes.string,
  componentTitle: PropTypes.string,
  contentType: PropTypes.oneOf(["html", "pdf"]),
  content: PropTypes.string,
  actionButtonIcon: PropTypes.oneOf(["print", "download"]),
  actionButtonAccessibleText: PropTypes.string,
  actionButtonText: PropTypes.string,
  headingLevel: PropTypes.number,
  hideTitle: PropTypes.bool,
  languages: PropTypes.string,
  selectedTab: PropTypes.number,
  viewerAccessibleName: PropTypes.string,
  htmlEncoded: PropTypes.bool,
  viewerHeight: PropTypes.number,
  byteArray: PropTypes.bool,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onClickActionButton: PropTypes.func,
  onClickTab: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsDocumentViewer.defaultProps = {
  headingLevel: 2,
  hideTitle: false,
  selectedTab: 0,
  htmlEncoded: false,
  viewerHeight: 300,
  byteArray: false,
  // Events
  onClick: null,
  onClickActionButton: null,
  onClickTab: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsDropZone = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDropZone, _React$Component);

  var _super = _createSuper(MdsDropZone);

  function MdsDropZone(props) {
    var _this;

    _classCallCheck(this, MdsDropZone);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFileValid", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFileValid) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFileValid(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFileInvalid", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFileInvalid) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFileInvalid(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onDelete", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onDelete) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onDelete(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onDrop", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onDrop) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onDrop(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onInput) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onInput(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onTouchstart) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onFocus) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onClick) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onCancel", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onCancel) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onCancel(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onTouchend) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onDragleave", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onDragleave) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onDragleave(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props33, _this$props34;

      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onKeyup) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props35, _this$props36;

      ((_this$props35 = _this.props) === null || _this$props35 === void 0 ? void 0 : _this$props35.onMouseover) && ((_this$props36 = _this.props) === null || _this$props36 === void 0 ? void 0 : _this$props36.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props37, _this$props38;

      ((_this$props37 = _this.props) === null || _this$props37 === void 0 ? void 0 : _this$props37.onMouseup) && ((_this$props38 = _this.props) === null || _this$props38 === void 0 ? void 0 : _this$props38.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onDragenter", function (event) {
      var _this$props39, _this$props40;

      ((_this$props39 = _this.props) === null || _this$props39 === void 0 ? void 0 : _this$props39.onDragenter) && ((_this$props40 = _this.props) === null || _this$props40 === void 0 ? void 0 : _this$props40.onDragenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props41, _this$props42;

      ((_this$props41 = _this.props) === null || _this$props41 === void 0 ? void 0 : _this$props41.onChange) && ((_this$props42 = _this.props) === null || _this$props42 === void 0 ? void 0 : _this$props42.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickDelete", function (event) {
      var _this$props43, _this$props44;

      ((_this$props43 = _this.props) === null || _this$props43 === void 0 ? void 0 : _this$props43.onClickDelete) && ((_this$props44 = _this.props) === null || _this$props44 === void 0 ? void 0 : _this$props44.onClickDelete(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInvalid", function (event) {
      var _this$props45, _this$props46;

      ((_this$props45 = _this.props) === null || _this$props45 === void 0 ? void 0 : _this$props45.onInvalid) && ((_this$props46 = _this.props) === null || _this$props46 === void 0 ? void 0 : _this$props46.onInvalid(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onValid", function (event) {
      var _this$props47, _this$props48;

      ((_this$props47 = _this.props) === null || _this$props47 === void 0 ? void 0 : _this$props47.onValid) && ((_this$props48 = _this.props) === null || _this$props48 === void 0 ? void 0 : _this$props48.onValid(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onCustomValidate", function (event) {
      var _this$props49, _this$props50;

      ((_this$props49 = _this.props) === null || _this$props49 === void 0 ? void 0 : _this$props49.onCustomValidate) && ((_this$props50 = _this.props) === null || _this$props50 === void 0 ? void 0 : _this$props50.onCustomValidate(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFileValid = _this._onFileValid.bind(_assertThisInitialized(_this));
    _this._onFileInvalid = _this._onFileInvalid.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onDelete = _this._onDelete.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onDrop = _this._onDrop.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onCancel = _this._onCancel.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onDragleave = _this._onDragleave.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onDragenter = _this._onDragenter.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onClickDelete = _this._onClickDelete.bind(_assertThisInitialized(_this));
    _this._onInvalid = _this._onInvalid.bind(_assertThisInitialized(_this));
    _this._onValid = _this._onValid.bind(_assertThisInitialized(_this));
    _this._onCustomValidate = _this._onCustomValidate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDropZone, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("fileValid", this._onFileValid);

      this._ref.current.addEventListener("fileInvalid", this._onFileInvalid);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("delete", this._onDelete);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("drop", this._onDrop);

      this._ref.current.addEventListener("input", this._onInput);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("cancel", this._onCancel);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("dragleave", this._onDragleave);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("dragenter", this._onDragenter);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("click-delete", this._onClickDelete);

      this._ref.current.addEventListener("invalid", this._onInvalid);

      this._ref.current.addEventListener("valid", this._onValid);

      this._ref.current.addEventListener("custom-validate", this._onCustomValidate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("fileValid", this._onFileValid);

      this._ref.current.removeEventListener("fileInvalid", this._onFileInvalid);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("delete", this._onDelete);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("drop", this._onDrop);

      this._ref.current.removeEventListener("input", this._onInput);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("cancel", this._onCancel);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("dragleave", this._onDragleave);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("dragenter", this._onDragenter);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("click-delete", this._onClickDelete);

      this._ref.current.removeEventListener("invalid", this._onInvalid);

      this._ref.current.removeEventListener("valid", this._onValid);

      this._ref.current.removeEventListener("custom-validate", this._onCustomValidate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-drop-zone", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "field-label": Array.isArray(this.props.fieldLabel) || this.props.fieldLabel === Object(this.props.fieldLabel) ? JSON.stringify(this.props.fieldLabel) : this.props.fieldLabel,
        "instruction-text": Array.isArray(this.props.instructionText) || this.props.instructionText === Object(this.props.instructionText) ? JSON.stringify(this.props.instructionText) : this.props.instructionText,
        "file-types": Array.isArray(this.props.fileTypes) || this.props.fileTypes === Object(this.props.fileTypes) ? JSON.stringify(this.props.fileTypes) : this.props.fileTypes,
        "helper-text": Array.isArray(this.props.helperText) || this.props.helperText === Object(this.props.helperText) ? JSON.stringify(this.props.helperText) : this.props.helperText,
        "helper-text-title": Array.isArray(this.props.helperTextTitle) || this.props.helperTextTitle === Object(this.props.helperTextTitle) ? JSON.stringify(this.props.helperTextTitle) : this.props.helperTextTitle,
        "error-message": Array.isArray(this.props.errorMessage) || this.props.errorMessage === Object(this.props.errorMessage) ? JSON.stringify(this.props.errorMessage) : this.props.errorMessage,
        "max-file-size": Array.isArray(this.props.maxFileSize) || this.props.maxFileSize === Object(this.props.maxFileSize) ? JSON.stringify(this.props.maxFileSize) : this.props.maxFileSize,
        "max-number-of-files": Array.isArray(this.props.maxNumberOfFiles) || this.props.maxNumberOfFiles === Object(this.props.maxNumberOfFiles) ? JSON.stringify(this.props.maxNumberOfFiles) : this.props.maxNumberOfFiles,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        "upload-file-button-text": Array.isArray(this.props.uploadFileButtonText) || this.props.uploadFileButtonText === Object(this.props.uploadFileButtonText) ? JSON.stringify(this.props.uploadFileButtonText) : this.props.uploadFileButtonText,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "max-file-size-error-message": Array.isArray(this.props.maxFileSizeErrorMessage) || this.props.maxFileSizeErrorMessage === Object(this.props.maxFileSizeErrorMessage) ? JSON.stringify(this.props.maxFileSizeErrorMessage) : this.props.maxFileSizeErrorMessage,
        "max-number-of-files-error-message": Array.isArray(this.props.maxNumberOfFilesErrorMessage) || this.props.maxNumberOfFilesErrorMessage === Object(this.props.maxNumberOfFilesErrorMessage) ? JSON.stringify(this.props.maxNumberOfFilesErrorMessage) : this.props.maxNumberOfFilesErrorMessage,
        "container-width": Array.isArray(this.props.containerWidth) || this.props.containerWidth === Object(this.props.containerWidth) ? JSON.stringify(this.props.containerWidth) : this.props.containerWidth,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "accessible-text-status-message": Array.isArray(this.props.accessibleTextStatusMessage) || this.props.accessibleTextStatusMessage === Object(this.props.accessibleTextStatusMessage) ? JSON.stringify(this.props.accessibleTextStatusMessage) : this.props.accessibleTextStatusMessage,
        "accessible-text-table-caption": Array.isArray(this.props.accessibleTextTableCaption) || this.props.accessibleTextTableCaption === Object(this.props.accessibleTextTableCaption) ? JSON.stringify(this.props.accessibleTextTableCaption) : this.props.accessibleTextTableCaption,
        "action-heading-text": Array.isArray(this.props.actionHeadingText) || this.props.actionHeadingText === Object(this.props.actionHeadingText) ? JSON.stringify(this.props.actionHeadingText) : this.props.actionHeadingText,
        "cancel-link-text": Array.isArray(this.props.cancelLinkText) || this.props.cancelLinkText === Object(this.props.cancelLinkText) ? JSON.stringify(this.props.cancelLinkText) : this.props.cancelLinkText,
        "delete-link-text": Array.isArray(this.props.deleteLinkText) || this.props.deleteLinkText === Object(this.props.deleteLinkText) ? JSON.stringify(this.props.deleteLinkText) : this.props.deleteLinkText,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        "uploaded-message": Array.isArray(this.props.uploadedMessage) || this.props.uploadedMessage === Object(this.props.uploadedMessage) ? JSON.stringify(this.props.uploadedMessage) : this.props.uploadedMessage,
        "status-heading-text": Array.isArray(this.props.statusHeadingText) || this.props.statusHeadingText === Object(this.props.statusHeadingText) ? JSON.stringify(this.props.statusHeadingText) : this.props.statusHeadingText,
        "file-name-heading-text": Array.isArray(this.props.fileNameHeadingText) || this.props.fileNameHeadingText === Object(this.props.fileNameHeadingText) ? JSON.stringify(this.props.fileNameHeadingText) : this.props.fileNameHeadingText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDropZone;
}(React.Component);
MdsDropZone.propTypes = {
  // Values
  fieldLabel: PropTypes.string,
  instructionText: PropTypes.string,
  fileTypes: PropTypes.array,
  helperText: PropTypes.string,
  helperTextTitle: PropTypes.string,
  errorMessage: PropTypes.string,
  maxFileSize: PropTypes.number,
  maxNumberOfFiles: CustomPropTypes.integer,
  microcopy: PropTypes.array,
  uploadFileButtonText: PropTypes.string,
  label: PropTypes.string,
  maxFileSizeErrorMessage: PropTypes.string,
  maxNumberOfFilesErrorMessage: PropTypes.string,
  containerWidth: PropTypes.string,
  brand: PropTypes.string,
  accessibleTextStatusMessage: PropTypes.string,
  accessibleTextTableCaption: PropTypes.string,
  actionHeadingText: PropTypes.string,
  cancelLinkText: PropTypes.string,
  deleteLinkText: PropTypes.string,
  name: PropTypes.string,
  inactive: PropTypes.string,
  uploadedMessage: PropTypes.string,
  statusHeadingText: PropTypes.string,
  fileNameHeadingText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["hovered", "disabled", "focused", "active", "error"]),
  // Events
  onFileValid: PropTypes.func,
  onFileInvalid: PropTypes.func,
  onMousedown: PropTypes.func,
  onDelete: PropTypes.func,
  onBlur: PropTypes.func,
  onDrop: PropTypes.func,
  onInput: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  onCancel: PropTypes.func,
  onTouchend: PropTypes.func,
  onDragleave: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseup: PropTypes.func,
  onDragenter: PropTypes.func,
  onChange: PropTypes.func,
  onClickDelete: PropTypes.func,
  onInvalid: PropTypes.func,
  onValid: PropTypes.func,
  onCustomValidate: PropTypes.func
};
MdsDropZone.defaultProps = {
  maxNumberOfFilesErrorMessage: "280px",
  containerWidth: "280px",
  // Events
  onFileValid: null,
  onFileInvalid: null,
  onMousedown: null,
  onDelete: null,
  onBlur: null,
  onDrop: null,
  onInput: null,
  onMouseout: null,
  onKeydown: null,
  onMouseenter: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null,
  onCancel: null,
  onTouchend: null,
  onDragleave: null,
  onKeyup: null,
  onMouseover: null,
  onMouseup: null,
  onDragenter: null,
  onChange: null,
  onClickDelete: null,
  onInvalid: null,
  onValid: null,
  onCustomValidate: null
};

var MdsExpandableText = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsExpandableText, _React$Component);

  var _super = _createSuper(MdsExpandableText);

  function MdsExpandableText(props) {
    var _this;

    _classCallCheck(this, MdsExpandableText);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onExpand", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onExpand) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onExpand(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onCollapse", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onCollapse) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onCollapse(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onTouchend) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickCollapse", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onClickCollapse) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onClickCollapse(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickExpand", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onClickExpand) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onClickExpand(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseover) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onFocus) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onClick) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onExpand = _this._onExpand.bind(_assertThisInitialized(_this));
    _this._onCollapse = _this._onCollapse.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onClickCollapse = _this._onClickCollapse.bind(_assertThisInitialized(_this));
    _this._onClickExpand = _this._onClickExpand.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsExpandableText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("expand", this._onExpand);

      this._ref.current.addEventListener("collapse", this._onCollapse);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("click-collapse", this._onClickCollapse);

      this._ref.current.addEventListener("click-expand", this._onClickExpand);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("expand", this._onExpand);

      this._ref.current.removeEventListener("collapse", this._onCollapse);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("click-collapse", this._onClickCollapse);

      this._ref.current.removeEventListener("click-expand", this._onClickExpand);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-expandable-text", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-description": Array.isArray(this.props.accessibleDescription) || this.props.accessibleDescription === Object(this.props.accessibleDescription) ? JSON.stringify(this.props.accessibleDescription) : this.props.accessibleDescription,
        "leading-text-content": Array.isArray(this.props.leadingTextContent) || this.props.leadingTextContent === Object(this.props.leadingTextContent) ? JSON.stringify(this.props.leadingTextContent) : this.props.leadingTextContent,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "text-color": Array.isArray(this.props.textColor) || this.props.textColor === Object(this.props.textColor) ? JSON.stringify(this.props.textColor) : this.props.textColor,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsExpandableText;
}(React.Component);
MdsExpandableText.propTypes = {
  // Values
  accessibleDescription: PropTypes.string,
  leadingTextContent: PropTypes.string,
  label: PropTypes.string,
  textColor: PropTypes.oneOf(["textColorLink", "textColorRegular"]),
  inactive: PropTypes.bool,
  name: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "disabled"]),
  // Events
  onExpand: PropTypes.func,
  onCollapse: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onClickCollapse: PropTypes.func,
  onClickExpand: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsExpandableText.defaultProps = {
  textColor: "textColorLink",
  inactive: false,
  name: "expandable-text",
  // Events
  onExpand: null,
  onCollapse: null,
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onClickCollapse: null,
  onClickExpand: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsFieldset = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsFieldset, _React$Component);

  var _super = _createSuper(MdsFieldset);

  function MdsFieldset(props) {
    var _this;

    _classCallCheck(this, MdsFieldset);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onChange) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onInput) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onInput(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMousedown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseup) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseover) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseout) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onTouchend) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsFieldset, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("input", this._onInput);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("input", this._onInput);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-fieldset", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "legend-text": Array.isArray(this.props.legendText) || this.props.legendText === Object(this.props.legendText) ? JSON.stringify(this.props.legendText) : this.props.legendText,
        "hide-legend": Array.isArray(this.props.hideLegend) || this.props.hideLegend === Object(this.props.hideLegend) ? JSON.stringify(this.props.hideLegend) : this.props.hideLegend,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        "label-alignment": Array.isArray(this.props.labelAlignment) || this.props.labelAlignment === Object(this.props.labelAlignment) ? JSON.stringify(this.props.labelAlignment) : this.props.labelAlignment,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        "label-columns": Array.isArray(this.props.labelColumns) || this.props.labelColumns === Object(this.props.labelColumns) ? JSON.stringify(this.props.labelColumns) : this.props.labelColumns,
        "input-columns": Array.isArray(this.props.inputColumns) || this.props.inputColumns === Object(this.props.inputColumns) ? JSON.stringify(this.props.inputColumns) : this.props.inputColumns,
        "error-messages": Array.isArray(this.props.errorMessages) || this.props.errorMessages === Object(this.props.errorMessages) ? JSON.stringify(this.props.errorMessages) : this.props.errorMessages,
        "focus-on-error": Array.isArray(this.props.focusOnError) || this.props.focusOnError === Object(this.props.focusOnError) ? JSON.stringify(this.props.focusOnError) : this.props.focusOnError,
        "error-message-prefix-accessible-text": Array.isArray(this.props.errorMessagePrefixAccessibleText) || this.props.errorMessagePrefixAccessibleText === Object(this.props.errorMessagePrefixAccessibleText) ? JSON.stringify(this.props.errorMessagePrefixAccessibleText) : this.props.errorMessagePrefixAccessibleText,
        "label-size": Array.isArray(this.props.labelSize) || this.props.labelSize === Object(this.props.labelSize) ? JSON.stringify(this.props.labelSize) : this.props.labelSize,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsFieldset;
}(React.Component);
MdsFieldset.propTypes = {
  // Values
  legendText: PropTypes.string,
  hideLegend: PropTypes.bool,
  layout: PropTypes.oneOf(["horizontal", "vertical"]),
  labelAlignment: PropTypes.oneOf(["left", "right"]),
  microcopy: PropTypes.string,
  labelColumns: PropTypes.string,
  inputColumns: PropTypes.string,
  errorMessages: PropTypes.array,
  focusOnError: PropTypes.bool,
  errorMessagePrefixAccessibleText: PropTypes.string,
  labelSize: PropTypes.oneOf(["regular", "medium", "prominent"]),
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["error"]),
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onInput: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsFieldset.defaultProps = {
  hideLegend: false,
  layout: "vertical",
  labelAlignment: "left",
  labelColumns: "mds-col-3",
  inputColumns: "mds-col-9",
  focusOnError: false,
  errorMessagePrefixAccessibleText: "Error",
  labelSize: "regular",
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onChange: null,
  onKeyup: null,
  onKeydown: null,
  onInput: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsFlyout = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsFlyout, _React$Component);

  var _super = _createSuper(MdsFlyout);

  function MdsFlyout(props) {
    var _this;

    _classCallCheck(this, MdsFlyout);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onOpen) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onDismiss", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onDismiss) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onDismiss(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClose) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickCloseButton", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onClickCloseButton) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onClickCloseButton(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onDismiss = _this._onDismiss.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onClickCloseButton = _this._onClickCloseButton.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsFlyout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("dismiss", this._onDismiss);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("click-close-button", this._onClickCloseButton);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("dismiss", this._onDismiss);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("click-close-button", this._onClickCloseButton);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-flyout", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        alignment: Array.isArray(this.props.alignment) || this.props.alignment === Object(this.props.alignment) ? JSON.stringify(this.props.alignment) : this.props.alignment,
        "tooltip-placement": Array.isArray(this.props.tooltipPlacement) || this.props.tooltipPlacement === Object(this.props.tooltipPlacement) ? JSON.stringify(this.props.tooltipPlacement) : this.props.tooltipPlacement,
        header: Array.isArray(this.props.header) || this.props.header === Object(this.props.header) ? JSON.stringify(this.props.header) : this.props.header,
        width: Array.isArray(this.props.width) || this.props.width === Object(this.props.width) ? JSON.stringify(this.props.width) : this.props.width,
        height: Array.isArray(this.props.height) || this.props.height === Object(this.props.height) ? JSON.stringify(this.props.height) : this.props.height,
        "header-icon": Array.isArray(this.props.headerIcon) || this.props.headerIcon === Object(this.props.headerIcon) ? JSON.stringify(this.props.headerIcon) : this.props.headerIcon,
        "icon-color": Array.isArray(this.props.iconColor) || this.props.iconColor === Object(this.props.iconColor) ? JSON.stringify(this.props.iconColor) : this.props.iconColor,
        "accesible-text-flyout-content-start": Array.isArray(this.props.accesibleTextFlyoutContentStart) || this.props.accesibleTextFlyoutContentStart === Object(this.props.accesibleTextFlyoutContentStart) ? JSON.stringify(this.props.accesibleTextFlyoutContentStart) : this.props.accesibleTextFlyoutContentStart,
        "accessible-text-flyout-content-start": Array.isArray(this.props.accessibleTextFlyoutContentStart) || this.props.accessibleTextFlyoutContentStart === Object(this.props.accessibleTextFlyoutContentStart) ? JSON.stringify(this.props.accessibleTextFlyoutContentStart) : this.props.accessibleTextFlyoutContentStart,
        "accesible-text-flyout-content-end": Array.isArray(this.props.accesibleTextFlyoutContentEnd) || this.props.accesibleTextFlyoutContentEnd === Object(this.props.accesibleTextFlyoutContentEnd) ? JSON.stringify(this.props.accesibleTextFlyoutContentEnd) : this.props.accesibleTextFlyoutContentEnd,
        "accessible-text-flyout-content-end": Array.isArray(this.props.accessibleTextFlyoutContentEnd) || this.props.accessibleTextFlyoutContentEnd === Object(this.props.accessibleTextFlyoutContentEnd) ? JSON.stringify(this.props.accessibleTextFlyoutContentEnd) : this.props.accessibleTextFlyoutContentEnd,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "detect-trigger-wrap": Array.isArray(this.props.detectTriggerWrap) || this.props.detectTriggerWrap === Object(this.props.detectTriggerWrap) ? JSON.stringify(this.props.detectTriggerWrap) : this.props.detectTriggerWrap,
        "accessible-close-button": Array.isArray(this.props.accessibleCloseButton) || this.props.accessibleCloseButton === Object(this.props.accessibleCloseButton) ? JSON.stringify(this.props.accessibleCloseButton) : this.props.accessibleCloseButton,
        "edge-detection-container-id": Array.isArray(this.props.edgeDetectionContainerId) || this.props.edgeDetectionContainerId === Object(this.props.edgeDetectionContainerId) ? JSON.stringify(this.props.edgeDetectionContainerId) : this.props.edgeDetectionContainerId,
        visible: Array.isArray(this.props.visible) || this.props.visible === Object(this.props.visible) ? JSON.stringify(this.props.visible) : this.props.visible,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        message: Array.isArray(this.props.message) || this.props.message === Object(this.props.message) ? JSON.stringify(this.props.message) : this.props.message,
        "manual-control": Array.isArray(this.props.manualControl) || this.props.manualControl === Object(this.props.manualControl) ? JSON.stringify(this.props.manualControl) : this.props.manualControl,
        "edge-detection": Array.isArray(this.props.edgeDetection) || this.props.edgeDetection === Object(this.props.edgeDetection) ? JSON.stringify(this.props.edgeDetection) : this.props.edgeDetection,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsFlyout;
}(React.Component);
MdsFlyout.propTypes = {
  // Values
  alignment: PropTypes.oneOf(["left", "right", "center"]),
  tooltipPlacement: PropTypes.oneOf(["above", "below"]),
  header: PropTypes.string,
  width: CustomPropTypes.integer,
  height: CustomPropTypes.integer,
  headerIcon: PropTypes.string,
  iconColor: PropTypes.string,
  accesibleTextFlyoutContentStart: PropTypes.string,
  accessibleTextFlyoutContentStart: PropTypes.string,
  accesibleTextFlyoutContentEnd: PropTypes.string,
  accessibleTextFlyoutContentEnd: PropTypes.string,
  brand: PropTypes.string,
  detectTriggerWrap: PropTypes.string,
  accessibleCloseButton: PropTypes.string,
  edgeDetectionContainerId: PropTypes.string,
  visible: PropTypes.string,
  headingLevel: PropTypes.string,
  message: PropTypes.string,
  manualControl: PropTypes.string,
  edgeDetection: PropTypes.string,
  variant: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onOpen: PropTypes.func,
  onDismiss: PropTypes.func,
  onClose: PropTypes.func,
  onClickCloseButton: PropTypes.func
};
MdsFlyout.defaultProps = {
  alignment: "left",
  tooltipPlacement: "below",
  width: 300,
  height: 300,
  accesibleTextFlyoutContentStart: "popup content start",
  accessibleTextFlyoutContentStart: "popup content start",
  accesibleTextFlyoutContentEnd: "popup content end",
  accessibleTextFlyoutContentEnd: "popup content end",
  // Events
  onOpen: null,
  onDismiss: null,
  onClose: null,
  onClickCloseButton: null
};

var MdsHeroHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsHeroHeader, _React$Component);

  var _super = _createSuper(MdsHeroHeader);

  function MdsHeroHeader(props) {
    var _this;

    _classCallCheck(this, MdsHeroHeader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchend) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsHeroHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-hero-header", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "icon-color": Array.isArray(this.props.iconColor) || this.props.iconColor === Object(this.props.iconColor) ? JSON.stringify(this.props.iconColor) : this.props.iconColor,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        "icon-accessible-name": Array.isArray(this.props.iconAccessibleName) || this.props.iconAccessibleName === Object(this.props.iconAccessibleName) ? JSON.stringify(this.props.iconAccessibleName) : this.props.iconAccessibleName,
        heading: Array.isArray(this.props.heading) || this.props.heading === Object(this.props.heading) ? JSON.stringify(this.props.heading) : this.props.heading,
        "description-text": Array.isArray(this.props.descriptionText) || this.props.descriptionText === Object(this.props.descriptionText) ? JSON.stringify(this.props.descriptionText) : this.props.descriptionText,
        "max-width": Array.isArray(this.props.maxWidth) || this.props.maxWidth === Object(this.props.maxWidth) ? JSON.stringify(this.props.maxWidth) : this.props.maxWidth,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsHeroHeader;
}(React.Component);
MdsHeroHeader.propTypes = {
  // Values
  variant: PropTypes.oneOf(["iconAndText", "textOnly", "customImage", "leading", "confirmationAnimation"]),
  iconColor: PropTypes.oneOf(["success", "regular"]),
  icon: PropTypes.string,
  iconAccessibleName: PropTypes.string,
  heading: PropTypes.string,
  descriptionText: PropTypes.string,
  maxWidth: PropTypes.number,
  headingLevel: PropTypes.number,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsHeroHeader.defaultProps = {
  variant: "iconAndText",
  iconColor: "success",
  maxWidth: 396,
  headingLevel: 2,
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsIcon = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsIcon, _React$Component);

  var _super = _createSuper(MdsIcon);

  function MdsIcon(props) {
    var _this;

    _classCallCheck(this, MdsIcon);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsIcon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-icon", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        type: Array.isArray(this.props.type) || this.props.type === Object(this.props.type) ? JSON.stringify(this.props.type) : this.props.type,
        color: Array.isArray(this.props.color) || this.props.color === Object(this.props.color) ? JSON.stringify(this.props.color) : this.props.color,
        size: Array.isArray(this.props.size) || this.props.size === Object(this.props.size) ? JSON.stringify(this.props.size) : this.props.size,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "remove-horizontal-margin": Array.isArray(this.props.removeHorizontalMargin) || this.props.removeHorizontalMargin === Object(this.props.removeHorizontalMargin) ? JSON.stringify(this.props.removeHorizontalMargin) : this.props.removeHorizontalMargin,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsIcon;
}(React.Component);
MdsIcon.propTypes = {
  // Values
  type: PropTypes.string,
  color: PropTypes.oneOf(["default", "success", "inverse", "warning", "error", "interactive"]),
  size: PropTypes.oneOf([16, 20, 24, 48]),
  accessibleText: PropTypes.string,
  removeHorizontalMargin: PropTypes.bool,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsIcon.defaultProps = {
  color: "default",
  size: "16",
  removeHorizontalMargin: false,
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsImage = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsImage, _React$Component);

  var _super = _createSuper(MdsImage);

  function MdsImage(props) {
    var _this;

    _classCallCheck(this, MdsImage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-image", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        alt: Array.isArray(this.props.alt) || this.props.alt === Object(this.props.alt) ? JSON.stringify(this.props.alt) : this.props.alt,
        "background-size": Array.isArray(this.props.backgroundSize) || this.props.backgroundSize === Object(this.props.backgroundSize) ? JSON.stringify(this.props.backgroundSize) : this.props.backgroundSize,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "image-sources": Array.isArray(this.props.imageSources) || this.props.imageSources === Object(this.props.imageSources) ? JSON.stringify(this.props.imageSources) : this.props.imageSources // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsImage;
}(React.Component);
MdsImage.propTypes = {
  // Values
  alt: PropTypes.string,
  backgroundSize: PropTypes.oneOf(["cover", "contain", "fill"]),
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  imageSources: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsImage.defaultProps = {
  backgroundSize: "fill",
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsInlineForm = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsInlineForm, _React$Component);

  var _super = _createSuper(MdsInlineForm);

  function MdsInlineForm(props) {
    var _this;

    _classCallCheck(this, MdsInlineForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFocus) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onChange) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onTouchend) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onInput) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onInput(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeyup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseover) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onClick) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsInlineForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("input", this._onInput);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("input", this._onInput);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-inline-form", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsInlineForm;
}(React.Component);
MdsInlineForm.propTypes = {
  // Values
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onInput: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func
};
MdsInlineForm.defaultProps = {
  // Events
  onFocus: null,
  onChange: null,
  onMousedown: null,
  onTouchend: null,
  onBlur: null,
  onInput: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onClick: null
};

var MdsInlineInput = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsInlineInput, _React$Component);

  var _super = _createSuper(MdsInlineInput);

  function MdsInlineInput() {
    _classCallCheck(this, MdsInlineInput);

    return _super.apply(this, arguments);
  }

  _createClass(MdsInlineInput, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-inline-input", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "error-message": Array.isArray(this.props.errorMessage) || this.props.errorMessage === Object(this.props.errorMessage) ? JSON.stringify(this.props.errorMessage) : this.props.errorMessage,
        placeholder: Array.isArray(this.props.placeholder) || this.props.placeholder === Object(this.props.placeholder) ? JSON.stringify(this.props.placeholder) : this.props.placeholder,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "leading-text": Array.isArray(this.props.leadingText) || this.props.leadingText === Object(this.props.leadingText) ? JSON.stringify(this.props.leadingText) : this.props.leadingText,
        "trailing-text": Array.isArray(this.props.trailingText) || this.props.trailingText === Object(this.props.trailingText) ? JSON.stringify(this.props.trailingText) : this.props.trailingText,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        format: Array.isArray(this.props.format) || this.props.format === Object(this.props.format) ? JSON.stringify(this.props.format) : this.props.format,
        "error-message-prefix": Array.isArray(this.props.errorMessagePrefix) || this.props.errorMessagePrefix === Object(this.props.errorMessagePrefix) ? JSON.stringify(this.props.errorMessagePrefix) : this.props.errorMessagePrefix,
        "autocomplete-value": Array.isArray(this.props.autocompleteValue) || this.props.autocompleteValue === Object(this.props.autocompleteValue) ? JSON.stringify(this.props.autocompleteValue) : this.props.autocompleteValue,
        "currency-symbol": Array.isArray(this.props.currencySymbol) || this.props.currencySymbol === Object(this.props.currencySymbol) ? JSON.stringify(this.props.currencySymbol) : this.props.currencySymbol,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsInlineInput;
}(React.Component);
MdsInlineInput.propTypes = {
  // Values
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  leadingText: PropTypes.string,
  trailingText: PropTypes.string,
  accessibleText: PropTypes.string,
  name: PropTypes.string,
  format: PropTypes.oneOf(["moneyCommaInteger", "moneyDecimalInteger"]),
  errorMessagePrefix: PropTypes.string,
  autocompleteValue: PropTypes.string,
  currencySymbol: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["active", "error"])
};
MdsInlineInput.defaultProps = {
  value: "",
  errorMessagePrefix: "Error",
  autocompleteValue: "off"
};

var MdsInlineSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsInlineSelect, _React$Component);

  var _super = _createSuper(MdsInlineSelect);

  function MdsInlineSelect() {
    _classCallCheck(this, MdsInlineSelect);

    return _super.apply(this, arguments);
  }

  _createClass(MdsInlineSelect, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-inline-select", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "error-message": Array.isArray(this.props.errorMessage) || this.props.errorMessage === Object(this.props.errorMessage) ? JSON.stringify(this.props.errorMessage) : this.props.errorMessage,
        placeholder: Array.isArray(this.props.placeholder) || this.props.placeholder === Object(this.props.placeholder) ? JSON.stringify(this.props.placeholder) : this.props.placeholder,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "leading-text": Array.isArray(this.props.leadingText) || this.props.leadingText === Object(this.props.leadingText) ? JSON.stringify(this.props.leadingText) : this.props.leadingText,
        "trailing-text": Array.isArray(this.props.trailingText) || this.props.trailingText === Object(this.props.trailingText) ? JSON.stringify(this.props.trailingText) : this.props.trailingText,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        "label-key": Array.isArray(this.props.labelKey) || this.props.labelKey === Object(this.props.labelKey) ? JSON.stringify(this.props.labelKey) : this.props.labelKey,
        "value-key": Array.isArray(this.props.valueKey) || this.props.valueKey === Object(this.props.valueKey) ? JSON.stringify(this.props.valueKey) : this.props.valueKey,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "selected-index": Array.isArray(this.props.selectedIndex) || this.props.selectedIndex === Object(this.props.selectedIndex) ? JSON.stringify(this.props.selectedIndex) : this.props.selectedIndex,
        "error-message-prefix": Array.isArray(this.props.errorMessagePrefix) || this.props.errorMessagePrefix === Object(this.props.errorMessagePrefix) ? JSON.stringify(this.props.errorMessagePrefix) : this.props.errorMessagePrefix,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        options: Array.isArray(this.props.options) || this.props.options === Object(this.props.options) ? JSON.stringify(this.props.options) : this.props.options,
        state: this.props.state //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsInlineSelect;
}(React.Component);
MdsInlineSelect.propTypes = {
  // Values
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  leadingText: PropTypes.string,
  trailingText: PropTypes.string,
  accessibleText: PropTypes.string,
  name: PropTypes.string,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  brand: PropTypes.string,
  selectedIndex: PropTypes.string,
  errorMessagePrefix: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  options: PropTypes.arrayOf(CustomPropTypes.slot),
  state: PropTypes.oneOf(["active", "error"])
};
MdsInlineSelect.defaultProps = {
  errorMessagePrefix: "Error"
};

var MdsLink = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsLink, _React$Component);

  var _super = _createSuper(MdsLink);

  function MdsLink(props) {
    var _this;

    _classCallCheck(this, MdsLink);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onPress", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onPress) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onTouchend) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseover) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onClick) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onPress = _this._onPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsLink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("press", this._onPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("press", this._onPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-link", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        underline: Array.isArray(this.props.underline) || this.props.underline === Object(this.props.underline) ? JSON.stringify(this.props.underline) : this.props.underline,
        "start-icon": Array.isArray(this.props.startIcon) || this.props.startIcon === Object(this.props.startIcon) ? JSON.stringify(this.props.startIcon) : this.props.startIcon,
        "end-icon": Array.isArray(this.props.endIcon) || this.props.endIcon === Object(this.props.endIcon) ? JSON.stringify(this.props.endIcon) : this.props.endIcon,
        text: Array.isArray(this.props.text) || this.props.text === Object(this.props.text) ? JSON.stringify(this.props.text) : this.props.text,
        inverse: Array.isArray(this.props.inverse) || this.props.inverse === Object(this.props.inverse) ? JSON.stringify(this.props.inverse) : this.props.inverse,
        "leading-pipe": Array.isArray(this.props.leadingPipe) || this.props.leadingPipe === Object(this.props.leadingPipe) ? JSON.stringify(this.props.leadingPipe) : this.props.leadingPipe,
        "trailing-pipe": Array.isArray(this.props.trailingPipe) || this.props.trailingPipe === Object(this.props.trailingPipe) ? JSON.stringify(this.props.trailingPipe) : this.props.trailingPipe,
        truncation: Array.isArray(this.props.truncation) || this.props.truncation === Object(this.props.truncation) ? JSON.stringify(this.props.truncation) : this.props.truncation,
        href: Array.isArray(this.props.href) || this.props.href === Object(this.props.href) ? JSON.stringify(this.props.href) : this.props.href,
        "tab-focusable": Array.isArray(this.props.tabFocusable) || this.props.tabFocusable === Object(this.props.tabFocusable) ? JSON.stringify(this.props.tabFocusable) : this.props.tabFocusable,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "label-aria-text": Array.isArray(this.props.labelAriaText) || this.props.labelAriaText === Object(this.props.labelAriaText) ? JSON.stringify(this.props.labelAriaText) : this.props.labelAriaText,
        "is-button": Array.isArray(this.props.isButton) || this.props.isButton === Object(this.props.isButton) ? JSON.stringify(this.props.isButton) : this.props.isButton,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsLink;
}(React.Component);
MdsLink.propTypes = {
  // Values
  underline: PropTypes.bool,
  startIcon: PropTypes.string,
  endIcon: PropTypes.string,
  text: PropTypes.string,
  inverse: PropTypes.bool,
  leadingPipe: PropTypes.bool,
  trailingPipe: PropTypes.bool,
  truncation: PropTypes.oneOf(["leading", "trailing", "none"]),
  href: PropTypes.string,
  tabFocusable: PropTypes.bool,
  inactive: PropTypes.bool,
  accessibleText: PropTypes.string,
  labelAriaText: PropTypes.string,
  isButton: PropTypes.bool,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["pressed", "focused", "hovered", "disabled"]),
  // Events
  onPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsLink.defaultProps = {
  underline: false,
  inverse: false,
  leadingPipe: false,
  trailingPipe: false,
  truncation: "none",
  tabFocusable: true,
  inactive: false,
  isButton: false,
  // Events
  onPress: null,
  onMousedown: null,
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMouseover: null,
  onMouseup: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsListItem, _React$Component);

  var _super = _createSuper(MdsListItem);

  function MdsListItem(props) {
    var _this;

    _classCallCheck(this, MdsListItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeydown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseenter) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseover) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchend) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsListItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-list-item", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "secondary-label": Array.isArray(this.props.secondaryLabel) || this.props.secondaryLabel === Object(this.props.secondaryLabel) ? JSON.stringify(this.props.secondaryLabel) : this.props.secondaryLabel,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        "icon-accessible-text": Array.isArray(this.props.iconAccessibleText) || this.props.iconAccessibleText === Object(this.props.iconAccessibleText) ? JSON.stringify(this.props.iconAccessibleText) : this.props.iconAccessibleText,
        "image-accessible-text": Array.isArray(this.props.imageAccessibleText) || this.props.imageAccessibleText === Object(this.props.imageAccessibleText) ? JSON.stringify(this.props.imageAccessibleText) : this.props.imageAccessibleText,
        "image-url": Array.isArray(this.props.imageUrl) || this.props.imageUrl === Object(this.props.imageUrl) ? JSON.stringify(this.props.imageUrl) : this.props.imageUrl,
        "label-value": Array.isArray(this.props.labelValue) || this.props.labelValue === Object(this.props.labelValue) ? JSON.stringify(this.props.labelValue) : this.props.labelValue,
        "is-animated": Array.isArray(this.props.isAnimated) || this.props.isAnimated === Object(this.props.isAnimated) ? JSON.stringify(this.props.isAnimated) : this.props.isAnimated,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        description: Array.isArray(this.props.description) || this.props.description === Object(this.props.description) ? JSON.stringify(this.props.description) : this.props.description,
        "description-color": Array.isArray(this.props.descriptionColor) || this.props.descriptionColor === Object(this.props.descriptionColor) ? JSON.stringify(this.props.descriptionColor) : this.props.descriptionColor,
        "secondary-label-color": Array.isArray(this.props.secondaryLabelColor) || this.props.secondaryLabelColor === Object(this.props.secondaryLabelColor) ? JSON.stringify(this.props.secondaryLabelColor) : this.props.secondaryLabelColor,
        "secondary-description": Array.isArray(this.props.secondaryDescription) || this.props.secondaryDescription === Object(this.props.secondaryDescription) ? JSON.stringify(this.props.secondaryDescription) : this.props.secondaryDescription,
        "secondary-description-color": Array.isArray(this.props.secondaryDescriptionColor) || this.props.secondaryDescriptionColor === Object(this.props.secondaryDescriptionColor) ? JSON.stringify(this.props.secondaryDescriptionColor) : this.props.secondaryDescriptionColor,
        "icon-accessible-description": Array.isArray(this.props.iconAccessibleDescription) || this.props.iconAccessibleDescription === Object(this.props.iconAccessibleDescription) ? JSON.stringify(this.props.iconAccessibleDescription) : this.props.iconAccessibleDescription,
        "image-width": Array.isArray(this.props.imageWidth) || this.props.imageWidth === Object(this.props.imageWidth) ? JSON.stringify(this.props.imageWidth) : this.props.imageWidth,
        "list-type": Array.isArray(this.props.listType) || this.props.listType === Object(this.props.listType) ? JSON.stringify(this.props.listType) : this.props.listType,
        "tag-text": Array.isArray(this.props.tagText) || this.props.tagText === Object(this.props.tagText) ? JSON.stringify(this.props.tagText) : this.props.tagText,
        href: Array.isArray(this.props.href) || this.props.href === Object(this.props.href) ? JSON.stringify(this.props.href) : this.props.href,
        "navigational-accessible-description": Array.isArray(this.props.navigationalAccessibleDescription) || this.props.navigationalAccessibleDescription === Object(this.props.navigationalAccessibleDescription) ? JSON.stringify(this.props.navigationalAccessibleDescription) : this.props.navigationalAccessibleDescription,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        "tag-accessible-text": Array.isArray(this.props.tagAccessibleText) || this.props.tagAccessibleText === Object(this.props.tagAccessibleText) ? JSON.stringify(this.props.tagAccessibleText) : this.props.tagAccessibleText,
        "tag-color": Array.isArray(this.props.tagColor) || this.props.tagColor === Object(this.props.tagColor) ? JSON.stringify(this.props.tagColor) : this.props.tagColor,
        "tag-icon": Array.isArray(this.props.tagIcon) || this.props.tagIcon === Object(this.props.tagIcon) ? JSON.stringify(this.props.tagIcon) : this.props.tagIcon,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        badge: Array.isArray(this.props.badge) || this.props.badge === Object(this.props.badge) ? JSON.stringify(this.props.badge) : this.props.badge,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsListItem;
}(React.Component);
MdsListItem.propTypes = {
  // Values
  label: PropTypes.string,
  secondaryLabel: PropTypes.string,
  image: PropTypes.string,
  icon: PropTypes.string,
  iconAccessibleText: PropTypes.string,
  imageAccessibleText: PropTypes.string,
  imageUrl: PropTypes.string,
  labelValue: PropTypes.number,
  isAnimated: PropTypes.bool,
  accessibleName: PropTypes.string,
  description: PropTypes.string,
  descriptionColor: PropTypes.oneOf(["regular", "subdued", "gain", "loss"]),
  secondaryLabelColor: PropTypes.oneOf(["regular", "subdued", "gain", "loss"]),
  secondaryDescription: PropTypes.string,
  secondaryDescriptionColor: PropTypes.oneOf(["regular", "subdued", "gain", "loss"]),
  iconAccessibleDescription: PropTypes.string,
  imageWidth: PropTypes.number,
  listType: PropTypes.oneOf(["read-only", "navigational", "selectable", "single-select", "multi-select", "quick-select"]),
  tagText: PropTypes.string,
  href: PropTypes.string,
  navigationalAccessibleDescription: PropTypes.string,
  value: PropTypes.string,
  tagAccessibleText: PropTypes.string,
  tagColor: PropTypes.oneOf(["base", "accent"]),
  tagIcon: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  badge: CustomPropTypes.slot,
  state: PropTypes.oneOf(["default", "pressed", "selected"]),
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeydown: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsListItem.defaultProps = {
  isAnimated: false,
  descriptionColor: "subdued",
  secondaryLabelColor: "regular",
  secondaryDescriptionColor: "subdued",
  tagColor: "base",
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onKeydown: null,
  onKeyup: null,
  onMouseenter: null,
  onMouseover: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsList = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsList, _React$Component);

  var _super = _createSuper(MdsList);

  function MdsList(props) {
    var _this;

    _classCallCheck(this, MdsList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onChange) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMousedown) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseover) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseout) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchend) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onExpand", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onExpand) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onExpand(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onCollapse", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onCollapse) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onCollapse(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onExpand = _this._onExpand.bind(_assertThisInitialized(_this));
    _this._onCollapse = _this._onCollapse.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("expand", this._onExpand);

      this._ref.current.addEventListener("collapse", this._onCollapse);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("expand", this._onExpand);

      this._ref.current.removeEventListener("collapse", this._onCollapse);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-list", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        header: Array.isArray(this.props.header) || this.props.header === Object(this.props.header) ? JSON.stringify(this.props.header) : this.props.header,
        collapsible: Array.isArray(this.props.collapsible) || this.props.collapsible === Object(this.props.collapsible) ? JSON.stringify(this.props.collapsible) : this.props.collapsible,
        "default-collapsed": Array.isArray(this.props.defaultCollapsed) || this.props.defaultCollapsed === Object(this.props.defaultCollapsed) ? JSON.stringify(this.props.defaultCollapsed) : this.props.defaultCollapsed,
        "selected-index": Array.isArray(this.props.selectedIndex) || this.props.selectedIndex === Object(this.props.selectedIndex) ? JSON.stringify(this.props.selectedIndex) : this.props.selectedIndex,
        "selected-indices": Array.isArray(this.props.selectedIndices) || this.props.selectedIndices === Object(this.props.selectedIndices) ? JSON.stringify(this.props.selectedIndices) : this.props.selectedIndices,
        "show-last-divider": Array.isArray(this.props.showLastDivider) || this.props.showLastDivider === Object(this.props.showLastDivider) ? JSON.stringify(this.props.showLastDivider) : this.props.showLastDivider,
        "multi-column-enabled": Array.isArray(this.props.multiColumnEnabled) || this.props.multiColumnEnabled === Object(this.props.multiColumnEnabled) ? JSON.stringify(this.props.multiColumnEnabled) : this.props.multiColumnEnabled,
        condensed: Array.isArray(this.props.condensed) || this.props.condensed === Object(this.props.condensed) ? JSON.stringify(this.props.condensed) : this.props.condensed,
        "show-dividers": Array.isArray(this.props.showDividers) || this.props.showDividers === Object(this.props.showDividers) ? JSON.stringify(this.props.showDividers) : this.props.showDividers,
        "selected-radio": Array.isArray(this.props.selectedRadio) || this.props.selectedRadio === Object(this.props.selectedRadio) ? JSON.stringify(this.props.selectedRadio) : this.props.selectedRadio,
        "list-type": Array.isArray(this.props.listType) || this.props.listType === Object(this.props.listType) ? JSON.stringify(this.props.listType) : this.props.listType,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsList;
}(React.Component);
MdsList.propTypes = {
  // Values
  header: PropTypes.string,
  collapsible: PropTypes.bool,
  defaultCollapsed: PropTypes.bool,
  selectedIndex: CustomPropTypes.integer,
  selectedIndices: PropTypes.array,
  showLastDivider: PropTypes.bool,
  multiColumnEnabled: PropTypes.bool,
  condensed: PropTypes.bool,
  showDividers: PropTypes.bool,
  selectedRadio: PropTypes.string,
  listType: PropTypes.oneOf(["read-only", "selectable", "navigational", "single-select", "multi-select", "quick-select"]),
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func,
  onExpand: PropTypes.func,
  onCollapse: PropTypes.func
};
MdsList.defaultProps = {
  collapsible: false,
  defaultCollapsed: false,
  selectedIndex: -1,
  selectedIndices: [],
  showLastDivider: false,
  multiColumnEnabled: false,
  condensed: false,
  selectedRadio: "",
  listType: "read-only",
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onChange: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null,
  onExpand: null,
  onCollapse: null
};

var MdsLoadMore = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsLoadMore, _React$Component);

  var _super = _createSuper(MdsLoadMore);

  function MdsLoadMore(props) {
    var _this;

    _classCallCheck(this, MdsLoadMore);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeydown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseenter) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseover) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchend) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsLoadMore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-load-more", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "cta-text": Array.isArray(this.props.ctaText) || this.props.ctaText === Object(this.props.ctaText) ? JSON.stringify(this.props.ctaText) : this.props.ctaText,
        "hide-cta": Array.isArray(this.props.hideCta) || this.props.hideCta === Object(this.props.hideCta) ? JSON.stringify(this.props.hideCta) : this.props.hideCta,
        "horizontal-rule": Array.isArray(this.props.horizontalRule) || this.props.horizontalRule === Object(this.props.horizontalRule) ? JSON.stringify(this.props.horizontalRule) : this.props.horizontalRule,
        "status-text": Array.isArray(this.props.statusText) || this.props.statusText === Object(this.props.statusText) ? JSON.stringify(this.props.statusText) : this.props.statusText,
        "status-accessible-text": Array.isArray(this.props.statusAccessibleText) || this.props.statusAccessibleText === Object(this.props.statusAccessibleText) ? JSON.stringify(this.props.statusAccessibleText) : this.props.statusAccessibleText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsLoadMore;
}(React.Component);
MdsLoadMore.propTypes = {
  // Values
  ctaText: PropTypes.string,
  hideCta: PropTypes.bool,
  horizontalRule: PropTypes.bool,
  statusText: PropTypes.string,
  statusAccessibleText: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeydown: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsLoadMore.defaultProps = {
  hideCta: false,
  horizontalRule: false,
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onKeydown: null,
  onKeyup: null,
  onMouseenter: null,
  onMouseover: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsMenu, _React$Component);

  var _super = _createSuper(MdsMenu);

  function MdsMenu(props) {
    var _this;

    _classCallCheck(this, MdsMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onOpen) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClose) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onFocus) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMousedown) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseover) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseout) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchend) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-menu", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "footnote-text": Array.isArray(this.props.footnoteText) || this.props.footnoteText === Object(this.props.footnoteText) ? JSON.stringify(this.props.footnoteText) : this.props.footnoteText,
        "column-width": Array.isArray(this.props.columnWidth) || this.props.columnWidth === Object(this.props.columnWidth) ? JSON.stringify(this.props.columnWidth) : this.props.columnWidth,
        "menu-alignment": Array.isArray(this.props.menuAlignment) || this.props.menuAlignment === Object(this.props.menuAlignment) ? JSON.stringify(this.props.menuAlignment) : this.props.menuAlignment,
        "menu-position": Array.isArray(this.props.menuPosition) || this.props.menuPosition === Object(this.props.menuPosition) ? JSON.stringify(this.props.menuPosition) : this.props.menuPosition,
        "show-pointer": Array.isArray(this.props.showPointer) || this.props.showPointer === Object(this.props.showPointer) ? JSON.stringify(this.props.showPointer) : this.props.showPointer,
        visible: Array.isArray(this.props.visible) || this.props.visible === Object(this.props.visible) ? JSON.stringify(this.props.visible) : this.props.visible,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsMenu;
}(React.Component);
MdsMenu.propTypes = {
  // Values
  footnoteText: PropTypes.string,
  columnWidth: CustomPropTypes.integer,
  menuAlignment: PropTypes.oneOf(["left", "right", "center"]),
  menuPosition: PropTypes.oneOf(["above", "below"]),
  showPointer: PropTypes.bool,
  visible: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsMenu.defaultProps = {
  columnWidth: 120,
  menuAlignment: "left",
  menuPosition: "below",
  showPointer: false,
  visible: false,
  // Events
  onOpen: null,
  onClose: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsMenuButton = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsMenuButton, _React$Component);

  var _super = _createSuper(MdsMenuButton);

  function MdsMenuButton(props) {
    var _this;

    _classCallCheck(this, MdsMenuButton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onOpen) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClose) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickMenu", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClickMenu) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClickMenu(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onClick) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onClickMenu = _this._onClickMenu.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsMenuButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("click-menu", this._onClickMenu);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("click-menu", this._onClickMenu);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-menu-button", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "max-width": Array.isArray(this.props.maxWidth) || this.props.maxWidth === Object(this.props.maxWidth) ? JSON.stringify(this.props.maxWidth) : this.props.maxWidth,
        visible: Array.isArray(this.props.visible) || this.props.visible === Object(this.props.visible) ? JSON.stringify(this.props.visible) : this.props.visible,
        "tooltip-placement": Array.isArray(this.props.tooltipPlacement) || this.props.tooltipPlacement === Object(this.props.tooltipPlacement) ? JSON.stringify(this.props.tooltipPlacement) : this.props.tooltipPlacement,
        alignment: Array.isArray(this.props.alignment) || this.props.alignment === Object(this.props.alignment) ? JSON.stringify(this.props.alignment) : this.props.alignment,
        "edge-detection": Array.isArray(this.props.edgeDetection) || this.props.edgeDetection === Object(this.props.edgeDetection) ? JSON.stringify(this.props.edgeDetection) : this.props.edgeDetection,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "custom-menu": Array.isArray(this.props.customMenu) || this.props.customMenu === Object(this.props.customMenu) ? JSON.stringify(this.props.customMenu) : this.props.customMenu // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsMenuButton;
}(React.Component);
MdsMenuButton.propTypes = {
  // Values
  maxWidth: PropTypes.string,
  visible: PropTypes.bool,
  tooltipPlacement: PropTypes.oneOf(["above", "below"]),
  alignment: PropTypes.oneOf(["left", "right", "center"]),
  edgeDetection: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  customMenu: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onClickMenu: PropTypes.func,
  onClick: PropTypes.func
};
MdsMenuButton.defaultProps = {
  visible: false,
  tooltipPlacement: "below",
  alignment: "left",
  edgeDetection: true,
  // Events
  onOpen: null,
  onClose: null,
  onClickMenu: null,
  onClick: null
};

var MdsMessageDrawer = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsMessageDrawer, _React$Component);

  var _super = _createSuper(MdsMessageDrawer);

  function MdsMessageDrawer(props) {
    var _this;

    _classCallCheck(this, MdsMessageDrawer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onKeyup) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onKeydown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onTouchstart) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onTouchend) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsMessageDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-message-drawer", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        expanded: Array.isArray(this.props.expanded) || this.props.expanded === Object(this.props.expanded) ? JSON.stringify(this.props.expanded) : this.props.expanded,
        "sort-type": Array.isArray(this.props.sortType) || this.props.sortType === Object(this.props.sortType) ? JSON.stringify(this.props.sortType) : this.props.sortType,
        "content-slots": Array.isArray(this.props.contentSlots) || this.props.contentSlots === Object(this.props.contentSlots) ? JSON.stringify(this.props.contentSlots) : this.props.contentSlots,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsMessageDrawer;
}(React.Component);
MdsMessageDrawer.propTypes = {
  // Values
  accessibleText: PropTypes.string,
  expanded: PropTypes.bool,
  sortType: PropTypes.oneOf(["severity", "specified"]),
  contentSlots: PropTypes.array,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsMessageDrawer.defaultProps = {
  expanded: true,
  sortType: "specified",
  // Events
  onClick: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsMultiselectOption = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsMultiselectOption, _React$Component);

  var _super = _createSuper(MdsMultiselectOption);

  function MdsMultiselectOption() {
    _classCallCheck(this, MdsMultiselectOption);

    return _super.apply(this, arguments);
  }

  _createClass(MdsMultiselectOption, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-multiselect-option", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        selected: Array.isArray(this.props.selected) || this.props.selected === Object(this.props.selected) ? JSON.stringify(this.props.selected) : this.props.selected,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsMultiselectOption;
}(React.Component);
MdsMultiselectOption.propTypes = {
  // Values
  label: PropTypes.string,
  value: PropTypes.string,
  selected: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["hovered"])
};
MdsMultiselectOption.defaultProps = {
  selected: false
};

var MdsMultiselect = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsMultiselect, _React$Component);

  var _super = _createSuper(MdsMultiselect);

  function MdsMultiselect(props) {
    var _this;

    _classCallCheck(this, MdsMultiselect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFocus) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onChange) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onInput) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onInput(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onKeyup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseout) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onKeydown) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onClick) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onOpen) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onClose) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onAdd", function (event) {
      var _this$props33, _this$props34;

      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onAdd) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onAdd(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onRemove", function (event) {
      var _this$props35, _this$props36;

      ((_this$props35 = _this.props) === null || _this$props35 === void 0 ? void 0 : _this$props35.onRemove) && ((_this$props36 = _this.props) === null || _this$props36 === void 0 ? void 0 : _this$props36.onRemove(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydup", function (event) {
      var _this$props37, _this$props38;

      ((_this$props37 = _this.props) === null || _this$props37 === void 0 ? void 0 : _this$props37.onKeydup) && ((_this$props38 = _this.props) === null || _this$props38 === void 0 ? void 0 : _this$props38.onKeydup(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onAdd = _this._onAdd.bind(_assertThisInitialized(_this));
    _this._onRemove = _this._onRemove.bind(_assertThisInitialized(_this));
    _this._onKeydup = _this._onKeydup.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsMultiselect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("input", this._onInput);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("add", this._onAdd);

      this._ref.current.addEventListener("remove", this._onRemove);

      this._ref.current.addEventListener("keydup", this._onKeydup);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("input", this._onInput);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("add", this._onAdd);

      this._ref.current.removeEventListener("remove", this._onRemove);

      this._ref.current.removeEventListener("keydup", this._onKeydup);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-multiselect", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "floating-label": Array.isArray(this.props.floatingLabel) || this.props.floatingLabel === Object(this.props.floatingLabel) ? JSON.stringify(this.props.floatingLabel) : this.props.floatingLabel,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        "read-only": Array.isArray(this.props.readOnly) || this.props.readOnly === Object(this.props.readOnly) ? JSON.stringify(this.props.readOnly) : this.props.readOnly,
        placeholder: Array.isArray(this.props.placeholder) || this.props.placeholder === Object(this.props.placeholder) ? JSON.stringify(this.props.placeholder) : this.props.placeholder,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        "error-message": Array.isArray(this.props.errorMessage) || this.props.errorMessage === Object(this.props.errorMessage) ? JSON.stringify(this.props.errorMessage) : this.props.errorMessage,
        "error-messages": Array.isArray(this.props.errorMessages) || this.props.errorMessages === Object(this.props.errorMessages) ? JSON.stringify(this.props.errorMessages) : this.props.errorMessages,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        "input-columns": Array.isArray(this.props.inputColumns) || this.props.inputColumns === Object(this.props.inputColumns) ? JSON.stringify(this.props.inputColumns) : this.props.inputColumns,
        "label-columns": Array.isArray(this.props.labelColumns) || this.props.labelColumns === Object(this.props.labelColumns) ? JSON.stringify(this.props.labelColumns) : this.props.labelColumns,
        "error-message-prefix": Array.isArray(this.props.errorMessagePrefix) || this.props.errorMessagePrefix === Object(this.props.errorMessagePrefix) ? JSON.stringify(this.props.errorMessagePrefix) : this.props.errorMessagePrefix,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "accessible-text-selection-status": Array.isArray(this.props.accessibleTextSelectionStatus) || this.props.accessibleTextSelectionStatus === Object(this.props.accessibleTextSelectionStatus) ? JSON.stringify(this.props.accessibleTextSelectionStatus) : this.props.accessibleTextSelectionStatus,
        "accessible-text-input": Array.isArray(this.props.accessibleTextInput) || this.props.accessibleTextInput === Object(this.props.accessibleTextInput) ? JSON.stringify(this.props.accessibleTextInput) : this.props.accessibleTextInput,
        "accessible-text-pill": Array.isArray(this.props.accessibleTextPill) || this.props.accessibleTextPill === Object(this.props.accessibleTextPill) ? JSON.stringify(this.props.accessibleTextPill) : this.props.accessibleTextPill,
        "accessible-text-pill-group": Array.isArray(this.props.accessibleTextPillGroup) || this.props.accessibleTextPillGroup === Object(this.props.accessibleTextPillGroup) ? JSON.stringify(this.props.accessibleTextPillGroup) : this.props.accessibleTextPillGroup,
        "accessible-text-option-count": Array.isArray(this.props.accessibleTextOptionCount) || this.props.accessibleTextOptionCount === Object(this.props.accessibleTextOptionCount) ? JSON.stringify(this.props.accessibleTextOptionCount) : this.props.accessibleTextOptionCount,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        "input-value": Array.isArray(this.props.inputValue) || this.props.inputValue === Object(this.props.inputValue) ? JSON.stringify(this.props.inputValue) : this.props.inputValue,
        "no-options-text": Array.isArray(this.props.noOptionsText) || this.props.noOptionsText === Object(this.props.noOptionsText) ? JSON.stringify(this.props.noOptionsText) : this.props.noOptionsText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsMultiselect;
}(React.Component);
MdsMultiselect.propTypes = {
  // Values
  layout: PropTypes.oneOf(["horizontal", "vertical"]),
  label: PropTypes.string,
  variant: PropTypes.oneOf(["line", "box"]),
  floatingLabel: PropTypes.bool,
  microcopy: PropTypes.string,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  errorMessages: PropTypes.array,
  name: PropTypes.string,
  inputColumns: PropTypes.string,
  labelColumns: PropTypes.string,
  errorMessagePrefix: PropTypes.string,
  brand: PropTypes.string,
  accessibleName: PropTypes.string,
  accessibleTextSelectionStatus: PropTypes.string,
  accessibleTextInput: PropTypes.string,
  accessibleTextPill: PropTypes.string,
  accessibleTextPillGroup: PropTypes.string,
  accessibleTextOptionCount: PropTypes.string,
  inactive: PropTypes.string,
  inputValue: PropTypes.string,
  noOptionsText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "active", "disabled", "error"]),
  // Events
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onInput: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  onKeydup: PropTypes.func
};
MdsMultiselect.defaultProps = {
  layout: "vertical",
  variant: "line",
  floatingLabel: false,
  readOnly: false,
  placeholder: "",
  errorMessagePrefix: "Error",
  // Events
  onFocus: null,
  onChange: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onInput: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onClick: null,
  onOpen: null,
  onClose: null,
  onAdd: null,
  onRemove: null,
  onKeydup: null
};

var MdsNavigationBar = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsNavigationBar, _React$Component);

  var _super = _createSuper(MdsNavigationBar);

  function MdsNavigationBar(props) {
    var _this;

    _classCallCheck(this, MdsNavigationBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClickBackButton", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClickBackButton) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClickBackButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickActionButton", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClickActionButton) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClickActionButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickBottomSheetTrigger", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClickBottomSheetTrigger) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClickBottomSheetTrigger(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusBackButton", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onFocusBackButton) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onFocusBackButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusActionButton", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onFocusActionButton) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onFocusActionButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusBottomSheetTrigger", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onFocusBottomSheetTrigger) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onFocusBottomSheetTrigger(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurBackButton", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onBlurBackButton) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onBlurBackButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurActionButton", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onBlurActionButton) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onBlurActionButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurBottomSheetTrigger", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onBlurBottomSheetTrigger) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onBlurBottomSheetTrigger(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onActivate", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onActivate) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onActivate(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClickBackButton = _this._onClickBackButton.bind(_assertThisInitialized(_this));
    _this._onClickActionButton = _this._onClickActionButton.bind(_assertThisInitialized(_this));
    _this._onClickBottomSheetTrigger = _this._onClickBottomSheetTrigger.bind(_assertThisInitialized(_this));
    _this._onFocusBackButton = _this._onFocusBackButton.bind(_assertThisInitialized(_this));
    _this._onFocusActionButton = _this._onFocusActionButton.bind(_assertThisInitialized(_this));
    _this._onFocusBottomSheetTrigger = _this._onFocusBottomSheetTrigger.bind(_assertThisInitialized(_this));
    _this._onBlurBackButton = _this._onBlurBackButton.bind(_assertThisInitialized(_this));
    _this._onBlurActionButton = _this._onBlurActionButton.bind(_assertThisInitialized(_this));
    _this._onBlurBottomSheetTrigger = _this._onBlurBottomSheetTrigger.bind(_assertThisInitialized(_this));
    _this._onActivate = _this._onActivate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsNavigationBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click-back-button", this._onClickBackButton);

      this._ref.current.addEventListener("click-action-button", this._onClickActionButton);

      this._ref.current.addEventListener("click-bottom-sheet-trigger", this._onClickBottomSheetTrigger);

      this._ref.current.addEventListener("focus-back-button", this._onFocusBackButton);

      this._ref.current.addEventListener("focus-action-button", this._onFocusActionButton);

      this._ref.current.addEventListener("focus-bottom-sheet-trigger", this._onFocusBottomSheetTrigger);

      this._ref.current.addEventListener("blur-back-button", this._onBlurBackButton);

      this._ref.current.addEventListener("blur-action-button", this._onBlurActionButton);

      this._ref.current.addEventListener("blur-bottom-sheet-trigger", this._onBlurBottomSheetTrigger);

      this._ref.current.addEventListener("activate", this._onActivate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click-back-button", this._onClickBackButton);

      this._ref.current.removeEventListener("click-action-button", this._onClickActionButton);

      this._ref.current.removeEventListener("click-bottom-sheet-trigger", this._onClickBottomSheetTrigger);

      this._ref.current.removeEventListener("focus-back-button", this._onFocusBackButton);

      this._ref.current.removeEventListener("focus-action-button", this._onFocusActionButton);

      this._ref.current.removeEventListener("focus-bottom-sheet-trigger", this._onFocusBottomSheetTrigger);

      this._ref.current.removeEventListener("blur-back-button", this._onBlurBackButton);

      this._ref.current.removeEventListener("blur-action-button", this._onBlurActionButton);

      this._ref.current.removeEventListener("blur-bottom-sheet-trigger", this._onBlurBottomSheetTrigger);

      this._ref.current.removeEventListener("activate", this._onActivate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-navigation-bar", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "active-index": Array.isArray(this.props.activeIndex) || this.props.activeIndex === Object(this.props.activeIndex) ? JSON.stringify(this.props.activeIndex) : this.props.activeIndex,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "active-bottom-slot": Array.isArray(this.props.activeBottomSlot) || this.props.activeBottomSlot === Object(this.props.activeBottomSlot) ? JSON.stringify(this.props.activeBottomSlot) : this.props.activeBottomSlot,
        "action-button-text": Array.isArray(this.props.actionButtonText) || this.props.actionButtonText === Object(this.props.actionButtonText) ? JSON.stringify(this.props.actionButtonText) : this.props.actionButtonText,
        "action-button-accessible-text": Array.isArray(this.props.actionButtonAccessibleText) || this.props.actionButtonAccessibleText === Object(this.props.actionButtonAccessibleText) ? JSON.stringify(this.props.actionButtonAccessibleText) : this.props.actionButtonAccessibleText,
        "max-width": Array.isArray(this.props.maxWidth) || this.props.maxWidth === Object(this.props.maxWidth) ? JSON.stringify(this.props.maxWidth) : this.props.maxWidth,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "experience-name": Array.isArray(this.props.experienceName) || this.props.experienceName === Object(this.props.experienceName) ? JSON.stringify(this.props.experienceName) : this.props.experienceName,
        "product-marker": Array.isArray(this.props.productMarker) || this.props.productMarker === Object(this.props.productMarker) ? JSON.stringify(this.props.productMarker) : this.props.productMarker,
        "product-marker-accessible-text": Array.isArray(this.props.productMarkerAccessibleText) || this.props.productMarkerAccessibleText === Object(this.props.productMarkerAccessibleText) ? JSON.stringify(this.props.productMarkerAccessibleText) : this.props.productMarkerAccessibleText,
        "page-name": Array.isArray(this.props.pageName) || this.props.pageName === Object(this.props.pageName) ? JSON.stringify(this.props.pageName) : this.props.pageName,
        "back-button-text": Array.isArray(this.props.backButtonText) || this.props.backButtonText === Object(this.props.backButtonText) ? JSON.stringify(this.props.backButtonText) : this.props.backButtonText,
        "back-button-accessible-text": Array.isArray(this.props.backButtonAccessibleText) || this.props.backButtonAccessibleText === Object(this.props.backButtonAccessibleText) ? JSON.stringify(this.props.backButtonAccessibleText) : this.props.backButtonAccessibleText,
        "secondary-xs-button-text": Array.isArray(this.props.secondaryXsButtonText) || this.props.secondaryXsButtonText === Object(this.props.secondaryXsButtonText) ? JSON.stringify(this.props.secondaryXsButtonText) : this.props.secondaryXsButtonText,
        "secondary-xs-button-accessible-text": Array.isArray(this.props.secondaryXsButtonAccessibleText) || this.props.secondaryXsButtonAccessibleText === Object(this.props.secondaryXsButtonAccessibleText) ? JSON.stringify(this.props.secondaryXsButtonAccessibleText) : this.props.secondaryXsButtonAccessibleText,
        "background-color": Array.isArray(this.props.backgroundColor) || this.props.backgroundColor === Object(this.props.backgroundColor) ? JSON.stringify(this.props.backgroundColor) : this.props.backgroundColor,
        sticky: Array.isArray(this.props.sticky) || this.props.sticky === Object(this.props.sticky) ? JSON.stringify(this.props.sticky) : this.props.sticky,
        "experience-name-heading-level": Array.isArray(this.props.experienceNameHeadingLevel) || this.props.experienceNameHeadingLevel === Object(this.props.experienceNameHeadingLevel) ? JSON.stringify(this.props.experienceNameHeadingLevel) : this.props.experienceNameHeadingLevel,
        "page-name-heading-level": Array.isArray(this.props.pageNameHeadingLevel) || this.props.pageNameHeadingLevel === Object(this.props.pageNameHeadingLevel) ? JSON.stringify(this.props.pageNameHeadingLevel) : this.props.pageNameHeadingLevel,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "search-box-data": Array.isArray(this.props.searchBoxData) || this.props.searchBoxData === Object(this.props.searchBoxData) ? JSON.stringify(this.props.searchBoxData) : this.props.searchBoxData // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsNavigationBar;
}(React.Component);
MdsNavigationBar.propTypes = {
  // Values
  activeIndex: PropTypes.number,
  accessibleText: PropTypes.string,
  activeBottomSlot: PropTypes.string,
  actionButtonText: PropTypes.string,
  actionButtonAccessibleText: PropTypes.string,
  maxWidth: PropTypes.number,
  variant: PropTypes.oneOf(["global", "inApp", "primary", "secondary", "back"]),
  experienceName: PropTypes.string,
  productMarker: PropTypes.string,
  productMarkerAccessibleText: PropTypes.string,
  pageName: PropTypes.string,
  backButtonText: PropTypes.string,
  backButtonAccessibleText: PropTypes.string,
  secondaryXsButtonText: PropTypes.string,
  secondaryXsButtonAccessibleText: PropTypes.string,
  backgroundColor: PropTypes.oneOf(["secondary", "primary"]),
  sticky: PropTypes.bool,
  experienceNameHeadingLevel: PropTypes.number,
  pageNameHeadingLevel: PropTypes.number,
  id: PropTypes.string,
  slot: PropTypes.string,
  searchBoxData: CustomPropTypes.slot,
  // Events
  onClickBackButton: PropTypes.func,
  onClickActionButton: PropTypes.func,
  onClickBottomSheetTrigger: PropTypes.func,
  onFocusBackButton: PropTypes.func,
  onFocusActionButton: PropTypes.func,
  onFocusBottomSheetTrigger: PropTypes.func,
  onBlurBackButton: PropTypes.func,
  onBlurActionButton: PropTypes.func,
  onBlurBottomSheetTrigger: PropTypes.func,
  onActivate: PropTypes.func
};
MdsNavigationBar.defaultProps = {
  activeIndex: -1,
  maxWidth: 1200,
  variant: "global",
  backgroundColor: "primary",
  sticky: false,
  // Events
  onClickBackButton: null,
  onClickActionButton: null,
  onClickBottomSheetTrigger: null,
  onFocusBackButton: null,
  onFocusActionButton: null,
  onFocusBottomSheetTrigger: null,
  onBlurBackButton: null,
  onBlurActionButton: null,
  onBlurBottomSheetTrigger: null,
  onActivate: null
};

var MdsNavigationBarItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsNavigationBarItem, _React$Component);

  var _super = _createSuper(MdsNavigationBarItem);

  function MdsNavigationBarItem(props) {
    var _this;

    _classCallCheck(this, MdsNavigationBarItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onActivate", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onActivate) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onActivate(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onActivate = _this._onActivate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsNavigationBarItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("activate", this._onActivate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("activate", this._onActivate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-navigation-bar-item", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        active: Array.isArray(this.props.active) || this.props.active === Object(this.props.active) ? JSON.stringify(this.props.active) : this.props.active,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "badge-label": Array.isArray(this.props.badgeLabel) || this.props.badgeLabel === Object(this.props.badgeLabel) ? JSON.stringify(this.props.badgeLabel) : this.props.badgeLabel,
        "badge-icon": Array.isArray(this.props.badgeIcon) || this.props.badgeIcon === Object(this.props.badgeIcon) ? JSON.stringify(this.props.badgeIcon) : this.props.badgeIcon,
        "badge-accessible-text": Array.isArray(this.props.badgeAccessibleText) || this.props.badgeAccessibleText === Object(this.props.badgeAccessibleText) ? JSON.stringify(this.props.badgeAccessibleText) : this.props.badgeAccessibleText,
        "trailing-icon": Array.isArray(this.props.trailingIcon) || this.props.trailingIcon === Object(this.props.trailingIcon) ? JSON.stringify(this.props.trailingIcon) : this.props.trailingIcon,
        "bottom-slot-key": Array.isArray(this.props.bottomSlotKey) || this.props.bottomSlotKey === Object(this.props.bottomSlotKey) ? JSON.stringify(this.props.bottomSlotKey) : this.props.bottomSlotKey,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsNavigationBarItem;
}(React.Component);
MdsNavigationBarItem.propTypes = {
  // Values
  variant: PropTypes.oneOf(["global", "inApp"]),
  label: PropTypes.string,
  active: PropTypes.bool,
  accessibleText: PropTypes.string,
  badgeLabel: PropTypes.string,
  badgeIcon: PropTypes.string,
  badgeAccessibleText: PropTypes.string,
  trailingIcon: PropTypes.string,
  bottomSlotKey: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["hovered", "focused", "pressed"]),
  // Events
  onActivate: PropTypes.func
};
MdsNavigationBarItem.defaultProps = {
  variant: "global",
  active: false,
  // Events
  onActivate: null
};

var MdsNavigationBarBottom = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsNavigationBarBottom, _React$Component);

  var _super = _createSuper(MdsNavigationBarBottom);

  function MdsNavigationBarBottom(props) {
    var _this;

    _classCallCheck(this, MdsNavigationBarBottom);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onActivate", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onActivate) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onActivate(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onActivate = _this._onActivate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsNavigationBarBottom, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("activate", this._onActivate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("activate", this._onActivate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-navigation-bar-bottom", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "experience-name": Array.isArray(this.props.experienceName) || this.props.experienceName === Object(this.props.experienceName) ? JSON.stringify(this.props.experienceName) : this.props.experienceName,
        "product-marker": Array.isArray(this.props.productMarker) || this.props.productMarker === Object(this.props.productMarker) ? JSON.stringify(this.props.productMarker) : this.props.productMarker,
        subtitle: Array.isArray(this.props.subtitle) || this.props.subtitle === Object(this.props.subtitle) ? JSON.stringify(this.props.subtitle) : this.props.subtitle,
        "journey-marker-text": Array.isArray(this.props.journeyMarkerText) || this.props.journeyMarkerText === Object(this.props.journeyMarkerText) ? JSON.stringify(this.props.journeyMarkerText) : this.props.journeyMarkerText,
        "active-index": Array.isArray(this.props.activeIndex) || this.props.activeIndex === Object(this.props.activeIndex) ? JSON.stringify(this.props.activeIndex) : this.props.activeIndex,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsNavigationBarBottom;
}(React.Component);
MdsNavigationBarBottom.propTypes = {
  // Values
  experienceName: PropTypes.string,
  productMarker: PropTypes.string,
  subtitle: PropTypes.string,
  journeyMarkerText: PropTypes.string,
  activeIndex: PropTypes.number,
  accessibleText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onActivate: PropTypes.func
};
MdsNavigationBarBottom.defaultProps = {
  activeIndex: 0,
  // Events
  onActivate: null
};

var MdsNavigationBarMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsNavigationBarMenu, _React$Component);

  var _super = _createSuper(MdsNavigationBarMenu);

  function MdsNavigationBarMenu(props) {
    var _this;

    _classCallCheck(this, MdsNavigationBarMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onOpen) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClose) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onChange) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onChange(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsNavigationBarMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("change", this._onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("change", this._onChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-navigation-bar-menu", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "active-index": Array.isArray(this.props.activeIndex) || this.props.activeIndex === Object(this.props.activeIndex) ? JSON.stringify(this.props.activeIndex) : this.props.activeIndex,
        "inactive-message": Array.isArray(this.props.inactiveMessage) || this.props.inactiveMessage === Object(this.props.inactiveMessage) ? JSON.stringify(this.props.inactiveMessage) : this.props.inactiveMessage,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsNavigationBarMenu;
}(React.Component);
MdsNavigationBarMenu.propTypes = {
  // Values
  variant: PropTypes.oneOf(["single", "mega", "overflow"]),
  activeIndex: CustomPropTypes.integer,
  inactiveMessage: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onChange: PropTypes.func
};
MdsNavigationBarMenu.defaultProps = {
  variant: "single",
  activeIndex: -1,
  // Events
  onOpen: null,
  onClose: null,
  onChange: null
};

var MdsNavigationBarMenuItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsNavigationBarMenuItem, _React$Component);

  var _super = _createSuper(MdsNavigationBarMenuItem);

  function MdsNavigationBarMenuItem(props) {
    var _this;

    _classCallCheck(this, MdsNavigationBarMenuItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onActivate", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onActivate) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onActivate(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onActivate = _this._onActivate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsNavigationBarMenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("activate", this._onActivate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("activate", this._onActivate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-navigation-bar-menu-item", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        active: Array.isArray(this.props.active) || this.props.active === Object(this.props.active) ? JSON.stringify(this.props.active) : this.props.active,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        type: Array.isArray(this.props.type) || this.props.type === Object(this.props.type) ? JSON.stringify(this.props.type) : this.props.type,
        expanded: Array.isArray(this.props.expanded) || this.props.expanded === Object(this.props.expanded) ? JSON.stringify(this.props.expanded) : this.props.expanded,
        "bottom-slot-key": Array.isArray(this.props.bottomSlotKey) || this.props.bottomSlotKey === Object(this.props.bottomSlotKey) ? JSON.stringify(this.props.bottomSlotKey) : this.props.bottomSlotKey,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsNavigationBarMenuItem;
}(React.Component);
MdsNavigationBarMenuItem.propTypes = {
  // Values
  label: PropTypes.string,
  active: PropTypes.bool,
  inactive: PropTypes.bool,
  type: PropTypes.oneOf(["link", "collapsible", "heading"]),
  expanded: PropTypes.bool,
  bottomSlotKey: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["hovered", "focused", "pressed"]),
  // Events
  onActivate: PropTypes.func
};
MdsNavigationBarMenuItem.defaultProps = {
  active: false,
  inactive: false,
  type: "link",
  expanded: false,
  // Events
  onActivate: null
};

var MdsProgressBar = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsProgressBar, _React$Component);

  var _super = _createSuper(MdsProgressBar);

  function MdsProgressBar(props) {
    var _this;

    _classCallCheck(this, MdsProgressBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-progress-bar", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "progress-percentage": Array.isArray(this.props.progressPercentage) || this.props.progressPercentage === Object(this.props.progressPercentage) ? JSON.stringify(this.props.progressPercentage) : this.props.progressPercentage,
        "role-name": Array.isArray(this.props.roleName) || this.props.roleName === Object(this.props.roleName) ? JSON.stringify(this.props.roleName) : this.props.roleName,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsProgressBar;
}(React.Component);
MdsProgressBar.propTypes = {
  // Values
  accessibleText: PropTypes.string,
  progressPercentage: PropTypes.number,
  roleName: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsProgressBar.defaultProps = {
  progressPercentage: 0,
  roleName: "progress bar",
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsProgressBarRadial = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsProgressBarRadial, _React$Component);

  var _super = _createSuper(MdsProgressBarRadial);

  function MdsProgressBarRadial(props) {
    var _this;

    _classCallCheck(this, MdsProgressBarRadial);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsProgressBarRadial, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-progress-bar-radial", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "progress-percentage": Array.isArray(this.props.progressPercentage) || this.props.progressPercentage === Object(this.props.progressPercentage) ? JSON.stringify(this.props.progressPercentage) : this.props.progressPercentage,
        text: Array.isArray(this.props.text) || this.props.text === Object(this.props.text) ? JSON.stringify(this.props.text) : this.props.text,
        size: Array.isArray(this.props.size) || this.props.size === Object(this.props.size) ? JSON.stringify(this.props.size) : this.props.size,
        "percent-sign": Array.isArray(this.props.percentSign) || this.props.percentSign === Object(this.props.percentSign) ? JSON.stringify(this.props.percentSign) : this.props.percentSign,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }), Array.isArray(this.props.key) || this.props.key === Object(this.props.key) ? JSON.stringify(this.props.key) : this.props.key);
    }
  }]);

  return MdsProgressBarRadial;
}(React.Component);
MdsProgressBarRadial.propTypes = {
  // Values
  accessibleText: PropTypes.string,
  progressPercentage: PropTypes.number,
  key: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.oneOf(["regular", "small"]),
  percentSign: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsProgressBarRadial.defaultProps = {
  size: "regular",
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsProgressSpinner = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsProgressSpinner, _React$Component);

  var _super = _createSuper(MdsProgressSpinner);

  function MdsProgressSpinner(props) {
    var _this;

    _classCallCheck(this, MdsProgressSpinner);

    _this = _super.call(this, props);
    _this._ref = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(MdsProgressSpinner, [{
    key: "componentDidMount",
    value: function componentDidMount() {// Imperative Actions
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Imperative Actions
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-progress-spinner", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "loading-label": Array.isArray(this.props.loadingLabel) || this.props.loadingLabel === Object(this.props.loadingLabel) ? JSON.stringify(this.props.loadingLabel) : this.props.loadingLabel,
        open: Array.isArray(this.props.open) || this.props.open === Object(this.props.open) ? JSON.stringify(this.props.open) : this.props.open,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        "trigger-id": Array.isArray(this.props.triggerId) || this.props.triggerId === Object(this.props.triggerId) ? JSON.stringify(this.props.triggerId) : this.props.triggerId,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        inverse: Array.isArray(this.props.inverse) || this.props.inverse === Object(this.props.inverse) ? JSON.stringify(this.props.inverse) : this.props.inverse,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsProgressSpinner;
}(React.Component);
MdsProgressSpinner.propTypes = {
  // Values
  loadingLabel: PropTypes.string,
  open: PropTypes.bool,
  microcopy: PropTypes.string,
  triggerId: PropTypes.string,
  brand: PropTypes.string,
  inverse: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string
};
MdsProgressSpinner.defaultProps = {
  loadingLabel: "Loading",
  open: false,
  inverse: false
};

var MdsProgressSpinnerInline = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsProgressSpinnerInline, _React$Component);

  var _super = _createSuper(MdsProgressSpinnerInline);

  function MdsProgressSpinnerInline() {
    _classCallCheck(this, MdsProgressSpinnerInline);

    return _super.apply(this, arguments);
  }

  _createClass(MdsProgressSpinnerInline, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-progress-spinner-inline", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        size: Array.isArray(this.props.size) || this.props.size === Object(this.props.size) ? JSON.stringify(this.props.size) : this.props.size,
        inverse: Array.isArray(this.props.inverse) || this.props.inverse === Object(this.props.inverse) ? JSON.stringify(this.props.inverse) : this.props.inverse,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsProgressSpinnerInline;
}(React.Component);
MdsProgressSpinnerInline.propTypes = {
  // Values
  size: PropTypes.oneOf(["extraSmall", "small", "medium", "large"]),
  inverse: PropTypes.bool,
  accessibleText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string
};
MdsProgressSpinnerInline.defaultProps = {
  size: "medium",
  inverse: false,
  accessibleText: "false"
};

var MdsProgressSteps = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsProgressSteps, _React$Component);

  var _super = _createSuper(MdsProgressSteps);

  function MdsProgressSteps(props) {
    var _this;

    _classCallCheck(this, MdsProgressSteps);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsProgressSteps, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-progress-steps", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "active-step": Array.isArray(this.props.activeStep) || this.props.activeStep === Object(this.props.activeStep) ? JSON.stringify(this.props.activeStep) : this.props.activeStep,
        "num-steps": Array.isArray(this.props.numSteps) || this.props.numSteps === Object(this.props.numSteps) ? JSON.stringify(this.props.numSteps) : this.props.numSteps,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsProgressSteps;
}(React.Component);
MdsProgressSteps.propTypes = {
  // Values
  accessibleText: PropTypes.string,
  activeStep: CustomPropTypes.integer,
  numSteps: CustomPropTypes.integer,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsProgressSteps.defaultProps = {
  activeStep: 1,
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsQuickActionBar = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsQuickActionBar, _React$Component);

  var _super = _createSuper(MdsQuickActionBar);

  function MdsQuickActionBar(props) {
    var _this;

    _classCallCheck(this, MdsQuickActionBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTouchend) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onBlur) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onKeyup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseout) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickButton", function (event) {
      var _event$detail, _event$detail$target, _event$detail$target$, _this$props9, _this$props10;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : (_event$detail$target = _event$detail.target) === null || _event$detail$target === void 0 ? void 0 : (_event$detail$target$ = _event$detail$target.dataset) === null || _event$detail$target$ === void 0 ? void 0 : _event$detail$target$.index) + 1 || 1;
      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onClickButton) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onClickButton(event, eventIndex));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseover) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseenter) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onClick) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onClickButton = _this._onClickButton.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsQuickActionBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("click-button1", this._onClickButton);

      this._ref.current.addEventListener("click-button2", this._onClickButton);

      this._ref.current.addEventListener("click-button3", this._onClickButton);

      this._ref.current.addEventListener("click-button4", this._onClickButton);

      this._ref.current.addEventListener("click-button5", this._onClickButton);

      this._ref.current.addEventListener("click-button6", this._onClickButton);

      this._ref.current.addEventListener("click-button7", this._onClickButton);

      this._ref.current.addEventListener("click-button8", this._onClickButton);

      this._ref.current.addEventListener("click-button9", this._onClickButton);

      this._ref.current.addEventListener("click-button10", this._onClickButton);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("click-button1", this._onClickButton);

      this._ref.current.removeEventListener("click-button2", this._onClickButton);

      this._ref.current.removeEventListener("click-button3", this._onClickButton);

      this._ref.current.removeEventListener("click-button4", this._onClickButton);

      this._ref.current.removeEventListener("click-button5", this._onClickButton);

      this._ref.current.removeEventListener("click-button6", this._onClickButton);

      this._ref.current.removeEventListener("click-button7", this._onClickButton);

      this._ref.current.removeEventListener("click-button8", this._onClickButton);

      this._ref.current.removeEventListener("click-button9", this._onClickButton);

      this._ref.current.removeEventListener("click-button10", this._onClickButton);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-quick-action-bar", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "width-type": Array.isArray(this.props.widthType) || this.props.widthType === Object(this.props.widthType) ? JSON.stringify(this.props.widthType) : this.props.widthType,
        "button-set-alignment": Array.isArray(this.props.buttonSetAlignment) || this.props.buttonSetAlignment === Object(this.props.buttonSetAlignment) ? JSON.stringify(this.props.buttonSetAlignment) : this.props.buttonSetAlignment,
        "leading-padding": Array.isArray(this.props.leadingPadding) || this.props.leadingPadding === Object(this.props.leadingPadding) ? JSON.stringify(this.props.leadingPadding) : this.props.leadingPadding,
        "trailing-padding": Array.isArray(this.props.trailingPadding) || this.props.trailingPadding === Object(this.props.trailingPadding) ? JSON.stringify(this.props.trailingPadding) : this.props.trailingPadding,
        "accessible-heading-name": Array.isArray(this.props.accessibleHeadingName) || this.props.accessibleHeadingName === Object(this.props.accessibleHeadingName) ? JSON.stringify(this.props.accessibleHeadingName) : this.props.accessibleHeadingName,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "quick-action-buttons": Array.isArray(this.props.quickActionButtons) || this.props.quickActionButtons === Object(this.props.quickActionButtons) ? JSON.stringify(this.props.quickActionButtons) : this.props.quickActionButtons // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsQuickActionBar;
}(React.Component);
MdsQuickActionBar.propTypes = {
  // Values
  variant: PropTypes.oneOf(["button", "tile"]),
  widthType: PropTypes.oneOf(["fixed", "dynamic"]),
  buttonSetAlignment: PropTypes.oneOf(["leading", "trailing", "center"]),
  leadingPadding: PropTypes.string,
  trailingPadding: PropTypes.string,
  accessibleHeadingName: PropTypes.string,
  headingLevel: PropTypes.number,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  quickActionButtons: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onClickButton: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsQuickActionBar.defaultProps = {
  widthType: "dynamic",
  buttonSetAlignment: "leading",
  leadingPadding: "0px",
  trailingPadding: "0px",
  headingLevel: 2,
  // Events
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onClickButton: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsRadioGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsRadioGroup, _React$Component);

  var _super = _createSuper(MdsRadioGroup);

  function MdsRadioGroup(props) {
    var _this;

    _classCallCheck(this, MdsRadioGroup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseover) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onTouchend) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeyup) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseout) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onKeydown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onFocus) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseup) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onClick) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsRadioGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-radio-group", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "radio-type": Array.isArray(this.props.radioType) || this.props.radioType === Object(this.props.radioType) ? JSON.stringify(this.props.radioType) : this.props.radioType,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        "selected-index": Array.isArray(this.props.selectedIndex) || this.props.selectedIndex === Object(this.props.selectedIndex) ? JSON.stringify(this.props.selectedIndex) : this.props.selectedIndex,
        "selected-radio": Array.isArray(this.props.selectedRadio) || this.props.selectedRadio === Object(this.props.selectedRadio) ? JSON.stringify(this.props.selectedRadio) : this.props.selectedRadio,
        error: Array.isArray(this.props.error) || this.props.error === Object(this.props.error) ? JSON.stringify(this.props.error) : this.props.error,
        "error-message": Array.isArray(this.props.errorMessage) || this.props.errorMessage === Object(this.props.errorMessage) ? JSON.stringify(this.props.errorMessage) : this.props.errorMessage,
        "field-group-layout": Array.isArray(this.props.fieldGroupLayout) || this.props.fieldGroupLayout === Object(this.props.fieldGroupLayout) ? JSON.stringify(this.props.fieldGroupLayout) : this.props.fieldGroupLayout,
        "field-group-microcopy": Array.isArray(this.props.fieldGroupMicrocopy) || this.props.fieldGroupMicrocopy === Object(this.props.fieldGroupMicrocopy) ? JSON.stringify(this.props.fieldGroupMicrocopy) : this.props.fieldGroupMicrocopy,
        "radio-field-group-label-text": Array.isArray(this.props.radioFieldGroupLabelText) || this.props.radioFieldGroupLabelText === Object(this.props.radioFieldGroupLabelText) ? JSON.stringify(this.props.radioFieldGroupLabelText) : this.props.radioFieldGroupLabelText,
        "error-icon-accessible-text": Array.isArray(this.props.errorIconAccessibleText) || this.props.errorIconAccessibleText === Object(this.props.errorIconAccessibleText) ? JSON.stringify(this.props.errorIconAccessibleText) : this.props.errorIconAccessibleText,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        "label-size": Array.isArray(this.props.labelSize) || this.props.labelSize === Object(this.props.labelSize) ? JSON.stringify(this.props.labelSize) : this.props.labelSize,
        "label-columns": Array.isArray(this.props.labelColumns) || this.props.labelColumns === Object(this.props.labelColumns) ? JSON.stringify(this.props.labelColumns) : this.props.labelColumns,
        "input-columns": Array.isArray(this.props.inputColumns) || this.props.inputColumns === Object(this.props.inputColumns) ? JSON.stringify(this.props.inputColumns) : this.props.inputColumns,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "button-size": Array.isArray(this.props.buttonSize) || this.props.buttonSize === Object(this.props.buttonSize) ? JSON.stringify(this.props.buttonSize) : this.props.buttonSize,
        "remove-bottom-margin": Array.isArray(this.props.removeBottomMargin) || this.props.removeBottomMargin === Object(this.props.removeBottomMargin) ? JSON.stringify(this.props.removeBottomMargin) : this.props.removeBottomMargin,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "radio-buttons": Array.isArray(this.props.radioButtons) || this.props.radioButtons === Object(this.props.radioButtons) ? JSON.stringify(this.props.radioButtons) : this.props.radioButtons // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsRadioGroup;
}(React.Component);
MdsRadioGroup.propTypes = {
  // Values
  radioType: PropTypes.oneOf(["base", "button"]),
  layout: PropTypes.oneOf(["horizontal", "vertical"]),
  selectedIndex: CustomPropTypes.integer,
  selectedRadio: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  fieldGroupLayout: PropTypes.oneOf(["horizontal", "vertical"]),
  fieldGroupMicrocopy: PropTypes.string,
  radioFieldGroupLabelText: PropTypes.string,
  errorIconAccessibleText: PropTypes.string,
  inactive: PropTypes.bool,
  name: PropTypes.string,
  labelSize: PropTypes.oneOf(["regular", "medium", "prominent"]),
  labelColumns: PropTypes.string,
  inputColumns: PropTypes.string,
  brand: PropTypes.string,
  buttonSize: PropTypes.oneOf(["regular", "small"]),
  removeBottomMargin: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  radioButtons: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func
};
MdsRadioGroup.defaultProps = {
  radioType: "base",
  layout: "vertical",
  selectedIndex: -1,
  selectedRadio: "",
  error: false,
  fieldGroupLayout: "vertical",
  errorIconAccessibleText: "",
  inactive: false,
  labelSize: "regular",
  labelColumns: "mds-col-3",
  inputColumns: "mds-col-9",
  buttonSize: "regular",
  removeBottomMargin: false,
  // Events
  onChange: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onFocus: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onClick: null
};

var MdsRatingIndicator = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsRatingIndicator, _React$Component);

  var _super = _createSuper(MdsRatingIndicator);

  function MdsRatingIndicator(props) {
    var _this;

    _classCallCheck(this, MdsRatingIndicator);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsRatingIndicator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-rating-indicator", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        rating: Array.isArray(this.props.rating) || this.props.rating === Object(this.props.rating) ? JSON.stringify(this.props.rating) : this.props.rating,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsRatingIndicator;
}(React.Component);
MdsRatingIndicator.propTypes = {
  // Values
  rating: PropTypes.oneOf([0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5]),
  accessibleText: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsRatingIndicator.defaultProps = {
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsSearchBox = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSearchBox, _React$Component);

  var _super = _createSuper(MdsSearchBox);

  function MdsSearchBox(props) {
    var _this;

    _classCallCheck(this, MdsSearchBox);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFocus) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onChange) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onOpen) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onInput) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onInput(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseout) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onClose) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onTouchstart) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onClick) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchend) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onKeyup) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onMouseover) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onMouseup) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSelection", function (event) {
      var _this$props33, _this$props34;

      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onSelection) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onSelection(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onSelection = _this._onSelection.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsSearchBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("input", this._onInput);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("selection", this._onSelection);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("input", this._onInput);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("selection", this._onSelection);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-search-box", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "label-style": Array.isArray(this.props.labelStyle) || this.props.labelStyle === Object(this.props.labelStyle) ? JSON.stringify(this.props.labelStyle) : this.props.labelStyle,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        placeholder: Array.isArray(this.props.placeholder) || this.props.placeholder === Object(this.props.placeholder) ? JSON.stringify(this.props.placeholder) : this.props.placeholder,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        "menu-width": Array.isArray(this.props.menuWidth) || this.props.menuWidth === Object(this.props.menuWidth) ? JSON.stringify(this.props.menuWidth) : this.props.menuWidth,
        "no-results-text": Array.isArray(this.props.noResultsText) || this.props.noResultsText === Object(this.props.noResultsText) ? JSON.stringify(this.props.noResultsText) : this.props.noResultsText,
        "show-query-if-no-results": Array.isArray(this.props.showQueryIfNoResults) || this.props.showQueryIfNoResults === Object(this.props.showQueryIfNoResults) ? JSON.stringify(this.props.showQueryIfNoResults) : this.props.showQueryIfNoResults,
        "input-value": Array.isArray(this.props.inputValue) || this.props.inputValue === Object(this.props.inputValue) ? JSON.stringify(this.props.inputValue) : this.props.inputValue,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        "search-mode": Array.isArray(this.props.searchMode) || this.props.searchMode === Object(this.props.searchMode) ? JSON.stringify(this.props.searchMode) : this.props.searchMode,
        "waiting-state": Array.isArray(this.props.waitingState) || this.props.waitingState === Object(this.props.waitingState) ? JSON.stringify(this.props.waitingState) : this.props.waitingState,
        "waiting-state-accessible-text": Array.isArray(this.props.waitingStateAccessibleText) || this.props.waitingStateAccessibleText === Object(this.props.waitingStateAccessibleText) ? JSON.stringify(this.props.waitingStateAccessibleText) : this.props.waitingStateAccessibleText,
        "z-index": Array.isArray(this.props.zIndex) || this.props.zIndex === Object(this.props.zIndex) ? JSON.stringify(this.props.zIndex) : this.props.zIndex,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "label-columns": Array.isArray(this.props.labelColumns) || this.props.labelColumns === Object(this.props.labelColumns) ? JSON.stringify(this.props.labelColumns) : this.props.labelColumns,
        "input-columns": Array.isArray(this.props.inputColumns) || this.props.inputColumns === Object(this.props.inputColumns) ? JSON.stringify(this.props.inputColumns) : this.props.inputColumns,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        "clear-button-accessible-text": Array.isArray(this.props.clearButtonAccessibleText) || this.props.clearButtonAccessibleText === Object(this.props.clearButtonAccessibleText) ? JSON.stringify(this.props.clearButtonAccessibleText) : this.props.clearButtonAccessibleText,
        "result-count-accessible-text": Array.isArray(this.props.resultCountAccessibleText) || this.props.resultCountAccessibleText === Object(this.props.resultCountAccessibleText) ? JSON.stringify(this.props.resultCountAccessibleText) : this.props.resultCountAccessibleText,
        "disable-edge-detection": Array.isArray(this.props.disableEdgeDetection) || this.props.disableEdgeDetection === Object(this.props.disableEdgeDetection) ? JSON.stringify(this.props.disableEdgeDetection) : this.props.disableEdgeDetection,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        options: Array.isArray(this.props.options) || this.props.options === Object(this.props.options) ? JSON.stringify(this.props.options) : this.props.options // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSearchBox;
}(React.Component);
MdsSearchBox.propTypes = {
  // Values
  label: PropTypes.string,
  labelStyle: PropTypes.oneOf(["horizontal", "vertical", "floating", "hidden"]),
  variant: PropTypes.oneOf(["line", "box"]),
  placeholder: PropTypes.string,
  microcopy: PropTypes.string,
  menuWidth: PropTypes.number,
  noResultsText: PropTypes.string,
  showQueryIfNoResults: PropTypes.bool,
  inputValue: PropTypes.string,
  value: PropTypes.string,
  searchMode: PropTypes.oneOf(["simple", "advanced"]),
  waitingState: PropTypes.bool,
  waitingStateAccessibleText: PropTypes.string,
  zIndex: PropTypes.number,
  brand: PropTypes.string,
  labelColumns: PropTypes.string,
  inputColumns: PropTypes.string,
  name: PropTypes.string,
  inactive: PropTypes.string,
  clearButtonAccessibleText: PropTypes.string,
  resultCountAccessibleText: PropTypes.string,
  disableEdgeDetection: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  options: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onBlur: PropTypes.func,
  onOpen: PropTypes.func,
  onInput: PropTypes.func,
  onMouseout: PropTypes.func,
  onClose: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseup: PropTypes.func,
  onSelection: PropTypes.func
};
MdsSearchBox.defaultProps = {
  labelStyle: "hidden",
  variant: "box",
  showQueryIfNoResults: true,
  searchMode: "simple",
  disableEdgeDetection: false,
  // Events
  onFocus: null,
  onChange: null,
  onMousedown: null,
  onBlur: null,
  onOpen: null,
  onInput: null,
  onMouseout: null,
  onClose: null,
  onKeydown: null,
  onMouseenter: null,
  onTouchstart: null,
  onClick: null,
  onTouchend: null,
  onKeyup: null,
  onMouseover: null,
  onMouseup: null,
  onSelection: null
};

var MdsSelectOptionGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSelectOptionGroup, _React$Component);

  var _super = _createSuper(MdsSelectOptionGroup);

  function MdsSelectOptionGroup() {
    _classCallCheck(this, MdsSelectOptionGroup);

    return _super.apply(this, arguments);
  }

  _createClass(MdsSelectOptionGroup, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-select-option-group", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        collapsible: Array.isArray(this.props.collapsible) || this.props.collapsible === Object(this.props.collapsible) ? JSON.stringify(this.props.collapsible) : this.props.collapsible,
        expanded: Array.isArray(this.props.expanded) || this.props.expanded === Object(this.props.expanded) ? JSON.stringify(this.props.expanded) : this.props.expanded,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSelectOptionGroup;
}(React.Component);
MdsSelectOptionGroup.propTypes = {
  // Values
  label: PropTypes.string,
  collapsible: PropTypes.bool,
  expanded: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string
};
MdsSelectOptionGroup.defaultProps = {};

var MdsSelectOption = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSelectOption, _React$Component);

  var _super = _createSuper(MdsSelectOption);

  function MdsSelectOption(props) {
    var _this;

    _classCallCheck(this, MdsSelectOption);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeydown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseenter) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseover) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchend) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsSelectOption, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-select-option", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "secondary-label": Array.isArray(this.props.secondaryLabel) || this.props.secondaryLabel === Object(this.props.secondaryLabel) ? JSON.stringify(this.props.secondaryLabel) : this.props.secondaryLabel,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        "icon-accessible-text": Array.isArray(this.props.iconAccessibleText) || this.props.iconAccessibleText === Object(this.props.iconAccessibleText) ? JSON.stringify(this.props.iconAccessibleText) : this.props.iconAccessibleText,
        "image-accessible-text": Array.isArray(this.props.imageAccessibleText) || this.props.imageAccessibleText === Object(this.props.imageAccessibleText) ? JSON.stringify(this.props.imageAccessibleText) : this.props.imageAccessibleText,
        "image-url": Array.isArray(this.props.imageUrl) || this.props.imageUrl === Object(this.props.imageUrl) ? JSON.stringify(this.props.imageUrl) : this.props.imageUrl,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        selected: Array.isArray(this.props.selected) || this.props.selected === Object(this.props.selected) ? JSON.stringify(this.props.selected) : this.props.selected,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSelectOption;
}(React.Component);
MdsSelectOption.propTypes = {
  // Values
  label: PropTypes.string,
  secondaryLabel: PropTypes.string,
  image: PropTypes.string,
  icon: PropTypes.string,
  iconAccessibleText: PropTypes.string,
  imageAccessibleText: PropTypes.string,
  imageUrl: PropTypes.string,
  value: PropTypes.string,
  selected: PropTypes.bool,
  accessibleText: PropTypes.string,
  inactive: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "hovered", "disabled"]),
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeydown: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsSelectOption.defaultProps = {
  selected: false,
  inactive: false,
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onKeydown: null,
  onKeyup: null,
  onMouseenter: null,
  onMouseover: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSelect, _React$Component);

  var _super = _createSuper(MdsSelect);

  function MdsSelect(props) {
    var _this;

    _classCallCheck(this, MdsSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFocus) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onChange) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onInput) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onInput(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onKeyup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseout) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onKeydown) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onClick) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onValidate", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onValidate) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onValidate(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onValidate = _this._onValidate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("input", this._onInput);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("validate", this._onValidate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("input", this._onInput);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("validate", this._onValidate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-select", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "floating-label": Array.isArray(this.props.floatingLabel) || this.props.floatingLabel === Object(this.props.floatingLabel) ? JSON.stringify(this.props.floatingLabel) : this.props.floatingLabel,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        "read-only": Array.isArray(this.props.readOnly) || this.props.readOnly === Object(this.props.readOnly) ? JSON.stringify(this.props.readOnly) : this.props.readOnly,
        placeholder: Array.isArray(this.props.placeholder) || this.props.placeholder === Object(this.props.placeholder) ? JSON.stringify(this.props.placeholder) : this.props.placeholder,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        "error-message": Array.isArray(this.props.errorMessage) || this.props.errorMessage === Object(this.props.errorMessage) ? JSON.stringify(this.props.errorMessage) : this.props.errorMessage,
        "error-messages": Array.isArray(this.props.errorMessages) || this.props.errorMessages === Object(this.props.errorMessages) ? JSON.stringify(this.props.errorMessages) : this.props.errorMessages,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        "input-columns": Array.isArray(this.props.inputColumns) || this.props.inputColumns === Object(this.props.inputColumns) ? JSON.stringify(this.props.inputColumns) : this.props.inputColumns,
        "label-columns": Array.isArray(this.props.labelColumns) || this.props.labelColumns === Object(this.props.labelColumns) ? JSON.stringify(this.props.labelColumns) : this.props.labelColumns,
        "error-message-prefix": Array.isArray(this.props.errorMessagePrefix) || this.props.errorMessagePrefix === Object(this.props.errorMessagePrefix) ? JSON.stringify(this.props.errorMessagePrefix) : this.props.errorMessagePrefix,
        decoration: Array.isArray(this.props.decoration) || this.props.decoration === Object(this.props.decoration) ? JSON.stringify(this.props.decoration) : this.props.decoration,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "accessible-text-cardinality-separator": Array.isArray(this.props.accessibleTextCardinalitySeparator) || this.props.accessibleTextCardinalitySeparator === Object(this.props.accessibleTextCardinalitySeparator) ? JSON.stringify(this.props.accessibleTextCardinalitySeparator) : this.props.accessibleTextCardinalitySeparator,
        "accessible-text-collapsed": Array.isArray(this.props.accessibleTextCollapsed) || this.props.accessibleTextCollapsed === Object(this.props.accessibleTextCollapsed) ? JSON.stringify(this.props.accessibleTextCollapsed) : this.props.accessibleTextCollapsed,
        "label-key": Array.isArray(this.props.labelKey) || this.props.labelKey === Object(this.props.labelKey) ? JSON.stringify(this.props.labelKey) : this.props.labelKey,
        "value-key": Array.isArray(this.props.valueKey) || this.props.valueKey === Object(this.props.valueKey) ? JSON.stringify(this.props.valueKey) : this.props.valueKey,
        "selected-index": Array.isArray(this.props.selectedIndex) || this.props.selectedIndex === Object(this.props.selectedIndex) ? JSON.stringify(this.props.selectedIndex) : this.props.selectedIndex,
        "accessible-text-expanded": Array.isArray(this.props.accessibleTextExpanded) || this.props.accessibleTextExpanded === Object(this.props.accessibleTextExpanded) ? JSON.stringify(this.props.accessibleTextExpanded) : this.props.accessibleTextExpanded,
        "label-style": Array.isArray(this.props.labelStyle) || this.props.labelStyle === Object(this.props.labelStyle) ? JSON.stringify(this.props.labelStyle) : this.props.labelStyle,
        "search-enabled": Array.isArray(this.props.searchEnabled) || this.props.searchEnabled === Object(this.props.searchEnabled) ? JSON.stringify(this.props.searchEnabled) : this.props.searchEnabled,
        "search-placeholder": Array.isArray(this.props.searchPlaceholder) || this.props.searchPlaceholder === Object(this.props.searchPlaceholder) ? JSON.stringify(this.props.searchPlaceholder) : this.props.searchPlaceholder,
        "search-input-value": Array.isArray(this.props.searchInputValue) || this.props.searchInputValue === Object(this.props.searchInputValue) ? JSON.stringify(this.props.searchInputValue) : this.props.searchInputValue,
        "search-no-results-text": Array.isArray(this.props.searchNoResultsText) || this.props.searchNoResultsText === Object(this.props.searchNoResultsText) ? JSON.stringify(this.props.searchNoResultsText) : this.props.searchNoResultsText,
        "clear-search-button-acessible-text": Array.isArray(this.props.clearSearchButtonAcessibleText) || this.props.clearSearchButtonAcessibleText === Object(this.props.clearSearchButtonAcessibleText) ? JSON.stringify(this.props.clearSearchButtonAcessibleText) : this.props.clearSearchButtonAcessibleText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        options: Array.isArray(this.props.options) || this.props.options === Object(this.props.options) ? JSON.stringify(this.props.options) : this.props.options,
        "disable-edge-detection": Array.isArray(this.props.disableEdgeDetection) || this.props.disableEdgeDetection === Object(this.props.disableEdgeDetection) ? JSON.stringify(this.props.disableEdgeDetection) : this.props.disableEdgeDetection,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSelect;
}(React.Component);
MdsSelect.propTypes = {
  // Values
  layout: PropTypes.oneOf(["horizontal", "vertical"]),
  label: PropTypes.string,
  variant: PropTypes.oneOf(["line", "box"]),
  floatingLabel: PropTypes.bool,
  microcopy: PropTypes.string,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  errorMessages: PropTypes.array,
  name: PropTypes.string,
  inputColumns: PropTypes.string,
  labelColumns: PropTypes.string,
  errorMessagePrefix: PropTypes.string,
  decoration: PropTypes.oneOf(["none", "image", "icon"]),
  image: PropTypes.string,
  inactive: PropTypes.bool,
  accessibleText: PropTypes.string,
  accessibleTextCardinalitySeparator: PropTypes.string,
  accessibleTextCollapsed: PropTypes.string,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  selectedIndex: PropTypes.number,
  accessibleTextExpanded: PropTypes.string,
  labelStyle: PropTypes.oneOf(["horizontal", "vertical", "floating"]),
  searchEnabled: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  searchInputValue: PropTypes.string,
  searchNoResultsText: PropTypes.string,
  clearSearchButtonAcessibleText: PropTypes.string,
  brand: PropTypes.string,
  options: PropTypes.string,
  disableEdgeDetection: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "active", "disabled", "error"]),
  // Events
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onInput: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func,
  onValidate: PropTypes.func
};
MdsSelect.defaultProps = {
  layout: "vertical",
  variant: "line",
  floatingLabel: false,
  readOnly: false,
  placeholder: "",
  errorMessagePrefix: "Error",
  decoration: "none",
  inactive: false,
  accessibleTextCardinalitySeparator: "of",
  accessibleTextCollapsed: "expanded",
  labelKey: "label",
  valueKey: "value",
  selectedIndex: -1,
  accessibleTextExpanded: "expanded",
  labelStyle: "vertical",
  searchEnabled: false,
  disableEdgeDetection: false,
  // Events
  onFocus: null,
  onChange: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onInput: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onClick: null,
  onValidate: null
};

var MdsSelectableTile = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSelectableTile, _React$Component);

  var _super = _createSuper(MdsSelectableTile);

  function MdsSelectableTile(props) {
    var _this;

    _classCallCheck(this, MdsSelectableTile);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseover) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onTouchend) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeyup) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseout) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onKeydown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onFocus) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseup) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onClick) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsSelectableTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-selectable-tile", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "full-width": Array.isArray(this.props.fullWidth) || this.props.fullWidth === Object(this.props.fullWidth) ? JSON.stringify(this.props.fullWidth) : this.props.fullWidth,
        width: Array.isArray(this.props.width) || this.props.width === Object(this.props.width) ? JSON.stringify(this.props.width) : this.props.width,
        height: Array.isArray(this.props.height) || this.props.height === Object(this.props.height) ? JSON.stringify(this.props.height) : this.props.height,
        checked: Array.isArray(this.props.checked) || this.props.checked === Object(this.props.checked) ? JSON.stringify(this.props.checked) : this.props.checked,
        "content-area": Array.isArray(this.props.contentArea) || this.props.contentArea === Object(this.props.contentArea) ? JSON.stringify(this.props.contentArea) : this.props.contentArea,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        error: Array.isArray(this.props.error) || this.props.error === Object(this.props.error) ? JSON.stringify(this.props.error) : this.props.error,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSelectableTile;
}(React.Component);
MdsSelectableTile.propTypes = {
  // Values
  label: PropTypes.string,
  fullWidth: PropTypes.bool,
  width: CustomPropTypes.integer,
  height: CustomPropTypes.integer,
  checked: PropTypes.bool,
  contentArea: PropTypes.string,
  variant: PropTypes.oneOf(["checkbox", "radio"]),
  accessibleName: PropTypes.string,
  inactive: PropTypes.bool,
  error: PropTypes.bool,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "disabled"]),
  // Events
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func
};
MdsSelectableTile.defaultProps = {
  fullWidth: false,
  checked: false,
  variant: "checkbox",
  inactive: false,
  error: false,
  // Events
  onChange: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onFocus: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onClick: null
};

var MdsSkeletonLoader = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSkeletonLoader, _React$Component);

  var _super = _createSuper(MdsSkeletonLoader);

  function MdsSkeletonLoader(props) {
    var _this;

    _classCallCheck(this, MdsSkeletonLoader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsSkeletonLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-skeleton-loader", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-is-loading-text": Array.isArray(this.props.accessibleIsLoadingText) || this.props.accessibleIsLoadingText === Object(this.props.accessibleIsLoadingText) ? JSON.stringify(this.props.accessibleIsLoadingText) : this.props.accessibleIsLoadingText,
        "accessible-has-loaded-text": Array.isArray(this.props.accessibleHasLoadedText) || this.props.accessibleHasLoadedText === Object(this.props.accessibleHasLoadedText) ? JSON.stringify(this.props.accessibleHasLoadedText) : this.props.accessibleHasLoadedText,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "suppressed-visual-shapes": Array.isArray(this.props.suppressedVisualShapes) || this.props.suppressedVisualShapes === Object(this.props.suppressedVisualShapes) ? JSON.stringify(this.props.suppressedVisualShapes) : this.props.suppressedVisualShapes,
        "is-animated": Array.isArray(this.props.isAnimated) || this.props.isAnimated === Object(this.props.isAnimated) ? JSON.stringify(this.props.isAnimated) : this.props.isAnimated,
        height: Array.isArray(this.props.height) || this.props.height === Object(this.props.height) ? JSON.stringify(this.props.height) : this.props.height,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSkeletonLoader;
}(React.Component);
MdsSkeletonLoader.propTypes = {
  // Values
  accessibleIsLoadingText: PropTypes.string,
  accessibleHasLoadedText: PropTypes.string,
  variant: PropTypes.oneOf(["list", "content-block", "image-and-content"]),
  suppressedVisualShapes: PropTypes.array,
  isAnimated: PropTypes.bool,
  height: CustomPropTypes.integer,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsSkeletonLoader.defaultProps = {
  isAnimated: false,
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsSkipLink = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSkipLink, _React$Component);

  var _super = _createSuper(MdsSkipLink);

  function MdsSkipLink(props) {
    var _this;

    _classCallCheck(this, MdsSkipLink);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onLinkPress", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onLinkPress) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onLinkPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onTouchend) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeyup) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseover) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseenter) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onClick) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onLinkPress = _this._onLinkPress.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsSkipLink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("linkPress", this._onLinkPress);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("linkPress", this._onLinkPress);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-skip-link", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "skip-to": Array.isArray(this.props.skipTo) || this.props.skipTo === Object(this.props.skipTo) ? JSON.stringify(this.props.skipTo) : this.props.skipTo,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        links: Array.isArray(this.props.links) || this.props.links === Object(this.props.links) ? JSON.stringify(this.props.links) : this.props.links // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSkipLink;
}(React.Component);
MdsSkipLink.propTypes = {
  // Values
  skipTo: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  links: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onLinkPress: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsSkipLink.defaultProps = {
  skipTo: "Skip to:",
  // Events
  onLinkPress: null,
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsSlideInPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSlideInPanel, _React$Component);

  var _super = _createSuper(MdsSlideInPanel);

  function MdsSlideInPanel(props) {
    var _this;

    _classCallCheck(this, MdsSlideInPanel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onSlideIn", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onSlideIn) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onSlideIn(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSlideOut", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onSlideOut) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onSlideOut(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickCancelExit", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClickCancelExit) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClickCancelExit(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickBackButton", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onClickBackButton) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onClickBackButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onClose) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onClose(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickConfirmExit", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onClickConfirmExit) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onClickConfirmExit(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickCloseButton", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onClickCloseButton) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onClickCloseButton(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onSlideIn = _this._onSlideIn.bind(_assertThisInitialized(_this));
    _this._onSlideOut = _this._onSlideOut.bind(_assertThisInitialized(_this));
    _this._onClickCancelExit = _this._onClickCancelExit.bind(_assertThisInitialized(_this));
    _this._onClickBackButton = _this._onClickBackButton.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    _this._onClickConfirmExit = _this._onClickConfirmExit.bind(_assertThisInitialized(_this));
    _this._onClickCloseButton = _this._onClickCloseButton.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsSlideInPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("slideIn", this._onSlideIn);

      this._ref.current.addEventListener("slideOut", this._onSlideOut);

      this._ref.current.addEventListener("click-cancel-exit", this._onClickCancelExit);

      this._ref.current.addEventListener("click-back-button", this._onClickBackButton);

      this._ref.current.addEventListener("close", this._onClose);

      this._ref.current.addEventListener("click-confirm-exit", this._onClickConfirmExit);

      this._ref.current.addEventListener("click-close-button", this._onClickCloseButton); // Imperative Actions

    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("slideIn", this._onSlideIn);

      this._ref.current.removeEventListener("slideOut", this._onSlideOut);

      this._ref.current.removeEventListener("click-cancel-exit", this._onClickCancelExit);

      this._ref.current.removeEventListener("click-back-button", this._onClickBackButton);

      this._ref.current.removeEventListener("close", this._onClose);

      this._ref.current.removeEventListener("click-confirm-exit", this._onClickConfirmExit);

      this._ref.current.removeEventListener("click-close-button", this._onClickCloseButton);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
      // Imperative Actions
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-slide-in-panel", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "hide-header": Array.isArray(this.props.hideHeader) || this.props.hideHeader === Object(this.props.hideHeader) ? JSON.stringify(this.props.hideHeader) : this.props.hideHeader,
        "title-text": Array.isArray(this.props.titleText) || this.props.titleText === Object(this.props.titleText) ? JSON.stringify(this.props.titleText) : this.props.titleText,
        "accessible-back-label-text": Array.isArray(this.props.accessibleBackLabelText) || this.props.accessibleBackLabelText === Object(this.props.accessibleBackLabelText) ? JSON.stringify(this.props.accessibleBackLabelText) : this.props.accessibleBackLabelText,
        "accessible-close-label-text": Array.isArray(this.props.accessibleCloseLabelText) || this.props.accessibleCloseLabelText === Object(this.props.accessibleCloseLabelText) ? JSON.stringify(this.props.accessibleCloseLabelText) : this.props.accessibleCloseLabelText,
        subtitle: Array.isArray(this.props.subtitle) || this.props.subtitle === Object(this.props.subtitle) ? JSON.stringify(this.props.subtitle) : this.props.subtitle,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        "width-type": Array.isArray(this.props.widthType) || this.props.widthType === Object(this.props.widthType) ? JSON.stringify(this.props.widthType) : this.props.widthType,
        "back-icon": Array.isArray(this.props.backIcon) || this.props.backIcon === Object(this.props.backIcon) ? JSON.stringify(this.props.backIcon) : this.props.backIcon,
        "back-trigger-id": Array.isArray(this.props.backTriggerId) || this.props.backTriggerId === Object(this.props.backTriggerId) ? JSON.stringify(this.props.backTriggerId) : this.props.backTriggerId,
        "exit-confirmation-okay-button-label": Array.isArray(this.props.exitConfirmationOkayButtonLabel) || this.props.exitConfirmationOkayButtonLabel === Object(this.props.exitConfirmationOkayButtonLabel) ? JSON.stringify(this.props.exitConfirmationOkayButtonLabel) : this.props.exitConfirmationOkayButtonLabel,
        "exit-confirmation-cancel-button-label": Array.isArray(this.props.exitConfirmationCancelButtonLabel) || this.props.exitConfirmationCancelButtonLabel === Object(this.props.exitConfirmationCancelButtonLabel) ? JSON.stringify(this.props.exitConfirmationCancelButtonLabel) : this.props.exitConfirmationCancelButtonLabel,
        "exit-confirmation-required": Array.isArray(this.props.exitConfirmationRequired) || this.props.exitConfirmationRequired === Object(this.props.exitConfirmationRequired) ? JSON.stringify(this.props.exitConfirmationRequired) : this.props.exitConfirmationRequired,
        "exit-confirmation-alert-title": Array.isArray(this.props.exitConfirmationAlertTitle) || this.props.exitConfirmationAlertTitle === Object(this.props.exitConfirmationAlertTitle) ? JSON.stringify(this.props.exitConfirmationAlertTitle) : this.props.exitConfirmationAlertTitle,
        "exit-confirmation-alert-message": Array.isArray(this.props.exitConfirmationAlertMessage) || this.props.exitConfirmationAlertMessage === Object(this.props.exitConfirmationAlertMessage) ? JSON.stringify(this.props.exitConfirmationAlertMessage) : this.props.exitConfirmationAlertMessage,
        "exit-confirmation-alert-accessible-text-icon": Array.isArray(this.props.exitConfirmationAlertAccessibleTextIcon) || this.props.exitConfirmationAlertAccessibleTextIcon === Object(this.props.exitConfirmationAlertAccessibleTextIcon) ? JSON.stringify(this.props.exitConfirmationAlertAccessibleTextIcon) : this.props.exitConfirmationAlertAccessibleTextIcon,
        "exit-confirmation-content-width": Array.isArray(this.props.exitConfirmationContentWidth) || this.props.exitConfirmationContentWidth === Object(this.props.exitConfirmationContentWidth) ? JSON.stringify(this.props.exitConfirmationContentWidth) : this.props.exitConfirmationContentWidth,
        open: Array.isArray(this.props.open) || this.props.open === Object(this.props.open) ? JSON.stringify(this.props.open) : this.props.open,
        "trigger-id": Array.isArray(this.props.triggerId) || this.props.triggerId === Object(this.props.triggerId) ? JSON.stringify(this.props.triggerId) : this.props.triggerId,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSlideInPanel;
}(React.Component);
MdsSlideInPanel.propTypes = {
  // Values
  hideHeader: PropTypes.bool,
  titleText: PropTypes.string,
  accessibleBackLabelText: PropTypes.string,
  accessibleCloseLabelText: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  widthType: PropTypes.oneOf(["extraSmall", "small", "large"]),
  backIcon: PropTypes.bool,
  backTriggerId: PropTypes.string,
  exitConfirmationOkayButtonLabel: PropTypes.string,
  exitConfirmationCancelButtonLabel: PropTypes.string,
  exitConfirmationRequired: PropTypes.bool,
  exitConfirmationAlertTitle: PropTypes.string,
  exitConfirmationAlertMessage: PropTypes.string,
  exitConfirmationAlertAccessibleTextIcon: PropTypes.string,
  exitConfirmationContentWidth: PropTypes.number,
  open: PropTypes.bool,
  triggerId: PropTypes.string,
  brand: PropTypes.string,
  headingLevel: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onSlideIn: PropTypes.func,
  onSlideOut: PropTypes.func,
  onClickCancelExit: PropTypes.func,
  onClickBackButton: PropTypes.func,
  onClose: PropTypes.func,
  onClickConfirmExit: PropTypes.func,
  onClickCloseButton: PropTypes.func
};
MdsSlideInPanel.defaultProps = {
  hideHeader: false,
  accessibleBackLabelText: "back",
  accessibleCloseLabelText: "close",
  widthType: "large",
  backIcon: false,
  exitConfirmationRequired: false,
  open: false,
  // Events
  onSlideIn: null,
  onSlideOut: null,
  onClickCancelExit: null,
  onClickBackButton: null,
  onClose: null,
  onClickConfirmExit: null,
  onClickCloseButton: null
};

var MdsSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSlider, _React$Component);

  var _super = _createSuper(MdsSlider);

  function MdsSlider(props) {
    var _this;

    _classCallCheck(this, MdsSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFocus) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onChange) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onInput) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onInput(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurThumb", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onBlurThumb) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onBlurThumb(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseout) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onKeydown) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseenter) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchstart) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onClick) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchend) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusThumb", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onFocusThumb) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onFocusThumb(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onKeyup) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onMouseover) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onMouseup) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onMouseup(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onBlurThumb = _this._onBlurThumb.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onFocusThumb = _this._onFocusThumb.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("input", this._onInput);

      this._ref.current.addEventListener("blur-thumb", this._onBlurThumb);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("focus-thumb", this._onFocusThumb);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseup", this._onMouseup);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("input", this._onInput);

      this._ref.current.removeEventListener("blur-thumb", this._onBlurThumb);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("focus-thumb", this._onFocusThumb);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-slider", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "slider-label": Array.isArray(this.props.sliderLabel) || this.props.sliderLabel === Object(this.props.sliderLabel) ? JSON.stringify(this.props.sliderLabel) : this.props.sliderLabel,
        "selected-values-label": Array.isArray(this.props.selectedValuesLabel) || this.props.selectedValuesLabel === Object(this.props.selectedValuesLabel) ? JSON.stringify(this.props.selectedValuesLabel) : this.props.selectedValuesLabel,
        "starting-value": Array.isArray(this.props.startingValue) || this.props.startingValue === Object(this.props.startingValue) ? JSON.stringify(this.props.startingValue) : this.props.startingValue,
        "ending-value": Array.isArray(this.props.endingValue) || this.props.endingValue === Object(this.props.endingValue) ? JSON.stringify(this.props.endingValue) : this.props.endingValue,
        "selected-value": Array.isArray(this.props.selectedValue) || this.props.selectedValue === Object(this.props.selectedValue) ? JSON.stringify(this.props.selectedValue) : this.props.selectedValue,
        "leading-selected-value": Array.isArray(this.props.leadingSelectedValue) || this.props.leadingSelectedValue === Object(this.props.leadingSelectedValue) ? JSON.stringify(this.props.leadingSelectedValue) : this.props.leadingSelectedValue,
        "trailing-selected-value": Array.isArray(this.props.trailingSelectedValue) || this.props.trailingSelectedValue === Object(this.props.trailingSelectedValue) ? JSON.stringify(this.props.trailingSelectedValue) : this.props.trailingSelectedValue,
        "leading-label": Array.isArray(this.props.leadingLabel) || this.props.leadingLabel === Object(this.props.leadingLabel) ? JSON.stringify(this.props.leadingLabel) : this.props.leadingLabel,
        "trailing-label": Array.isArray(this.props.trailingLabel) || this.props.trailingLabel === Object(this.props.trailingLabel) ? JSON.stringify(this.props.trailingLabel) : this.props.trailingLabel,
        "leading-label-width": Array.isArray(this.props.leadingLabelWidth) || this.props.leadingLabelWidth === Object(this.props.leadingLabelWidth) ? JSON.stringify(this.props.leadingLabelWidth) : this.props.leadingLabelWidth,
        "trailing-label-width": Array.isArray(this.props.trailingLabelWidth) || this.props.trailingLabelWidth === Object(this.props.trailingLabelWidth) ? JSON.stringify(this.props.trailingLabelWidth) : this.props.trailingLabelWidth,
        "track-width": Array.isArray(this.props.trackWidth) || this.props.trackWidth === Object(this.props.trackWidth) ? JSON.stringify(this.props.trackWidth) : this.props.trackWidth,
        "leading-icon": Array.isArray(this.props.leadingIcon) || this.props.leadingIcon === Object(this.props.leadingIcon) ? JSON.stringify(this.props.leadingIcon) : this.props.leadingIcon,
        "trailing-icon": Array.isArray(this.props.trailingIcon) || this.props.trailingIcon === Object(this.props.trailingIcon) ? JSON.stringify(this.props.trailingIcon) : this.props.trailingIcon,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        "num-intervals": Array.isArray(this.props.numIntervals) || this.props.numIntervals === Object(this.props.numIntervals) ? JSON.stringify(this.props.numIntervals) : this.props.numIntervals,
        "num-range-label-intervals": Array.isArray(this.props.numRangeLabelIntervals) || this.props.numRangeLabelIntervals === Object(this.props.numRangeLabelIntervals) ? JSON.stringify(this.props.numRangeLabelIntervals) : this.props.numRangeLabelIntervals,
        narrow: Array.isArray(this.props.narrow) || this.props.narrow === Object(this.props.narrow) ? JSON.stringify(this.props.narrow) : this.props.narrow,
        "is-selected-value-editable": Array.isArray(this.props.isSelectedValueEditable) || this.props.isSelectedValueEditable === Object(this.props.isSelectedValueEditable) ? JSON.stringify(this.props.isSelectedValueEditable) : this.props.isSelectedValueEditable,
        labels: Array.isArray(this.props.labels) || this.props.labels === Object(this.props.labels) ? JSON.stringify(this.props.labels) : this.props.labels,
        "custom-label": Array.isArray(this.props.customLabel) || this.props.customLabel === Object(this.props.customLabel) ? JSON.stringify(this.props.customLabel) : this.props.customLabel,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "accessible-error-nearest": Array.isArray(this.props.accessibleErrorNearest) || this.props.accessibleErrorNearest === Object(this.props.accessibleErrorNearest) ? JSON.stringify(this.props.accessibleErrorNearest) : this.props.accessibleErrorNearest,
        "accessible-value-text": Array.isArray(this.props.accessibleValueText) || this.props.accessibleValueText === Object(this.props.accessibleValueText) ? JSON.stringify(this.props.accessibleValueText) : this.props.accessibleValueText,
        "accessible-slider-value": Array.isArray(this.props.accessibleSliderValue) || this.props.accessibleSliderValue === Object(this.props.accessibleSliderValue) ? JSON.stringify(this.props.accessibleSliderValue) : this.props.accessibleSliderValue,
        "accessible-range-premodifier": Array.isArray(this.props.accessibleRangePremodifier) || this.props.accessibleRangePremodifier === Object(this.props.accessibleRangePremodifier) ? JSON.stringify(this.props.accessibleRangePremodifier) : this.props.accessibleRangePremodifier,
        "accessible-range-separator": Array.isArray(this.props.accessibleRangeSeparator) || this.props.accessibleRangeSeparator === Object(this.props.accessibleRangeSeparator) ? JSON.stringify(this.props.accessibleRangeSeparator) : this.props.accessibleRangeSeparator,
        "input-size": Array.isArray(this.props.inputSize) || this.props.inputSize === Object(this.props.inputSize) ? JSON.stringify(this.props.inputSize) : this.props.inputSize,
        "accessible-interval": Array.isArray(this.props.accessibleInterval) || this.props.accessibleInterval === Object(this.props.accessibleInterval) ? JSON.stringify(this.props.accessibleInterval) : this.props.accessibleInterval,
        "accessible-slider-premodifier": Array.isArray(this.props.accessibleSliderPremodifier) || this.props.accessibleSliderPremodifier === Object(this.props.accessibleSliderPremodifier) ? JSON.stringify(this.props.accessibleSliderPremodifier) : this.props.accessibleSliderPremodifier,
        states: Array.isArray(this.props.states) || this.props.states === Object(this.props.states) ? JSON.stringify(this.props.states) : this.props.states,
        "accessible-error-adjust": Array.isArray(this.props.accessibleErrorAdjust) || this.props.accessibleErrorAdjust === Object(this.props.accessibleErrorAdjust) ? JSON.stringify(this.props.accessibleErrorAdjust) : this.props.accessibleErrorAdjust,
        "accessible-input": Array.isArray(this.props.accessibleInput) || this.props.accessibleInput === Object(this.props.accessibleInput) ? JSON.stringify(this.props.accessibleInput) : this.props.accessibleInput,
        "slider-type": Array.isArray(this.props.sliderType) || this.props.sliderType === Object(this.props.sliderType) ? JSON.stringify(this.props.sliderType) : this.props.sliderType,
        "accessible-max": Array.isArray(this.props.accessibleMax) || this.props.accessibleMax === Object(this.props.accessibleMax) ? JSON.stringify(this.props.accessibleMax) : this.props.accessibleMax,
        "accessible-min": Array.isArray(this.props.accessibleMin) || this.props.accessibleMin === Object(this.props.accessibleMin) ? JSON.stringify(this.props.accessibleMin) : this.props.accessibleMin,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSlider;
}(React.Component);
MdsSlider.propTypes = {
  // Values
  variant: PropTypes.oneOf(["single", "range"]),
  sliderLabel: PropTypes.string,
  selectedValuesLabel: PropTypes.string,
  startingValue: CustomPropTypes.integer,
  endingValue: CustomPropTypes.integer,
  selectedValue: CustomPropTypes.integer,
  leadingSelectedValue: CustomPropTypes.integer,
  trailingSelectedValue: CustomPropTypes.integer,
  leadingLabel: PropTypes.string,
  trailingLabel: PropTypes.string,
  leadingLabelWidth: PropTypes.string,
  trailingLabelWidth: PropTypes.string,
  trackWidth: PropTypes.string,
  leadingIcon: PropTypes.string,
  trailingIcon: PropTypes.string,
  microcopy: PropTypes.string,
  numIntervals: CustomPropTypes.integer,
  numRangeLabelIntervals: CustomPropTypes.integer,
  narrow: PropTypes.bool,
  isSelectedValueEditable: PropTypes.bool,
  labels: PropTypes.array,
  customLabel: PropTypes.string,
  brand: PropTypes.string,
  accessibleErrorNearest: PropTypes.string,
  accessibleValueText: PropTypes.string,
  accessibleSliderValue: PropTypes.string,
  accessibleRangePremodifier: PropTypes.string,
  accessibleRangeSeparator: PropTypes.string,
  inputSize: PropTypes.string,
  accessibleInterval: PropTypes.string,
  accessibleSliderPremodifier: PropTypes.string,
  states: PropTypes.string,
  accessibleErrorAdjust: PropTypes.string,
  accessibleInput: PropTypes.string,
  sliderType: PropTypes.string,
  accessibleMax: PropTypes.string,
  accessibleMin: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["disabled"]),
  // Events
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onBlur: PropTypes.func,
  onInput: PropTypes.func,
  onBlurThumb: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func,
  onTouchend: PropTypes.func,
  onFocusThumb: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseup: PropTypes.func
};
MdsSlider.defaultProps = {
  variant: "single",
  leadingLabelWidth: "20%",
  trailingLabelWidth: "20%",
  trackWidth: "60%",
  numIntervals: 0,
  numRangeLabelIntervals: 0,
  narrow: false,
  isSelectedValueEditable: false,
  // Events
  onFocus: null,
  onChange: null,
  onMousedown: null,
  onBlur: null,
  onInput: null,
  onBlurThumb: null,
  onMouseout: null,
  onKeydown: null,
  onMouseenter: null,
  onTouchstart: null,
  onClick: null,
  onTouchend: null,
  onFocusThumb: null,
  onKeyup: null,
  onMouseover: null,
  onMouseup: null
};

var MdsStatusTracker = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsStatusTracker, _React$Component);

  var _super = _createSuper(MdsStatusTracker);

  function MdsStatusTracker(props) {
    var _this;

    _classCallCheck(this, MdsStatusTracker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsStatusTracker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-status-tracker", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        cancelled: Array.isArray(this.props.cancelled) || this.props.cancelled === Object(this.props.cancelled) ? JSON.stringify(this.props.cancelled) : this.props.cancelled,
        expandable: Array.isArray(this.props.expandable) || this.props.expandable === Object(this.props.expandable) ? JSON.stringify(this.props.expandable) : this.props.expandable,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "accessible-text-upcoming": Array.isArray(this.props.accessibleTextUpcoming) || this.props.accessibleTextUpcoming === Object(this.props.accessibleTextUpcoming) ? JSON.stringify(this.props.accessibleTextUpcoming) : this.props.accessibleTextUpcoming,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "accessible-text-completed": Array.isArray(this.props.accessibleTextCompleted) || this.props.accessibleTextCompleted === Object(this.props.accessibleTextCompleted) ? JSON.stringify(this.props.accessibleTextCompleted) : this.props.accessibleTextCompleted,
        "accessible-text-incoming": Array.isArray(this.props.accessibleTextIncoming) || this.props.accessibleTextIncoming === Object(this.props.accessibleTextIncoming) ? JSON.stringify(this.props.accessibleTextIncoming) : this.props.accessibleTextIncoming,
        "accessible-text-group-end": Array.isArray(this.props.accessibleTextGroupEnd) || this.props.accessibleTextGroupEnd === Object(this.props.accessibleTextGroupEnd) ? JSON.stringify(this.props.accessibleTextGroupEnd) : this.props.accessibleTextGroupEnd,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "status-steps": Array.isArray(this.props.statusSteps) || this.props.statusSteps === Object(this.props.statusSteps) ? JSON.stringify(this.props.statusSteps) : this.props.statusSteps,
        "expandable-steps": Array.isArray(this.props.expandableSteps) || this.props.expandableSteps === Object(this.props.expandableSteps) ? JSON.stringify(this.props.expandableSteps) : this.props.expandableSteps // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsStatusTracker;
}(React.Component);
MdsStatusTracker.propTypes = {
  // Values
  layout: PropTypes.oneOf(["horizontal", "vertical"]),
  variant: PropTypes.oneOf(["success", "critical"]),
  cancelled: PropTypes.bool,
  expandable: PropTypes.bool,
  brand: PropTypes.string,
  accessibleTextUpcoming: PropTypes.string,
  accessibleName: PropTypes.string,
  accessibleTextCompleted: PropTypes.string,
  accessibleTextIncoming: PropTypes.string,
  accessibleTextGroupEnd: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  statusSteps: PropTypes.arrayOf(CustomPropTypes.slot),
  expandableSteps: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsStatusTracker.defaultProps = {
  layout: "vertical",
  variant: "success",
  cancelled: false,
  expandable: false,
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsStickyFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsStickyFooter, _React$Component);

  var _super = _createSuper(MdsStickyFooter);

  function MdsStickyFooter(props) {
    var _this;

    _classCallCheck(this, MdsStickyFooter);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClickButton", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClickButton) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClickButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurButton", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onBlurButton) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onBlurButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onTouchend) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeydown) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseover) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseenter) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchstart) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onClick) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClickButton = _this._onClickButton.bind(_assertThisInitialized(_this));
    _this._onBlurButton = _this._onBlurButton.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsStickyFooter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click-button", this._onClickButton);

      this._ref.current.addEventListener("blur-button", this._onBlurButton);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click-button", this._onClickButton);

      this._ref.current.removeEventListener("blur-button", this._onBlurButton);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-sticky-footer", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "horizontal-layout": Array.isArray(this.props.horizontalLayout) || this.props.horizontalLayout === Object(this.props.horizontalLayout) ? JSON.stringify(this.props.horizontalLayout) : this.props.horizontalLayout,
        "stick-to-parent-container": Array.isArray(this.props.stickToParentContainer) || this.props.stickToParentContainer === Object(this.props.stickToParentContainer) ? JSON.stringify(this.props.stickToParentContainer) : this.props.stickToParentContainer,
        "show-box-shadow": Array.isArray(this.props.showBoxShadow) || this.props.showBoxShadow === Object(this.props.showBoxShadow) ? JSON.stringify(this.props.showBoxShadow) : this.props.showBoxShadow,
        "footer-text": Array.isArray(this.props.footerText) || this.props.footerText === Object(this.props.footerText) ? JSON.stringify(this.props.footerText) : this.props.footerText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "sticky-footer-buttons": Array.isArray(this.props.stickyFooterButtons) || this.props.stickyFooterButtons === Object(this.props.stickyFooterButtons) ? JSON.stringify(this.props.stickyFooterButtons) : this.props.stickyFooterButtons // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsStickyFooter;
}(React.Component);
MdsStickyFooter.propTypes = {
  // Values
  horizontalLayout: PropTypes.bool,
  stickToParentContainer: PropTypes.bool,
  showBoxShadow: PropTypes.bool,
  footerText: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  stickyFooterButtons: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onClickButton: PropTypes.func,
  onBlurButton: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func
};
MdsStickyFooter.defaultProps = {
  horizontalLayout: false,
  stickToParentContainer: true,
  showBoxShadow: true,
  // Events
  onClickButton: null,
  onBlurButton: null,
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onTouchstart: null,
  onClick: null
};

var MdsSwitch = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSwitch, _React$Component);

  var _super = _createSuper(MdsSwitch);

  function MdsSwitch(props) {
    var _this;

    _classCallCheck(this, MdsSwitch);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFocus) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onChange) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeyup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseenter) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseup) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchstart) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onClick) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsSwitch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-switch", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        checked: Array.isArray(this.props.checked) || this.props.checked === Object(this.props.checked) ? JSON.stringify(this.props.checked) : this.props.checked,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "label-size": Array.isArray(this.props.labelSize) || this.props.labelSize === Object(this.props.labelSize) ? JSON.stringify(this.props.labelSize) : this.props.labelSize,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "label-accessible-text": Array.isArray(this.props.labelAccessibleText) || this.props.labelAccessibleText === Object(this.props.labelAccessibleText) ? JSON.stringify(this.props.labelAccessibleText) : this.props.labelAccessibleText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "is-state-visible": Array.isArray(this.props.isStateVisible) || this.props.isStateVisible === Object(this.props.isStateVisible) ? JSON.stringify(this.props.isStateVisible) : this.props.isStateVisible,
        "state-label-on": Array.isArray(this.props.stateLabelOn) || this.props.stateLabelOn === Object(this.props.stateLabelOn) ? JSON.stringify(this.props.stateLabelOn) : this.props.stateLabelOn,
        "state-label-off": Array.isArray(this.props.stateLabelOff) || this.props.stateLabelOff === Object(this.props.stateLabelOff) ? JSON.stringify(this.props.stateLabelOff) : this.props.stateLabelOff,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSwitch;
}(React.Component);
MdsSwitch.propTypes = {
  // Values
  checked: PropTypes.bool,
  variant: PropTypes.oneOf(["wide", "narrow"]),
  labelSize: PropTypes.oneOf(["large", "medium"]),
  label: PropTypes.string,
  labelAccessibleText: PropTypes.string,
  brand: PropTypes.string,
  isStateVisible: PropTypes.string,
  stateLabelOn: PropTypes.string,
  stateLabelOff: PropTypes.string,
  inactive: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "hovered", "active", "disabled"]),
  // Events
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func
};
MdsSwitch.defaultProps = {
  checked: false,
  variant: "narrow",
  labelSize: "large",
  // Events
  onFocus: null,
  onChange: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onClick: null
};

var MdsTabBar = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsTabBar, _React$Component);

  var _super = _createSuper(MdsTabBar);

  function MdsTabBar(props) {
    var _this;

    _classCallCheck(this, MdsTabBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTabChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTabChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTabChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onTouchend) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onBlur) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeydown) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseover) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseenter) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseup) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onTouchstart) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onFocus) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onClick) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickTab", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onClickTab) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onClickTab(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTabChange = _this._onTabChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onClickTab = _this._onClickTab.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsTabBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("tabChange", this._onTabChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("click-tab", this._onClickTab);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("tabChange", this._onTabChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("click-tab", this._onClickTab);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-tab-bar", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "selected-tab": Array.isArray(this.props.selectedTab) || this.props.selectedTab === Object(this.props.selectedTab) ? JSON.stringify(this.props.selectedTab) : this.props.selectedTab,
        "indicator-position": Array.isArray(this.props.indicatorPosition) || this.props.indicatorPosition === Object(this.props.indicatorPosition) ? JSON.stringify(this.props.indicatorPosition) : this.props.indicatorPosition,
        "tab-width-type": Array.isArray(this.props.tabWidthType) || this.props.tabWidthType === Object(this.props.tabWidthType) ? JSON.stringify(this.props.tabWidthType) : this.props.tabWidthType,
        alignment: Array.isArray(this.props.alignment) || this.props.alignment === Object(this.props.alignment) ? JSON.stringify(this.props.alignment) : this.props.alignment,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        tabs: Array.isArray(this.props.tabs) || this.props.tabs === Object(this.props.tabs) ? JSON.stringify(this.props.tabs) : this.props.tabs // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsTabBar;
}(React.Component);
MdsTabBar.propTypes = {
  // Values
  variant: PropTypes.oneOf(["base", "inverse"]),
  selectedTab: CustomPropTypes.integer,
  indicatorPosition: PropTypes.oneOf(["bottom", "top"]),
  tabWidthType: PropTypes.oneOf(["content", "layout"]),
  alignment: PropTypes.oneOf(["left", "center"]),
  accessibleName: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  tabs: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onTabChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  onClickTab: PropTypes.func
};
MdsTabBar.defaultProps = {
  variant: "base",
  selectedTab: 0,
  indicatorPosition: "bottom",
  tabWidthType: "content",
  alignment: "left",
  // Events
  onTabChange: null,
  onMousedown: null,
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null,
  onClickTab: null
};

var MdsTag = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsTag, _React$Component);

  var _super = _createSuper(MdsTag);

  function MdsTag(props) {
    var _this;

    _classCallCheck(this, MdsTag);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeyup) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeydown) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMousedown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseover) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseenter) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseout) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onTouchstart) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchend) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsTag, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-tag", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        color: Array.isArray(this.props.color) || this.props.color === Object(this.props.color) ? JSON.stringify(this.props.color) : this.props.color,
        interactive: Array.isArray(this.props.interactive) || this.props.interactive === Object(this.props.interactive) ? JSON.stringify(this.props.interactive) : this.props.interactive,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        text: Array.isArray(this.props.text) || this.props.text === Object(this.props.text) ? JSON.stringify(this.props.text) : this.props.text,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsTag;
}(React.Component);
MdsTag.propTypes = {
  // Values
  color: PropTypes.oneOf(["base", "accent"]),
  interactive: PropTypes.bool,
  icon: PropTypes.string,
  text: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "hovered"]),
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsTag.defaultProps = {
  color: "base",
  interactive: false,
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsTextInput = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsTextInput, _React$Component);

  var _super = _createSuper(MdsTextInput);

  function MdsTextInput(props) {
    var _this;

    _classCallCheck(this, MdsTextInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFocus) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onChange) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onInput) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onInput(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onKeyup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseout) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onKeydown) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onClick) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onValidate", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onValidate) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onValidate(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickFieldSuffix", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onClickFieldSuffix) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onClickFieldSuffix(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onValidate = _this._onValidate.bind(_assertThisInitialized(_this));
    _this._onClickFieldSuffix = _this._onClickFieldSuffix.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsTextInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("input", this._onInput);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("validate", this._onValidate);

      this._ref.current.addEventListener("click-field-suffix", this._onClickFieldSuffix);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("input", this._onInput);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("validate", this._onValidate);

      this._ref.current.removeEventListener("click-field-suffix", this._onClickFieldSuffix);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-text-input", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "floating-label": Array.isArray(this.props.floatingLabel) || this.props.floatingLabel === Object(this.props.floatingLabel) ? JSON.stringify(this.props.floatingLabel) : this.props.floatingLabel,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        "read-only": Array.isArray(this.props.readOnly) || this.props.readOnly === Object(this.props.readOnly) ? JSON.stringify(this.props.readOnly) : this.props.readOnly,
        placeholder: Array.isArray(this.props.placeholder) || this.props.placeholder === Object(this.props.placeholder) ? JSON.stringify(this.props.placeholder) : this.props.placeholder,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        "error-message": Array.isArray(this.props.errorMessage) || this.props.errorMessage === Object(this.props.errorMessage) ? JSON.stringify(this.props.errorMessage) : this.props.errorMessage,
        "error-messages": Array.isArray(this.props.errorMessages) || this.props.errorMessages === Object(this.props.errorMessages) ? JSON.stringify(this.props.errorMessages) : this.props.errorMessages,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        "input-columns": Array.isArray(this.props.inputColumns) || this.props.inputColumns === Object(this.props.inputColumns) ? JSON.stringify(this.props.inputColumns) : this.props.inputColumns,
        "label-columns": Array.isArray(this.props.labelColumns) || this.props.labelColumns === Object(this.props.labelColumns) ? JSON.stringify(this.props.labelColumns) : this.props.labelColumns,
        "error-message-prefix": Array.isArray(this.props.errorMessagePrefix) || this.props.errorMessagePrefix === Object(this.props.errorMessagePrefix) ? JSON.stringify(this.props.errorMessagePrefix) : this.props.errorMessagePrefix,
        multiline: Array.isArray(this.props.multiline) || this.props.multiline === Object(this.props.multiline) ? JSON.stringify(this.props.multiline) : this.props.multiline,
        centered: Array.isArray(this.props.centered) || this.props.centered === Object(this.props.centered) ? JSON.stringify(this.props.centered) : this.props.centered,
        hero: Array.isArray(this.props.hero) || this.props.hero === Object(this.props.hero) ? JSON.stringify(this.props.hero) : this.props.hero,
        format: Array.isArray(this.props.format) || this.props.format === Object(this.props.format) ? JSON.stringify(this.props.format) : this.props.format,
        "label-style": Array.isArray(this.props.labelStyle) || this.props.labelStyle === Object(this.props.labelStyle) ? JSON.stringify(this.props.labelStyle) : this.props.labelStyle,
        "preview-formatting": Array.isArray(this.props.previewFormatting) || this.props.previewFormatting === Object(this.props.previewFormatting) ? JSON.stringify(this.props.previewFormatting) : this.props.previewFormatting,
        "character-count": Array.isArray(this.props.characterCount) || this.props.characterCount === Object(this.props.characterCount) ? JSON.stringify(this.props.characterCount) : this.props.characterCount,
        "field-prefix": Array.isArray(this.props.fieldPrefix) || this.props.fieldPrefix === Object(this.props.fieldPrefix) ? JSON.stringify(this.props.fieldPrefix) : this.props.fieldPrefix,
        "field-suffix": Array.isArray(this.props.fieldSuffix) || this.props.fieldSuffix === Object(this.props.fieldSuffix) ? JSON.stringify(this.props.fieldSuffix) : this.props.fieldSuffix,
        "max-length": Array.isArray(this.props.maxLength) || this.props.maxLength === Object(this.props.maxLength) ? JSON.stringify(this.props.maxLength) : this.props.maxLength,
        "character-count-string": Array.isArray(this.props.characterCountString) || this.props.characterCountString === Object(this.props.characterCountString) ? JSON.stringify(this.props.characterCountString) : this.props.characterCountString,
        "waiting-state": Array.isArray(this.props.waitingState) || this.props.waitingState === Object(this.props.waitingState) ? JSON.stringify(this.props.waitingState) : this.props.waitingState,
        "waiting-state-accessible-text": Array.isArray(this.props.waitingStateAccessibleText) || this.props.waitingStateAccessibleText === Object(this.props.waitingStateAccessibleText) ? JSON.stringify(this.props.waitingStateAccessibleText) : this.props.waitingStateAccessibleText,
        "clear-button-accessible-text": Array.isArray(this.props.clearButtonAccessibleText) || this.props.clearButtonAccessibleText === Object(this.props.clearButtonAccessibleText) ? JSON.stringify(this.props.clearButtonAccessibleText) : this.props.clearButtonAccessibleText,
        "formatted-value": Array.isArray(this.props.formattedValue) || this.props.formattedValue === Object(this.props.formattedValue) ? JSON.stringify(this.props.formattedValue) : this.props.formattedValue,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        ssn: Array.isArray(this.props.ssn) || this.props.ssn === Object(this.props.ssn) ? JSON.stringify(this.props.ssn) : this.props.ssn,
        "currency-symbol": Array.isArray(this.props.currencySymbol) || this.props.currencySymbol === Object(this.props.currencySymbol) ? JSON.stringify(this.props.currencySymbol) : this.props.currencySymbol,
        "default-height": Array.isArray(this.props.defaultHeight) || this.props.defaultHeight === Object(this.props.defaultHeight) ? JSON.stringify(this.props.defaultHeight) : this.props.defaultHeight,
        "field-suffix-accessible-text": Array.isArray(this.props.fieldSuffixAccessibleText) || this.props.fieldSuffixAccessibleText === Object(this.props.fieldSuffixAccessibleText) ? JSON.stringify(this.props.fieldSuffixAccessibleText) : this.props.fieldSuffixAccessibleText,
        "field-prefix-accessible-text": Array.isArray(this.props.fieldPrefixAccessibleText) || this.props.fieldPrefixAccessibleText === Object(this.props.fieldPrefixAccessibleText) ? JSON.stringify(this.props.fieldPrefixAccessibleText) : this.props.fieldPrefixAccessibleText,
        "character-count-text": Array.isArray(this.props.characterCountText) || this.props.characterCountText === Object(this.props.characterCountText) ? JSON.stringify(this.props.characterCountText) : this.props.characterCountText,
        "autocomplete-value": Array.isArray(this.props.autocompleteValue) || this.props.autocompleteValue === Object(this.props.autocompleteValue) ? JSON.stringify(this.props.autocompleteValue) : this.props.autocompleteValue,
        "float-digits": Array.isArray(this.props.floatDigits) || this.props.floatDigits === Object(this.props.floatDigits) ? JSON.stringify(this.props.floatDigits) : this.props.floatDigits,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsTextInput;
}(React.Component);
MdsTextInput.propTypes = {
  // Values
  layout: PropTypes.oneOf(["horizontal", "vertical"]),
  label: PropTypes.string,
  variant: PropTypes.oneOf(["line", "box"]),
  floatingLabel: PropTypes.bool,
  microcopy: PropTypes.string,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  errorMessages: PropTypes.array,
  name: PropTypes.string,
  inputColumns: PropTypes.string,
  labelColumns: PropTypes.string,
  errorMessagePrefix: PropTypes.string,
  multiline: PropTypes.bool,
  centered: PropTypes.bool,
  hero: PropTypes.bool,
  format: PropTypes.oneOf(["credit", "moneyCommaFloat", "moneyDecimalFloat", "phone", "ssn", "moneyFloat", "moneyInteger", "percentageCommaFloat", "percentageDecimalFloat", "percentageCommaInteger", "percentageDecimalInteger", "email"]),
  labelStyle: PropTypes.oneOf(["horizontal", "vertical", "floating", "hidden"]),
  previewFormatting: PropTypes.bool,
  characterCount: PropTypes.bool,
  fieldPrefix: PropTypes.string,
  fieldSuffix: PropTypes.string,
  maxLength: CustomPropTypes.integer,
  characterCountString: PropTypes.string,
  waitingState: PropTypes.bool,
  waitingStateAccessibleText: PropTypes.string,
  clearButtonAccessibleText: PropTypes.string,
  formattedValue: PropTypes.number,
  inactive: PropTypes.bool,
  ssn: PropTypes.string,
  currencySymbol: PropTypes.string,
  defaultHeight: PropTypes.string,
  fieldSuffixAccessibleText: PropTypes.string,
  fieldPrefixAccessibleText: PropTypes.string,
  characterCountText: PropTypes.array,
  autocompleteValue: PropTypes.string,
  floatDigits: PropTypes.number,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "active", "disabled", "error"]),
  // Events
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onInput: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func,
  onValidate: PropTypes.func,
  onClickFieldSuffix: PropTypes.func
};
MdsTextInput.defaultProps = {
  layout: "vertical",
  variant: "line",
  floatingLabel: false,
  readOnly: false,
  placeholder: "",
  errorMessagePrefix: "Error",
  multiline: false,
  centered: false,
  hero: false,
  labelStyle: "vertical",
  previewFormatting: true,
  characterCount: false,
  autocompleteValue: "off",
  // Events
  onFocus: null,
  onChange: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onInput: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onClick: null,
  onValidate: null,
  onClickFieldSuffix: null
};

var MdsTextInputSecure = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsTextInputSecure, _React$Component);

  var _super = _createSuper(MdsTextInputSecure);

  function MdsTextInputSecure(props) {
    var _this;

    _classCallCheck(this, MdsTextInputSecure);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFocus) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onChange) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onInput) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onInput(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onKeyup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseout) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onKeydown) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onClick) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onValidate", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onValidate) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onValidate(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickFieldSuffix", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onClickFieldSuffix) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onClickFieldSuffix(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickShowHideButton", function (event) {
      var _this$props33, _this$props34;

      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onClickShowHideButton) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onClickShowHideButton(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onValidate = _this._onValidate.bind(_assertThisInitialized(_this));
    _this._onClickFieldSuffix = _this._onClickFieldSuffix.bind(_assertThisInitialized(_this));
    _this._onClickShowHideButton = _this._onClickShowHideButton.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsTextInputSecure, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("input", this._onInput);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("validate", this._onValidate);

      this._ref.current.addEventListener("click-field-suffix", this._onClickFieldSuffix);

      this._ref.current.addEventListener("click-show-hide-button", this._onClickShowHideButton);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("input", this._onInput);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("validate", this._onValidate);

      this._ref.current.removeEventListener("click-field-suffix", this._onClickFieldSuffix);

      this._ref.current.removeEventListener("click-show-hide-button", this._onClickShowHideButton);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-text-input-secure", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "floating-label": Array.isArray(this.props.floatingLabel) || this.props.floatingLabel === Object(this.props.floatingLabel) ? JSON.stringify(this.props.floatingLabel) : this.props.floatingLabel,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        "read-only": Array.isArray(this.props.readOnly) || this.props.readOnly === Object(this.props.readOnly) ? JSON.stringify(this.props.readOnly) : this.props.readOnly,
        placeholder: Array.isArray(this.props.placeholder) || this.props.placeholder === Object(this.props.placeholder) ? JSON.stringify(this.props.placeholder) : this.props.placeholder,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        "error-message": Array.isArray(this.props.errorMessage) || this.props.errorMessage === Object(this.props.errorMessage) ? JSON.stringify(this.props.errorMessage) : this.props.errorMessage,
        "error-messages": Array.isArray(this.props.errorMessages) || this.props.errorMessages === Object(this.props.errorMessages) ? JSON.stringify(this.props.errorMessages) : this.props.errorMessages,
        name: Array.isArray(this.props.name) || this.props.name === Object(this.props.name) ? JSON.stringify(this.props.name) : this.props.name,
        "input-columns": Array.isArray(this.props.inputColumns) || this.props.inputColumns === Object(this.props.inputColumns) ? JSON.stringify(this.props.inputColumns) : this.props.inputColumns,
        "label-columns": Array.isArray(this.props.labelColumns) || this.props.labelColumns === Object(this.props.labelColumns) ? JSON.stringify(this.props.labelColumns) : this.props.labelColumns,
        "error-message-prefix": Array.isArray(this.props.errorMessagePrefix) || this.props.errorMessagePrefix === Object(this.props.errorMessagePrefix) ? JSON.stringify(this.props.errorMessagePrefix) : this.props.errorMessagePrefix,
        multiline: Array.isArray(this.props.multiline) || this.props.multiline === Object(this.props.multiline) ? JSON.stringify(this.props.multiline) : this.props.multiline,
        centered: Array.isArray(this.props.centered) || this.props.centered === Object(this.props.centered) ? JSON.stringify(this.props.centered) : this.props.centered,
        hero: Array.isArray(this.props.hero) || this.props.hero === Object(this.props.hero) ? JSON.stringify(this.props.hero) : this.props.hero,
        format: Array.isArray(this.props.format) || this.props.format === Object(this.props.format) ? JSON.stringify(this.props.format) : this.props.format,
        "label-style": Array.isArray(this.props.labelStyle) || this.props.labelStyle === Object(this.props.labelStyle) ? JSON.stringify(this.props.labelStyle) : this.props.labelStyle,
        "preview-formatting": Array.isArray(this.props.previewFormatting) || this.props.previewFormatting === Object(this.props.previewFormatting) ? JSON.stringify(this.props.previewFormatting) : this.props.previewFormatting,
        "character-count": Array.isArray(this.props.characterCount) || this.props.characterCount === Object(this.props.characterCount) ? JSON.stringify(this.props.characterCount) : this.props.characterCount,
        "field-prefix": Array.isArray(this.props.fieldPrefix) || this.props.fieldPrefix === Object(this.props.fieldPrefix) ? JSON.stringify(this.props.fieldPrefix) : this.props.fieldPrefix,
        "field-suffix": Array.isArray(this.props.fieldSuffix) || this.props.fieldSuffix === Object(this.props.fieldSuffix) ? JSON.stringify(this.props.fieldSuffix) : this.props.fieldSuffix,
        "max-length": Array.isArray(this.props.maxLength) || this.props.maxLength === Object(this.props.maxLength) ? JSON.stringify(this.props.maxLength) : this.props.maxLength,
        "character-count-string": Array.isArray(this.props.characterCountString) || this.props.characterCountString === Object(this.props.characterCountString) ? JSON.stringify(this.props.characterCountString) : this.props.characterCountString,
        "waiting-state": Array.isArray(this.props.waitingState) || this.props.waitingState === Object(this.props.waitingState) ? JSON.stringify(this.props.waitingState) : this.props.waitingState,
        "waiting-state-accessible-text": Array.isArray(this.props.waitingStateAccessibleText) || this.props.waitingStateAccessibleText === Object(this.props.waitingStateAccessibleText) ? JSON.stringify(this.props.waitingStateAccessibleText) : this.props.waitingStateAccessibleText,
        "clear-button-accessible-text": Array.isArray(this.props.clearButtonAccessibleText) || this.props.clearButtonAccessibleText === Object(this.props.clearButtonAccessibleText) ? JSON.stringify(this.props.clearButtonAccessibleText) : this.props.clearButtonAccessibleText,
        "formatted-value": Array.isArray(this.props.formattedValue) || this.props.formattedValue === Object(this.props.formattedValue) ? JSON.stringify(this.props.formattedValue) : this.props.formattedValue,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        ssn: Array.isArray(this.props.ssn) || this.props.ssn === Object(this.props.ssn) ? JSON.stringify(this.props.ssn) : this.props.ssn,
        "currency-symbol": Array.isArray(this.props.currencySymbol) || this.props.currencySymbol === Object(this.props.currencySymbol) ? JSON.stringify(this.props.currencySymbol) : this.props.currencySymbol,
        "default-height": Array.isArray(this.props.defaultHeight) || this.props.defaultHeight === Object(this.props.defaultHeight) ? JSON.stringify(this.props.defaultHeight) : this.props.defaultHeight,
        "field-suffix-accessible-text": Array.isArray(this.props.fieldSuffixAccessibleText) || this.props.fieldSuffixAccessibleText === Object(this.props.fieldSuffixAccessibleText) ? JSON.stringify(this.props.fieldSuffixAccessibleText) : this.props.fieldSuffixAccessibleText,
        "field-prefix-accessible-text": Array.isArray(this.props.fieldPrefixAccessibleText) || this.props.fieldPrefixAccessibleText === Object(this.props.fieldPrefixAccessibleText) ? JSON.stringify(this.props.fieldPrefixAccessibleText) : this.props.fieldPrefixAccessibleText,
        "character-count-text": Array.isArray(this.props.characterCountText) || this.props.characterCountText === Object(this.props.characterCountText) ? JSON.stringify(this.props.characterCountText) : this.props.characterCountText,
        "autocomplete-value": Array.isArray(this.props.autocompleteValue) || this.props.autocompleteValue === Object(this.props.autocompleteValue) ? JSON.stringify(this.props.autocompleteValue) : this.props.autocompleteValue,
        "float-digits": Array.isArray(this.props.floatDigits) || this.props.floatDigits === Object(this.props.floatDigits) ? JSON.stringify(this.props.floatDigits) : this.props.floatDigits,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "caps-lock-tooltip-text": Array.isArray(this.props.capsLockTooltipText) || this.props.capsLockTooltipText === Object(this.props.capsLockTooltipText) ? JSON.stringify(this.props.capsLockTooltipText) : this.props.capsLockTooltipText,
        "button-show-text": Array.isArray(this.props.buttonShowText) || this.props.buttonShowText === Object(this.props.buttonShowText) ? JSON.stringify(this.props.buttonShowText) : this.props.buttonShowText,
        "button-hide-text": Array.isArray(this.props.buttonHideText) || this.props.buttonHideText === Object(this.props.buttonHideText) ? JSON.stringify(this.props.buttonHideText) : this.props.buttonHideText,
        "hide-button-text": Array.isArray(this.props.hideButtonText) || this.props.hideButtonText === Object(this.props.hideButtonText) ? JSON.stringify(this.props.hideButtonText) : this.props.hideButtonText,
        "show-button-text": Array.isArray(this.props.showButtonText) || this.props.showButtonText === Object(this.props.showButtonText) ? JSON.stringify(this.props.showButtonText) : this.props.showButtonText,
        "caps-lock-message": Array.isArray(this.props.capsLockMessage) || this.props.capsLockMessage === Object(this.props.capsLockMessage) ? JSON.stringify(this.props.capsLockMessage) : this.props.capsLockMessage,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsTextInputSecure;
}(React.Component);
MdsTextInputSecure.propTypes = {
  // Values
  layout: PropTypes.oneOf(["horizontal", "vertical"]),
  label: PropTypes.string,
  variant: PropTypes.oneOf(["line", "box"]),
  floatingLabel: PropTypes.bool,
  microcopy: PropTypes.string,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  errorMessages: PropTypes.array,
  name: PropTypes.string,
  inputColumns: PropTypes.string,
  labelColumns: PropTypes.string,
  errorMessagePrefix: PropTypes.string,
  multiline: PropTypes.bool,
  centered: PropTypes.bool,
  hero: PropTypes.bool,
  format: PropTypes.oneOf(["credit", "moneyCommaFloat", "moneyDecimalFloat", "phone", "ssn", "moneyFloat", "moneyInteger", "percentageCommaFloat", "percentageDecimalFloat", "percentageCommaInteger", "percentageDecimalInteger", "email"]),
  labelStyle: PropTypes.oneOf(["horizontal", "vertical", "floating", "hidden"]),
  previewFormatting: PropTypes.bool,
  characterCount: PropTypes.bool,
  fieldPrefix: PropTypes.string,
  fieldSuffix: PropTypes.string,
  maxLength: CustomPropTypes.integer,
  characterCountString: PropTypes.string,
  waitingState: PropTypes.bool,
  waitingStateAccessibleText: PropTypes.string,
  clearButtonAccessibleText: PropTypes.string,
  formattedValue: PropTypes.number,
  inactive: PropTypes.bool,
  ssn: PropTypes.string,
  currencySymbol: PropTypes.string,
  defaultHeight: PropTypes.string,
  fieldSuffixAccessibleText: PropTypes.string,
  fieldPrefixAccessibleText: PropTypes.string,
  characterCountText: PropTypes.array,
  autocompleteValue: PropTypes.string,
  floatDigits: PropTypes.number,
  brand: PropTypes.string,
  capsLockTooltipText: PropTypes.string,
  buttonShowText: PropTypes.string,
  buttonHideText: PropTypes.string,
  hideButtonText: PropTypes.string,
  showButtonText: PropTypes.string,
  capsLockMessage: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "active", "disabled", "error"]),
  // Events
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onInput: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func,
  onValidate: PropTypes.func,
  onClickFieldSuffix: PropTypes.func,
  onClickShowHideButton: PropTypes.func
};
MdsTextInputSecure.defaultProps = {
  layout: "vertical",
  variant: "line",
  floatingLabel: false,
  readOnly: false,
  placeholder: "",
  errorMessagePrefix: "Error",
  labelStyle: "vertical",
  previewFormatting: true,
  characterCount: false,
  autocompleteValue: "off",
  capsLockTooltipText: "Caps lock is on.",
  buttonShowText: "Show",
  buttonHideText: "Hide",
  hideButtonText: "Hide",
  showButtonText: "Show",
  capsLockMessage: "Caps lock is on.",
  // Events
  onFocus: null,
  onChange: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onInput: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onClick: null,
  onValidate: null,
  onClickFieldSuffix: null,
  onClickShowHideButton: null
};

var MdsTile = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsTile, _React$Component);

  var _super = _createSuper(MdsTile);

  function MdsTile(props) {
    var _this;

    _classCallCheck(this, MdsTile);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeydown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeyup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseenter) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseover) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchend) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickTile", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onClickTile) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onClickTile(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickButton1", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onClickButton1) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onClickButton1(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusButton1", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onFocusButton1) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onFocusButton1(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurButton1", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onBlurButton1) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onBlurButton1(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickButton2", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onClickButton2) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onClickButton2(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusButton2", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onFocusButton2) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onFocusButton2(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurButton2", function (event) {
      var _this$props33, _this$props34;

      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onBlurButton2) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onBlurButton2(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickButton3", function (event) {
      var _this$props35, _this$props36;

      ((_this$props35 = _this.props) === null || _this$props35 === void 0 ? void 0 : _this$props35.onClickButton3) && ((_this$props36 = _this.props) === null || _this$props36 === void 0 ? void 0 : _this$props36.onClickButton3(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusButton3", function (event) {
      var _this$props37, _this$props38;

      ((_this$props37 = _this.props) === null || _this$props37 === void 0 ? void 0 : _this$props37.onFocusButton3) && ((_this$props38 = _this.props) === null || _this$props38 === void 0 ? void 0 : _this$props38.onFocusButton3(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurButton3", function (event) {
      var _this$props39, _this$props40;

      ((_this$props39 = _this.props) === null || _this$props39 === void 0 ? void 0 : _this$props39.onBlurButton3) && ((_this$props40 = _this.props) === null || _this$props40 === void 0 ? void 0 : _this$props40.onBlurButton3(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickButtonMore", function (event) {
      var _this$props41, _this$props42;

      ((_this$props41 = _this.props) === null || _this$props41 === void 0 ? void 0 : _this$props41.onClickButtonMore) && ((_this$props42 = _this.props) === null || _this$props42 === void 0 ? void 0 : _this$props42.onClickButtonMore(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusButtonMore", function (event) {
      var _this$props43, _this$props44;

      ((_this$props43 = _this.props) === null || _this$props43 === void 0 ? void 0 : _this$props43.onFocusButtonMore) && ((_this$props44 = _this.props) === null || _this$props44 === void 0 ? void 0 : _this$props44.onFocusButtonMore(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurButtonMore", function (event) {
      var _this$props45, _this$props46;

      ((_this$props45 = _this.props) === null || _this$props45 === void 0 ? void 0 : _this$props45.onBlurButtonMore) && ((_this$props46 = _this.props) === null || _this$props46 === void 0 ? void 0 : _this$props46.onBlurButtonMore(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickButtonHelp", function (event) {
      var _this$props47, _this$props48;

      ((_this$props47 = _this.props) === null || _this$props47 === void 0 ? void 0 : _this$props47.onClickButtonHelp) && ((_this$props48 = _this.props) === null || _this$props48 === void 0 ? void 0 : _this$props48.onClickButtonHelp(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusButtonHelp", function (event) {
      var _this$props49, _this$props50;

      ((_this$props49 = _this.props) === null || _this$props49 === void 0 ? void 0 : _this$props49.onFocusButtonHelp) && ((_this$props50 = _this.props) === null || _this$props50 === void 0 ? void 0 : _this$props50.onFocusButtonHelp(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurButtonHelp", function (event) {
      var _this$props51, _this$props52;

      ((_this$props51 = _this.props) === null || _this$props51 === void 0 ? void 0 : _this$props51.onBlurButtonHelp) && ((_this$props52 = _this.props) === null || _this$props52 === void 0 ? void 0 : _this$props52.onBlurButtonHelp(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickHeading", function (event) {
      var _this$props53, _this$props54;

      ((_this$props53 = _this.props) === null || _this$props53 === void 0 ? void 0 : _this$props53.onClickHeading) && ((_this$props54 = _this.props) === null || _this$props54 === void 0 ? void 0 : _this$props54.onClickHeading(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocusHeading", function (event) {
      var _this$props55, _this$props56;

      ((_this$props55 = _this.props) === null || _this$props55 === void 0 ? void 0 : _this$props55.onFocusHeading) && ((_this$props56 = _this.props) === null || _this$props56 === void 0 ? void 0 : _this$props56.onFocusHeading(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlurHeading", function (event) {
      var _this$props57, _this$props58;

      ((_this$props57 = _this.props) === null || _this$props57 === void 0 ? void 0 : _this$props57.onBlurHeading) && ((_this$props58 = _this.props) === null || _this$props58 === void 0 ? void 0 : _this$props58.onBlurHeading(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onClickTile = _this._onClickTile.bind(_assertThisInitialized(_this));
    _this._onClickButton1 = _this._onClickButton1.bind(_assertThisInitialized(_this));
    _this._onFocusButton1 = _this._onFocusButton1.bind(_assertThisInitialized(_this));
    _this._onBlurButton1 = _this._onBlurButton1.bind(_assertThisInitialized(_this));
    _this._onClickButton2 = _this._onClickButton2.bind(_assertThisInitialized(_this));
    _this._onFocusButton2 = _this._onFocusButton2.bind(_assertThisInitialized(_this));
    _this._onBlurButton2 = _this._onBlurButton2.bind(_assertThisInitialized(_this));
    _this._onClickButton3 = _this._onClickButton3.bind(_assertThisInitialized(_this));
    _this._onFocusButton3 = _this._onFocusButton3.bind(_assertThisInitialized(_this));
    _this._onBlurButton3 = _this._onBlurButton3.bind(_assertThisInitialized(_this));
    _this._onClickButtonMore = _this._onClickButtonMore.bind(_assertThisInitialized(_this));
    _this._onFocusButtonMore = _this._onFocusButtonMore.bind(_assertThisInitialized(_this));
    _this._onBlurButtonMore = _this._onBlurButtonMore.bind(_assertThisInitialized(_this));
    _this._onClickButtonHelp = _this._onClickButtonHelp.bind(_assertThisInitialized(_this));
    _this._onFocusButtonHelp = _this._onFocusButtonHelp.bind(_assertThisInitialized(_this));
    _this._onBlurButtonHelp = _this._onBlurButtonHelp.bind(_assertThisInitialized(_this));
    _this._onClickHeading = _this._onClickHeading.bind(_assertThisInitialized(_this));
    _this._onFocusHeading = _this._onFocusHeading.bind(_assertThisInitialized(_this));
    _this._onBlurHeading = _this._onBlurHeading.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("click-tile", this._onClickTile);

      this._ref.current.addEventListener("click-button1", this._onClickButton1);

      this._ref.current.addEventListener("focus-button1", this._onFocusButton1);

      this._ref.current.addEventListener("blur-button1", this._onBlurButton1);

      this._ref.current.addEventListener("click-button2", this._onClickButton2);

      this._ref.current.addEventListener("focus-button2", this._onFocusButton2);

      this._ref.current.addEventListener("blur-button2", this._onBlurButton2);

      this._ref.current.addEventListener("click-button3", this._onClickButton3);

      this._ref.current.addEventListener("focus-button3", this._onFocusButton3);

      this._ref.current.addEventListener("blur-button3", this._onBlurButton3);

      this._ref.current.addEventListener("click-button-more", this._onClickButtonMore);

      this._ref.current.addEventListener("focus-button-more", this._onFocusButtonMore);

      this._ref.current.addEventListener("blur-button-more", this._onBlurButtonMore);

      this._ref.current.addEventListener("click-button-help", this._onClickButtonHelp);

      this._ref.current.addEventListener("focus-button-help", this._onFocusButtonHelp);

      this._ref.current.addEventListener("blur-button-help", this._onBlurButtonHelp);

      this._ref.current.addEventListener("click-heading", this._onClickHeading);

      this._ref.current.addEventListener("focus-heading", this._onFocusHeading);

      this._ref.current.addEventListener("blur-heading", this._onBlurHeading);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("click-tile", this._onClickTile);

      this._ref.current.removeEventListener("click-button1", this._onClickButton1);

      this._ref.current.removeEventListener("focus-button1", this._onFocusButton1);

      this._ref.current.removeEventListener("blur-button1", this._onBlurButton1);

      this._ref.current.removeEventListener("click-button2", this._onClickButton2);

      this._ref.current.removeEventListener("focus-button2", this._onFocusButton2);

      this._ref.current.removeEventListener("blur-button2", this._onBlurButton2);

      this._ref.current.removeEventListener("click-button3", this._onClickButton3);

      this._ref.current.removeEventListener("focus-button3", this._onFocusButton3);

      this._ref.current.removeEventListener("blur-button3", this._onBlurButton3);

      this._ref.current.removeEventListener("click-button-more", this._onClickButtonMore);

      this._ref.current.removeEventListener("focus-button-more", this._onFocusButtonMore);

      this._ref.current.removeEventListener("blur-button-more", this._onBlurButtonMore);

      this._ref.current.removeEventListener("click-button-help", this._onClickButtonHelp);

      this._ref.current.removeEventListener("focus-button-help", this._onFocusButtonHelp);

      this._ref.current.removeEventListener("blur-button-help", this._onBlurButtonHelp);

      this._ref.current.removeEventListener("click-heading", this._onClickHeading);

      this._ref.current.removeEventListener("focus-heading", this._onFocusHeading);

      this._ref.current.removeEventListener("blur-heading", this._onBlurHeading);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-tile", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "tile-style": Array.isArray(this.props.tileStyle) || this.props.tileStyle === Object(this.props.tileStyle) ? JSON.stringify(this.props.tileStyle) : this.props.tileStyle,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "tile-title": Array.isArray(this.props.tileTitle) || this.props.tileTitle === Object(this.props.tileTitle) ? JSON.stringify(this.props.tileTitle) : this.props.tileTitle,
        "title-icon": Array.isArray(this.props.titleIcon) || this.props.titleIcon === Object(this.props.titleIcon) ? JSON.stringify(this.props.titleIcon) : this.props.titleIcon,
        "title-icon-color": Array.isArray(this.props.titleIconColor) || this.props.titleIconColor === Object(this.props.titleIconColor) ? JSON.stringify(this.props.titleIconColor) : this.props.titleIconColor,
        "hide-title": Array.isArray(this.props.hideTitle) || this.props.hideTitle === Object(this.props.hideTitle) ? JSON.stringify(this.props.hideTitle) : this.props.hideTitle,
        buttons: Array.isArray(this.props.buttons) || this.props.buttons === Object(this.props.buttons) ? JSON.stringify(this.props.buttons) : this.props.buttons,
        "more-button-enabled": Array.isArray(this.props.moreButtonEnabled) || this.props.moreButtonEnabled === Object(this.props.moreButtonEnabled) ? JSON.stringify(this.props.moreButtonEnabled) : this.props.moreButtonEnabled,
        interactive: Array.isArray(this.props.interactive) || this.props.interactive === Object(this.props.interactive) ? JSON.stringify(this.props.interactive) : this.props.interactive,
        "more-button-accessible-text": Array.isArray(this.props.moreButtonAccessibleText) || this.props.moreButtonAccessibleText === Object(this.props.moreButtonAccessibleText) ? JSON.stringify(this.props.moreButtonAccessibleText) : this.props.moreButtonAccessibleText,
        "horizontal-padding": Array.isArray(this.props.horizontalPadding) || this.props.horizontalPadding === Object(this.props.horizontalPadding) ? JSON.stringify(this.props.horizontalPadding) : this.props.horizontalPadding,
        "tile-cta-orientation": Array.isArray(this.props.tileCTAOrientation) || this.props.tileCTAOrientation === Object(this.props.tileCTAOrientation) ? JSON.stringify(this.props.tileCTAOrientation) : this.props.tileCTAOrientation,
        "tile-subtitle": Array.isArray(this.props.tileSubtitle) || this.props.tileSubtitle === Object(this.props.tileSubtitle) ? JSON.stringify(this.props.tileSubtitle) : this.props.tileSubtitle,
        "help-button-enabled": Array.isArray(this.props.helpButtonEnabled) || this.props.helpButtonEnabled === Object(this.props.helpButtonEnabled) ? JSON.stringify(this.props.helpButtonEnabled) : this.props.helpButtonEnabled,
        "help-button-label": Array.isArray(this.props.helpButtonLabel) || this.props.helpButtonLabel === Object(this.props.helpButtonLabel) ? JSON.stringify(this.props.helpButtonLabel) : this.props.helpButtonLabel,
        "help-button-accessible-text": Array.isArray(this.props.helpButtonAccessibleText) || this.props.helpButtonAccessibleText === Object(this.props.helpButtonAccessibleText) ? JSON.stringify(this.props.helpButtonAccessibleText) : this.props.helpButtonAccessibleText,
        "bottom-padding": Array.isArray(this.props.bottomPadding) || this.props.bottomPadding === Object(this.props.bottomPadding) ? JSON.stringify(this.props.bottomPadding) : this.props.bottomPadding,
        "tile-title-heading-level": Array.isArray(this.props.tileTitleHeadingLevel) || this.props.tileTitleHeadingLevel === Object(this.props.tileTitleHeadingLevel) ? JSON.stringify(this.props.tileTitleHeadingLevel) : this.props.tileTitleHeadingLevel,
        "icon-accessible-description": Array.isArray(this.props.iconAccessibleDescription) || this.props.iconAccessibleDescription === Object(this.props.iconAccessibleDescription) ? JSON.stringify(this.props.iconAccessibleDescription) : this.props.iconAccessibleDescription,
        "title-href": Array.isArray(this.props.titleHref) || this.props.titleHref === Object(this.props.titleHref) ? JSON.stringify(this.props.titleHref) : this.props.titleHref,
        "stacked-tile": Array.isArray(this.props.stackedTile) || this.props.stackedTile === Object(this.props.stackedTile) ? JSON.stringify(this.props.stackedTile) : this.props.stackedTile,
        inverse: Array.isArray(this.props.inverse) || this.props.inverse === Object(this.props.inverse) ? JSON.stringify(this.props.inverse) : this.props.inverse,
        "background-image": Array.isArray(this.props.backgroundImage) || this.props.backgroundImage === Object(this.props.backgroundImage) ? JSON.stringify(this.props.backgroundImage) : this.props.backgroundImage,
        "gradient-colors": Array.isArray(this.props.gradientColors) || this.props.gradientColors === Object(this.props.gradientColors) ? JSON.stringify(this.props.gradientColors) : this.props.gradientColors,
        "background-color": Array.isArray(this.props.backgroundColor) || this.props.backgroundColor === Object(this.props.backgroundColor) ? JSON.stringify(this.props.backgroundColor) : this.props.backgroundColor,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        "image-alt-text": Array.isArray(this.props.imageAltText) || this.props.imageAltText === Object(this.props.imageAltText) ? JSON.stringify(this.props.imageAltText) : this.props.imageAltText,
        "image-position-vertical": Array.isArray(this.props.imagePositionVertical) || this.props.imagePositionVertical === Object(this.props.imagePositionVertical) ? JSON.stringify(this.props.imagePositionVertical) : this.props.imagePositionVertical,
        "image-position-horizontal": Array.isArray(this.props.imagePositionHorizontal) || this.props.imagePositionHorizontal === Object(this.props.imagePositionHorizontal) ? JSON.stringify(this.props.imagePositionHorizontal) : this.props.imagePositionHorizontal,
        "image-height": Array.isArray(this.props.imageHeight) || this.props.imageHeight === Object(this.props.imageHeight) ? JSON.stringify(this.props.imageHeight) : this.props.imageHeight,
        "minimum-height": Array.isArray(this.props.minimumHeight) || this.props.minimumHeight === Object(this.props.minimumHeight) ? JSON.stringify(this.props.minimumHeight) : this.props.minimumHeight,
        "icon-accessible-text": Array.isArray(this.props.iconAccessibleText) || this.props.iconAccessibleText === Object(this.props.iconAccessibleText) ? JSON.stringify(this.props.iconAccessibleText) : this.props.iconAccessibleText,
        "header-title-accessible-text": Array.isArray(this.props.headerTitleAccessibleText) || this.props.headerTitleAccessibleText === Object(this.props.headerTitleAccessibleText) ? JSON.stringify(this.props.headerTitleAccessibleText) : this.props.headerTitleAccessibleText,
        "header-sub-title-accessible-text": Array.isArray(this.props.headerSubTitleAccessibleText) || this.props.headerSubTitleAccessibleText === Object(this.props.headerSubTitleAccessibleText) ? JSON.stringify(this.props.headerSubTitleAccessibleText) : this.props.headerSubTitleAccessibleText,
        "more-button": Array.isArray(this.props.moreButton) || this.props.moreButton === Object(this.props.moreButton) ? JSON.stringify(this.props.moreButton) : this.props.moreButton,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        badge: Array.isArray(this.props.badge) || this.props.badge === Object(this.props.badge) ? JSON.stringify(this.props.badge) : this.props.badge // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsTile;
}(React.Component);
MdsTile.propTypes = {
  // Values
  tileStyle: PropTypes.oneOf(["next", "classic"]),
  variant: PropTypes.oneOf(["next", "hero", "classic"]),
  tileTitle: PropTypes.string,
  titleIcon: PropTypes.string,
  titleIconColor: PropTypes.oneOf(["regular", "interactive"]),
  hideTitle: PropTypes.bool,
  buttons: PropTypes.array,
  moreButtonEnabled: PropTypes.bool,
  interactive: PropTypes.bool,
  moreButtonAccessibleText: PropTypes.string,
  horizontalPadding: PropTypes.oneOf(["regular", "none"]),
  tileCTAOrientation: PropTypes.oneOf(["vertical", "horizontal"]),
  tileSubtitle: PropTypes.string,
  helpButtonEnabled: PropTypes.bool,
  helpButtonLabel: PropTypes.string,
  helpButtonAccessibleText: PropTypes.string,
  bottomPadding: PropTypes.bool,
  tileTitleHeadingLevel: PropTypes.number,
  iconAccessibleDescription: PropTypes.string,
  titleHref: PropTypes.string,
  stackedTile: PropTypes.bool,
  inverse: PropTypes.bool,
  backgroundImage: PropTypes.string,
  gradientColors: PropTypes.object,
  backgroundColor: PropTypes.string,
  brand: PropTypes.string,
  image: PropTypes.string,
  imageAltText: PropTypes.string,
  imagePositionVertical: PropTypes.oneOf(["top", "center", "bottom"]),
  imagePositionHorizontal: PropTypes.oneOf(["left", "center", "right"]),
  imageHeight: PropTypes.number,
  minimumHeight: PropTypes.number,
  iconAccessibleText: PropTypes.string,
  headerTitleAccessibleText: PropTypes.string,
  headerSubTitleAccessibleText: PropTypes.string,
  moreButton: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  badge: CustomPropTypes.slot,
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeydown: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func,
  onClickTile: PropTypes.func,
  onClickButton1: PropTypes.func,
  onFocusButton1: PropTypes.func,
  onBlurButton1: PropTypes.func,
  onClickButton2: PropTypes.func,
  onFocusButton2: PropTypes.func,
  onBlurButton2: PropTypes.func,
  onClickButton3: PropTypes.func,
  onFocusButton3: PropTypes.func,
  onBlurButton3: PropTypes.func,
  onClickButtonMore: PropTypes.func,
  onFocusButtonMore: PropTypes.func,
  onBlurButtonMore: PropTypes.func,
  onClickButtonHelp: PropTypes.func,
  onFocusButtonHelp: PropTypes.func,
  onBlurButtonHelp: PropTypes.func,
  onClickHeading: PropTypes.func,
  onFocusHeading: PropTypes.func,
  onBlurHeading: PropTypes.func
};
MdsTile.defaultProps = {
  tileStyle: "classic",
  variant: "next",
  titleIconColor: "regular",
  hideTitle: false,
  moreButtonEnabled: false,
  interactive: true,
  horizontalPadding: "regular",
  tileCTAOrientation: "horizontal",
  helpButtonEnabled: false,
  bottomPadding: true,
  tileTitleHeadingLevel: 2,
  iconAccessibleDescription: "More",
  stackedTile: false,
  inverse: false,
  backgroundColor: "#FFFFFF",
  imagePositionVertical: "center",
  imagePositionHorizontal: "center",
  moreButton: false,
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onKeydown: null,
  onKeyup: null,
  onMouseenter: null,
  onMouseover: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null,
  onClickTile: null,
  onClickButton1: null,
  onFocusButton1: null,
  onBlurButton1: null,
  onClickButton2: null,
  onFocusButton2: null,
  onBlurButton2: null,
  onClickButton3: null,
  onFocusButton3: null,
  onBlurButton3: null,
  onClickButtonMore: null,
  onFocusButtonMore: null,
  onBlurButtonMore: null,
  onClickButtonHelp: null,
  onFocusButtonHelp: null,
  onBlurButtonHelp: null,
  onClickHeading: null,
  onFocusHeading: null,
  onBlurHeading: null
};

var MdsTileAccordionItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsTileAccordionItem, _React$Component);

  var _super = _createSuper(MdsTileAccordionItem);

  function MdsTileAccordionItem() {
    _classCallCheck(this, MdsTileAccordionItem);

    return _super.apply(this, arguments);
  }

  _createClass(MdsTileAccordionItem, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-tile-accordion-item", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "heading-level": Array.isArray(this.props.headingLevel) || this.props.headingLevel === Object(this.props.headingLevel) ? JSON.stringify(this.props.headingLevel) : this.props.headingLevel,
        "accordion-label": Array.isArray(this.props.accordionLabel) || this.props.accordionLabel === Object(this.props.accordionLabel) ? JSON.stringify(this.props.accordionLabel) : this.props.accordionLabel,
        "secondary-label": Array.isArray(this.props.secondaryLabel) || this.props.secondaryLabel === Object(this.props.secondaryLabel) ? JSON.stringify(this.props.secondaryLabel) : this.props.secondaryLabel,
        "error-message": Array.isArray(this.props.errorMessage) || this.props.errorMessage === Object(this.props.errorMessage) ? JSON.stringify(this.props.errorMessage) : this.props.errorMessage,
        expanded: Array.isArray(this.props.expanded) || this.props.expanded === Object(this.props.expanded) ? JSON.stringify(this.props.expanded) : this.props.expanded,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsTileAccordionItem;
}(React.Component);
MdsTileAccordionItem.propTypes = {
  // Values
  headingLevel: PropTypes.number,
  accordionLabel: PropTypes.string,
  secondaryLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  expanded: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["error"])
};
MdsTileAccordionItem.defaultProps = {
  headingLevel: 2,
  expanded: false
};

var MdsTileAccordion = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsTileAccordion, _React$Component);

  var _super = _createSuper(MdsTileAccordion);

  function MdsTileAccordion(props) {
    var _this;

    _classCallCheck(this, MdsTileAccordion);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTouchend) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onBlur) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onKeyup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseout) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeydown) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onTouchstart) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onFocus) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onClick) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsTileAccordion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-tile-accordion", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "default-open": Array.isArray(this.props.defaultOpen) || this.props.defaultOpen === Object(this.props.defaultOpen) ? JSON.stringify(this.props.defaultOpen) : this.props.defaultOpen,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        lock: Array.isArray(this.props.lock) || this.props.lock === Object(this.props.lock) ? JSON.stringify(this.props.lock) : this.props.lock,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "accordion-items": Array.isArray(this.props.accordionItems) || this.props.accordionItems === Object(this.props.accordionItems) ? JSON.stringify(this.props.accordionItems) : this.props.accordionItems // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsTileAccordion;
}(React.Component);
MdsTileAccordion.propTypes = {
  // Values
  defaultOpen: PropTypes.string,
  brand: PropTypes.string,
  lock: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  accordionItems: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsTileAccordion.defaultProps = {
  defaultOpen: "0",
  // Events
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsTooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsTooltip, _React$Component);

  var _super = _createSuper(MdsTooltip);

  function MdsTooltip(props) {
    var _this;

    _classCallCheck(this, MdsTooltip);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onOpen) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClose) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClose(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("close", this._onClose);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("close", this._onClose);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-tooltip", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        alignment: Array.isArray(this.props.alignment) || this.props.alignment === Object(this.props.alignment) ? JSON.stringify(this.props.alignment) : this.props.alignment,
        "tooltip-placement": Array.isArray(this.props.tooltipPlacement) || this.props.tooltipPlacement === Object(this.props.tooltipPlacement) ? JSON.stringify(this.props.tooltipPlacement) : this.props.tooltipPlacement,
        message: Array.isArray(this.props.message) || this.props.message === Object(this.props.message) ? JSON.stringify(this.props.message) : this.props.message,
        "edge-detection-container-id": Array.isArray(this.props.edgeDetectionContainerId) || this.props.edgeDetectionContainerId === Object(this.props.edgeDetectionContainerId) ? JSON.stringify(this.props.edgeDetectionContainerId) : this.props.edgeDetectionContainerId,
        "manual-control": Array.isArray(this.props.manualControl) || this.props.manualControl === Object(this.props.manualControl) ? JSON.stringify(this.props.manualControl) : this.props.manualControl,
        visible: Array.isArray(this.props.visible) || this.props.visible === Object(this.props.visible) ? JSON.stringify(this.props.visible) : this.props.visible,
        "edge-detection": Array.isArray(this.props.edgeDetection) || this.props.edgeDetection === Object(this.props.edgeDetection) ? JSON.stringify(this.props.edgeDetection) : this.props.edgeDetection,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsTooltip;
}(React.Component);
MdsTooltip.propTypes = {
  // Values
  variant: PropTypes.oneOf(["base", "information", "success", "error"]),
  alignment: PropTypes.oneOf(["left", "right", "center"]),
  tooltipPlacement: PropTypes.oneOf(["above", "below"]),
  message: PropTypes.string,
  edgeDetectionContainerId: PropTypes.string,
  manualControl: PropTypes.bool,
  visible: PropTypes.bool,
  edgeDetection: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};
MdsTooltip.defaultProps = {
  variant: "base",
  tooltipPlacement: "below",
  edgeDetectionContainerId: "below",
  manualControl: false,
  visible: false,
  edgeDetection: true,
  // Events
  onOpen: null,
  onClose: null
};

var MdsVerticalNavigationFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsVerticalNavigationFooter, _React$Component);

  var _super = _createSuper(MdsVerticalNavigationFooter);

  function MdsVerticalNavigationFooter() {
    _classCallCheck(this, MdsVerticalNavigationFooter);

    return _super.apply(this, arguments);
  }

  _createClass(MdsVerticalNavigationFooter, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-vertical-navigation-footer", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        items: Array.isArray(this.props.items) || this.props.items === Object(this.props.items) ? JSON.stringify(this.props.items) : this.props.items,
        inverse: Array.isArray(this.props.inverse) || this.props.inverse === Object(this.props.inverse) ? JSON.stringify(this.props.inverse) : this.props.inverse,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsVerticalNavigationFooter;
}(React.Component);
MdsVerticalNavigationFooter.propTypes = {
  // Values
  items: PropTypes.array,
  inverse: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string
};
MdsVerticalNavigationFooter.defaultProps = {};

var MdsVerticalNavigationItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsVerticalNavigationItem, _React$Component);

  var _super = _createSuper(MdsVerticalNavigationItem);

  function MdsVerticalNavigationItem() {
    _classCallCheck(this, MdsVerticalNavigationItem);

    return _super.apply(this, arguments);
  }

  _createClass(MdsVerticalNavigationItem, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-vertical-navigation-item", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        inverse: Array.isArray(this.props.inverse) || this.props.inverse === Object(this.props.inverse) ? JSON.stringify(this.props.inverse) : this.props.inverse,
        type: Array.isArray(this.props.type) || this.props.type === Object(this.props.type) ? JSON.stringify(this.props.type) : this.props.type,
        expanded: Array.isArray(this.props.expanded) || this.props.expanded === Object(this.props.expanded) ? JSON.stringify(this.props.expanded) : this.props.expanded,
        "badge-label": Array.isArray(this.props.badgeLabel) || this.props.badgeLabel === Object(this.props.badgeLabel) ? JSON.stringify(this.props.badgeLabel) : this.props.badgeLabel,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsVerticalNavigationItem;
}(React.Component);
MdsVerticalNavigationItem.propTypes = {
  // Values
  label: PropTypes.string,
  inverse: PropTypes.bool,
  type: PropTypes.oneOf(["collapsible", "heading", "link"]),
  expanded: PropTypes.bool,
  badgeLabel: PropTypes.number,
  icon: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["hovered", "pressed", "active"])
};
MdsVerticalNavigationItem.defaultProps = {
  type: "link",
  expanded: false
};

var MdsVerticalNavigation = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsVerticalNavigation, _React$Component);

  var _super = _createSuper(MdsVerticalNavigation);

  function MdsVerticalNavigation(props) {
    var _this;

    _classCallCheck(this, MdsVerticalNavigation);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onActivate", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onActivate) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onActivate(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onTouchend) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeyup) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseover) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseenter) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onClick) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onActivate = _this._onActivate.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsVerticalNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("activate", this._onActivate);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("activate", this._onActivate);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-vertical-navigation", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        inverse: Array.isArray(this.props.inverse) || this.props.inverse === Object(this.props.inverse) ? JSON.stringify(this.props.inverse) : this.props.inverse,
        "active-item": Array.isArray(this.props.activeItem) || this.props.activeItem === Object(this.props.activeItem) ? JSON.stringify(this.props.activeItem) : this.props.activeItem,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "active-index": Array.isArray(this.props.activeIndex) || this.props.activeIndex === Object(this.props.activeIndex) ? JSON.stringify(this.props.activeIndex) : this.props.activeIndex,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsVerticalNavigation;
}(React.Component);
MdsVerticalNavigation.propTypes = {
  // Values
  inverse: PropTypes.bool,
  activeItem: PropTypes.string,
  brand: PropTypes.string,
  activeIndex: PropTypes.string,
  accessibleName: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onActivate: PropTypes.func,
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsVerticalNavigation.defaultProps = {
  inverse: false,
  // Events
  onActivate: null,
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onMouseover: null,
  onMouseenter: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsVideoPlayer = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsVideoPlayer, _React$Component);

  var _super = _createSuper(MdsVideoPlayer);

  function MdsVideoPlayer(props) {
    var _this;

    _classCallCheck(this, MdsVideoPlayer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onPlay", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onPlay) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onPlay(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onPause", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onPause) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onPause(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTimeupdate", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onTimeupdate) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onTimeupdate(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onProgress25PercentComplete", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onProgress25PercentComplete) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onProgress25PercentComplete(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onProgress50PercentComplete", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onProgress50PercentComplete) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onProgress50PercentComplete(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onProgress75PercentComplete", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onProgress75PercentComplete) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onProgress75PercentComplete(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onProgress100PercentComplete", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onProgress100PercentComplete) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onProgress100PercentComplete(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onVolumechange", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onVolumechange) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onVolumechange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMute", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMute) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMute(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onClick) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onKeydown) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onKeyup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onMouseenter) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onMouseover) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onMouseout) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onTouchstart) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props33, _this$props34;

      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onTouchend) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onPlay = _this._onPlay.bind(_assertThisInitialized(_this));
    _this._onPause = _this._onPause.bind(_assertThisInitialized(_this));
    _this._onTimeupdate = _this._onTimeupdate.bind(_assertThisInitialized(_this));
    _this._onProgress25PercentComplete = _this._onProgress25PercentComplete.bind(_assertThisInitialized(_this));
    _this._onProgress50PercentComplete = _this._onProgress50PercentComplete.bind(_assertThisInitialized(_this));
    _this._onProgress75PercentComplete = _this._onProgress75PercentComplete.bind(_assertThisInitialized(_this));
    _this._onProgress100PercentComplete = _this._onProgress100PercentComplete.bind(_assertThisInitialized(_this));
    _this._onVolumechange = _this._onVolumechange.bind(_assertThisInitialized(_this));
    _this._onMute = _this._onMute.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsVideoPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("play", this._onPlay);

      this._ref.current.addEventListener("pause", this._onPause);

      this._ref.current.addEventListener("timeupdate", this._onTimeupdate);

      this._ref.current.addEventListener("progress25PercentComplete", this._onProgress25PercentComplete);

      this._ref.current.addEventListener("progress50PercentComplete", this._onProgress50PercentComplete);

      this._ref.current.addEventListener("progress75PercentComplete", this._onProgress75PercentComplete);

      this._ref.current.addEventListener("progress100PercentComplete", this._onProgress100PercentComplete);

      this._ref.current.addEventListener("volumechange", this._onVolumechange);

      this._ref.current.addEventListener("mute", this._onMute);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("play", this._onPlay);

      this._ref.current.removeEventListener("pause", this._onPause);

      this._ref.current.removeEventListener("timeupdate", this._onTimeupdate);

      this._ref.current.removeEventListener("progress25PercentComplete", this._onProgress25PercentComplete);

      this._ref.current.removeEventListener("progress50PercentComplete", this._onProgress50PercentComplete);

      this._ref.current.removeEventListener("progress75PercentComplete", this._onProgress75PercentComplete);

      this._ref.current.removeEventListener("progress100PercentComplete", this._onProgress100PercentComplete);

      this._ref.current.removeEventListener("volumechange", this._onVolumechange);

      this._ref.current.removeEventListener("mute", this._onMute);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-video-player", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "account-id": Array.isArray(this.props.accountId) || this.props.accountId === Object(this.props.accountId) ? JSON.stringify(this.props.accountId) : this.props.accountId,
        "player-id": Array.isArray(this.props.playerId) || this.props.playerId === Object(this.props.playerId) ? JSON.stringify(this.props.playerId) : this.props.playerId,
        "video-id": Array.isArray(this.props.videoId) || this.props.videoId === Object(this.props.videoId) ? JSON.stringify(this.props.videoId) : this.props.videoId,
        config: Array.isArray(this.props.config) || this.props.config === Object(this.props.config) ? JSON.stringify(this.props.config) : this.props.config,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsVideoPlayer;
}(React.Component);
MdsVideoPlayer.propTypes = {
  // Values
  accountId: PropTypes.string,
  playerId: PropTypes.string,
  videoId: PropTypes.string,
  config: PropTypes.object,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
  onTimeupdate: PropTypes.func,
  onProgress25PercentComplete: PropTypes.func,
  onProgress50PercentComplete: PropTypes.func,
  onProgress75PercentComplete: PropTypes.func,
  onProgress100PercentComplete: PropTypes.func,
  onVolumechange: PropTypes.func,
  onMute: PropTypes.func,
  onClick: PropTypes.func,
  onKeydown: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsVideoPlayer.defaultProps = {
  // Events
  onPlay: null,
  onPause: null,
  onTimeupdate: null,
  onProgress25PercentComplete: null,
  onProgress50PercentComplete: null,
  onProgress75PercentComplete: null,
  onProgress100PercentComplete: null,
  onVolumechange: null,
  onMute: null,
  onClick: null,
  onKeydown: null,
  onKeyup: null,
  onMouseenter: null,
  onMouseover: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsAvatarBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsAvatarBanner, _React$Component);

  var _super = _createSuper(MdsAvatarBanner);

  function MdsAvatarBanner(props) {
    var _this;

    _classCallCheck(this, MdsAvatarBanner);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onTouchstart) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onTouchend) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsAvatarBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-avatar-banner", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "avatar-title": Array.isArray(this.props.avatarTitle) || this.props.avatarTitle === Object(this.props.avatarTitle) ? JSON.stringify(this.props.avatarTitle) : this.props.avatarTitle,
        subtitle: Array.isArray(this.props.subtitle) || this.props.subtitle === Object(this.props.subtitle) ? JSON.stringify(this.props.subtitle) : this.props.subtitle,
        "avatar-illustration": Array.isArray(this.props.avatarIllustration) || this.props.avatarIllustration === Object(this.props.avatarIllustration) ? JSON.stringify(this.props.avatarIllustration) : this.props.avatarIllustration,
        title: Array.isArray(this.props.title) || this.props.title === Object(this.props.title) ? JSON.stringify(this.props.title) : this.props.title,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsAvatarBanner;
}(React.Component);
MdsAvatarBanner.propTypes = {
  // Values
  avatarTitle: PropTypes.string,
  subtitle: PropTypes.string,
  avatarIllustration: PropTypes.string,
  title: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsAvatarBanner.defaultProps = {
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsChatBubble = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsChatBubble, _React$Component);

  var _super = _createSuper(MdsChatBubble);

  function MdsChatBubble(props) {
    var _this;

    _classCallCheck(this, MdsChatBubble);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeyup) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeydown) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMousedown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseover) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseenter) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseout) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onTouchstart) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchend) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsChatBubble, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-chat-bubble", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "first-in-group": Array.isArray(this.props.firstInGroup) || this.props.firstInGroup === Object(this.props.firstInGroup) ? JSON.stringify(this.props.firstInGroup) : this.props.firstInGroup,
        error: Array.isArray(this.props.error) || this.props.error === Object(this.props.error) ? JSON.stringify(this.props.error) : this.props.error,
        message: Array.isArray(this.props.message) || this.props.message === Object(this.props.message) ? JSON.stringify(this.props.message) : this.props.message,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        "image-width": Array.isArray(this.props.imageWidth) || this.props.imageWidth === Object(this.props.imageWidth) ? JSON.stringify(this.props.imageWidth) : this.props.imageWidth,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsChatBubble;
}(React.Component);
MdsChatBubble.propTypes = {
  // Values
  variant: PropTypes.oneOf(["agent", "assistant", "customer"]),
  firstInGroup: PropTypes.bool,
  error: PropTypes.bool,
  message: PropTypes.string,
  microcopy: PropTypes.string,
  image: PropTypes.string,
  imageWidth: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsChatBubble.defaultProps = {
  error: false,
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsChatInput = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsChatInput, _React$Component);

  var _super = _createSuper(MdsChatInput);

  function MdsChatInput(props) {
    var _this;

    _classCallCheck(this, MdsChatInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onMessageSent", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onMessageSent) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onMessageSent(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickSubmitButton", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onClickSubmitButton) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onClickSubmitButton(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickVoiceButton", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onClickVoiceButton) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onClickVoiceButton(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onMessageSent = _this._onMessageSent.bind(_assertThisInitialized(_this));
    _this._onClickSubmitButton = _this._onClickSubmitButton.bind(_assertThisInitialized(_this));
    _this._onClickVoiceButton = _this._onClickVoiceButton.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsChatInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("messageSent", this._onMessageSent);

      this._ref.current.addEventListener("click-submit-button", this._onClickSubmitButton);

      this._ref.current.addEventListener("click-voice-button", this._onClickVoiceButton);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("messageSent", this._onMessageSent);

      this._ref.current.removeEventListener("click-submit-button", this._onClickSubmitButton);

      this._ref.current.removeEventListener("click-voice-button", this._onClickVoiceButton);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-chat-input", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        "ada-text": Array.isArray(this.props.adaText) || this.props.adaText === Object(this.props.adaText) ? JSON.stringify(this.props.adaText) : this.props.adaText,
        "ada-text-send-button": Array.isArray(this.props.adaTextSendButton) || this.props.adaTextSendButton === Object(this.props.adaTextSendButton) ? JSON.stringify(this.props.adaTextSendButton) : this.props.adaTextSendButton,
        "has-voice-button": Array.isArray(this.props.hasVoiceButton) || this.props.hasVoiceButton === Object(this.props.hasVoiceButton) ? JSON.stringify(this.props.hasVoiceButton) : this.props.hasVoiceButton,
        "voice-button-enabled": Array.isArray(this.props.voiceButtonEnabled) || this.props.voiceButtonEnabled === Object(this.props.voiceButtonEnabled) ? JSON.stringify(this.props.voiceButtonEnabled) : this.props.voiceButtonEnabled,
        "has-leading-button": Array.isArray(this.props.hasLeadingButton) || this.props.hasLeadingButton === Object(this.props.hasLeadingButton) ? JSON.stringify(this.props.hasLeadingButton) : this.props.hasLeadingButton,
        "leading-button-enabled": Array.isArray(this.props.leadingButtonEnabled) || this.props.leadingButtonEnabled === Object(this.props.leadingButtonEnabled) ? JSON.stringify(this.props.leadingButtonEnabled) : this.props.leadingButtonEnabled,
        "send-button-always-disabled": Array.isArray(this.props.sendButtonAlwaysDisabled) || this.props.sendButtonAlwaysDisabled === Object(this.props.sendButtonAlwaysDisabled) ? JSON.stringify(this.props.sendButtonAlwaysDisabled) : this.props.sendButtonAlwaysDisabled,
        "ada-text-voice-button": Array.isArray(this.props.adaTextVoiceButton) || this.props.adaTextVoiceButton === Object(this.props.adaTextVoiceButton) ? JSON.stringify(this.props.adaTextVoiceButton) : this.props.adaTextVoiceButton,
        "ada-text-leading-button": Array.isArray(this.props.adaTextLeadingButton) || this.props.adaTextLeadingButton === Object(this.props.adaTextLeadingButton) ? JSON.stringify(this.props.adaTextLeadingButton) : this.props.adaTextLeadingButton,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        "ada-text-send-button-disabled-text": Array.isArray(this.props.adaTextSendButtonDisabledText) || this.props.adaTextSendButtonDisabledText === Object(this.props.adaTextSendButtonDisabledText) ? JSON.stringify(this.props.adaTextSendButtonDisabledText) : this.props.adaTextSendButtonDisabledText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsChatInput;
}(React.Component);
MdsChatInput.propTypes = {
  // Values
  label: PropTypes.string,
  value: PropTypes.string,
  adaText: PropTypes.string,
  adaTextSendButton: PropTypes.string,
  hasVoiceButton: PropTypes.bool,
  voiceButtonEnabled: PropTypes.bool,
  hasLeadingButton: PropTypes.bool,
  leadingButtonEnabled: PropTypes.bool,
  sendButtonAlwaysDisabled: PropTypes.bool,
  adaTextVoiceButton: PropTypes.string,
  adaTextLeadingButton: PropTypes.string,
  brand: PropTypes.string,
  inactive: PropTypes.string,
  adaTextSendButtonDisabledText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "disabled"]),
  // Events
  onMessageSent: PropTypes.func,
  onClickSubmitButton: PropTypes.func,
  onClickVoiceButton: PropTypes.func
};
MdsChatInput.defaultProps = {
  label: "Type your message",
  value: "",
  adaText: "Type your message",
  adaTextSendButton: "Send",
  hasVoiceButton: false,
  voiceButtonEnabled: true,
  hasLeadingButton: false,
  leadingButtonEnabled: true,
  sendButtonAlwaysDisabled: false,
  adaTextVoiceButton: "Switch to voice input",
  // Events
  onMessageSent: null,
  onClickSubmitButton: null,
  onClickVoiceButton: null
};

var MdsLoadingBubble = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsLoadingBubble, _React$Component);

  var _super = _createSuper(MdsLoadingBubble);

  function MdsLoadingBubble(props) {
    var _this;

    _classCallCheck(this, MdsLoadingBubble);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeyup) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeydown) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMousedown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseover) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseenter) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseout) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onTouchstart) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchend) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchend(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsLoadingBubble, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-loading-bubble", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        "first-in-group": Array.isArray(this.props.firstInGroup) || this.props.firstInGroup === Object(this.props.firstInGroup) ? JSON.stringify(this.props.firstInGroup) : this.props.firstInGroup,
        error: Array.isArray(this.props.error) || this.props.error === Object(this.props.error) ? JSON.stringify(this.props.error) : this.props.error,
        message: Array.isArray(this.props.message) || this.props.message === Object(this.props.message) ? JSON.stringify(this.props.message) : this.props.message,
        microcopy: Array.isArray(this.props.microcopy) || this.props.microcopy === Object(this.props.microcopy) ? JSON.stringify(this.props.microcopy) : this.props.microcopy,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        "image-width": Array.isArray(this.props.imageWidth) || this.props.imageWidth === Object(this.props.imageWidth) ? JSON.stringify(this.props.imageWidth) : this.props.imageWidth,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsLoadingBubble;
}(React.Component);
MdsLoadingBubble.propTypes = {
  // Values
  variant: PropTypes.oneOf(["agent", "assistant"]),
  firstInGroup: PropTypes.string,
  error: PropTypes.bool,
  message: PropTypes.string,
  microcopy: PropTypes.string,
  image: PropTypes.string,
  imageWidth: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func
};
MdsLoadingBubble.defaultProps = {
  variant: "assistant",
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null
};

var MdsQuickReplyBar = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsQuickReplyBar, _React$Component);

  var _super = _createSuper(MdsQuickReplyBar);

  function MdsQuickReplyBar(props) {
    var _this;

    _classCallCheck(this, MdsQuickReplyBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTouchend) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onBlur) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onKeyup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseout) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickButton", function (event) {
      var _event$detail, _event$detail$target, _event$detail$target$, _this$props9, _this$props10;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : (_event$detail$target = _event$detail.target) === null || _event$detail$target === void 0 ? void 0 : (_event$detail$target$ = _event$detail$target.dataset) === null || _event$detail$target$ === void 0 ? void 0 : _event$detail$target$.index) + 1 || 1;
      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onClickButton) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onClickButton(event, eventIndex));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onKeydown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onChange) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseover) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseenter) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchstart) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onFocus) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onClick) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onClickButton = _this._onClickButton.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsQuickReplyBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("click-button1", this._onClickButton);

      this._ref.current.addEventListener("click-button2", this._onClickButton);

      this._ref.current.addEventListener("click-button3", this._onClickButton);

      this._ref.current.addEventListener("click-button4", this._onClickButton);

      this._ref.current.addEventListener("click-button5", this._onClickButton);

      this._ref.current.addEventListener("click-button6", this._onClickButton);

      this._ref.current.addEventListener("click-button7", this._onClickButton);

      this._ref.current.addEventListener("click-button8", this._onClickButton);

      this._ref.current.addEventListener("click-button9", this._onClickButton);

      this._ref.current.addEventListener("click-button10", this._onClickButton);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("click-button1", this._onClickButton);

      this._ref.current.removeEventListener("click-button2", this._onClickButton);

      this._ref.current.removeEventListener("click-button3", this._onClickButton);

      this._ref.current.removeEventListener("click-button4", this._onClickButton);

      this._ref.current.removeEventListener("click-button5", this._onClickButton);

      this._ref.current.removeEventListener("click-button6", this._onClickButton);

      this._ref.current.removeEventListener("click-button7", this._onClickButton);

      this._ref.current.removeEventListener("click-button8", this._onClickButton);

      this._ref.current.removeEventListener("click-button9", this._onClickButton);

      this._ref.current.removeEventListener("click-button10", this._onClickButton);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-quick-reply-bar", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        multiline: Array.isArray(this.props.multiline) || this.props.multiline === Object(this.props.multiline) ? JSON.stringify(this.props.multiline) : this.props.multiline,
        "quick-reply-alignment": Array.isArray(this.props.quickReplyAlignment) || this.props.quickReplyAlignment === Object(this.props.quickReplyAlignment) ? JSON.stringify(this.props.quickReplyAlignment) : this.props.quickReplyAlignment,
        "leading-padding": Array.isArray(this.props.leadingPadding) || this.props.leadingPadding === Object(this.props.leadingPadding) ? JSON.stringify(this.props.leadingPadding) : this.props.leadingPadding,
        "trailing-padding": Array.isArray(this.props.trailingPadding) || this.props.trailingPadding === Object(this.props.trailingPadding) ? JSON.stringify(this.props.trailingPadding) : this.props.trailingPadding,
        "image-width": Array.isArray(this.props.imageWidth) || this.props.imageWidth === Object(this.props.imageWidth) ? JSON.stringify(this.props.imageWidth) : this.props.imageWidth,
        "image-height": Array.isArray(this.props.imageHeight) || this.props.imageHeight === Object(this.props.imageHeight) ? JSON.stringify(this.props.imageHeight) : this.props.imageHeight,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "quick-reply-buttons": Array.isArray(this.props.quickReplyButtons) || this.props.quickReplyButtons === Object(this.props.quickReplyButtons) ? JSON.stringify(this.props.quickReplyButtons) : this.props.quickReplyButtons // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsQuickReplyBar;
}(React.Component);
MdsQuickReplyBar.propTypes = {
  // Values
  multiline: PropTypes.bool,
  quickReplyAlignment: PropTypes.oneOf(["leading", "trailing", "centered"]),
  leadingPadding: PropTypes.string,
  trailingPadding: PropTypes.string,
  imageWidth: PropTypes.string,
  imageHeight: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  quickReplyButtons: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onTouchend: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onClickButton: PropTypes.func,
  onKeydown: PropTypes.func,
  onChange: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onTouchstart: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func
};
MdsQuickReplyBar.defaultProps = {
  multiline: false,
  quickReplyAlignment: "centered",
  // Events
  onTouchend: null,
  onBlur: null,
  onKeyup: null,
  onMouseout: null,
  onClickButton: null,
  onKeydown: null,
  onChange: null,
  onMouseover: null,
  onMouseenter: null,
  onTouchstart: null,
  onFocus: null,
  onClick: null
};

var MdsQuickReplyButton = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsQuickReplyButton, _React$Component);

  var _super = _createSuper(MdsQuickReplyButton);

  function MdsQuickReplyButton() {
    _classCallCheck(this, MdsQuickReplyButton);

    return _super.apply(this, arguments);
  }

  _createClass(MdsQuickReplyButton, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-quick-reply-button", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        label: Array.isArray(this.props.label) || this.props.label === Object(this.props.label) ? JSON.stringify(this.props.label) : this.props.label,
        "secondary-label": Array.isArray(this.props.secondaryLabel) || this.props.secondaryLabel === Object(this.props.secondaryLabel) ? JSON.stringify(this.props.secondaryLabel) : this.props.secondaryLabel,
        image: Array.isArray(this.props.image) || this.props.image === Object(this.props.image) ? JSON.stringify(this.props.image) : this.props.image,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        multiline: Array.isArray(this.props.multiline) || this.props.multiline === Object(this.props.multiline) ? JSON.stringify(this.props.multiline) : this.props.multiline,
        "image-height": Array.isArray(this.props.imageHeight) || this.props.imageHeight === Object(this.props.imageHeight) ? JSON.stringify(this.props.imageHeight) : this.props.imageHeight,
        "image-width": Array.isArray(this.props.imageWidth) || this.props.imageWidth === Object(this.props.imageWidth) ? JSON.stringify(this.props.imageWidth) : this.props.imageWidth,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        text: Array.isArray(this.props.text) || this.props.text === Object(this.props.text) ? JSON.stringify(this.props.text) : this.props.text,
        "icon-accessible-description": Array.isArray(this.props.iconAccessibleDescription) || this.props.iconAccessibleDescription === Object(this.props.iconAccessibleDescription) ? JSON.stringify(this.props.iconAccessibleDescription) : this.props.iconAccessibleDescription,
        inverse: Array.isArray(this.props.inverse) || this.props.inverse === Object(this.props.inverse) ? JSON.stringify(this.props.inverse) : this.props.inverse,
        type: Array.isArray(this.props.type) || this.props.type === Object(this.props.type) ? JSON.stringify(this.props.type) : this.props.type,
        "width-type": Array.isArray(this.props.widthType) || this.props.widthType === Object(this.props.widthType) ? JSON.stringify(this.props.widthType) : this.props.widthType,
        inactive: Array.isArray(this.props.inactive) || this.props.inactive === Object(this.props.inactive) ? JSON.stringify(this.props.inactive) : this.props.inactive,
        small: Array.isArray(this.props.small) || this.props.small === Object(this.props.small) ? JSON.stringify(this.props.small) : this.props.small,
        "tab-focusable": Array.isArray(this.props.tabFocusable) || this.props.tabFocusable === Object(this.props.tabFocusable) ? JSON.stringify(this.props.tabFocusable) : this.props.tabFocusable,
        value: Array.isArray(this.props.value) || this.props.value === Object(this.props.value) ? JSON.stringify(this.props.value) : this.props.value,
        "icon-type": Array.isArray(this.props.iconType) || this.props.iconType === Object(this.props.iconType) ? JSON.stringify(this.props.iconType) : this.props.iconType,
        badge: Array.isArray(this.props.badge) || this.props.badge === Object(this.props.badge) ? JSON.stringify(this.props.badge) : this.props.badge,
        "icon-position": Array.isArray(this.props.iconPosition) || this.props.iconPosition === Object(this.props.iconPosition) ? JSON.stringify(this.props.iconPosition) : this.props.iconPosition,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsQuickReplyButton;
}(React.Component);
MdsQuickReplyButton.propTypes = {
  // Values
  label: PropTypes.string,
  secondaryLabel: PropTypes.string,
  image: PropTypes.string,
  icon: PropTypes.string,
  multiline: PropTypes.bool,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  accessibleText: PropTypes.string,
  brand: PropTypes.string,
  text: PropTypes.string,
  iconAccessibleDescription: PropTypes.string,
  inverse: PropTypes.string,
  type: PropTypes.string,
  widthType: PropTypes.string,
  inactive: PropTypes.string,
  small: PropTypes.string,
  tabFocusable: PropTypes.string,
  value: PropTypes.string,
  iconType: PropTypes.string,
  badge: PropTypes.string,
  iconPosition: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["pressed", "hover", "focused"])
};
MdsQuickReplyButton.defaultProps = {
  multiline: false
};

var MdsStatusBlock = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsStatusBlock, _React$Component);

  var _super = _createSuper(MdsStatusBlock);

  function MdsStatusBlock(props) {
    var _this;

    _classCallCheck(this, MdsStatusBlock);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsStatusBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-status-block", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        message: Array.isArray(this.props.message) || this.props.message === Object(this.props.message) ? JSON.stringify(this.props.message) : this.props.message,
        "is-animated": Array.isArray(this.props.isAnimated) || this.props.isAnimated === Object(this.props.isAnimated) ? JSON.stringify(this.props.isAnimated) : this.props.isAnimated,
        avatar: Array.isArray(this.props.avatar) || this.props.avatar === Object(this.props.avatar) ? JSON.stringify(this.props.avatar) : this.props.avatar,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsStatusBlock;
}(React.Component);
MdsStatusBlock.propTypes = {
  // Values
  message: PropTypes.string,
  isAnimated: PropTypes.bool,
  avatar: PropTypes.string,
  brand: PropTypes.string,
  accessibleName: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsStatusBlock.defaultProps = {
  isAnimated: false,
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsAreaChart = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsAreaChart, _React$Component);

  var _super = _createSuper(MdsAreaChart);

  function MdsAreaChart(props) {
    var _this;

    _classCallCheck(this, MdsAreaChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTabChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTabChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTabChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onAccessibleAlternativeLinkPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onAccessibleAlternativeLinkPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onAccessibleAlternativeLinkPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onExpandFullScreenButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onExpandFullScreenButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onExpandFullScreenButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onClick) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTabChange = _this._onTabChange.bind(_assertThisInitialized(_this));
    _this._onAccessibleAlternativeLinkPress = _this._onAccessibleAlternativeLinkPress.bind(_assertThisInitialized(_this));
    _this._onExpandFullScreenButtonPress = _this._onExpandFullScreenButtonPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsAreaChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("tabChange", this._onTabChange);

      this._ref.current.addEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.addEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("tabChange", this._onTabChange);

      this._ref.current.removeEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.removeEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-area-chart", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "short-description": Array.isArray(this.props.shortDescription) || this.props.shortDescription === Object(this.props.shortDescription) ? JSON.stringify(this.props.shortDescription) : this.props.shortDescription,
        "chart-title": Array.isArray(this.props.chartTitle) || this.props.chartTitle === Object(this.props.chartTitle) ? JSON.stringify(this.props.chartTitle) : this.props.chartTitle,
        "show-full-screen-button": Array.isArray(this.props.showFullScreenButton) || this.props.showFullScreenButton === Object(this.props.showFullScreenButton) ? JSON.stringify(this.props.showFullScreenButton) : this.props.showFullScreenButton,
        "accessible-alternative-link-text": Array.isArray(this.props.accessibleAlternativeLinkText) || this.props.accessibleAlternativeLinkText === Object(this.props.accessibleAlternativeLinkText) ? JSON.stringify(this.props.accessibleAlternativeLinkText) : this.props.accessibleAlternativeLinkText,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        "d3-legend-format-string": Array.isArray(this.props.d3LegendFormatString) || this.props.d3LegendFormatString === Object(this.props.d3LegendFormatString) ? JSON.stringify(this.props.d3LegendFormatString) : this.props.d3LegendFormatString,
        "d3-bar-label-format-string": Array.isArray(this.props.d3BarLabelFormatString) || this.props.d3BarLabelFormatString === Object(this.props.d3BarLabelFormatString) ? JSON.stringify(this.props.d3BarLabelFormatString) : this.props.d3BarLabelFormatString,
        "d3-prefix-formatter": Array.isArray(this.props.d3PrefixFormatter) || this.props.d3PrefixFormatter === Object(this.props.d3PrefixFormatter) ? JSON.stringify(this.props.d3PrefixFormatter) : this.props.d3PrefixFormatter,
        "d3-data-point-detail-x-format-string": Array.isArray(this.props.d3DataPointDetailXFormatString) || this.props.d3DataPointDetailXFormatString === Object(this.props.d3DataPointDetailXFormatString) ? JSON.stringify(this.props.d3DataPointDetailXFormatString) : this.props.d3DataPointDetailXFormatString,
        "d3-data-point-detail-y-format-string": Array.isArray(this.props.d3DataPointDetailYFormatString) || this.props.d3DataPointDetailYFormatString === Object(this.props.d3DataPointDetailYFormatString) ? JSON.stringify(this.props.d3DataPointDetailYFormatString) : this.props.d3DataPointDetailYFormatString,
        "chart-height": Array.isArray(this.props.chartHeight) || this.props.chartHeight === Object(this.props.chartHeight) ? JSON.stringify(this.props.chartHeight) : this.props.chartHeight,
        "show-y-axis": Array.isArray(this.props.showYAxis) || this.props.showYAxis === Object(this.props.showYAxis) ? JSON.stringify(this.props.showYAxis) : this.props.showYAxis,
        "highlighted-x-value": Array.isArray(this.props.highlightedXValue) || this.props.highlightedXValue === Object(this.props.highlightedXValue) ? JSON.stringify(this.props.highlightedXValue) : this.props.highlightedXValue,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "default-data-point-detail-position": Array.isArray(this.props.defaultDataPointDetailPosition) || this.props.defaultDataPointDetailPosition === Object(this.props.defaultDataPointDetailPosition) ? JSON.stringify(this.props.defaultDataPointDetailPosition) : this.props.defaultDataPointDetailPosition,
        "full-screen-button-alternative-text": Array.isArray(this.props.fullScreenButtonAlternativeText) || this.props.fullScreenButtonAlternativeText === Object(this.props.fullScreenButtonAlternativeText) ? JSON.stringify(this.props.fullScreenButtonAlternativeText) : this.props.fullScreenButtonAlternativeText,
        baseline: Array.isArray(this.props.baseline) || this.props.baseline === Object(this.props.baseline) ? JSON.stringify(this.props.baseline) : this.props.baseline,
        "top-border": Array.isArray(this.props.topBorder) || this.props.topBorder === Object(this.props.topBorder) ? JSON.stringify(this.props.topBorder) : this.props.topBorder,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        tabs: Array.isArray(this.props.tabs) || this.props.tabs === Object(this.props.tabs) ? JSON.stringify(this.props.tabs) : this.props.tabs,
        line: Array.isArray(this.props.line) || this.props.line === Object(this.props.line) ? JSON.stringify(this.props.line) : this.props.line,
        "x-axis": Array.isArray(this.props.xAxis) || this.props.xAxis === Object(this.props.xAxis) ? JSON.stringify(this.props.xAxis) : this.props.xAxis,
        "y-axis": Array.isArray(this.props.yAxis) || this.props.yAxis === Object(this.props.yAxis) ? JSON.stringify(this.props.yAxis) : this.props.yAxis,
        "reference-lines": Array.isArray(this.props.referenceLines) || this.props.referenceLines === Object(this.props.referenceLines) ? JSON.stringify(this.props.referenceLines) : this.props.referenceLines,
        lines: Array.isArray(this.props.lines) || this.props.lines === Object(this.props.lines) ? JSON.stringify(this.props.lines) : this.props.lines // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsAreaChart;
}(React.Component);
MdsAreaChart.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  shortDescription: PropTypes.string,
  chartTitle: PropTypes.string,
  showFullScreenButton: PropTypes.string,
  accessibleAlternativeLinkText: PropTypes.string,
  noDataPointText: PropTypes.string,
  d3LegendFormatString: PropTypes.string,
  d3BarLabelFormatString: PropTypes.string,
  d3PrefixFormatter: PropTypes.bool,
  d3DataPointDetailXFormatString: PropTypes.string,
  d3DataPointDetailYFormatString: PropTypes.string,
  chartHeight: CustomPropTypes.integer,
  showYAxis: PropTypes.bool,
  highlightedXValue: PropTypes.number,
  brand: PropTypes.string,
  defaultDataPointDetailPosition: PropTypes.string,
  fullScreenButtonAlternativeText: PropTypes.string,
  baseline: PropTypes.bool,
  topBorder: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  tabs: CustomPropTypes.slot,
  line: CustomPropTypes.slot,
  xAxis: CustomPropTypes.slot,
  yAxis: CustomPropTypes.slot,
  referenceLines: PropTypes.arrayOf(CustomPropTypes.slot),
  lines: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onTabChange: PropTypes.func,
  onAccessibleAlternativeLinkPress: PropTypes.func,
  onExpandFullScreenButtonPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onClick: PropTypes.func
};
MdsAreaChart.defaultProps = {
  d3PrefixFormatter: false,
  showYAxis: true,
  baseline: true,
  topBorder: true,
  // Events
  onTabChange: null,
  onAccessibleAlternativeLinkPress: null,
  onExpandFullScreenButtonPress: null,
  onMousedown: null,
  onMouseout: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onClick: null
};

var MdsBarChart = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBarChart, _React$Component);

  var _super = _createSuper(MdsBarChart);

  function MdsBarChart(props) {
    var _this;

    _classCallCheck(this, MdsBarChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTabChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTabChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTabChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onAccessibleAlternativeLinkPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onAccessibleAlternativeLinkPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onAccessibleAlternativeLinkPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onExpandFullScreenButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onExpandFullScreenButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onExpandFullScreenButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onClick) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTabChange = _this._onTabChange.bind(_assertThisInitialized(_this));
    _this._onAccessibleAlternativeLinkPress = _this._onAccessibleAlternativeLinkPress.bind(_assertThisInitialized(_this));
    _this._onExpandFullScreenButtonPress = _this._onExpandFullScreenButtonPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBarChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("tabChange", this._onTabChange);

      this._ref.current.addEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.addEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("tabChange", this._onTabChange);

      this._ref.current.removeEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.removeEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-bar-chart", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "short-description": Array.isArray(this.props.shortDescription) || this.props.shortDescription === Object(this.props.shortDescription) ? JSON.stringify(this.props.shortDescription) : this.props.shortDescription,
        "chart-title": Array.isArray(this.props.chartTitle) || this.props.chartTitle === Object(this.props.chartTitle) ? JSON.stringify(this.props.chartTitle) : this.props.chartTitle,
        "show-full-screen-button": Array.isArray(this.props.showFullScreenButton) || this.props.showFullScreenButton === Object(this.props.showFullScreenButton) ? JSON.stringify(this.props.showFullScreenButton) : this.props.showFullScreenButton,
        "accessible-alternative-link-text": Array.isArray(this.props.accessibleAlternativeLinkText) || this.props.accessibleAlternativeLinkText === Object(this.props.accessibleAlternativeLinkText) ? JSON.stringify(this.props.accessibleAlternativeLinkText) : this.props.accessibleAlternativeLinkText,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        "d3-legend-format-string": Array.isArray(this.props.d3LegendFormatString) || this.props.d3LegendFormatString === Object(this.props.d3LegendFormatString) ? JSON.stringify(this.props.d3LegendFormatString) : this.props.d3LegendFormatString,
        "d3-bar-label-format-string": Array.isArray(this.props.d3BarLabelFormatString) || this.props.d3BarLabelFormatString === Object(this.props.d3BarLabelFormatString) ? JSON.stringify(this.props.d3BarLabelFormatString) : this.props.d3BarLabelFormatString,
        "d3-prefix-formatter": Array.isArray(this.props.d3PrefixFormatter) || this.props.d3PrefixFormatter === Object(this.props.d3PrefixFormatter) ? JSON.stringify(this.props.d3PrefixFormatter) : this.props.d3PrefixFormatter,
        "d3-data-point-detail-x-format-string": Array.isArray(this.props.d3DataPointDetailXFormatString) || this.props.d3DataPointDetailXFormatString === Object(this.props.d3DataPointDetailXFormatString) ? JSON.stringify(this.props.d3DataPointDetailXFormatString) : this.props.d3DataPointDetailXFormatString,
        "d3-data-point-detail-y-format-string": Array.isArray(this.props.d3DataPointDetailYFormatString) || this.props.d3DataPointDetailYFormatString === Object(this.props.d3DataPointDetailYFormatString) ? JSON.stringify(this.props.d3DataPointDetailYFormatString) : this.props.d3DataPointDetailYFormatString,
        "chart-height": Array.isArray(this.props.chartHeight) || this.props.chartHeight === Object(this.props.chartHeight) ? JSON.stringify(this.props.chartHeight) : this.props.chartHeight,
        "group-type": Array.isArray(this.props.groupType) || this.props.groupType === Object(this.props.groupType) ? JSON.stringify(this.props.groupType) : this.props.groupType,
        "bar-width": Array.isArray(this.props.barWidth) || this.props.barWidth === Object(this.props.barWidth) ? JSON.stringify(this.props.barWidth) : this.props.barWidth,
        "inter-bar-width": Array.isArray(this.props.interBarWidth) || this.props.interBarWidth === Object(this.props.interBarWidth) ? JSON.stringify(this.props.interBarWidth) : this.props.interBarWidth,
        "legend-position": Array.isArray(this.props.legendPosition) || this.props.legendPosition === Object(this.props.legendPosition) ? JSON.stringify(this.props.legendPosition) : this.props.legendPosition,
        "left-legend-width": Array.isArray(this.props.leftLegendWidth) || this.props.leftLegendWidth === Object(this.props.leftLegendWidth) ? JSON.stringify(this.props.leftLegendWidth) : this.props.leftLegendWidth,
        "has-bar-labels": Array.isArray(this.props.hasBarLabels) || this.props.hasBarLabels === Object(this.props.hasBarLabels) ? JSON.stringify(this.props.hasBarLabels) : this.props.hasBarLabels,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "full-screen-button-alternative-text": Array.isArray(this.props.fullScreenButtonAlternativeText) || this.props.fullScreenButtonAlternativeText === Object(this.props.fullScreenButtonAlternativeText) ? JSON.stringify(this.props.fullScreenButtonAlternativeText) : this.props.fullScreenButtonAlternativeText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        tabs: Array.isArray(this.props.tabs) || this.props.tabs === Object(this.props.tabs) ? JSON.stringify(this.props.tabs) : this.props.tabs,
        series: Array.isArray(this.props.series) || this.props.series === Object(this.props.series) ? JSON.stringify(this.props.series) : this.props.series,
        "x-axis-labels": Array.isArray(this.props.xAxisLabels) || this.props.xAxisLabels === Object(this.props.xAxisLabels) ? JSON.stringify(this.props.xAxisLabels) : this.props.xAxisLabels,
        "y-axis": Array.isArray(this.props.yAxis) || this.props.yAxis === Object(this.props.yAxis) ? JSON.stringify(this.props.yAxis) : this.props.yAxis // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBarChart;
}(React.Component);
MdsBarChart.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  shortDescription: PropTypes.string,
  chartTitle: PropTypes.string,
  showFullScreenButton: PropTypes.bool,
  accessibleAlternativeLinkText: PropTypes.string,
  noDataPointText: PropTypes.string,
  d3LegendFormatString: PropTypes.string,
  d3BarLabelFormatString: PropTypes.string,
  d3PrefixFormatter: PropTypes.bool,
  d3DataPointDetailXFormatString: PropTypes.string,
  d3DataPointDetailYFormatString: PropTypes.string,
  chartHeight: CustomPropTypes.integer,
  groupType: PropTypes.oneOf(["stacked", "grouped"]),
  barWidth: PropTypes.oneOf([8, 16, 24, 32, 48, 64]),
  interBarWidth: CustomPropTypes.integer,
  legendPosition: PropTypes.oneOf(["top", "left"]),
  leftLegendWidth: CustomPropTypes.integer,
  hasBarLabels: PropTypes.bool,
  brand: PropTypes.string,
  fullScreenButtonAlternativeText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  tabs: CustomPropTypes.slot,
  series: PropTypes.arrayOf(CustomPropTypes.slot),
  xAxisLabels: PropTypes.arrayOf(CustomPropTypes.slot),
  yAxis: CustomPropTypes.slot,
  // Events
  onTabChange: PropTypes.func,
  onAccessibleAlternativeLinkPress: PropTypes.func,
  onExpandFullScreenButtonPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onClick: PropTypes.func
};
MdsBarChart.defaultProps = {
  showFullScreenButton: false,
  noDataPointText: "Chart temporarily unavailable.",
  d3PrefixFormatter: false,
  // Events
  onTabChange: null,
  onAccessibleAlternativeLinkPress: null,
  onExpandFullScreenButtonPress: null,
  onMousedown: null,
  onMouseout: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onClick: null
};

var MdsBarChartSegmented = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBarChartSegmented, _React$Component);

  var _super = _createSuper(MdsBarChartSegmented);

  function MdsBarChartSegmented(props) {
    var _this;

    _classCallCheck(this, MdsBarChartSegmented);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onBarSelected", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onBarSelected) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onBarSelected(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseoutSegment", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseoutSegment) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseoutSegment(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseout) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseoverSegment", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseoverSegment) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseoverSegment(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickSegment", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onClickSegment) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onClickSegment(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onClick) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onBarSelected = _this._onBarSelected.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseoutSegment = _this._onMouseoutSegment.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseoverSegment = _this._onMouseoverSegment.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onClickSegment = _this._onClickSegment.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBarChartSegmented, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("barSelected", this._onBarSelected);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseout-segment", this._onMouseoutSegment);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover-segment", this._onMouseoverSegment);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("click-segment", this._onClickSegment);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("barSelected", this._onBarSelected);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseout-segment", this._onMouseoutSegment);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover-segment", this._onMouseoverSegment);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("click-segment", this._onClickSegment);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-bar-chart-segmented", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        size: Array.isArray(this.props.size) || this.props.size === Object(this.props.size) ? JSON.stringify(this.props.size) : this.props.size,
        "accessible-description": Array.isArray(this.props.accessibleDescription) || this.props.accessibleDescription === Object(this.props.accessibleDescription) ? JSON.stringify(this.props.accessibleDescription) : this.props.accessibleDescription,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        interactive: Array.isArray(this.props.interactive) || this.props.interactive === Object(this.props.interactive) ? JSON.stringify(this.props.interactive) : this.props.interactive,
        "sort-segments": Array.isArray(this.props.sortSegments) || this.props.sortSegments === Object(this.props.sortSegments) ? JSON.stringify(this.props.sortSegments) : this.props.sortSegments,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        segments: Array.isArray(this.props.segments) || this.props.segments === Object(this.props.segments) ? JSON.stringify(this.props.segments) : this.props.segments // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBarChartSegmented;
}(React.Component);
MdsBarChartSegmented.propTypes = {
  // Values
  size: PropTypes.oneOf(["small", "medium", "large"]),
  accessibleDescription: PropTypes.string,
  accessibleName: PropTypes.string,
  interactive: PropTypes.bool,
  sortSegments: PropTypes.bool,
  noDataPointText: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  segments: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onBarSelected: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseoutSegment: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseoverSegment: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onClickSegment: PropTypes.func,
  onClick: PropTypes.func
};
MdsBarChartSegmented.defaultProps = {
  size: "medium",
  interactive: true,
  sortSegments: false,
  // Events
  onBarSelected: null,
  onMousedown: null,
  onMouseoutSegment: null,
  onMouseout: null,
  onMouseoverSegment: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onClickSegment: null,
  onClick: null
};

var MdsBarChartSelectable = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBarChartSelectable, _React$Component);

  var _super = _createSuper(MdsBarChartSelectable);

  function MdsBarChartSelectable(props) {
    var _this;

    _classCallCheck(this, MdsBarChartSelectable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTabChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTabChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTabChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onAccessibleAlternativeLinkPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onAccessibleAlternativeLinkPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onAccessibleAlternativeLinkPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onExpandFullScreenButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onExpandFullScreenButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onExpandFullScreenButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onClick) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSelection", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onSelection) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onSelection(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTabChange = _this._onTabChange.bind(_assertThisInitialized(_this));
    _this._onAccessibleAlternativeLinkPress = _this._onAccessibleAlternativeLinkPress.bind(_assertThisInitialized(_this));
    _this._onExpandFullScreenButtonPress = _this._onExpandFullScreenButtonPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onSelection = _this._onSelection.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBarChartSelectable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("tabChange", this._onTabChange);

      this._ref.current.addEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.addEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("selection", this._onSelection);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("tabChange", this._onTabChange);

      this._ref.current.removeEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.removeEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("selection", this._onSelection);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-bar-chart-selectable", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "short-description": Array.isArray(this.props.shortDescription) || this.props.shortDescription === Object(this.props.shortDescription) ? JSON.stringify(this.props.shortDescription) : this.props.shortDescription,
        "chart-title": Array.isArray(this.props.chartTitle) || this.props.chartTitle === Object(this.props.chartTitle) ? JSON.stringify(this.props.chartTitle) : this.props.chartTitle,
        "show-full-screen-button": Array.isArray(this.props.showFullScreenButton) || this.props.showFullScreenButton === Object(this.props.showFullScreenButton) ? JSON.stringify(this.props.showFullScreenButton) : this.props.showFullScreenButton,
        "accessible-alternative-link-text": Array.isArray(this.props.accessibleAlternativeLinkText) || this.props.accessibleAlternativeLinkText === Object(this.props.accessibleAlternativeLinkText) ? JSON.stringify(this.props.accessibleAlternativeLinkText) : this.props.accessibleAlternativeLinkText,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        "d3-legend-format-string": Array.isArray(this.props.d3LegendFormatString) || this.props.d3LegendFormatString === Object(this.props.d3LegendFormatString) ? JSON.stringify(this.props.d3LegendFormatString) : this.props.d3LegendFormatString,
        "d3-bar-label-format-string": Array.isArray(this.props.d3BarLabelFormatString) || this.props.d3BarLabelFormatString === Object(this.props.d3BarLabelFormatString) ? JSON.stringify(this.props.d3BarLabelFormatString) : this.props.d3BarLabelFormatString,
        "d3-prefix-formatter": Array.isArray(this.props.d3PrefixFormatter) || this.props.d3PrefixFormatter === Object(this.props.d3PrefixFormatter) ? JSON.stringify(this.props.d3PrefixFormatter) : this.props.d3PrefixFormatter,
        "d3-data-point-detail-x-format-string": Array.isArray(this.props.d3DataPointDetailXFormatString) || this.props.d3DataPointDetailXFormatString === Object(this.props.d3DataPointDetailXFormatString) ? JSON.stringify(this.props.d3DataPointDetailXFormatString) : this.props.d3DataPointDetailXFormatString,
        "d3-data-point-detail-y-format-string": Array.isArray(this.props.d3DataPointDetailYFormatString) || this.props.d3DataPointDetailYFormatString === Object(this.props.d3DataPointDetailYFormatString) ? JSON.stringify(this.props.d3DataPointDetailYFormatString) : this.props.d3DataPointDetailYFormatString,
        "chart-height": Array.isArray(this.props.chartHeight) || this.props.chartHeight === Object(this.props.chartHeight) ? JSON.stringify(this.props.chartHeight) : this.props.chartHeight,
        "selected-bar": Array.isArray(this.props.selectedBar) || this.props.selectedBar === Object(this.props.selectedBar) ? JSON.stringify(this.props.selectedBar) : this.props.selectedBar,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "full-screen-button-alternative-text": Array.isArray(this.props.fullScreenButtonAlternativeText) || this.props.fullScreenButtonAlternativeText === Object(this.props.fullScreenButtonAlternativeText) ? JSON.stringify(this.props.fullScreenButtonAlternativeText) : this.props.fullScreenButtonAlternativeText,
        "unselected-bar-color": Array.isArray(this.props.unselectedBarColor) || this.props.unselectedBarColor === Object(this.props.unselectedBarColor) ? JSON.stringify(this.props.unselectedBarColor) : this.props.unselectedBarColor,
        "background-color": Array.isArray(this.props.backgroundColor) || this.props.backgroundColor === Object(this.props.backgroundColor) ? JSON.stringify(this.props.backgroundColor) : this.props.backgroundColor,
        "bar-width": Array.isArray(this.props.barWidth) || this.props.barWidth === Object(this.props.barWidth) ? JSON.stringify(this.props.barWidth) : this.props.barWidth,
        "primary-background": Array.isArray(this.props.primaryBackground) || this.props.primaryBackground === Object(this.props.primaryBackground) ? JSON.stringify(this.props.primaryBackground) : this.props.primaryBackground,
        "is-legend-hidden": Array.isArray(this.props.isLegendHidden) || this.props.isLegendHidden === Object(this.props.isLegendHidden) ? JSON.stringify(this.props.isLegendHidden) : this.props.isLegendHidden,
        "show-y-axis": Array.isArray(this.props.showYAxis) || this.props.showYAxis === Object(this.props.showYAxis) ? JSON.stringify(this.props.showYAxis) : this.props.showYAxis,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        tabs: Array.isArray(this.props.tabs) || this.props.tabs === Object(this.props.tabs) ? JSON.stringify(this.props.tabs) : this.props.tabs,
        legend: Array.isArray(this.props.legend) || this.props.legend === Object(this.props.legend) ? JSON.stringify(this.props.legend) : this.props.legend,
        series: Array.isArray(this.props.series) || this.props.series === Object(this.props.series) ? JSON.stringify(this.props.series) : this.props.series,
        "reference-line": Array.isArray(this.props.referenceLine) || this.props.referenceLine === Object(this.props.referenceLine) ? JSON.stringify(this.props.referenceLine) : this.props.referenceLine,
        "x-axis-labels": Array.isArray(this.props.xAxisLabels) || this.props.xAxisLabels === Object(this.props.xAxisLabels) ? JSON.stringify(this.props.xAxisLabels) : this.props.xAxisLabels,
        "y-axis": Array.isArray(this.props.yAxis) || this.props.yAxis === Object(this.props.yAxis) ? JSON.stringify(this.props.yAxis) : this.props.yAxis // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBarChartSelectable;
}(React.Component);
MdsBarChartSelectable.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  shortDescription: PropTypes.string,
  chartTitle: PropTypes.string,
  showFullScreenButton: PropTypes.bool,
  accessibleAlternativeLinkText: PropTypes.string,
  noDataPointText: PropTypes.string,
  d3LegendFormatString: PropTypes.string,
  d3BarLabelFormatString: PropTypes.string,
  d3PrefixFormatter: PropTypes.bool,
  d3DataPointDetailXFormatString: PropTypes.string,
  d3DataPointDetailYFormatString: PropTypes.string,
  chartHeight: CustomPropTypes.integer,
  selectedBar: CustomPropTypes.integer,
  variant: PropTypes.oneOf(["groupedBars", "regular", "barValue"]),
  brand: PropTypes.string,
  fullScreenButtonAlternativeText: PropTypes.string,
  unselectedBarColor: PropTypes.string,
  backgroundColor: PropTypes.bool,
  barWidth: PropTypes.oneOf([8, 16, 24, 32, 48, 64]),
  primaryBackground: PropTypes.bool,
  isLegendHidden: PropTypes.bool,
  showYAxis: PropTypes.bool,
  id: PropTypes.string,
  slot: PropTypes.string,
  tabs: CustomPropTypes.slot,
  legend: CustomPropTypes.slot,
  series: PropTypes.arrayOf(CustomPropTypes.slot),
  referenceLine: CustomPropTypes.slot,
  xAxisLabels: PropTypes.arrayOf(CustomPropTypes.slot),
  yAxis: CustomPropTypes.slot,
  // Events
  onTabChange: PropTypes.func,
  onAccessibleAlternativeLinkPress: PropTypes.func,
  onExpandFullScreenButtonPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onClick: PropTypes.func,
  onSelection: PropTypes.func
};
MdsBarChartSelectable.defaultProps = {
  showFullScreenButton: false,
  noDataPointText: "Chart temporarily unavailable.",
  d3PrefixFormatter: false,
  variant: "regular",
  backgroundColor: false,
  barWidth: "32",
  primaryBackground: false,
  isLegendHidden: false,
  showYAxis: false,
  // Events
  onTabChange: null,
  onAccessibleAlternativeLinkPress: null,
  onExpandFullScreenButtonPress: null,
  onMousedown: null,
  onMouseout: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onClick: null,
  onSelection: null
};

var MdsBulletChart = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsBulletChart, _React$Component);

  var _super = _createSuper(MdsBulletChart);

  function MdsBulletChart(props) {
    var _this;

    _classCallCheck(this, MdsBulletChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsBulletChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-bullet-chart", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        benchmark: Array.isArray(this.props.benchmark) || this.props.benchmark === Object(this.props.benchmark) ? JSON.stringify(this.props.benchmark) : this.props.benchmark,
        "featured-measure": Array.isArray(this.props.featuredMeasure) || this.props.featuredMeasure === Object(this.props.featuredMeasure) ? JSON.stringify(this.props.featuredMeasure) : this.props.featuredMeasure,
        "max-value": Array.isArray(this.props.maxValue) || this.props.maxValue === Object(this.props.maxValue) ? JSON.stringify(this.props.maxValue) : this.props.maxValue,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "accessible-description": Array.isArray(this.props.accessibleDescription) || this.props.accessibleDescription === Object(this.props.accessibleDescription) ? JSON.stringify(this.props.accessibleDescription) : this.props.accessibleDescription,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsBulletChart;
}(React.Component);
MdsBulletChart.propTypes = {
  // Values
  benchmark: PropTypes.number,
  featuredMeasure: PropTypes.number,
  maxValue: PropTypes.number,
  brand: PropTypes.string,
  accessibleName: PropTypes.string,
  accessibleDescription: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsBulletChart.defaultProps = {
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsCashFlowChart = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsCashFlowChart, _React$Component);

  var _super = _createSuper(MdsCashFlowChart);

  function MdsCashFlowChart(props) {
    var _this;

    _classCallCheck(this, MdsCashFlowChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTabChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTabChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTabChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onAccessibleAlternativeLinkPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onAccessibleAlternativeLinkPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onAccessibleAlternativeLinkPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onExpandFullScreenButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onExpandFullScreenButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onExpandFullScreenButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onClick) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTabChange = _this._onTabChange.bind(_assertThisInitialized(_this));
    _this._onAccessibleAlternativeLinkPress = _this._onAccessibleAlternativeLinkPress.bind(_assertThisInitialized(_this));
    _this._onExpandFullScreenButtonPress = _this._onExpandFullScreenButtonPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsCashFlowChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("tabChange", this._onTabChange);

      this._ref.current.addEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.addEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("tabChange", this._onTabChange);

      this._ref.current.removeEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.removeEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-cash-flow-chart", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "short-description": Array.isArray(this.props.shortDescription) || this.props.shortDescription === Object(this.props.shortDescription) ? JSON.stringify(this.props.shortDescription) : this.props.shortDescription,
        "chart-title": Array.isArray(this.props.chartTitle) || this.props.chartTitle === Object(this.props.chartTitle) ? JSON.stringify(this.props.chartTitle) : this.props.chartTitle,
        "show-full-screen-button": Array.isArray(this.props.showFullScreenButton) || this.props.showFullScreenButton === Object(this.props.showFullScreenButton) ? JSON.stringify(this.props.showFullScreenButton) : this.props.showFullScreenButton,
        "accessible-alternative-link-text": Array.isArray(this.props.accessibleAlternativeLinkText) || this.props.accessibleAlternativeLinkText === Object(this.props.accessibleAlternativeLinkText) ? JSON.stringify(this.props.accessibleAlternativeLinkText) : this.props.accessibleAlternativeLinkText,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        "d3-legend-format-string": Array.isArray(this.props.d3LegendFormatString) || this.props.d3LegendFormatString === Object(this.props.d3LegendFormatString) ? JSON.stringify(this.props.d3LegendFormatString) : this.props.d3LegendFormatString,
        "d3-bar-label-format-string": Array.isArray(this.props.d3BarLabelFormatString) || this.props.d3BarLabelFormatString === Object(this.props.d3BarLabelFormatString) ? JSON.stringify(this.props.d3BarLabelFormatString) : this.props.d3BarLabelFormatString,
        "d3-prefix-formatter": Array.isArray(this.props.d3PrefixFormatter) || this.props.d3PrefixFormatter === Object(this.props.d3PrefixFormatter) ? JSON.stringify(this.props.d3PrefixFormatter) : this.props.d3PrefixFormatter,
        "d3-data-point-detail-x-format-string": Array.isArray(this.props.d3DataPointDetailXFormatString) || this.props.d3DataPointDetailXFormatString === Object(this.props.d3DataPointDetailXFormatString) ? JSON.stringify(this.props.d3DataPointDetailXFormatString) : this.props.d3DataPointDetailXFormatString,
        "d3-data-point-detail-y-format-string": Array.isArray(this.props.d3DataPointDetailYFormatString) || this.props.d3DataPointDetailYFormatString === Object(this.props.d3DataPointDetailYFormatString) ? JSON.stringify(this.props.d3DataPointDetailYFormatString) : this.props.d3DataPointDetailYFormatString,
        "chart-height": Array.isArray(this.props.chartHeight) || this.props.chartHeight === Object(this.props.chartHeight) ? JSON.stringify(this.props.chartHeight) : this.props.chartHeight,
        "selected-index": Array.isArray(this.props.selectedIndex) || this.props.selectedIndex === Object(this.props.selectedIndex) ? JSON.stringify(this.props.selectedIndex) : this.props.selectedIndex,
        "legend-title": Array.isArray(this.props.legendTitle) || this.props.legendTitle === Object(this.props.legendTitle) ? JSON.stringify(this.props.legendTitle) : this.props.legendTitle,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "full-screen-button-alternative-text": Array.isArray(this.props.fullScreenButtonAlternativeText) || this.props.fullScreenButtonAlternativeText === Object(this.props.fullScreenButtonAlternativeText) ? JSON.stringify(this.props.fullScreenButtonAlternativeText) : this.props.fullScreenButtonAlternativeText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        tabs: Array.isArray(this.props.tabs) || this.props.tabs === Object(this.props.tabs) ? JSON.stringify(this.props.tabs) : this.props.tabs,
        series: Array.isArray(this.props.series) || this.props.series === Object(this.props.series) ? JSON.stringify(this.props.series) : this.props.series,
        "x-axis-labels": Array.isArray(this.props.xAxisLabels) || this.props.xAxisLabels === Object(this.props.xAxisLabels) ? JSON.stringify(this.props.xAxisLabels) : this.props.xAxisLabels,
        "y-axis": Array.isArray(this.props.yAxis) || this.props.yAxis === Object(this.props.yAxis) ? JSON.stringify(this.props.yAxis) : this.props.yAxis // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsCashFlowChart;
}(React.Component);
MdsCashFlowChart.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  shortDescription: PropTypes.string,
  chartTitle: PropTypes.string,
  showFullScreenButton: PropTypes.bool,
  accessibleAlternativeLinkText: PropTypes.string,
  noDataPointText: PropTypes.string,
  d3LegendFormatString: PropTypes.string,
  d3BarLabelFormatString: PropTypes.string,
  d3PrefixFormatter: PropTypes.bool,
  d3DataPointDetailXFormatString: PropTypes.string,
  d3DataPointDetailYFormatString: PropTypes.string,
  chartHeight: CustomPropTypes.integer,
  selectedIndex: CustomPropTypes.integer,
  legendTitle: PropTypes.string,
  brand: PropTypes.string,
  fullScreenButtonAlternativeText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  tabs: CustomPropTypes.slot,
  series: CustomPropTypes.slot,
  xAxisLabels: PropTypes.arrayOf(CustomPropTypes.slot),
  yAxis: CustomPropTypes.slot,
  // Events
  onTabChange: PropTypes.func,
  onAccessibleAlternativeLinkPress: PropTypes.func,
  onExpandFullScreenButtonPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onClick: PropTypes.func
};
MdsCashFlowChart.defaultProps = {
  showFullScreenButton: false,
  noDataPointText: "Chart temporarily unavailable.",
  d3PrefixFormatter: false,
  // Events
  onTabChange: null,
  onAccessibleAlternativeLinkPress: null,
  onExpandFullScreenButtonPress: null,
  onMousedown: null,
  onMouseout: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onClick: null
};

var MdsComparisonTable = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsComparisonTable, _React$Component);

  var _super = _createSuper(MdsComparisonTable);

  function MdsComparisonTable() {
    _classCallCheck(this, MdsComparisonTable);

    return _super.apply(this, arguments);
  }

  _createClass(MdsComparisonTable, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-comparison-table", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "column-headers": Array.isArray(this.props.columnHeaders) || this.props.columnHeaders === Object(this.props.columnHeaders) ? JSON.stringify(this.props.columnHeaders) : this.props.columnHeaders,
        "sticky-header": Array.isArray(this.props.stickyHeader) || this.props.stickyHeader === Object(this.props.stickyHeader) ? JSON.stringify(this.props.stickyHeader) : this.props.stickyHeader,
        "true-icon-accessible-text": Array.isArray(this.props.trueIconAccessibleText) || this.props.trueIconAccessibleText === Object(this.props.trueIconAccessibleText) ? JSON.stringify(this.props.trueIconAccessibleText) : this.props.trueIconAccessibleText,
        "table-accessible-text": Array.isArray(this.props.tableAccessibleText) || this.props.tableAccessibleText === Object(this.props.tableAccessibleText) ? JSON.stringify(this.props.tableAccessibleText) : this.props.tableAccessibleText,
        "null-state-message": Array.isArray(this.props.nullStateMessage) || this.props.nullStateMessage === Object(this.props.nullStateMessage) ? JSON.stringify(this.props.nullStateMessage) : this.props.nullStateMessage,
        "row-type": Array.isArray(this.props.rowType) || this.props.rowType === Object(this.props.rowType) ? JSON.stringify(this.props.rowType) : this.props.rowType,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "empty-state-header": Array.isArray(this.props.emptyStateHeader) || this.props.emptyStateHeader === Object(this.props.emptyStateHeader) ? JSON.stringify(this.props.emptyStateHeader) : this.props.emptyStateHeader,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        series: Array.isArray(this.props.series) || this.props.series === Object(this.props.series) ? JSON.stringify(this.props.series) : this.props.series //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsComparisonTable;
}(React.Component);
MdsComparisonTable.propTypes = {
  // Values
  columnHeaders: PropTypes.array,
  stickyHeader: PropTypes.bool,
  trueIconAccessibleText: PropTypes.string,
  tableAccessibleText: PropTypes.string,
  nullStateMessage: PropTypes.string,
  rowType: PropTypes.oneOf(["text", "icon"]),
  brand: PropTypes.string,
  emptyStateHeader: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  series: PropTypes.arrayOf(CustomPropTypes.slot)
};
MdsComparisonTable.defaultProps = {
  stickyHeader: false
};

var MdsDataTableActionBar = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDataTableActionBar, _React$Component);

  var _super = _createSuper(MdsDataTableActionBar);

  function MdsDataTableActionBar(props) {
    var _this;

    _classCallCheck(this, MdsDataTableActionBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onFilteringButtonPress", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onFilteringButtonPress) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onFilteringButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSettingsButtonPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onSettingsButtonPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onSettingsButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onTouchend) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onClick) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onFilteringButtonPress = _this._onFilteringButtonPress.bind(_assertThisInitialized(_this));
    _this._onSettingsButtonPress = _this._onSettingsButtonPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDataTableActionBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("filteringButtonPress", this._onFilteringButtonPress);

      this._ref.current.addEventListener("settingsButtonPress", this._onSettingsButtonPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("filteringButtonPress", this._onFilteringButtonPress);

      this._ref.current.removeEventListener("settingsButtonPress", this._onSettingsButtonPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-data-table-action-bar", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "utility-actions": Array.isArray(this.props.utilityActions) || this.props.utilityActions === Object(this.props.utilityActions) ? JSON.stringify(this.props.utilityActions) : this.props.utilityActions,
        "filtering-content": Array.isArray(this.props.filteringContent) || this.props.filteringContent === Object(this.props.filteringContent) ? JSON.stringify(this.props.filteringContent) : this.props.filteringContent,
        "utility-actions-content": Array.isArray(this.props.utilityActionsContent) || this.props.utilityActionsContent === Object(this.props.utilityActionsContent) ? JSON.stringify(this.props.utilityActionsContent) : this.props.utilityActionsContent,
        "filtering-feedback-label": Array.isArray(this.props.filteringFeedbackLabel) || this.props.filteringFeedbackLabel === Object(this.props.filteringFeedbackLabel) ? JSON.stringify(this.props.filteringFeedbackLabel) : this.props.filteringFeedbackLabel,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "filter-width": Array.isArray(this.props.filterWidth) || this.props.filterWidth === Object(this.props.filterWidth) ? JSON.stringify(this.props.filterWidth) : this.props.filterWidth,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDataTableActionBar;
}(React.Component);
MdsDataTableActionBar.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  utilityActions: PropTypes.oneOf(["settingsButton", "settingsIconOnlyButton", "none"]),
  filteringContent: PropTypes.array,
  utilityActionsContent: PropTypes.array,
  filteringFeedbackLabel: PropTypes.string,
  brand: PropTypes.string,
  filterWidth: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onFilteringButtonPress: PropTypes.func,
  onSettingsButtonPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onTouchend: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onClick: PropTypes.func
};
MdsDataTableActionBar.defaultProps = {
  utilityActions: "settingsButton",
  // Events
  onFilteringButtonPress: null,
  onSettingsButtonPress: null,
  onMousedown: null,
  onTouchend: null,
  onMouseout: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onClick: null
};

var MdsDataTableForAccounts = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDataTableForAccounts, _React$Component);

  var _super = _createSuper(MdsDataTableForAccounts);

  function MdsDataTableForAccounts(props) {
    var _this;

    _classCallCheck(this, MdsDataTableForAccounts);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onColumnSort", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onColumnSort) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onColumnSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSort", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onSort) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeyup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onChange) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onClick) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickMenu", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onClickMenu) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onClickMenu(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenterRow", function (event) {
      var _event$detail, _event$detail$target, _event$detail$target$, _this$props33, _this$props34;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : (_event$detail$target = _event$detail.target) === null || _event$detail$target === void 0 ? void 0 : (_event$detail$target$ = _event$detail$target.dataset) === null || _event$detail$target$ === void 0 ? void 0 : _event$detail$target$.index) + 1 || 1;
      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onMouseenterRow) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onMouseenterRow(event, eventIndex));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseleaveRow", function (event) {
      var _event$detail2, _event$detail2$target, _event$detail2$target2, _this$props35, _this$props36;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail2 = event.detail) === null || _event$detail2 === void 0 ? void 0 : (_event$detail2$target = _event$detail2.target) === null || _event$detail2$target === void 0 ? void 0 : (_event$detail2$target2 = _event$detail2$target.dataset) === null || _event$detail2$target2 === void 0 ? void 0 : _event$detail2$target2.index) + 1 || 1;
      ((_this$props35 = _this.props) === null || _this$props35 === void 0 ? void 0 : _this$props35.onMouseleaveRow) && ((_this$props36 = _this.props) === null || _this$props36 === void 0 ? void 0 : _this$props36.onMouseleaveRow(event, eventIndex));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onColumnSort = _this._onColumnSort.bind(_assertThisInitialized(_this));
    _this._onSort = _this._onSort.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onClickMenu = _this._onClickMenu.bind(_assertThisInitialized(_this));
    _this._onMouseenterRow = _this._onMouseenterRow.bind(_assertThisInitialized(_this));
    _this._onMouseleaveRow = _this._onMouseleaveRow.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDataTableForAccounts, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("columnSort", this._onColumnSort);

      this._ref.current.addEventListener("sort", this._onSort);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("click-menu", this._onClickMenu);

      this._ref.current.addEventListener("mouseenter-row1", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row2", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row3", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row4", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row5", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row6", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row7", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row8", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row9", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row10", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseleave-row1", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row2", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row3", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row4", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row5", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row6", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row7", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row8", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row9", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row10", this._onMouseleaveRow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("columnSort", this._onColumnSort);

      this._ref.current.removeEventListener("sort", this._onSort);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("click-menu", this._onClickMenu);

      this._ref.current.removeEventListener("mouseenter-row1", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row2", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row3", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row4", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row5", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row6", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row7", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row8", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row9", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row10", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseleave-row1", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row2", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row3", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row4", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row5", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row6", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row7", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row8", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row9", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row10", this._onMouseleaveRow);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-data-table-for-accounts", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        caption: Array.isArray(this.props.caption) || this.props.caption === Object(this.props.caption) ? JSON.stringify(this.props.caption) : this.props.caption,
        "has-visible-caption": Array.isArray(this.props.hasVisibleCaption) || this.props.hasVisibleCaption === Object(this.props.hasVisibleCaption) ? JSON.stringify(this.props.hasVisibleCaption) : this.props.hasVisibleCaption,
        "highlighted-index": Array.isArray(this.props.highlightedIndex) || this.props.highlightedIndex === Object(this.props.highlightedIndex) ? JSON.stringify(this.props.highlightedIndex) : this.props.highlightedIndex,
        "has-hover-color": Array.isArray(this.props.hasHoverColor) || this.props.hasHoverColor === Object(this.props.hasHoverColor) ? JSON.stringify(this.props.hasHoverColor) : this.props.hasHoverColor,
        activated: Array.isArray(this.props.activated) || this.props.activated === Object(this.props.activated) ? JSON.stringify(this.props.activated) : this.props.activated,
        "row-style": Array.isArray(this.props.rowStyle) || this.props.rowStyle === Object(this.props.rowStyle) ? JSON.stringify(this.props.rowStyle) : this.props.rowStyle,
        "suppress-last-row-border": Array.isArray(this.props.suppressLastRowBorder) || this.props.suppressLastRowBorder === Object(this.props.suppressLastRowBorder) ? JSON.stringify(this.props.suppressLastRowBorder) : this.props.suppressLastRowBorder,
        "negative-value-color": Array.isArray(this.props.negativeValueColor) || this.props.negativeValueColor === Object(this.props.negativeValueColor) ? JSON.stringify(this.props.negativeValueColor) : this.props.negativeValueColor,
        "accessible-single-value-negative": Array.isArray(this.props.accessibleSingleValueNegative) || this.props.accessibleSingleValueNegative === Object(this.props.accessibleSingleValueNegative) ? JSON.stringify(this.props.accessibleSingleValueNegative) : this.props.accessibleSingleValueNegative,
        "accessible-single-value-empty": Array.isArray(this.props.accessibleSingleValueEmpty) || this.props.accessibleSingleValueEmpty === Object(this.props.accessibleSingleValueEmpty) ? JSON.stringify(this.props.accessibleSingleValueEmpty) : this.props.accessibleSingleValueEmpty,
        "null-state-message": Array.isArray(this.props.nullStateMessage) || this.props.nullStateMessage === Object(this.props.nullStateMessage) ? JSON.stringify(this.props.nullStateMessage) : this.props.nullStateMessage,
        mode: Array.isArray(this.props.mode) || this.props.mode === Object(this.props.mode) ? JSON.stringify(this.props.mode) : this.props.mode,
        summary: Array.isArray(this.props.summary) || this.props.summary === Object(this.props.summary) ? JSON.stringify(this.props.summary) : this.props.summary,
        stacked: Array.isArray(this.props.stacked) || this.props.stacked === Object(this.props.stacked) ? JSON.stringify(this.props.stacked) : this.props.stacked,
        "stacked-header-width": Array.isArray(this.props.stackedHeaderWidth) || this.props.stackedHeaderWidth === Object(this.props.stackedHeaderWidth) ? JSON.stringify(this.props.stackedHeaderWidth) : this.props.stackedHeaderWidth,
        "stacked-column-width": Array.isArray(this.props.stackedColumnWidth) || this.props.stackedColumnWidth === Object(this.props.stackedColumnWidth) ? JSON.stringify(this.props.stackedColumnWidth) : this.props.stackedColumnWidth,
        "stacked-caption-heading-level": Array.isArray(this.props.stackedCaptionHeadingLevel) || this.props.stackedCaptionHeadingLevel === Object(this.props.stackedCaptionHeadingLevel) ? JSON.stringify(this.props.stackedCaptionHeadingLevel) : this.props.stackedCaptionHeadingLevel,
        "has-highlight": Array.isArray(this.props.hasHighlight) || this.props.hasHighlight === Object(this.props.hasHighlight) ? JSON.stringify(this.props.hasHighlight) : this.props.hasHighlight,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "row-data": Array.isArray(this.props.rowData) || this.props.rowData === Object(this.props.rowData) ? JSON.stringify(this.props.rowData) : this.props.rowData,
        footer: Array.isArray(this.props.footer) || this.props.footer === Object(this.props.footer) ? JSON.stringify(this.props.footer) : this.props.footer,
        "column-configs": Array.isArray(this.props.columnConfigs) || this.props.columnConfigs === Object(this.props.columnConfigs) ? JSON.stringify(this.props.columnConfigs) : this.props.columnConfigs // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDataTableForAccounts;
}(React.Component);
MdsDataTableForAccounts.propTypes = {
  // Values
  caption: PropTypes.string,
  hasVisibleCaption: PropTypes.bool,
  highlightedIndex: CustomPropTypes.integer,
  hasHoverColor: PropTypes.bool,
  activated: PropTypes.bool,
  rowStyle: PropTypes.oneOf(["solid", "dashed"]),
  suppressLastRowBorder: PropTypes.bool,
  negativeValueColor: PropTypes.string,
  accessibleSingleValueNegative: PropTypes.string,
  accessibleSingleValueEmpty: PropTypes.string,
  nullStateMessage: PropTypes.string,
  mode: PropTypes.oneOf(["compact", "relaxed"]),
  summary: PropTypes.string,
  stacked: PropTypes.bool,
  stackedHeaderWidth: PropTypes.string,
  stackedColumnWidth: PropTypes.string,
  stackedCaptionHeadingLevel: PropTypes.number,
  hasHighlight: PropTypes.bool,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  rowData: PropTypes.arrayOf(CustomPropTypes.slot),
  footer: PropTypes.arrayOf(CustomPropTypes.slot),
  columnConfigs: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onColumnSort: PropTypes.func,
  onSort: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onClickMenu: PropTypes.func,
  onMouseenterRow: PropTypes.func,
  onMouseleaveRow: PropTypes.func
};
MdsDataTableForAccounts.defaultProps = {
  hasVisibleCaption: true,
  hasHoverColor: true,
  activated: true,
  suppressLastRowBorder: false,
  mode: "compact",
  stacked: false,
  stackedCaptionHeadingLevel: 2,
  hasHighlight: true,
  // Events
  onColumnSort: null,
  onSort: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onFocus: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onChange: null,
  onClick: null,
  onClickMenu: null,
  onMouseenterRow: null,
  onMouseleaveRow: null
};

var MdsDataTableForChart = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDataTableForChart, _React$Component);

  var _super = _createSuper(MdsDataTableForChart);

  function MdsDataTableForChart(props) {
    var _this;

    _classCallCheck(this, MdsDataTableForChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onColumnSort", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onColumnSort) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onColumnSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSort", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onSort) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeyup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onChange) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onClick) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenterRow", function (event) {
      var _event$detail, _event$detail$target, _event$detail$target$, _this$props31, _this$props32;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : (_event$detail$target = _event$detail.target) === null || _event$detail$target === void 0 ? void 0 : (_event$detail$target$ = _event$detail$target.dataset) === null || _event$detail$target$ === void 0 ? void 0 : _event$detail$target$.index) + 1 || 1;
      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onMouseenterRow) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onMouseenterRow(event, eventIndex));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseleaveRow", function (event) {
      var _event$detail2, _event$detail2$target, _event$detail2$target2, _this$props33, _this$props34;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail2 = event.detail) === null || _event$detail2 === void 0 ? void 0 : (_event$detail2$target = _event$detail2.target) === null || _event$detail2$target === void 0 ? void 0 : (_event$detail2$target2 = _event$detail2$target.dataset) === null || _event$detail2$target2 === void 0 ? void 0 : _event$detail2$target2.index) + 1 || 1;
      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onMouseleaveRow) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onMouseleaveRow(event, eventIndex));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onColumnSort = _this._onColumnSort.bind(_assertThisInitialized(_this));
    _this._onSort = _this._onSort.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMouseenterRow = _this._onMouseenterRow.bind(_assertThisInitialized(_this));
    _this._onMouseleaveRow = _this._onMouseleaveRow.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDataTableForChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("columnSort", this._onColumnSort);

      this._ref.current.addEventListener("sort", this._onSort);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mouseenter-row1", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row2", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row3", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row4", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row5", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row6", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row7", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row8", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row9", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row10", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseleave-row1", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row2", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row3", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row4", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row5", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row6", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row7", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row8", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row9", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row10", this._onMouseleaveRow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("columnSort", this._onColumnSort);

      this._ref.current.removeEventListener("sort", this._onSort);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mouseenter-row1", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row2", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row3", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row4", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row5", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row6", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row7", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row8", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row9", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row10", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseleave-row1", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row2", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row3", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row4", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row5", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row6", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row7", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row8", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row9", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row10", this._onMouseleaveRow);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-data-table-for-chart", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        caption: Array.isArray(this.props.caption) || this.props.caption === Object(this.props.caption) ? JSON.stringify(this.props.caption) : this.props.caption,
        "has-visible-caption": Array.isArray(this.props.hasVisibleCaption) || this.props.hasVisibleCaption === Object(this.props.hasVisibleCaption) ? JSON.stringify(this.props.hasVisibleCaption) : this.props.hasVisibleCaption,
        "highlighted-index": Array.isArray(this.props.highlightedIndex) || this.props.highlightedIndex === Object(this.props.highlightedIndex) ? JSON.stringify(this.props.highlightedIndex) : this.props.highlightedIndex,
        "has-hover-color": Array.isArray(this.props.hasHoverColor) || this.props.hasHoverColor === Object(this.props.hasHoverColor) ? JSON.stringify(this.props.hasHoverColor) : this.props.hasHoverColor,
        activated: Array.isArray(this.props.activated) || this.props.activated === Object(this.props.activated) ? JSON.stringify(this.props.activated) : this.props.activated,
        "row-style": Array.isArray(this.props.rowStyle) || this.props.rowStyle === Object(this.props.rowStyle) ? JSON.stringify(this.props.rowStyle) : this.props.rowStyle,
        "suppress-last-row-border": Array.isArray(this.props.suppressLastRowBorder) || this.props.suppressLastRowBorder === Object(this.props.suppressLastRowBorder) ? JSON.stringify(this.props.suppressLastRowBorder) : this.props.suppressLastRowBorder,
        "negative-value-color": Array.isArray(this.props.negativeValueColor) || this.props.negativeValueColor === Object(this.props.negativeValueColor) ? JSON.stringify(this.props.negativeValueColor) : this.props.negativeValueColor,
        "accessible-single-value-negative": Array.isArray(this.props.accessibleSingleValueNegative) || this.props.accessibleSingleValueNegative === Object(this.props.accessibleSingleValueNegative) ? JSON.stringify(this.props.accessibleSingleValueNegative) : this.props.accessibleSingleValueNegative,
        "accessible-single-value-empty": Array.isArray(this.props.accessibleSingleValueEmpty) || this.props.accessibleSingleValueEmpty === Object(this.props.accessibleSingleValueEmpty) ? JSON.stringify(this.props.accessibleSingleValueEmpty) : this.props.accessibleSingleValueEmpty,
        "null-state-message": Array.isArray(this.props.nullStateMessage) || this.props.nullStateMessage === Object(this.props.nullStateMessage) ? JSON.stringify(this.props.nullStateMessage) : this.props.nullStateMessage,
        mode: Array.isArray(this.props.mode) || this.props.mode === Object(this.props.mode) ? JSON.stringify(this.props.mode) : this.props.mode,
        summary: Array.isArray(this.props.summary) || this.props.summary === Object(this.props.summary) ? JSON.stringify(this.props.summary) : this.props.summary,
        stacked: Array.isArray(this.props.stacked) || this.props.stacked === Object(this.props.stacked) ? JSON.stringify(this.props.stacked) : this.props.stacked,
        "stacked-header-width": Array.isArray(this.props.stackedHeaderWidth) || this.props.stackedHeaderWidth === Object(this.props.stackedHeaderWidth) ? JSON.stringify(this.props.stackedHeaderWidth) : this.props.stackedHeaderWidth,
        "stacked-column-width": Array.isArray(this.props.stackedColumnWidth) || this.props.stackedColumnWidth === Object(this.props.stackedColumnWidth) ? JSON.stringify(this.props.stackedColumnWidth) : this.props.stackedColumnWidth,
        "stacked-caption-heading-level": Array.isArray(this.props.stackedCaptionHeadingLevel) || this.props.stackedCaptionHeadingLevel === Object(this.props.stackedCaptionHeadingLevel) ? JSON.stringify(this.props.stackedCaptionHeadingLevel) : this.props.stackedCaptionHeadingLevel,
        "hidden-accessible-total-sum-text": Array.isArray(this.props.hiddenAccessibleTotalSumText) || this.props.hiddenAccessibleTotalSumText === Object(this.props.hiddenAccessibleTotalSumText) ? JSON.stringify(this.props.hiddenAccessibleTotalSumText) : this.props.hiddenAccessibleTotalSumText,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        "swatch-shape": Array.isArray(this.props.swatchShape) || this.props.swatchShape === Object(this.props.swatchShape) ? JSON.stringify(this.props.swatchShape) : this.props.swatchShape,
        "swatch-colors": Array.isArray(this.props.swatchColors) || this.props.swatchColors === Object(this.props.swatchColors) ? JSON.stringify(this.props.swatchColors) : this.props.swatchColors,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        separators: Array.isArray(this.props.separators) || this.props.separators === Object(this.props.separators) ? JSON.stringify(this.props.separators) : this.props.separators,
        "row-data": Array.isArray(this.props.rowData) || this.props.rowData === Object(this.props.rowData) ? JSON.stringify(this.props.rowData) : this.props.rowData,
        footer: Array.isArray(this.props.footer) || this.props.footer === Object(this.props.footer) ? JSON.stringify(this.props.footer) : this.props.footer,
        "column-configs": Array.isArray(this.props.columnConfigs) || this.props.columnConfigs === Object(this.props.columnConfigs) ? JSON.stringify(this.props.columnConfigs) : this.props.columnConfigs // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDataTableForChart;
}(React.Component);
MdsDataTableForChart.propTypes = {
  // Values
  caption: PropTypes.string,
  hasVisibleCaption: PropTypes.bool,
  highlightedIndex: CustomPropTypes.integer,
  hasHoverColor: PropTypes.bool,
  activated: PropTypes.bool,
  rowStyle: PropTypes.oneOf(["solid", "dashed"]),
  suppressLastRowBorder: PropTypes.bool,
  negativeValueColor: PropTypes.string,
  accessibleSingleValueNegative: PropTypes.string,
  accessibleSingleValueEmpty: PropTypes.string,
  nullStateMessage: PropTypes.string,
  mode: PropTypes.oneOf(["compact", "relaxed"]),
  summary: PropTypes.string,
  stacked: PropTypes.bool,
  stackedHeaderWidth: PropTypes.string,
  stackedColumnWidth: PropTypes.string,
  stackedCaptionHeadingLevel: PropTypes.number,
  hiddenAccessibleTotalSumText: PropTypes.string,
  layout: PropTypes.oneOf(["columnRow", "row", "rowInline"]),
  swatchShape: PropTypes.oneOf(["circle", "square"]),
  swatchColors: PropTypes.array,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  separators: CustomPropTypes.slot,
  rowData: PropTypes.arrayOf(CustomPropTypes.slot),
  footer: PropTypes.arrayOf(CustomPropTypes.slot),
  columnConfigs: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onColumnSort: PropTypes.func,
  onSort: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onMouseenterRow: PropTypes.func,
  onMouseleaveRow: PropTypes.func
};
MdsDataTableForChart.defaultProps = {
  hasVisibleCaption: true,
  hasHoverColor: true,
  activated: true,
  suppressLastRowBorder: false,
  mode: "compact",
  stacked: false,
  stackedCaptionHeadingLevel: 2,
  layout: "column",
  // Events
  onColumnSort: null,
  onSort: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onFocus: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onChange: null,
  onClick: null,
  onMouseenterRow: null,
  onMouseleaveRow: null
};

var MdsDataTableForFiles = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDataTableForFiles, _React$Component);

  var _super = _createSuper(MdsDataTableForFiles);

  function MdsDataTableForFiles(props) {
    var _this;

    _classCallCheck(this, MdsDataTableForFiles);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onColumnSort", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onColumnSort) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onColumnSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSort", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onSort) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeyup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onChange) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onClick) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onColumnSort = _this._onColumnSort.bind(_assertThisInitialized(_this));
    _this._onSort = _this._onSort.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDataTableForFiles, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("columnSort", this._onColumnSort);

      this._ref.current.addEventListener("sort", this._onSort);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("columnSort", this._onColumnSort);

      this._ref.current.removeEventListener("sort", this._onSort);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-data-table-for-files", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        caption: Array.isArray(this.props.caption) || this.props.caption === Object(this.props.caption) ? JSON.stringify(this.props.caption) : this.props.caption,
        "has-visible-caption": Array.isArray(this.props.hasVisibleCaption) || this.props.hasVisibleCaption === Object(this.props.hasVisibleCaption) ? JSON.stringify(this.props.hasVisibleCaption) : this.props.hasVisibleCaption,
        "highlighted-index": Array.isArray(this.props.highlightedIndex) || this.props.highlightedIndex === Object(this.props.highlightedIndex) ? JSON.stringify(this.props.highlightedIndex) : this.props.highlightedIndex,
        "has-hover-color": Array.isArray(this.props.hasHoverColor) || this.props.hasHoverColor === Object(this.props.hasHoverColor) ? JSON.stringify(this.props.hasHoverColor) : this.props.hasHoverColor,
        activated: Array.isArray(this.props.activated) || this.props.activated === Object(this.props.activated) ? JSON.stringify(this.props.activated) : this.props.activated,
        "row-style": Array.isArray(this.props.rowStyle) || this.props.rowStyle === Object(this.props.rowStyle) ? JSON.stringify(this.props.rowStyle) : this.props.rowStyle,
        "suppress-last-row-border": Array.isArray(this.props.suppressLastRowBorder) || this.props.suppressLastRowBorder === Object(this.props.suppressLastRowBorder) ? JSON.stringify(this.props.suppressLastRowBorder) : this.props.suppressLastRowBorder,
        "negative-value-color": Array.isArray(this.props.negativeValueColor) || this.props.negativeValueColor === Object(this.props.negativeValueColor) ? JSON.stringify(this.props.negativeValueColor) : this.props.negativeValueColor,
        "accessible-single-value-negative": Array.isArray(this.props.accessibleSingleValueNegative) || this.props.accessibleSingleValueNegative === Object(this.props.accessibleSingleValueNegative) ? JSON.stringify(this.props.accessibleSingleValueNegative) : this.props.accessibleSingleValueNegative,
        "accessible-single-value-empty": Array.isArray(this.props.accessibleSingleValueEmpty) || this.props.accessibleSingleValueEmpty === Object(this.props.accessibleSingleValueEmpty) ? JSON.stringify(this.props.accessibleSingleValueEmpty) : this.props.accessibleSingleValueEmpty,
        "null-state-message": Array.isArray(this.props.nullStateMessage) || this.props.nullStateMessage === Object(this.props.nullStateMessage) ? JSON.stringify(this.props.nullStateMessage) : this.props.nullStateMessage,
        mode: Array.isArray(this.props.mode) || this.props.mode === Object(this.props.mode) ? JSON.stringify(this.props.mode) : this.props.mode,
        summary: Array.isArray(this.props.summary) || this.props.summary === Object(this.props.summary) ? JSON.stringify(this.props.summary) : this.props.summary,
        stacked: Array.isArray(this.props.stacked) || this.props.stacked === Object(this.props.stacked) ? JSON.stringify(this.props.stacked) : this.props.stacked,
        "stacked-header-width": Array.isArray(this.props.stackedHeaderWidth) || this.props.stackedHeaderWidth === Object(this.props.stackedHeaderWidth) ? JSON.stringify(this.props.stackedHeaderWidth) : this.props.stackedHeaderWidth,
        "stacked-column-width": Array.isArray(this.props.stackedColumnWidth) || this.props.stackedColumnWidth === Object(this.props.stackedColumnWidth) ? JSON.stringify(this.props.stackedColumnWidth) : this.props.stackedColumnWidth,
        "stacked-caption-heading-level": Array.isArray(this.props.stackedCaptionHeadingLevel) || this.props.stackedCaptionHeadingLevel === Object(this.props.stackedCaptionHeadingLevel) ? JSON.stringify(this.props.stackedCaptionHeadingLevel) : this.props.stackedCaptionHeadingLevel,
        "table-width": Array.isArray(this.props.tableWidth) || this.props.tableWidth === Object(this.props.tableWidth) ? JSON.stringify(this.props.tableWidth) : this.props.tableWidth,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "row-data": Array.isArray(this.props.rowData) || this.props.rowData === Object(this.props.rowData) ? JSON.stringify(this.props.rowData) : this.props.rowData,
        footer: Array.isArray(this.props.footer) || this.props.footer === Object(this.props.footer) ? JSON.stringify(this.props.footer) : this.props.footer,
        "column-configs": Array.isArray(this.props.columnConfigs) || this.props.columnConfigs === Object(this.props.columnConfigs) ? JSON.stringify(this.props.columnConfigs) : this.props.columnConfigs // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDataTableForFiles;
}(React.Component);
MdsDataTableForFiles.propTypes = {
  // Values
  caption: PropTypes.string,
  hasVisibleCaption: PropTypes.bool,
  highlightedIndex: CustomPropTypes.integer,
  hasHoverColor: PropTypes.bool,
  activated: PropTypes.bool,
  rowStyle: PropTypes.oneOf(["solid", "dashed"]),
  suppressLastRowBorder: PropTypes.bool,
  negativeValueColor: PropTypes.string,
  accessibleSingleValueNegative: PropTypes.string,
  accessibleSingleValueEmpty: PropTypes.string,
  nullStateMessage: PropTypes.string,
  mode: PropTypes.oneOf(["compact", "relaxed"]),
  summary: PropTypes.string,
  stacked: PropTypes.bool,
  stackedHeaderWidth: PropTypes.string,
  stackedColumnWidth: PropTypes.string,
  stackedCaptionHeadingLevel: PropTypes.number,
  tableWidth: PropTypes.string,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  rowData: PropTypes.arrayOf(CustomPropTypes.slot),
  footer: PropTypes.arrayOf(CustomPropTypes.slot),
  columnConfigs: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onColumnSort: PropTypes.func,
  onSort: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func
};
MdsDataTableForFiles.defaultProps = {
  hasVisibleCaption: true,
  hasHoverColor: true,
  activated: true,
  suppressLastRowBorder: false,
  mode: "compact",
  stacked: false,
  stackedCaptionHeadingLevel: 2,
  // Events
  onColumnSort: null,
  onSort: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onFocus: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onChange: null,
  onClick: null
};

var MdsDataTableForSecurities = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDataTableForSecurities, _React$Component);

  var _super = _createSuper(MdsDataTableForSecurities);

  function MdsDataTableForSecurities(props) {
    var _this;

    _classCallCheck(this, MdsDataTableForSecurities);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onColumnSort", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onColumnSort) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onColumnSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSort", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onSort) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeyup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onChange) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onClick) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onInput) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onInput(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenterRow", function (event) {
      var _event$detail, _event$detail$target, _event$detail$target$, _this$props33, _this$props34;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : (_event$detail$target = _event$detail.target) === null || _event$detail$target === void 0 ? void 0 : (_event$detail$target$ = _event$detail$target.dataset) === null || _event$detail$target$ === void 0 ? void 0 : _event$detail$target$.index) + 1 || 1;
      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onMouseenterRow) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onMouseenterRow(event, eventIndex));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseleaveRow", function (event) {
      var _event$detail2, _event$detail2$target, _event$detail2$target2, _this$props35, _this$props36;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail2 = event.detail) === null || _event$detail2 === void 0 ? void 0 : (_event$detail2$target = _event$detail2.target) === null || _event$detail2$target === void 0 ? void 0 : (_event$detail2$target2 = _event$detail2$target.dataset) === null || _event$detail2$target2 === void 0 ? void 0 : _event$detail2$target2.index) + 1 || 1;
      ((_this$props35 = _this.props) === null || _this$props35 === void 0 ? void 0 : _this$props35.onMouseleaveRow) && ((_this$props36 = _this.props) === null || _this$props36 === void 0 ? void 0 : _this$props36.onMouseleaveRow(event, eventIndex));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onColumnSort = _this._onColumnSort.bind(_assertThisInitialized(_this));
    _this._onSort = _this._onSort.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onMouseenterRow = _this._onMouseenterRow.bind(_assertThisInitialized(_this));
    _this._onMouseleaveRow = _this._onMouseleaveRow.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDataTableForSecurities, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("columnSort", this._onColumnSort);

      this._ref.current.addEventListener("sort", this._onSort);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("input", this._onInput);

      this._ref.current.addEventListener("mouseenter-row1", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row2", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row3", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row4", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row5", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row6", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row7", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row8", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row9", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row10", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseleave-row1", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row2", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row3", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row4", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row5", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row6", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row7", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row8", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row9", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row10", this._onMouseleaveRow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("columnSort", this._onColumnSort);

      this._ref.current.removeEventListener("sort", this._onSort);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("input", this._onInput);

      this._ref.current.removeEventListener("mouseenter-row1", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row2", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row3", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row4", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row5", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row6", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row7", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row8", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row9", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row10", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseleave-row1", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row2", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row3", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row4", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row5", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row6", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row7", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row8", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row9", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row10", this._onMouseleaveRow);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-data-table-for-securities", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        caption: Array.isArray(this.props.caption) || this.props.caption === Object(this.props.caption) ? JSON.stringify(this.props.caption) : this.props.caption,
        "has-visible-caption": Array.isArray(this.props.hasVisibleCaption) || this.props.hasVisibleCaption === Object(this.props.hasVisibleCaption) ? JSON.stringify(this.props.hasVisibleCaption) : this.props.hasVisibleCaption,
        "highlighted-index": Array.isArray(this.props.highlightedIndex) || this.props.highlightedIndex === Object(this.props.highlightedIndex) ? JSON.stringify(this.props.highlightedIndex) : this.props.highlightedIndex,
        "has-hover-color": Array.isArray(this.props.hasHoverColor) || this.props.hasHoverColor === Object(this.props.hasHoverColor) ? JSON.stringify(this.props.hasHoverColor) : this.props.hasHoverColor,
        activated: Array.isArray(this.props.activated) || this.props.activated === Object(this.props.activated) ? JSON.stringify(this.props.activated) : this.props.activated,
        "row-style": Array.isArray(this.props.rowStyle) || this.props.rowStyle === Object(this.props.rowStyle) ? JSON.stringify(this.props.rowStyle) : this.props.rowStyle,
        "suppress-last-row-border": Array.isArray(this.props.suppressLastRowBorder) || this.props.suppressLastRowBorder === Object(this.props.suppressLastRowBorder) ? JSON.stringify(this.props.suppressLastRowBorder) : this.props.suppressLastRowBorder,
        "negative-value-color": Array.isArray(this.props.negativeValueColor) || this.props.negativeValueColor === Object(this.props.negativeValueColor) ? JSON.stringify(this.props.negativeValueColor) : this.props.negativeValueColor,
        "accessible-single-value-negative": Array.isArray(this.props.accessibleSingleValueNegative) || this.props.accessibleSingleValueNegative === Object(this.props.accessibleSingleValueNegative) ? JSON.stringify(this.props.accessibleSingleValueNegative) : this.props.accessibleSingleValueNegative,
        "accessible-single-value-empty": Array.isArray(this.props.accessibleSingleValueEmpty) || this.props.accessibleSingleValueEmpty === Object(this.props.accessibleSingleValueEmpty) ? JSON.stringify(this.props.accessibleSingleValueEmpty) : this.props.accessibleSingleValueEmpty,
        "null-state-message": Array.isArray(this.props.nullStateMessage) || this.props.nullStateMessage === Object(this.props.nullStateMessage) ? JSON.stringify(this.props.nullStateMessage) : this.props.nullStateMessage,
        mode: Array.isArray(this.props.mode) || this.props.mode === Object(this.props.mode) ? JSON.stringify(this.props.mode) : this.props.mode,
        summary: Array.isArray(this.props.summary) || this.props.summary === Object(this.props.summary) ? JSON.stringify(this.props.summary) : this.props.summary,
        stacked: Array.isArray(this.props.stacked) || this.props.stacked === Object(this.props.stacked) ? JSON.stringify(this.props.stacked) : this.props.stacked,
        "stacked-header-width": Array.isArray(this.props.stackedHeaderWidth) || this.props.stackedHeaderWidth === Object(this.props.stackedHeaderWidth) ? JSON.stringify(this.props.stackedHeaderWidth) : this.props.stackedHeaderWidth,
        "stacked-column-width": Array.isArray(this.props.stackedColumnWidth) || this.props.stackedColumnWidth === Object(this.props.stackedColumnWidth) ? JSON.stringify(this.props.stackedColumnWidth) : this.props.stackedColumnWidth,
        "stacked-caption-heading-level": Array.isArray(this.props.stackedCaptionHeadingLevel) || this.props.stackedCaptionHeadingLevel === Object(this.props.stackedCaptionHeadingLevel) ? JSON.stringify(this.props.stackedCaptionHeadingLevel) : this.props.stackedCaptionHeadingLevel,
        "has-highlight": Array.isArray(this.props.hasHighlight) || this.props.hasHighlight === Object(this.props.hasHighlight) ? JSON.stringify(this.props.hasHighlight) : this.props.hasHighlight,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "row-data": Array.isArray(this.props.rowData) || this.props.rowData === Object(this.props.rowData) ? JSON.stringify(this.props.rowData) : this.props.rowData,
        footer: Array.isArray(this.props.footer) || this.props.footer === Object(this.props.footer) ? JSON.stringify(this.props.footer) : this.props.footer,
        "column-configs": Array.isArray(this.props.columnConfigs) || this.props.columnConfigs === Object(this.props.columnConfigs) ? JSON.stringify(this.props.columnConfigs) : this.props.columnConfigs // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDataTableForSecurities;
}(React.Component);
MdsDataTableForSecurities.propTypes = {
  // Values
  caption: PropTypes.string,
  hasVisibleCaption: PropTypes.bool,
  highlightedIndex: CustomPropTypes.integer,
  hasHoverColor: PropTypes.bool,
  activated: PropTypes.bool,
  rowStyle: PropTypes.oneOf(["solid", "dashed"]),
  suppressLastRowBorder: PropTypes.bool,
  negativeValueColor: PropTypes.string,
  accessibleSingleValueNegative: PropTypes.string,
  accessibleSingleValueEmpty: PropTypes.string,
  nullStateMessage: PropTypes.string,
  mode: PropTypes.oneOf(["compact", "relaxed"]),
  summary: PropTypes.string,
  stacked: PropTypes.bool,
  stackedHeaderWidth: PropTypes.string,
  stackedColumnWidth: PropTypes.string,
  stackedCaptionHeadingLevel: PropTypes.number,
  hasHighlight: PropTypes.bool,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  rowData: PropTypes.arrayOf(CustomPropTypes.slot),
  footer: PropTypes.arrayOf(CustomPropTypes.slot),
  columnConfigs: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onColumnSort: PropTypes.func,
  onSort: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onInput: PropTypes.func,
  onMouseenterRow: PropTypes.func,
  onMouseleaveRow: PropTypes.func
};
MdsDataTableForSecurities.defaultProps = {
  hasVisibleCaption: true,
  hasHoverColor: true,
  activated: true,
  suppressLastRowBorder: false,
  mode: "compact",
  stacked: false,
  stackedCaptionHeadingLevel: 2,
  hasHighlight: true,
  // Events
  onColumnSort: null,
  onSort: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onFocus: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onChange: null,
  onClick: null,
  onInput: null,
  onMouseenterRow: null,
  onMouseleaveRow: null
};

var MdsDataTableForTransactions = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDataTableForTransactions, _React$Component);

  var _super = _createSuper(MdsDataTableForTransactions);

  function MdsDataTableForTransactions(props) {
    var _this;

    _classCallCheck(this, MdsDataTableForTransactions);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onColumnSort", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onColumnSort) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onColumnSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSort", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onSort) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeyup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onChange) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onClick) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenterRow", function (event) {
      var _event$detail, _event$detail$target, _event$detail$target$, _this$props31, _this$props32;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : (_event$detail$target = _event$detail.target) === null || _event$detail$target === void 0 ? void 0 : (_event$detail$target$ = _event$detail$target.dataset) === null || _event$detail$target$ === void 0 ? void 0 : _event$detail$target$.index) + 1 || 1;
      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onMouseenterRow) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onMouseenterRow(event, eventIndex));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseleaveRow", function (event) {
      var _event$detail2, _event$detail2$target, _event$detail2$target2, _this$props33, _this$props34;

      var eventIndex = Number(event === null || event === void 0 ? void 0 : (_event$detail2 = event.detail) === null || _event$detail2 === void 0 ? void 0 : (_event$detail2$target = _event$detail2.target) === null || _event$detail2$target === void 0 ? void 0 : (_event$detail2$target2 = _event$detail2$target.dataset) === null || _event$detail2$target2 === void 0 ? void 0 : _event$detail2$target2.index) + 1 || 1;
      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onMouseleaveRow) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onMouseleaveRow(event, eventIndex));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onColumnSort = _this._onColumnSort.bind(_assertThisInitialized(_this));
    _this._onSort = _this._onSort.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMouseenterRow = _this._onMouseenterRow.bind(_assertThisInitialized(_this));
    _this._onMouseleaveRow = _this._onMouseleaveRow.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDataTableForTransactions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("columnSort", this._onColumnSort);

      this._ref.current.addEventListener("sort", this._onSort);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mouseenter-row1", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row2", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row3", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row4", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row5", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row6", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row7", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row8", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row9", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseenter-row10", this._onMouseenterRow);

      this._ref.current.addEventListener("mouseleave-row1", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row2", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row3", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row4", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row5", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row6", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row7", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row8", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row9", this._onMouseleaveRow);

      this._ref.current.addEventListener("mouseleave-row10", this._onMouseleaveRow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("columnSort", this._onColumnSort);

      this._ref.current.removeEventListener("sort", this._onSort);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mouseenter-row1", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row2", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row3", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row4", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row5", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row6", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row7", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row8", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row9", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseenter-row10", this._onMouseenterRow);

      this._ref.current.removeEventListener("mouseleave-row1", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row2", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row3", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row4", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row5", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row6", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row7", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row8", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row9", this._onMouseleaveRow);

      this._ref.current.removeEventListener("mouseleave-row10", this._onMouseleaveRow);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-data-table-for-transactions", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        caption: Array.isArray(this.props.caption) || this.props.caption === Object(this.props.caption) ? JSON.stringify(this.props.caption) : this.props.caption,
        "has-visible-caption": Array.isArray(this.props.hasVisibleCaption) || this.props.hasVisibleCaption === Object(this.props.hasVisibleCaption) ? JSON.stringify(this.props.hasVisibleCaption) : this.props.hasVisibleCaption,
        "highlighted-index": Array.isArray(this.props.highlightedIndex) || this.props.highlightedIndex === Object(this.props.highlightedIndex) ? JSON.stringify(this.props.highlightedIndex) : this.props.highlightedIndex,
        "has-hover-color": Array.isArray(this.props.hasHoverColor) || this.props.hasHoverColor === Object(this.props.hasHoverColor) ? JSON.stringify(this.props.hasHoverColor) : this.props.hasHoverColor,
        activated: Array.isArray(this.props.activated) || this.props.activated === Object(this.props.activated) ? JSON.stringify(this.props.activated) : this.props.activated,
        "row-style": Array.isArray(this.props.rowStyle) || this.props.rowStyle === Object(this.props.rowStyle) ? JSON.stringify(this.props.rowStyle) : this.props.rowStyle,
        "suppress-last-row-border": Array.isArray(this.props.suppressLastRowBorder) || this.props.suppressLastRowBorder === Object(this.props.suppressLastRowBorder) ? JSON.stringify(this.props.suppressLastRowBorder) : this.props.suppressLastRowBorder,
        "negative-value-color": Array.isArray(this.props.negativeValueColor) || this.props.negativeValueColor === Object(this.props.negativeValueColor) ? JSON.stringify(this.props.negativeValueColor) : this.props.negativeValueColor,
        "accessible-single-value-negative": Array.isArray(this.props.accessibleSingleValueNegative) || this.props.accessibleSingleValueNegative === Object(this.props.accessibleSingleValueNegative) ? JSON.stringify(this.props.accessibleSingleValueNegative) : this.props.accessibleSingleValueNegative,
        "accessible-single-value-empty": Array.isArray(this.props.accessibleSingleValueEmpty) || this.props.accessibleSingleValueEmpty === Object(this.props.accessibleSingleValueEmpty) ? JSON.stringify(this.props.accessibleSingleValueEmpty) : this.props.accessibleSingleValueEmpty,
        "null-state-message": Array.isArray(this.props.nullStateMessage) || this.props.nullStateMessage === Object(this.props.nullStateMessage) ? JSON.stringify(this.props.nullStateMessage) : this.props.nullStateMessage,
        mode: Array.isArray(this.props.mode) || this.props.mode === Object(this.props.mode) ? JSON.stringify(this.props.mode) : this.props.mode,
        summary: Array.isArray(this.props.summary) || this.props.summary === Object(this.props.summary) ? JSON.stringify(this.props.summary) : this.props.summary,
        stacked: Array.isArray(this.props.stacked) || this.props.stacked === Object(this.props.stacked) ? JSON.stringify(this.props.stacked) : this.props.stacked,
        "stacked-header-width": Array.isArray(this.props.stackedHeaderWidth) || this.props.stackedHeaderWidth === Object(this.props.stackedHeaderWidth) ? JSON.stringify(this.props.stackedHeaderWidth) : this.props.stackedHeaderWidth,
        "stacked-column-width": Array.isArray(this.props.stackedColumnWidth) || this.props.stackedColumnWidth === Object(this.props.stackedColumnWidth) ? JSON.stringify(this.props.stackedColumnWidth) : this.props.stackedColumnWidth,
        "stacked-caption-heading-level": Array.isArray(this.props.stackedCaptionHeadingLevel) || this.props.stackedCaptionHeadingLevel === Object(this.props.stackedCaptionHeadingLevel) ? JSON.stringify(this.props.stackedCaptionHeadingLevel) : this.props.stackedCaptionHeadingLevel,
        "has-highlight": Array.isArray(this.props.hasHighlight) || this.props.hasHighlight === Object(this.props.hasHighlight) ? JSON.stringify(this.props.hasHighlight) : this.props.hasHighlight,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "row-data": Array.isArray(this.props.rowData) || this.props.rowData === Object(this.props.rowData) ? JSON.stringify(this.props.rowData) : this.props.rowData,
        footer: Array.isArray(this.props.footer) || this.props.footer === Object(this.props.footer) ? JSON.stringify(this.props.footer) : this.props.footer,
        "column-configs": Array.isArray(this.props.columnConfigs) || this.props.columnConfigs === Object(this.props.columnConfigs) ? JSON.stringify(this.props.columnConfigs) : this.props.columnConfigs // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDataTableForTransactions;
}(React.Component);
MdsDataTableForTransactions.propTypes = {
  // Values
  caption: PropTypes.string,
  hasVisibleCaption: PropTypes.bool,
  highlightedIndex: CustomPropTypes.integer,
  hasHoverColor: PropTypes.bool,
  activated: PropTypes.bool,
  rowStyle: PropTypes.oneOf(["solid", "dashed"]),
  suppressLastRowBorder: PropTypes.bool,
  negativeValueColor: PropTypes.string,
  accessibleSingleValueNegative: PropTypes.string,
  accessibleSingleValueEmpty: PropTypes.string,
  nullStateMessage: PropTypes.string,
  mode: PropTypes.oneOf(["compact", "relaxed"]),
  summary: PropTypes.string,
  stacked: PropTypes.bool,
  stackedHeaderWidth: PropTypes.string,
  stackedColumnWidth: PropTypes.string,
  stackedCaptionHeadingLevel: PropTypes.number,
  hasHighlight: PropTypes.bool,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  rowData: PropTypes.arrayOf(CustomPropTypes.slot),
  footer: PropTypes.arrayOf(CustomPropTypes.slot),
  columnConfigs: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onColumnSort: PropTypes.func,
  onSort: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onMouseenterRow: PropTypes.func,
  onMouseleaveRow: PropTypes.func
};
MdsDataTableForTransactions.defaultProps = {
  hasVisibleCaption: true,
  hasHoverColor: true,
  activated: true,
  suppressLastRowBorder: false,
  mode: "compact",
  stacked: false,
  stackedCaptionHeadingLevel: 2,
  hasHighlight: true,
  // Events
  onColumnSort: null,
  onSort: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onFocus: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onChange: null,
  onClick: null,
  onMouseenterRow: null,
  onMouseleaveRow: null
};

var MdsDataTableSimple = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDataTableSimple, _React$Component);

  var _super = _createSuper(MdsDataTableSimple);

  function MdsDataTableSimple(props) {
    var _this;

    _classCallCheck(this, MdsDataTableSimple);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onColumnSort", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onColumnSort) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onColumnSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSort", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onSort) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onSort(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMousedown) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onBlur) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onTouchend) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onKeyup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onKeydown) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onFocus) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseenter) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseup) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onTouchstart) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onChange) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props29, _this$props30;

      ((_this$props29 = _this.props) === null || _this$props29 === void 0 ? void 0 : _this$props29.onClick) && ((_this$props30 = _this.props) === null || _this$props30 === void 0 ? void 0 : _this$props30.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenterRowN", function (event) {
      var _this$props31, _this$props32;

      ((_this$props31 = _this.props) === null || _this$props31 === void 0 ? void 0 : _this$props31.onMouseenterRowN) && ((_this$props32 = _this.props) === null || _this$props32 === void 0 ? void 0 : _this$props32.onMouseenterRowN(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseleaveRowN", function (event) {
      var _this$props33, _this$props34;

      ((_this$props33 = _this.props) === null || _this$props33 === void 0 ? void 0 : _this$props33.onMouseleaveRowN) && ((_this$props34 = _this.props) === null || _this$props34 === void 0 ? void 0 : _this$props34.onMouseleaveRowN(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onColumnSort = _this._onColumnSort.bind(_assertThisInitialized(_this));
    _this._onSort = _this._onSort.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMouseenterRowN = _this._onMouseenterRowN.bind(_assertThisInitialized(_this));
    _this._onMouseleaveRowN = _this._onMouseleaveRowN.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDataTableSimple, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("columnSort", this._onColumnSort);

      this._ref.current.addEventListener("sort", this._onSort);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("change", this._onChange);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mouseenterRowN", this._onMouseenterRowN);

      this._ref.current.addEventListener("mouseleaveRowN", this._onMouseleaveRowN);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("columnSort", this._onColumnSort);

      this._ref.current.removeEventListener("sort", this._onSort);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("change", this._onChange);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mouseenterRowN", this._onMouseenterRowN);

      this._ref.current.removeEventListener("mouseleaveRowN", this._onMouseleaveRowN);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-data-table-simple", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        caption: Array.isArray(this.props.caption) || this.props.caption === Object(this.props.caption) ? JSON.stringify(this.props.caption) : this.props.caption,
        "has-visible-caption": Array.isArray(this.props.hasVisibleCaption) || this.props.hasVisibleCaption === Object(this.props.hasVisibleCaption) ? JSON.stringify(this.props.hasVisibleCaption) : this.props.hasVisibleCaption,
        "highlighted-index": Array.isArray(this.props.highlightedIndex) || this.props.highlightedIndex === Object(this.props.highlightedIndex) ? JSON.stringify(this.props.highlightedIndex) : this.props.highlightedIndex,
        "has-hover-color": Array.isArray(this.props.hasHoverColor) || this.props.hasHoverColor === Object(this.props.hasHoverColor) ? JSON.stringify(this.props.hasHoverColor) : this.props.hasHoverColor,
        activated: Array.isArray(this.props.activated) || this.props.activated === Object(this.props.activated) ? JSON.stringify(this.props.activated) : this.props.activated,
        "row-style": Array.isArray(this.props.rowStyle) || this.props.rowStyle === Object(this.props.rowStyle) ? JSON.stringify(this.props.rowStyle) : this.props.rowStyle,
        "suppress-last-row-border": Array.isArray(this.props.suppressLastRowBorder) || this.props.suppressLastRowBorder === Object(this.props.suppressLastRowBorder) ? JSON.stringify(this.props.suppressLastRowBorder) : this.props.suppressLastRowBorder,
        "negative-value-color": Array.isArray(this.props.negativeValueColor) || this.props.negativeValueColor === Object(this.props.negativeValueColor) ? JSON.stringify(this.props.negativeValueColor) : this.props.negativeValueColor,
        "accessible-single-value-negative": Array.isArray(this.props.accessibleSingleValueNegative) || this.props.accessibleSingleValueNegative === Object(this.props.accessibleSingleValueNegative) ? JSON.stringify(this.props.accessibleSingleValueNegative) : this.props.accessibleSingleValueNegative,
        "accessible-single-value-empty": Array.isArray(this.props.accessibleSingleValueEmpty) || this.props.accessibleSingleValueEmpty === Object(this.props.accessibleSingleValueEmpty) ? JSON.stringify(this.props.accessibleSingleValueEmpty) : this.props.accessibleSingleValueEmpty,
        "null-state-message": Array.isArray(this.props.nullStateMessage) || this.props.nullStateMessage === Object(this.props.nullStateMessage) ? JSON.stringify(this.props.nullStateMessage) : this.props.nullStateMessage,
        mode: Array.isArray(this.props.mode) || this.props.mode === Object(this.props.mode) ? JSON.stringify(this.props.mode) : this.props.mode,
        summary: Array.isArray(this.props.summary) || this.props.summary === Object(this.props.summary) ? JSON.stringify(this.props.summary) : this.props.summary,
        stacked: Array.isArray(this.props.stacked) || this.props.stacked === Object(this.props.stacked) ? JSON.stringify(this.props.stacked) : this.props.stacked,
        "stacked-header-width": Array.isArray(this.props.stackedHeaderWidth) || this.props.stackedHeaderWidth === Object(this.props.stackedHeaderWidth) ? JSON.stringify(this.props.stackedHeaderWidth) : this.props.stackedHeaderWidth,
        "stacked-column-width": Array.isArray(this.props.stackedColumnWidth) || this.props.stackedColumnWidth === Object(this.props.stackedColumnWidth) ? JSON.stringify(this.props.stackedColumnWidth) : this.props.stackedColumnWidth,
        "stacked-caption-heading-level": Array.isArray(this.props.stackedCaptionHeadingLevel) || this.props.stackedCaptionHeadingLevel === Object(this.props.stackedCaptionHeadingLevel) ? JSON.stringify(this.props.stackedCaptionHeadingLevel) : this.props.stackedCaptionHeadingLevel,
        layout: Array.isArray(this.props.layout) || this.props.layout === Object(this.props.layout) ? JSON.stringify(this.props.layout) : this.props.layout,
        "has-highlight": Array.isArray(this.props.hasHighlight) || this.props.hasHighlight === Object(this.props.hasHighlight) ? JSON.stringify(this.props.hasHighlight) : this.props.hasHighlight,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "row-data": Array.isArray(this.props.rowData) || this.props.rowData === Object(this.props.rowData) ? JSON.stringify(this.props.rowData) : this.props.rowData,
        footer: Array.isArray(this.props.footer) || this.props.footer === Object(this.props.footer) ? JSON.stringify(this.props.footer) : this.props.footer,
        "column-configs": Array.isArray(this.props.columnConfigs) || this.props.columnConfigs === Object(this.props.columnConfigs) ? JSON.stringify(this.props.columnConfigs) : this.props.columnConfigs // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDataTableSimple;
}(React.Component);
MdsDataTableSimple.propTypes = {
  // Values
  caption: PropTypes.string,
  hasVisibleCaption: PropTypes.bool,
  highlightedIndex: CustomPropTypes.integer,
  hasHoverColor: PropTypes.bool,
  activated: PropTypes.bool,
  rowStyle: PropTypes.oneOf(["solid", "dashed"]),
  suppressLastRowBorder: PropTypes.bool,
  negativeValueColor: PropTypes.string,
  accessibleSingleValueNegative: PropTypes.string,
  accessibleSingleValueEmpty: PropTypes.string,
  nullStateMessage: PropTypes.string,
  mode: PropTypes.oneOf(["compact", "relaxed"]),
  summary: PropTypes.string,
  stacked: PropTypes.bool,
  stackedHeaderWidth: PropTypes.string,
  stackedColumnWidth: PropTypes.string,
  stackedCaptionHeadingLevel: PropTypes.number,
  layout: PropTypes.oneOf(["columnRow", "row", "column"]),
  hasHighlight: PropTypes.bool,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  rowData: PropTypes.arrayOf(CustomPropTypes.slot),
  footer: PropTypes.arrayOf(CustomPropTypes.slot),
  columnConfigs: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onColumnSort: PropTypes.func,
  onSort: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseover: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchend: PropTypes.func,
  onKeyup: PropTypes.func,
  onMouseout: PropTypes.func,
  onKeydown: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onTouchstart: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onMouseenterRowN: PropTypes.func,
  onMouseleaveRowN: PropTypes.func
};
MdsDataTableSimple.defaultProps = {
  hasVisibleCaption: true,
  hasHoverColor: true,
  activated: true,
  suppressLastRowBorder: false,
  mode: "compact",
  stacked: false,
  stackedCaptionHeadingLevel: 2,
  layout: "column",
  hasHighlight: true,
  // Events
  onColumnSort: null,
  onSort: null,
  onMousedown: null,
  onMouseover: null,
  onBlur: null,
  onTouchend: null,
  onKeyup: null,
  onMouseout: null,
  onKeydown: null,
  onFocus: null,
  onMouseenter: null,
  onMouseup: null,
  onTouchstart: null,
  onChange: null,
  onClick: null,
  onMouseenterRowN: null,
  onMouseleaveRowN: null
};

var MdsDonutChart = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsDonutChart, _React$Component);

  var _super = _createSuper(MdsDonutChart);

  function MdsDonutChart(props) {
    var _this;

    _classCallCheck(this, MdsDonutChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTabChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTabChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTabChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onAccessibleAlternativeLinkPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onAccessibleAlternativeLinkPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onAccessibleAlternativeLinkPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onExpandFullScreenButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onExpandFullScreenButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onExpandFullScreenButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onClick) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onSelectedSegment", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onSelectedSegment) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onSelectedSegment(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseoverSegment", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onMouseoverSegment) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onMouseoverSegment(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseoutSegment", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onMouseoutSegment) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onMouseoutSegment(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTabChange = _this._onTabChange.bind(_assertThisInitialized(_this));
    _this._onAccessibleAlternativeLinkPress = _this._onAccessibleAlternativeLinkPress.bind(_assertThisInitialized(_this));
    _this._onExpandFullScreenButtonPress = _this._onExpandFullScreenButtonPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onSelectedSegment = _this._onSelectedSegment.bind(_assertThisInitialized(_this));
    _this._onMouseoverSegment = _this._onMouseoverSegment.bind(_assertThisInitialized(_this));
    _this._onMouseoutSegment = _this._onMouseoutSegment.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsDonutChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("tabChange", this._onTabChange);

      this._ref.current.addEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.addEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("selected-segment", this._onSelectedSegment);

      this._ref.current.addEventListener("mouseover-segment", this._onMouseoverSegment);

      this._ref.current.addEventListener("mouseout-segment", this._onMouseoutSegment);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("tabChange", this._onTabChange);

      this._ref.current.removeEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.removeEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("selected-segment", this._onSelectedSegment);

      this._ref.current.removeEventListener("mouseover-segment", this._onMouseoverSegment);

      this._ref.current.removeEventListener("mouseout-segment", this._onMouseoutSegment);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-donut-chart", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "short-description": Array.isArray(this.props.shortDescription) || this.props.shortDescription === Object(this.props.shortDescription) ? JSON.stringify(this.props.shortDescription) : this.props.shortDescription,
        "chart-title": Array.isArray(this.props.chartTitle) || this.props.chartTitle === Object(this.props.chartTitle) ? JSON.stringify(this.props.chartTitle) : this.props.chartTitle,
        "show-full-screen-button": Array.isArray(this.props.showFullScreenButton) || this.props.showFullScreenButton === Object(this.props.showFullScreenButton) ? JSON.stringify(this.props.showFullScreenButton) : this.props.showFullScreenButton,
        "accessible-alternative-link-text": Array.isArray(this.props.accessibleAlternativeLinkText) || this.props.accessibleAlternativeLinkText === Object(this.props.accessibleAlternativeLinkText) ? JSON.stringify(this.props.accessibleAlternativeLinkText) : this.props.accessibleAlternativeLinkText,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        "d3-legend-format-string": Array.isArray(this.props.d3LegendFormatString) || this.props.d3LegendFormatString === Object(this.props.d3LegendFormatString) ? JSON.stringify(this.props.d3LegendFormatString) : this.props.d3LegendFormatString,
        "d3-bar-label-format-string": Array.isArray(this.props.d3BarLabelFormatString) || this.props.d3BarLabelFormatString === Object(this.props.d3BarLabelFormatString) ? JSON.stringify(this.props.d3BarLabelFormatString) : this.props.d3BarLabelFormatString,
        "d3-prefix-formatter": Array.isArray(this.props.d3PrefixFormatter) || this.props.d3PrefixFormatter === Object(this.props.d3PrefixFormatter) ? JSON.stringify(this.props.d3PrefixFormatter) : this.props.d3PrefixFormatter,
        "d3-data-point-detail-x-format-string": Array.isArray(this.props.d3DataPointDetailXFormatString) || this.props.d3DataPointDetailXFormatString === Object(this.props.d3DataPointDetailXFormatString) ? JSON.stringify(this.props.d3DataPointDetailXFormatString) : this.props.d3DataPointDetailXFormatString,
        "d3-data-point-detail-y-format-string": Array.isArray(this.props.d3DataPointDetailYFormatString) || this.props.d3DataPointDetailYFormatString === Object(this.props.d3DataPointDetailYFormatString) ? JSON.stringify(this.props.d3DataPointDetailYFormatString) : this.props.d3DataPointDetailYFormatString,
        "chart-height": Array.isArray(this.props.chartHeight) || this.props.chartHeight === Object(this.props.chartHeight) ? JSON.stringify(this.props.chartHeight) : this.props.chartHeight,
        interactive: Array.isArray(this.props.interactive) || this.props.interactive === Object(this.props.interactive) ? JSON.stringify(this.props.interactive) : this.props.interactive,
        "sort-segments": Array.isArray(this.props.sortSegments) || this.props.sortSegments === Object(this.props.sortSegments) ? JSON.stringify(this.props.sortSegments) : this.props.sortSegments,
        "selected-index": Array.isArray(this.props.selectedIndex) || this.props.selectedIndex === Object(this.props.selectedIndex) ? JSON.stringify(this.props.selectedIndex) : this.props.selectedIndex,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "full-screen-button-alternative-text": Array.isArray(this.props.fullScreenButtonAlternativeText) || this.props.fullScreenButtonAlternativeText === Object(this.props.fullScreenButtonAlternativeText) ? JSON.stringify(this.props.fullScreenButtonAlternativeText) : this.props.fullScreenButtonAlternativeText,
        "content-view": Array.isArray(this.props.contentView) || this.props.contentView === Object(this.props.contentView) ? JSON.stringify(this.props.contentView) : this.props.contentView,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        tabs: Array.isArray(this.props.tabs) || this.props.tabs === Object(this.props.tabs) ? JSON.stringify(this.props.tabs) : this.props.tabs,
        segments: Array.isArray(this.props.segments) || this.props.segments === Object(this.props.segments) ? JSON.stringify(this.props.segments) : this.props.segments // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsDonutChart;
}(React.Component);
MdsDonutChart.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  shortDescription: PropTypes.string,
  chartTitle: PropTypes.string,
  showFullScreenButton: PropTypes.bool,
  accessibleAlternativeLinkText: PropTypes.string,
  noDataPointText: PropTypes.string,
  d3LegendFormatString: PropTypes.string,
  d3BarLabelFormatString: PropTypes.string,
  d3PrefixFormatter: PropTypes.bool,
  d3DataPointDetailXFormatString: PropTypes.string,
  d3DataPointDetailYFormatString: PropTypes.string,
  chartHeight: CustomPropTypes.integer,
  interactive: PropTypes.bool,
  sortSegments: PropTypes.bool,
  selectedIndex: CustomPropTypes.integer,
  brand: PropTypes.string,
  fullScreenButtonAlternativeText: PropTypes.string,
  contentView: PropTypes.object,
  id: PropTypes.string,
  slot: PropTypes.string,
  tabs: CustomPropTypes.slot,
  segments: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onTabChange: PropTypes.func,
  onAccessibleAlternativeLinkPress: PropTypes.func,
  onExpandFullScreenButtonPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onClick: PropTypes.func,
  onSelectedSegment: PropTypes.func,
  onMouseoverSegment: PropTypes.func,
  onMouseoutSegment: PropTypes.func
};
MdsDonutChart.defaultProps = {
  showFullScreenButton: false,
  noDataPointText: "Chart temporarily unavailable.",
  d3PrefixFormatter: false,
  interactive: false,
  sortSegments: false,
  // Events
  onTabChange: null,
  onAccessibleAlternativeLinkPress: null,
  onExpandFullScreenButtonPress: null,
  onMousedown: null,
  onMouseout: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onClick: null,
  onSelectedSegment: null,
  onMouseoverSegment: null,
  onMouseoutSegment: null
};

var MdsGaugeChartLinear = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsGaugeChartLinear, _React$Component);

  var _super = _createSuper(MdsGaugeChartLinear);

  function MdsGaugeChartLinear(props) {
    var _this;

    _classCallCheck(this, MdsGaugeChartLinear);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsGaugeChartLinear, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-gauge-chart-linear", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "accessible-description": Array.isArray(this.props.accessibleDescription) || this.props.accessibleDescription === Object(this.props.accessibleDescription) ? JSON.stringify(this.props.accessibleDescription) : this.props.accessibleDescription,
        "primary-label": Array.isArray(this.props.primaryLabel) || this.props.primaryLabel === Object(this.props.primaryLabel) ? JSON.stringify(this.props.primaryLabel) : this.props.primaryLabel,
        "value-color": Array.isArray(this.props.valueColor) || this.props.valueColor === Object(this.props.valueColor) ? JSON.stringify(this.props.valueColor) : this.props.valueColor,
        "secondary-label": Array.isArray(this.props.secondaryLabel) || this.props.secondaryLabel === Object(this.props.secondaryLabel) ? JSON.stringify(this.props.secondaryLabel) : this.props.secondaryLabel,
        "secondary-label-value": Array.isArray(this.props.secondaryLabelValue) || this.props.secondaryLabelValue === Object(this.props.secondaryLabelValue) ? JSON.stringify(this.props.secondaryLabelValue) : this.props.secondaryLabelValue,
        "trailing-bar-label": Array.isArray(this.props.trailingBarLabel) || this.props.trailingBarLabel === Object(this.props.trailingBarLabel) ? JSON.stringify(this.props.trailingBarLabel) : this.props.trailingBarLabel,
        "trailing-bar-label-decimal-places": Array.isArray(this.props.trailingBarLabelDecimalPlaces) || this.props.trailingBarLabelDecimalPlaces === Object(this.props.trailingBarLabelDecimalPlaces) ? JSON.stringify(this.props.trailingBarLabelDecimalPlaces) : this.props.trailingBarLabelDecimalPlaces,
        "min-value": Array.isArray(this.props.minValue) || this.props.minValue === Object(this.props.minValue) ? JSON.stringify(this.props.minValue) : this.props.minValue,
        "max-value": Array.isArray(this.props.maxValue) || this.props.maxValue === Object(this.props.maxValue) ? JSON.stringify(this.props.maxValue) : this.props.maxValue,
        "current-value": Array.isArray(this.props.currentValue) || this.props.currentValue === Object(this.props.currentValue) ? JSON.stringify(this.props.currentValue) : this.props.currentValue,
        position: Array.isArray(this.props.position) || this.props.position === Object(this.props.position) ? JSON.stringify(this.props.position) : this.props.position,
        "primary-label-width": Array.isArray(this.props.primaryLabelWidth) || this.props.primaryLabelWidth === Object(this.props.primaryLabelWidth) ? JSON.stringify(this.props.primaryLabelWidth) : this.props.primaryLabelWidth,
        "pin-type": Array.isArray(this.props.pinType) || this.props.pinType === Object(this.props.pinType) ? JSON.stringify(this.props.pinType) : this.props.pinType,
        "pin-position": Array.isArray(this.props.pinPosition) || this.props.pinPosition === Object(this.props.pinPosition) ? JSON.stringify(this.props.pinPosition) : this.props.pinPosition,
        "pin-icon": Array.isArray(this.props.pinIcon) || this.props.pinIcon === Object(this.props.pinIcon) ? JSON.stringify(this.props.pinIcon) : this.props.pinIcon,
        "pin-text": Array.isArray(this.props.pinText) || this.props.pinText === Object(this.props.pinText) ? JSON.stringify(this.props.pinText) : this.props.pinText,
        variant: Array.isArray(this.props.variant) || this.props.variant === Object(this.props.variant) ? JSON.stringify(this.props.variant) : this.props.variant,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "pin-value-accessible-name": Array.isArray(this.props.pinValueAccessibleName) || this.props.pinValueAccessibleName === Object(this.props.pinValueAccessibleName) ? JSON.stringify(this.props.pinValueAccessibleName) : this.props.pinValueAccessibleName,
        "current-value-accessible-name": Array.isArray(this.props.currentValueAccessibleName) || this.props.currentValueAccessibleName === Object(this.props.currentValueAccessibleName) ? JSON.stringify(this.props.currentValueAccessibleName) : this.props.currentValueAccessibleName,
        "min-value-accessible-name": Array.isArray(this.props.minValueAccessibleName) || this.props.minValueAccessibleName === Object(this.props.minValueAccessibleName) ? JSON.stringify(this.props.minValueAccessibleName) : this.props.minValueAccessibleName,
        "component-role": Array.isArray(this.props.componentRole) || this.props.componentRole === Object(this.props.componentRole) ? JSON.stringify(this.props.componentRole) : this.props.componentRole,
        "max-value-accessible-name": Array.isArray(this.props.maxValueAccessibleName) || this.props.maxValueAccessibleName === Object(this.props.maxValueAccessibleName) ? JSON.stringify(this.props.maxValueAccessibleName) : this.props.maxValueAccessibleName,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsGaugeChartLinear;
}(React.Component);
MdsGaugeChartLinear.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  accessibleDescription: PropTypes.string,
  primaryLabel: PropTypes.string,
  valueColor: PropTypes.string,
  secondaryLabel: PropTypes.string,
  secondaryLabelValue: PropTypes.string,
  trailingBarLabel: PropTypes.oneOf(["percent", "value", "none"]),
  trailingBarLabelDecimalPlaces: CustomPropTypes.integer,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  currentValue: PropTypes.number,
  position: PropTypes.oneOf(["above", "below"]),
  primaryLabelWidth: PropTypes.number,
  pinType: PropTypes.oneOf(["icon", "text", "none"]),
  pinPosition: PropTypes.number,
  pinIcon: PropTypes.string,
  pinText: PropTypes.string,
  variant: PropTypes.oneOf(["regular", "range"]),
  brand: PropTypes.string,
  pinValueAccessibleName: PropTypes.string,
  currentValueAccessibleName: PropTypes.string,
  minValueAccessibleName: PropTypes.string,
  componentRole: PropTypes.string,
  maxValueAccessibleName: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsGaugeChartLinear.defaultProps = {
  trailingBarLabel: "none",
  trailingBarLabelDecimalPlaces: 0,
  minValue: 0,
  position: "above",
  primaryLabelWidth: 60,
  pinType: "none",
  variant: "regular",
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsGaugeChartRadial = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsGaugeChartRadial, _React$Component);

  var _super = _createSuper(MdsGaugeChartRadial);

  function MdsGaugeChartRadial(props) {
    var _this;

    _classCallCheck(this, MdsGaugeChartRadial);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsGaugeChartRadial, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-gauge-chart-radial", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        thickness: Array.isArray(this.props.thickness) || this.props.thickness === Object(this.props.thickness) ? JSON.stringify(this.props.thickness) : this.props.thickness,
        "max-value": Array.isArray(this.props.maxValue) || this.props.maxValue === Object(this.props.maxValue) ? JSON.stringify(this.props.maxValue) : this.props.maxValue,
        "bar-label": Array.isArray(this.props.barLabel) || this.props.barLabel === Object(this.props.barLabel) ? JSON.stringify(this.props.barLabel) : this.props.barLabel,
        "data-marker": Array.isArray(this.props.dataMarker) || this.props.dataMarker === Object(this.props.dataMarker) ? JSON.stringify(this.props.dataMarker) : this.props.dataMarker,
        "primary-value": Array.isArray(this.props.primaryValue) || this.props.primaryValue === Object(this.props.primaryValue) ? JSON.stringify(this.props.primaryValue) : this.props.primaryValue,
        "secondary-value": Array.isArray(this.props.secondaryValue) || this.props.secondaryValue === Object(this.props.secondaryValue) ? JSON.stringify(this.props.secondaryValue) : this.props.secondaryValue,
        "secondary-data-marker-icon": Array.isArray(this.props.secondaryDataMarkerIcon) || this.props.secondaryDataMarkerIcon === Object(this.props.secondaryDataMarkerIcon) ? JSON.stringify(this.props.secondaryDataMarkerIcon) : this.props.secondaryDataMarkerIcon,
        "formatted-min-value": Array.isArray(this.props.formattedMinValue) || this.props.formattedMinValue === Object(this.props.formattedMinValue) ? JSON.stringify(this.props.formattedMinValue) : this.props.formattedMinValue,
        "formatted-max-value": Array.isArray(this.props.formattedMaxValue) || this.props.formattedMaxValue === Object(this.props.formattedMaxValue) ? JSON.stringify(this.props.formattedMaxValue) : this.props.formattedMaxValue,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "content-accessible-text": Array.isArray(this.props.contentAccessibleText) || this.props.contentAccessibleText === Object(this.props.contentAccessibleText) ? JSON.stringify(this.props.contentAccessibleText) : this.props.contentAccessibleText,
        "secondary-value-accessible-name": Array.isArray(this.props.secondaryValueAccessibleName) || this.props.secondaryValueAccessibleName === Object(this.props.secondaryValueAccessibleName) ? JSON.stringify(this.props.secondaryValueAccessibleName) : this.props.secondaryValueAccessibleName,
        "min-value-accessible-name": Array.isArray(this.props.minValueAccessibleName) || this.props.minValueAccessibleName === Object(this.props.minValueAccessibleName) ? JSON.stringify(this.props.minValueAccessibleName) : this.props.minValueAccessibleName,
        "component-role": Array.isArray(this.props.componentRole) || this.props.componentRole === Object(this.props.componentRole) ? JSON.stringify(this.props.componentRole) : this.props.componentRole,
        "max-value-accessible-name": Array.isArray(this.props.maxValueAccessibleName) || this.props.maxValueAccessibleName === Object(this.props.maxValueAccessibleName) ? JSON.stringify(this.props.maxValueAccessibleName) : this.props.maxValueAccessibleName,
        "primary-value-accessible-name": Array.isArray(this.props.primaryValueAccessibleName) || this.props.primaryValueAccessibleName === Object(this.props.primaryValueAccessibleName) ? JSON.stringify(this.props.primaryValueAccessibleName) : this.props.primaryValueAccessibleName,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsGaugeChartRadial;
}(React.Component);
MdsGaugeChartRadial.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  thickness: PropTypes.oneOf(["regular", "thin"]),
  maxValue: PropTypes.number,
  barLabel: PropTypes.bool,
  dataMarker: PropTypes.bool,
  primaryValue: PropTypes.number,
  secondaryValue: PropTypes.number,
  secondaryDataMarkerIcon: PropTypes.bool,
  formattedMinValue: PropTypes.string,
  formattedMaxValue: PropTypes.string,
  brand: PropTypes.string,
  contentAccessibleText: PropTypes.string,
  secondaryValueAccessibleName: PropTypes.string,
  minValueAccessibleName: PropTypes.string,
  componentRole: PropTypes.string,
  maxValueAccessibleName: PropTypes.string,
  primaryValueAccessibleName: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsGaugeChartRadial.defaultProps = {
  thickness: "regular",
  barLabel: false,
  dataMarker: false,
  secondaryDataMarkerIcon: false,
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

var MdsLineChart = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsLineChart, _React$Component);

  var _super = _createSuper(MdsLineChart);

  function MdsLineChart(props) {
    var _this;

    _classCallCheck(this, MdsLineChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTabChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTabChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTabChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onAccessibleAlternativeLinkPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onAccessibleAlternativeLinkPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onAccessibleAlternativeLinkPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onExpandFullScreenButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onExpandFullScreenButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onExpandFullScreenButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onClick) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseoverChartarea", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseoverChartarea) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseoverChartarea(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTabChange = _this._onTabChange.bind(_assertThisInitialized(_this));
    _this._onAccessibleAlternativeLinkPress = _this._onAccessibleAlternativeLinkPress.bind(_assertThisInitialized(_this));
    _this._onExpandFullScreenButtonPress = _this._onExpandFullScreenButtonPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMouseoverChartarea = _this._onMouseoverChartarea.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsLineChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("tabChange", this._onTabChange);

      this._ref.current.addEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.addEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mouseover-chartarea", this._onMouseoverChartarea);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("tabChange", this._onTabChange);

      this._ref.current.removeEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.removeEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mouseover-chartarea", this._onMouseoverChartarea);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-line-chart", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "short-description": Array.isArray(this.props.shortDescription) || this.props.shortDescription === Object(this.props.shortDescription) ? JSON.stringify(this.props.shortDescription) : this.props.shortDescription,
        "chart-title": Array.isArray(this.props.chartTitle) || this.props.chartTitle === Object(this.props.chartTitle) ? JSON.stringify(this.props.chartTitle) : this.props.chartTitle,
        "show-full-screen-button": Array.isArray(this.props.showFullScreenButton) || this.props.showFullScreenButton === Object(this.props.showFullScreenButton) ? JSON.stringify(this.props.showFullScreenButton) : this.props.showFullScreenButton,
        "accessible-alternative-link-text": Array.isArray(this.props.accessibleAlternativeLinkText) || this.props.accessibleAlternativeLinkText === Object(this.props.accessibleAlternativeLinkText) ? JSON.stringify(this.props.accessibleAlternativeLinkText) : this.props.accessibleAlternativeLinkText,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        "d3-legend-format-string": Array.isArray(this.props.d3LegendFormatString) || this.props.d3LegendFormatString === Object(this.props.d3LegendFormatString) ? JSON.stringify(this.props.d3LegendFormatString) : this.props.d3LegendFormatString,
        "d3-bar-label-format-string": Array.isArray(this.props.d3BarLabelFormatString) || this.props.d3BarLabelFormatString === Object(this.props.d3BarLabelFormatString) ? JSON.stringify(this.props.d3BarLabelFormatString) : this.props.d3BarLabelFormatString,
        "d3-prefix-formatter": Array.isArray(this.props.d3PrefixFormatter) || this.props.d3PrefixFormatter === Object(this.props.d3PrefixFormatter) ? JSON.stringify(this.props.d3PrefixFormatter) : this.props.d3PrefixFormatter,
        "d3-data-point-detail-x-format-string": Array.isArray(this.props.d3DataPointDetailXFormatString) || this.props.d3DataPointDetailXFormatString === Object(this.props.d3DataPointDetailXFormatString) ? JSON.stringify(this.props.d3DataPointDetailXFormatString) : this.props.d3DataPointDetailXFormatString,
        "d3-data-point-detail-y-format-string": Array.isArray(this.props.d3DataPointDetailYFormatString) || this.props.d3DataPointDetailYFormatString === Object(this.props.d3DataPointDetailYFormatString) ? JSON.stringify(this.props.d3DataPointDetailYFormatString) : this.props.d3DataPointDetailYFormatString,
        "chart-height": Array.isArray(this.props.chartHeight) || this.props.chartHeight === Object(this.props.chartHeight) ? JSON.stringify(this.props.chartHeight) : this.props.chartHeight,
        "show-y-axis": Array.isArray(this.props.showYAxis) || this.props.showYAxis === Object(this.props.showYAxis) ? JSON.stringify(this.props.showYAxis) : this.props.showYAxis,
        "highlighted-x-value": Array.isArray(this.props.highlightedXValue) || this.props.highlightedXValue === Object(this.props.highlightedXValue) ? JSON.stringify(this.props.highlightedXValue) : this.props.highlightedXValue,
        "single-line-legend": Array.isArray(this.props.singleLineLegend) || this.props.singleLineLegend === Object(this.props.singleLineLegend) ? JSON.stringify(this.props.singleLineLegend) : this.props.singleLineLegend,
        "hide-top-border": Array.isArray(this.props.hideTopBorder) || this.props.hideTopBorder === Object(this.props.hideTopBorder) ? JSON.stringify(this.props.hideTopBorder) : this.props.hideTopBorder,
        "show-legend": Array.isArray(this.props.showLegend) || this.props.showLegend === Object(this.props.showLegend) ? JSON.stringify(this.props.showLegend) : this.props.showLegend,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "full-screen-button-alternative-text": Array.isArray(this.props.fullScreenButtonAlternativeText) || this.props.fullScreenButtonAlternativeText === Object(this.props.fullScreenButtonAlternativeText) ? JSON.stringify(this.props.fullScreenButtonAlternativeText) : this.props.fullScreenButtonAlternativeText,
        "legend-type": Array.isArray(this.props.legendType) || this.props.legendType === Object(this.props.legendType) ? JSON.stringify(this.props.legendType) : this.props.legendType,
        "default-data-point-detail-position": Array.isArray(this.props.defaultDataPointDetailPosition) || this.props.defaultDataPointDetailPosition === Object(this.props.defaultDataPointDetailPosition) ? JSON.stringify(this.props.defaultDataPointDetailPosition) : this.props.defaultDataPointDetailPosition,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        tabs: Array.isArray(this.props.tabs) || this.props.tabs === Object(this.props.tabs) ? JSON.stringify(this.props.tabs) : this.props.tabs,
        line: Array.isArray(this.props.line) || this.props.line === Object(this.props.line) ? JSON.stringify(this.props.line) : this.props.line,
        "x-axis": Array.isArray(this.props.xAxis) || this.props.xAxis === Object(this.props.xAxis) ? JSON.stringify(this.props.xAxis) : this.props.xAxis,
        "y-axis": Array.isArray(this.props.yAxis) || this.props.yAxis === Object(this.props.yAxis) ? JSON.stringify(this.props.yAxis) : this.props.yAxis,
        "reference-lines": Array.isArray(this.props.referenceLines) || this.props.referenceLines === Object(this.props.referenceLines) ? JSON.stringify(this.props.referenceLines) : this.props.referenceLines,
        legend: Array.isArray(this.props.legend) || this.props.legend === Object(this.props.legend) ? JSON.stringify(this.props.legend) : this.props.legend,
        lines: Array.isArray(this.props.lines) || this.props.lines === Object(this.props.lines) ? JSON.stringify(this.props.lines) : this.props.lines // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsLineChart;
}(React.Component);
MdsLineChart.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  shortDescription: PropTypes.string,
  chartTitle: PropTypes.string,
  showFullScreenButton: PropTypes.bool,
  accessibleAlternativeLinkText: PropTypes.string,
  noDataPointText: PropTypes.string,
  d3LegendFormatString: PropTypes.string,
  d3BarLabelFormatString: PropTypes.string,
  d3PrefixFormatter: PropTypes.bool,
  d3DataPointDetailXFormatString: PropTypes.string,
  d3DataPointDetailYFormatString: PropTypes.string,
  chartHeight: CustomPropTypes.integer,
  showYAxis: PropTypes.bool,
  highlightedXValue: PropTypes.number,
  singleLineLegend: PropTypes.oneOf(["legend", "dataTip"]),
  hideTopBorder: PropTypes.bool,
  showLegend: PropTypes.bool,
  brand: PropTypes.string,
  fullScreenButtonAlternativeText: PropTypes.string,
  legendType: PropTypes.string,
  defaultDataPointDetailPosition: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  tabs: CustomPropTypes.slot,
  line: CustomPropTypes.slot,
  xAxis: CustomPropTypes.slot,
  yAxis: CustomPropTypes.slot,
  referenceLines: PropTypes.arrayOf(CustomPropTypes.slot),
  legend: CustomPropTypes.slot,
  lines: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onTabChange: PropTypes.func,
  onAccessibleAlternativeLinkPress: PropTypes.func,
  onExpandFullScreenButtonPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onClick: PropTypes.func,
  onMouseoverChartarea: PropTypes.func
};
MdsLineChart.defaultProps = {
  showFullScreenButton: false,
  noDataPointText: "Chart temporarily unavailable.",
  d3PrefixFormatter: false,
  showYAxis: true,
  singleLineLegend: "dataTip",
  hideTopBorder: false,
  showLegend: true,
  // Events
  onTabChange: null,
  onAccessibleAlternativeLinkPress: null,
  onExpandFullScreenButtonPress: null,
  onMousedown: null,
  onMouseout: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onClick: null,
  onMouseoverChartarea: null
};

var MdsMap = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsMap, _React$Component);

  var _super = _createSuper(MdsMap);

  function MdsMap(props) {
    var _this;

    _classCallCheck(this, MdsMap);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyup", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onKeyup) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onKeyup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeydown", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onKeydown) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onKeydown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMousedown) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseup) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseover) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onMouseenter) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onMouseout) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onTouchstart) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onTouchend) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMapready", function (event) {
      var _this$props25, _this$props26;

      ((_this$props25 = _this.props) === null || _this$props25 === void 0 ? void 0 : _this$props25.onMapready) && ((_this$props26 = _this.props) === null || _this$props26 === void 0 ? void 0 : _this$props26.onMapready(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMaprendered", function (event) {
      var _this$props27, _this$props28;

      ((_this$props27 = _this.props) === null || _this$props27 === void 0 ? void 0 : _this$props27.onMaprendered) && ((_this$props28 = _this.props) === null || _this$props28 === void 0 ? void 0 : _this$props28.onMaprendered(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onMapready = _this._onMapready.bind(_assertThisInitialized(_this));
    _this._onMaprendered = _this._onMaprendered.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("keyup", this._onKeyup);

      this._ref.current.addEventListener("keydown", this._onKeydown);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("mapready", this._onMapready);

      this._ref.current.addEventListener("maprendered", this._onMaprendered);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("keyup", this._onKeyup);

      this._ref.current.removeEventListener("keydown", this._onKeydown);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("mapready", this._onMapready);

      this._ref.current.removeEventListener("maprendered", this._onMaprendered);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-map", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "api-key": Array.isArray(this.props.apiKey) || this.props.apiKey === Object(this.props.apiKey) ? JSON.stringify(this.props.apiKey) : this.props.apiKey,
        "default-zoom": Array.isArray(this.props.defaultZoom) || this.props.defaultZoom === Object(this.props.defaultZoom) ? JSON.stringify(this.props.defaultZoom) : this.props.defaultZoom,
        "default-center": Array.isArray(this.props.defaultCenter) || this.props.defaultCenter === Object(this.props.defaultCenter) ? JSON.stringify(this.props.defaultCenter) : this.props.defaultCenter,
        "restricted-bounds": Array.isArray(this.props.restrictedBounds) || this.props.restrictedBounds === Object(this.props.restrictedBounds) ? JSON.stringify(this.props.restrictedBounds) : this.props.restrictedBounds,
        "marker-icon": Array.isArray(this.props.markerIcon) || this.props.markerIcon === Object(this.props.markerIcon) ? JSON.stringify(this.props.markerIcon) : this.props.markerIcon,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "zoom-in-accessible-text": Array.isArray(this.props.zoomInAccessibleText) || this.props.zoomInAccessibleText === Object(this.props.zoomInAccessibleText) ? JSON.stringify(this.props.zoomInAccessibleText) : this.props.zoomInAccessibleText,
        "zoom-out-accessible-text": Array.isArray(this.props.zoomOutAccessibleText) || this.props.zoomOutAccessibleText === Object(this.props.zoomOutAccessibleText) ? JSON.stringify(this.props.zoomOutAccessibleText) : this.props.zoomOutAccessibleText,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        channel: Array.isArray(this.props.channel) || this.props.channel === Object(this.props.channel) ? JSON.stringify(this.props.channel) : this.props.channel,
        height: Array.isArray(this.props.height) || this.props.height === Object(this.props.height) ? JSON.stringify(this.props.height) : this.props.height,
        width: Array.isArray(this.props.width) || this.props.width === Object(this.props.width) ? JSON.stringify(this.props.width) : this.props.width,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsMap;
}(React.Component);
MdsMap.propTypes = {
  // Values
  apiKey: PropTypes.string,
  defaultZoom: CustomPropTypes.integer,
  defaultCenter: PropTypes.array,
  restrictedBounds: PropTypes.object,
  markerIcon: PropTypes.string,
  accessibleText: PropTypes.string,
  zoomInAccessibleText: PropTypes.string,
  zoomOutAccessibleText: PropTypes.string,
  brand: PropTypes.string,
  channel: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyup: PropTypes.func,
  onKeydown: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func,
  onMapready: PropTypes.func,
  onMaprendered: PropTypes.func
};
MdsMap.defaultProps = {
  defaultZoom: 10,
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onKeyup: null,
  onKeydown: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null,
  onMapready: null,
  onMaprendered: null
};

var MdsMapMarker = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsMapMarker, _React$Component);

  var _super = _createSuper(MdsMapMarker);

  function MdsMapMarker(props) {
    var _this;

    _classCallCheck(this, MdsMapMarker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onFocus) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onFocus(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onBlur) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onBlur(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseup) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseout) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchstart", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onTouchstart) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onTouchstart(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onTouchend", function (event) {
      var _this$props19, _this$props20;

      ((_this$props19 = _this.props) === null || _this$props19 === void 0 ? void 0 : _this$props19.onTouchend) && ((_this$props20 = _this.props) === null || _this$props20 === void 0 ? void 0 : _this$props20.onTouchend(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onOpen", function (event) {
      var _this$props21, _this$props22;

      ((_this$props21 = _this.props) === null || _this$props21 === void 0 ? void 0 : _this$props21.onOpen) && ((_this$props22 = _this.props) === null || _this$props22 === void 0 ? void 0 : _this$props22.onOpen(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClose", function (event) {
      var _this$props23, _this$props24;

      ((_this$props23 = _this.props) === null || _this$props23 === void 0 ? void 0 : _this$props23.onClose) && ((_this$props24 = _this.props) === null || _this$props24 === void 0 ? void 0 : _this$props24.onClose(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onTouchstart = _this._onTouchstart.bind(_assertThisInitialized(_this));
    _this._onTouchend = _this._onTouchend.bind(_assertThisInitialized(_this));
    _this._onOpen = _this._onOpen.bind(_assertThisInitialized(_this));
    _this._onClose = _this._onClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsMapMarker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("focus", this._onFocus);

      this._ref.current.addEventListener("blur", this._onBlur);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("touchstart", this._onTouchstart);

      this._ref.current.addEventListener("touchend", this._onTouchend);

      this._ref.current.addEventListener("open", this._onOpen);

      this._ref.current.addEventListener("close", this._onClose);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("focus", this._onFocus);

      this._ref.current.removeEventListener("blur", this._onBlur);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("touchstart", this._onTouchstart);

      this._ref.current.removeEventListener("touchend", this._onTouchend);

      this._ref.current.removeEventListener("open", this._onOpen);

      this._ref.current.removeEventListener("close", this._onClose);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-map-marker", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        latitude: Array.isArray(this.props.latitude) || this.props.latitude === Object(this.props.latitude) ? JSON.stringify(this.props.latitude) : this.props.latitude,
        longitude: Array.isArray(this.props.longitude) || this.props.longitude === Object(this.props.longitude) ? JSON.stringify(this.props.longitude) : this.props.longitude,
        address: Array.isArray(this.props.address) || this.props.address === Object(this.props.address) ? JSON.stringify(this.props.address) : this.props.address,
        icon: Array.isArray(this.props.icon) || this.props.icon === Object(this.props.icon) ? JSON.stringify(this.props.icon) : this.props.icon,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "landmark-detail": Array.isArray(this.props.landmarkDetail) || this.props.landmarkDetail === Object(this.props.landmarkDetail) ? JSON.stringify(this.props.landmarkDetail) : this.props.landmarkDetail,
        "landmark-title": Array.isArray(this.props.landmarkTitle) || this.props.landmarkTitle === Object(this.props.landmarkTitle) ? JSON.stringify(this.props.landmarkTitle) : this.props.landmarkTitle,
        "overlay-width": Array.isArray(this.props.overlayWidth) || this.props.overlayWidth === Object(this.props.overlayWidth) ? JSON.stringify(this.props.overlayWidth) : this.props.overlayWidth,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        state: this.props.state // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsMapMarker;
}(React.Component);
MdsMapMarker.propTypes = {
  // Values
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  address: PropTypes.string,
  icon: PropTypes.string,
  brand: PropTypes.string,
  landmarkDetail: PropTypes.string,
  landmarkTitle: PropTypes.string,
  overlayWidth: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  state: PropTypes.oneOf(["focused", "active"]),
  // Events
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func,
  onTouchstart: PropTypes.func,
  onTouchend: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};
MdsMapMarker.defaultProps = {
  // Events
  onClick: null,
  onFocus: null,
  onBlur: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null,
  onTouchstart: null,
  onTouchend: null,
  onOpen: null,
  onClose: null
};

var MdsMapStatic = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsMapStatic, _React$Component);

  var _super = _createSuper(MdsMapStatic);

  function MdsMapStatic() {
    _classCallCheck(this, MdsMapStatic);

    return _super.apply(this, arguments);
  }

  _createClass(MdsMapStatic, [{
    key: "render",
    value: function render() {
      var _this = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-map-static", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "api-key": Array.isArray(this.props.apiKey) || this.props.apiKey === Object(this.props.apiKey) ? JSON.stringify(this.props.apiKey) : this.props.apiKey,
        "accessible-text": Array.isArray(this.props.accessibleText) || this.props.accessibleText === Object(this.props.accessibleText) ? JSON.stringify(this.props.accessibleText) : this.props.accessibleText,
        "accessible-description": Array.isArray(this.props.accessibleDescription) || this.props.accessibleDescription === Object(this.props.accessibleDescription) ? JSON.stringify(this.props.accessibleDescription) : this.props.accessibleDescription,
        "center-address": Array.isArray(this.props.centerAddress) || this.props.centerAddress === Object(this.props.centerAddress) ? JSON.stringify(this.props.centerAddress) : this.props.centerAddress,
        "center-coordinates": Array.isArray(this.props.centerCoordinates) || this.props.centerCoordinates === Object(this.props.centerCoordinates) ? JSON.stringify(this.props.centerCoordinates) : this.props.centerCoordinates,
        format: Array.isArray(this.props.format) || this.props.format === Object(this.props.format) ? JSON.stringify(this.props.format) : this.props.format,
        scale: Array.isArray(this.props.scale) || this.props.scale === Object(this.props.scale) ? JSON.stringify(this.props.scale) : this.props.scale,
        zoom: Array.isArray(this.props.zoom) || this.props.zoom === Object(this.props.zoom) ? JSON.stringify(this.props.zoom) : this.props.zoom,
        height: Array.isArray(this.props.height) || this.props.height === Object(this.props.height) ? JSON.stringify(this.props.height) : this.props.height,
        width: Array.isArray(this.props.width) || this.props.width === Object(this.props.width) ? JSON.stringify(this.props.width) : this.props.width,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "manual-initial-render": Array.isArray(this.props.manualInitialRender) || this.props.manualInitialRender === Object(this.props.manualInitialRender) ? JSON.stringify(this.props.manualInitialRender) : this.props.manualInitialRender,
        channel: Array.isArray(this.props.channel) || this.props.channel === Object(this.props.channel) ? JSON.stringify(this.props.channel) : this.props.channel,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        markers: Array.isArray(this.props.markers) || this.props.markers === Object(this.props.markers) ? JSON.stringify(this.props.markers) : this.props.markers //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsMapStatic;
}(React.Component);
MdsMapStatic.propTypes = {
  // Values
  apiKey: PropTypes.string,
  accessibleText: PropTypes.string,
  accessibleDescription: PropTypes.string,
  centerAddress: PropTypes.string,
  centerCoordinates: PropTypes.array,
  format: PropTypes.oneOf(["png", "png32", "jpg", "gif"]),
  scale: PropTypes.oneOf([1, 2]),
  zoom: CustomPropTypes.integer,
  height: CustomPropTypes.integer,
  width: CustomPropTypes.integer,
  brand: PropTypes.string,
  manualInitialRender: PropTypes.string,
  channel: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  markers: PropTypes.arrayOf(CustomPropTypes.slot)
};
MdsMapStatic.defaultProps = {
  format: "png",
  scale: "2",
  zoom: 10,
  height: 128,
  width: 128
};

var MdsProjectionBarChart = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsProjectionBarChart, _React$Component);

  var _super = _createSuper(MdsProjectionBarChart);

  function MdsProjectionBarChart(props) {
    var _this;

    _classCallCheck(this, MdsProjectionBarChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTabChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTabChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTabChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onAccessibleAlternativeLinkPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onAccessibleAlternativeLinkPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onAccessibleAlternativeLinkPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onExpandFullScreenButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onExpandFullScreenButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onExpandFullScreenButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onClick) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTabChange = _this._onTabChange.bind(_assertThisInitialized(_this));
    _this._onAccessibleAlternativeLinkPress = _this._onAccessibleAlternativeLinkPress.bind(_assertThisInitialized(_this));
    _this._onExpandFullScreenButtonPress = _this._onExpandFullScreenButtonPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsProjectionBarChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("tabChange", this._onTabChange);

      this._ref.current.addEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.addEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("tabChange", this._onTabChange);

      this._ref.current.removeEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.removeEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-projection-bar-chart", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "short-description": Array.isArray(this.props.shortDescription) || this.props.shortDescription === Object(this.props.shortDescription) ? JSON.stringify(this.props.shortDescription) : this.props.shortDescription,
        "chart-title": Array.isArray(this.props.chartTitle) || this.props.chartTitle === Object(this.props.chartTitle) ? JSON.stringify(this.props.chartTitle) : this.props.chartTitle,
        "show-full-screen-button": Array.isArray(this.props.showFullScreenButton) || this.props.showFullScreenButton === Object(this.props.showFullScreenButton) ? JSON.stringify(this.props.showFullScreenButton) : this.props.showFullScreenButton,
        "accessible-alternative-link-text": Array.isArray(this.props.accessibleAlternativeLinkText) || this.props.accessibleAlternativeLinkText === Object(this.props.accessibleAlternativeLinkText) ? JSON.stringify(this.props.accessibleAlternativeLinkText) : this.props.accessibleAlternativeLinkText,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        "d3-legend-format-string": Array.isArray(this.props.d3LegendFormatString) || this.props.d3LegendFormatString === Object(this.props.d3LegendFormatString) ? JSON.stringify(this.props.d3LegendFormatString) : this.props.d3LegendFormatString,
        "d3-bar-label-format-string": Array.isArray(this.props.d3BarLabelFormatString) || this.props.d3BarLabelFormatString === Object(this.props.d3BarLabelFormatString) ? JSON.stringify(this.props.d3BarLabelFormatString) : this.props.d3BarLabelFormatString,
        "d3-prefix-formatter": Array.isArray(this.props.d3PrefixFormatter) || this.props.d3PrefixFormatter === Object(this.props.d3PrefixFormatter) ? JSON.stringify(this.props.d3PrefixFormatter) : this.props.d3PrefixFormatter,
        "d3-data-point-detail-x-format-string": Array.isArray(this.props.d3DataPointDetailXFormatString) || this.props.d3DataPointDetailXFormatString === Object(this.props.d3DataPointDetailXFormatString) ? JSON.stringify(this.props.d3DataPointDetailXFormatString) : this.props.d3DataPointDetailXFormatString,
        "d3-data-point-detail-y-format-string": Array.isArray(this.props.d3DataPointDetailYFormatString) || this.props.d3DataPointDetailYFormatString === Object(this.props.d3DataPointDetailYFormatString) ? JSON.stringify(this.props.d3DataPointDetailYFormatString) : this.props.d3DataPointDetailYFormatString,
        "chart-height": Array.isArray(this.props.chartHeight) || this.props.chartHeight === Object(this.props.chartHeight) ? JSON.stringify(this.props.chartHeight) : this.props.chartHeight,
        "graph-width": Array.isArray(this.props.graphWidth) || this.props.graphWidth === Object(this.props.graphWidth) ? JSON.stringify(this.props.graphWidth) : this.props.graphWidth,
        "graph-height": Array.isArray(this.props.graphHeight) || this.props.graphHeight === Object(this.props.graphHeight) ? JSON.stringify(this.props.graphHeight) : this.props.graphHeight,
        "legend-width": Array.isArray(this.props.legendWidth) || this.props.legendWidth === Object(this.props.legendWidth) ? JSON.stringify(this.props.legendWidth) : this.props.legendWidth,
        "high-projection-bar-width": Array.isArray(this.props.highProjectionBarWidth) || this.props.highProjectionBarWidth === Object(this.props.highProjectionBarWidth) ? JSON.stringify(this.props.highProjectionBarWidth) : this.props.highProjectionBarWidth,
        "legend-label": Array.isArray(this.props.legendLabel) || this.props.legendLabel === Object(this.props.legendLabel) ? JSON.stringify(this.props.legendLabel) : this.props.legendLabel,
        "current-measure-bar-background-color": Array.isArray(this.props.currentMeasureBarBackgroundColor) || this.props.currentMeasureBarBackgroundColor === Object(this.props.currentMeasureBarBackgroundColor) ? JSON.stringify(this.props.currentMeasureBarBackgroundColor) : this.props.currentMeasureBarBackgroundColor,
        message: Array.isArray(this.props.message) || this.props.message === Object(this.props.message) ? JSON.stringify(this.props.message) : this.props.message,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "full-screen-button-alternative-text": Array.isArray(this.props.fullScreenButtonAlternativeText) || this.props.fullScreenButtonAlternativeText === Object(this.props.fullScreenButtonAlternativeText) ? JSON.stringify(this.props.fullScreenButtonAlternativeText) : this.props.fullScreenButtonAlternativeText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        tabs: Array.isArray(this.props.tabs) || this.props.tabs === Object(this.props.tabs) ? JSON.stringify(this.props.tabs) : this.props.tabs,
        bars: Array.isArray(this.props.bars) || this.props.bars === Object(this.props.bars) ? JSON.stringify(this.props.bars) : this.props.bars // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsProjectionBarChart;
}(React.Component);
MdsProjectionBarChart.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  shortDescription: PropTypes.string,
  chartTitle: PropTypes.string,
  showFullScreenButton: PropTypes.bool,
  accessibleAlternativeLinkText: PropTypes.string,
  noDataPointText: PropTypes.string,
  d3LegendFormatString: PropTypes.string,
  d3BarLabelFormatString: PropTypes.string,
  d3PrefixFormatter: PropTypes.bool,
  d3DataPointDetailXFormatString: PropTypes.string,
  d3DataPointDetailYFormatString: PropTypes.string,
  chartHeight: CustomPropTypes.integer,
  graphWidth: CustomPropTypes.integer,
  graphHeight: CustomPropTypes.integer,
  legendWidth: PropTypes.number,
  highProjectionBarWidth: CustomPropTypes.integer,
  legendLabel: PropTypes.string,
  currentMeasureBarBackgroundColor: PropTypes.string,
  message: PropTypes.string,
  brand: PropTypes.string,
  fullScreenButtonAlternativeText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  tabs: CustomPropTypes.slot,
  bars: CustomPropTypes.slot,
  // Events
  onTabChange: PropTypes.func,
  onAccessibleAlternativeLinkPress: PropTypes.func,
  onExpandFullScreenButtonPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onClick: PropTypes.func
};
MdsProjectionBarChart.defaultProps = {
  showFullScreenButton: false,
  noDataPointText: "Chart temporarily unavailable.",
  d3PrefixFormatter: false,
  highProjectionBarWidth: 150,
  // Events
  onTabChange: null,
  onAccessibleAlternativeLinkPress: null,
  onExpandFullScreenButtonPress: null,
  onMousedown: null,
  onMouseout: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onClick: null
};

var MdsProjectionChart = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsProjectionChart, _React$Component);

  var _super = _createSuper(MdsProjectionChart);

  function MdsProjectionChart(props) {
    var _this;

    _classCallCheck(this, MdsProjectionChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTabChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTabChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTabChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onAccessibleAlternativeLinkPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onAccessibleAlternativeLinkPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onAccessibleAlternativeLinkPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onExpandFullScreenButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onExpandFullScreenButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onExpandFullScreenButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onClick) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTabChange = _this._onTabChange.bind(_assertThisInitialized(_this));
    _this._onAccessibleAlternativeLinkPress = _this._onAccessibleAlternativeLinkPress.bind(_assertThisInitialized(_this));
    _this._onExpandFullScreenButtonPress = _this._onExpandFullScreenButtonPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsProjectionChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("tabChange", this._onTabChange);

      this._ref.current.addEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.addEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("tabChange", this._onTabChange);

      this._ref.current.removeEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.removeEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-projection-chart", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "short-description": Array.isArray(this.props.shortDescription) || this.props.shortDescription === Object(this.props.shortDescription) ? JSON.stringify(this.props.shortDescription) : this.props.shortDescription,
        "chart-title": Array.isArray(this.props.chartTitle) || this.props.chartTitle === Object(this.props.chartTitle) ? JSON.stringify(this.props.chartTitle) : this.props.chartTitle,
        "show-full-screen-button": Array.isArray(this.props.showFullScreenButton) || this.props.showFullScreenButton === Object(this.props.showFullScreenButton) ? JSON.stringify(this.props.showFullScreenButton) : this.props.showFullScreenButton,
        "accessible-alternative-link-text": Array.isArray(this.props.accessibleAlternativeLinkText) || this.props.accessibleAlternativeLinkText === Object(this.props.accessibleAlternativeLinkText) ? JSON.stringify(this.props.accessibleAlternativeLinkText) : this.props.accessibleAlternativeLinkText,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        "d3-legend-format-string": Array.isArray(this.props.d3LegendFormatString) || this.props.d3LegendFormatString === Object(this.props.d3LegendFormatString) ? JSON.stringify(this.props.d3LegendFormatString) : this.props.d3LegendFormatString,
        "d3-bar-label-format-string": Array.isArray(this.props.d3BarLabelFormatString) || this.props.d3BarLabelFormatString === Object(this.props.d3BarLabelFormatString) ? JSON.stringify(this.props.d3BarLabelFormatString) : this.props.d3BarLabelFormatString,
        "d3-prefix-formatter": Array.isArray(this.props.d3PrefixFormatter) || this.props.d3PrefixFormatter === Object(this.props.d3PrefixFormatter) ? JSON.stringify(this.props.d3PrefixFormatter) : this.props.d3PrefixFormatter,
        "d3-data-point-detail-x-format-string": Array.isArray(this.props.d3DataPointDetailXFormatString) || this.props.d3DataPointDetailXFormatString === Object(this.props.d3DataPointDetailXFormatString) ? JSON.stringify(this.props.d3DataPointDetailXFormatString) : this.props.d3DataPointDetailXFormatString,
        "d3-data-point-detail-y-format-string": Array.isArray(this.props.d3DataPointDetailYFormatString) || this.props.d3DataPointDetailYFormatString === Object(this.props.d3DataPointDetailYFormatString) ? JSON.stringify(this.props.d3DataPointDetailYFormatString) : this.props.d3DataPointDetailYFormatString,
        "chart-height": Array.isArray(this.props.chartHeight) || this.props.chartHeight === Object(this.props.chartHeight) ? JSON.stringify(this.props.chartHeight) : this.props.chartHeight,
        "legend-heading-prefix": Array.isArray(this.props.legendHeadingPrefix) || this.props.legendHeadingPrefix === Object(this.props.legendHeadingPrefix) ? JSON.stringify(this.props.legendHeadingPrefix) : this.props.legendHeadingPrefix,
        "legend-heading-suffix-singular": Array.isArray(this.props.legendHeadingSuffixSingular) || this.props.legendHeadingSuffixSingular === Object(this.props.legendHeadingSuffixSingular) ? JSON.stringify(this.props.legendHeadingSuffixSingular) : this.props.legendHeadingSuffixSingular,
        "legend-heading-suffix-plural": Array.isArray(this.props.legendHeadingSuffixPlural) || this.props.legendHeadingSuffixPlural === Object(this.props.legendHeadingSuffixPlural) ? JSON.stringify(this.props.legendHeadingSuffixPlural) : this.props.legendHeadingSuffixPlural,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "full-screen-button-alternative-text": Array.isArray(this.props.fullScreenButtonAlternativeText) || this.props.fullScreenButtonAlternativeText === Object(this.props.fullScreenButtonAlternativeText) ? JSON.stringify(this.props.fullScreenButtonAlternativeText) : this.props.fullScreenButtonAlternativeText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        tabs: Array.isArray(this.props.tabs) || this.props.tabs === Object(this.props.tabs) ? JSON.stringify(this.props.tabs) : this.props.tabs,
        lines: Array.isArray(this.props.lines) || this.props.lines === Object(this.props.lines) ? JSON.stringify(this.props.lines) : this.props.lines,
        "x-axis": Array.isArray(this.props.xAxis) || this.props.xAxis === Object(this.props.xAxis) ? JSON.stringify(this.props.xAxis) : this.props.xAxis,
        "y-axis": Array.isArray(this.props.yAxis) || this.props.yAxis === Object(this.props.yAxis) ? JSON.stringify(this.props.yAxis) : this.props.yAxis // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsProjectionChart;
}(React.Component);
MdsProjectionChart.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  shortDescription: PropTypes.string,
  chartTitle: PropTypes.string,
  showFullScreenButton: PropTypes.bool,
  accessibleAlternativeLinkText: PropTypes.string,
  noDataPointText: PropTypes.string,
  d3LegendFormatString: PropTypes.string,
  d3BarLabelFormatString: PropTypes.string,
  d3PrefixFormatter: PropTypes.bool,
  d3DataPointDetailXFormatString: PropTypes.string,
  d3DataPointDetailYFormatString: PropTypes.string,
  chartHeight: CustomPropTypes.integer,
  legendHeadingPrefix: PropTypes.string,
  legendHeadingSuffixSingular: PropTypes.string,
  legendHeadingSuffixPlural: PropTypes.string,
  brand: PropTypes.string,
  fullScreenButtonAlternativeText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  tabs: CustomPropTypes.slot,
  lines: PropTypes.arrayOf(CustomPropTypes.slot),
  xAxis: CustomPropTypes.slot,
  yAxis: CustomPropTypes.slot,
  // Events
  onTabChange: PropTypes.func,
  onAccessibleAlternativeLinkPress: PropTypes.func,
  onExpandFullScreenButtonPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onClick: PropTypes.func
};
MdsProjectionChart.defaultProps = {
  showFullScreenButton: false,
  noDataPointText: "Chart temporarily unavailable.",
  d3PrefixFormatter: false,
  // Events
  onTabChange: null,
  onAccessibleAlternativeLinkPress: null,
  onExpandFullScreenButtonPress: null,
  onMousedown: null,
  onMouseout: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onClick: null
};

var MdsProjectionLineChart = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsProjectionLineChart, _React$Component);

  var _super = _createSuper(MdsProjectionLineChart);

  function MdsProjectionLineChart(props) {
    var _this;

    _classCallCheck(this, MdsProjectionLineChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onTabChange", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onTabChange) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onTabChange(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onAccessibleAlternativeLinkPress", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onAccessibleAlternativeLinkPress) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onAccessibleAlternativeLinkPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onExpandFullScreenButtonPress", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onExpandFullScreenButtonPress) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onExpandFullScreenButtonPress(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMousedown) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseout) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseout(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseover) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props13, _this$props14;

      ((_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.onMouseenter) && ((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props15, _this$props16;

      ((_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.onMouseup) && ((_this$props16 = _this.props) === null || _this$props16 === void 0 ? void 0 : _this$props16.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props17, _this$props18;

      ((_this$props17 = _this.props) === null || _this$props17 === void 0 ? void 0 : _this$props17.onClick) && ((_this$props18 = _this.props) === null || _this$props18 === void 0 ? void 0 : _this$props18.onClick(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onTabChange = _this._onTabChange.bind(_assertThisInitialized(_this));
    _this._onAccessibleAlternativeLinkPress = _this._onAccessibleAlternativeLinkPress.bind(_assertThisInitialized(_this));
    _this._onExpandFullScreenButtonPress = _this._onExpandFullScreenButtonPress.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsProjectionLineChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("tabChange", this._onTabChange);

      this._ref.current.addEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.addEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseout", this._onMouseout);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("click", this._onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("tabChange", this._onTabChange);

      this._ref.current.removeEventListener("accessibleAlternativeLinkPress", this._onAccessibleAlternativeLinkPress);

      this._ref.current.removeEventListener("expandFullScreenButtonPress", this._onExpandFullScreenButtonPress);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("click", this._onClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-projection-line-chart", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "short-description": Array.isArray(this.props.shortDescription) || this.props.shortDescription === Object(this.props.shortDescription) ? JSON.stringify(this.props.shortDescription) : this.props.shortDescription,
        "chart-title": Array.isArray(this.props.chartTitle) || this.props.chartTitle === Object(this.props.chartTitle) ? JSON.stringify(this.props.chartTitle) : this.props.chartTitle,
        "show-full-screen-button": Array.isArray(this.props.showFullScreenButton) || this.props.showFullScreenButton === Object(this.props.showFullScreenButton) ? JSON.stringify(this.props.showFullScreenButton) : this.props.showFullScreenButton,
        "accessible-alternative-link-text": Array.isArray(this.props.accessibleAlternativeLinkText) || this.props.accessibleAlternativeLinkText === Object(this.props.accessibleAlternativeLinkText) ? JSON.stringify(this.props.accessibleAlternativeLinkText) : this.props.accessibleAlternativeLinkText,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        "d3-legend-format-string": Array.isArray(this.props.d3LegendFormatString) || this.props.d3LegendFormatString === Object(this.props.d3LegendFormatString) ? JSON.stringify(this.props.d3LegendFormatString) : this.props.d3LegendFormatString,
        "d3-bar-label-format-string": Array.isArray(this.props.d3BarLabelFormatString) || this.props.d3BarLabelFormatString === Object(this.props.d3BarLabelFormatString) ? JSON.stringify(this.props.d3BarLabelFormatString) : this.props.d3BarLabelFormatString,
        "d3-prefix-formatter": Array.isArray(this.props.d3PrefixFormatter) || this.props.d3PrefixFormatter === Object(this.props.d3PrefixFormatter) ? JSON.stringify(this.props.d3PrefixFormatter) : this.props.d3PrefixFormatter,
        "d3-data-point-detail-x-format-string": Array.isArray(this.props.d3DataPointDetailXFormatString) || this.props.d3DataPointDetailXFormatString === Object(this.props.d3DataPointDetailXFormatString) ? JSON.stringify(this.props.d3DataPointDetailXFormatString) : this.props.d3DataPointDetailXFormatString,
        "d3-data-point-detail-y-format-string": Array.isArray(this.props.d3DataPointDetailYFormatString) || this.props.d3DataPointDetailYFormatString === Object(this.props.d3DataPointDetailYFormatString) ? JSON.stringify(this.props.d3DataPointDetailYFormatString) : this.props.d3DataPointDetailYFormatString,
        "chart-height": Array.isArray(this.props.chartHeight) || this.props.chartHeight === Object(this.props.chartHeight) ? JSON.stringify(this.props.chartHeight) : this.props.chartHeight,
        "legend-heading-prefix": Array.isArray(this.props.legendHeadingPrefix) || this.props.legendHeadingPrefix === Object(this.props.legendHeadingPrefix) ? JSON.stringify(this.props.legendHeadingPrefix) : this.props.legendHeadingPrefix,
        "legend-heading-suffix-singular": Array.isArray(this.props.legendHeadingSuffixSingular) || this.props.legendHeadingSuffixSingular === Object(this.props.legendHeadingSuffixSingular) ? JSON.stringify(this.props.legendHeadingSuffixSingular) : this.props.legendHeadingSuffixSingular,
        "legend-heading-suffix-plural": Array.isArray(this.props.legendHeadingSuffixPlural) || this.props.legendHeadingSuffixPlural === Object(this.props.legendHeadingSuffixPlural) ? JSON.stringify(this.props.legendHeadingSuffixPlural) : this.props.legendHeadingSuffixPlural,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        "full-screen-button-alternative-text": Array.isArray(this.props.fullScreenButtonAlternativeText) || this.props.fullScreenButtonAlternativeText === Object(this.props.fullScreenButtonAlternativeText) ? JSON.stringify(this.props.fullScreenButtonAlternativeText) : this.props.fullScreenButtonAlternativeText,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        tabs: Array.isArray(this.props.tabs) || this.props.tabs === Object(this.props.tabs) ? JSON.stringify(this.props.tabs) : this.props.tabs,
        lines: Array.isArray(this.props.lines) || this.props.lines === Object(this.props.lines) ? JSON.stringify(this.props.lines) : this.props.lines,
        "x-axis": Array.isArray(this.props.xAxis) || this.props.xAxis === Object(this.props.xAxis) ? JSON.stringify(this.props.xAxis) : this.props.xAxis,
        "y-axis": Array.isArray(this.props.yAxis) || this.props.yAxis === Object(this.props.yAxis) ? JSON.stringify(this.props.yAxis) : this.props.yAxis // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsProjectionLineChart;
}(React.Component);
MdsProjectionLineChart.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  shortDescription: PropTypes.string,
  chartTitle: PropTypes.string,
  showFullScreenButton: PropTypes.bool,
  accessibleAlternativeLinkText: PropTypes.string,
  noDataPointText: PropTypes.string,
  d3LegendFormatString: PropTypes.string,
  d3BarLabelFormatString: PropTypes.string,
  d3PrefixFormatter: PropTypes.bool,
  d3DataPointDetailXFormatString: PropTypes.string,
  d3DataPointDetailYFormatString: PropTypes.string,
  chartHeight: CustomPropTypes.integer,
  legendHeadingPrefix: PropTypes.string,
  legendHeadingSuffixSingular: PropTypes.string,
  legendHeadingSuffixPlural: PropTypes.string,
  brand: PropTypes.string,
  fullScreenButtonAlternativeText: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  tabs: CustomPropTypes.slot,
  lines: PropTypes.arrayOf(CustomPropTypes.slot),
  xAxis: CustomPropTypes.slot,
  yAxis: CustomPropTypes.slot,
  // Events
  onTabChange: PropTypes.func,
  onAccessibleAlternativeLinkPress: PropTypes.func,
  onExpandFullScreenButtonPress: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseout: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseup: PropTypes.func,
  onClick: PropTypes.func
};
MdsProjectionLineChart.defaultProps = {
  showFullScreenButton: false,
  noDataPointText: "Chart temporarily unavailable.",
  d3PrefixFormatter: false,
  // Events
  onTabChange: null,
  onAccessibleAlternativeLinkPress: null,
  onExpandFullScreenButtonPress: null,
  onMousedown: null,
  onMouseout: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseup: null,
  onClick: null
};

var MdsSparkline = /*#__PURE__*/function (_React$Component) {
  _inherits(MdsSparkline, _React$Component);

  var _super = _createSuper(MdsSparkline);

  function MdsSparkline(props) {
    var _this;

    _classCallCheck(this, MdsSparkline);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (event) {
      var _this$props, _this$props2;

      ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onClick) && ((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onClick(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMousedown", function (event) {
      var _this$props3, _this$props4;

      ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMousedown) && ((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.onMousedown(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseup", function (event) {
      var _this$props5, _this$props6;

      ((_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.onMouseup) && ((_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.onMouseup(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseover", function (event) {
      var _this$props7, _this$props8;

      ((_this$props7 = _this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.onMouseover) && ((_this$props8 = _this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.onMouseover(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseenter", function (event) {
      var _this$props9, _this$props10;

      ((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.onMouseenter) && ((_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.onMouseenter(event));
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseout", function (event) {
      var _this$props11, _this$props12;

      ((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.onMouseout) && ((_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.onMouseout(event));
    });

    _this._ref = /*#__PURE__*/React.createRef(); // Add event binder

    _this._onClick = _this._onClick.bind(_assertThisInitialized(_this));
    _this._onMousedown = _this._onMousedown.bind(_assertThisInitialized(_this));
    _this._onMouseup = _this._onMouseup.bind(_assertThisInitialized(_this));
    _this._onMouseover = _this._onMouseover.bind(_assertThisInitialized(_this));
    _this._onMouseenter = _this._onMouseenter.bind(_assertThisInitialized(_this));
    _this._onMouseout = _this._onMouseout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MdsSparkline, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add event Listeners
      this._ref.current.addEventListener("click", this._onClick);

      this._ref.current.addEventListener("mousedown", this._onMousedown);

      this._ref.current.addEventListener("mouseup", this._onMouseup);

      this._ref.current.addEventListener("mouseover", this._onMouseover);

      this._ref.current.addEventListener("mouseenter", this._onMouseenter);

      this._ref.current.addEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event Listeners
      this._ref.current.removeEventListener("click", this._onClick);

      this._ref.current.removeEventListener("mousedown", this._onMousedown);

      this._ref.current.removeEventListener("mouseup", this._onMouseup);

      this._ref.current.removeEventListener("mouseover", this._onMouseover);

      this._ref.current.removeEventListener("mouseenter", this._onMouseenter);

      this._ref.current.removeEventListener("mouseout", this._onMouseout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {// Update any imperative states, like "open".
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Add data attributes to pass-through to the web component.
      var dataProps = Object.keys(this.props).reduce(function (result, propKey) {
        if (propKey.startsWith('data-')) {
          result[propKey] = _this2.props[propKey];
        }

        return result;
      }, {});
      return /*#__PURE__*/jsx("mds-sparkline", _objectSpread2(_objectSpread2({
        ref: this._ref // values
        ,
        "accessible-name": Array.isArray(this.props.accessibleName) || this.props.accessibleName === Object(this.props.accessibleName) ? JSON.stringify(this.props.accessibleName) : this.props.accessibleName,
        "accessible-description": Array.isArray(this.props.accessibleDescription) || this.props.accessibleDescription === Object(this.props.accessibleDescription) ? JSON.stringify(this.props.accessibleDescription) : this.props.accessibleDescription,
        "line-color": Array.isArray(this.props.lineColor) || this.props.lineColor === Object(this.props.lineColor) ? JSON.stringify(this.props.lineColor) : this.props.lineColor,
        "reference-line-value": Array.isArray(this.props.referenceLineValue) || this.props.referenceLineValue === Object(this.props.referenceLineValue) ? JSON.stringify(this.props.referenceLineValue) : this.props.referenceLineValue,
        "final-value-point": Array.isArray(this.props.finalValuePoint) || this.props.finalValuePoint === Object(this.props.finalValuePoint) ? JSON.stringify(this.props.finalValuePoint) : this.props.finalValuePoint,
        "final-value-point-color": Array.isArray(this.props.finalValuePointColor) || this.props.finalValuePointColor === Object(this.props.finalValuePointColor) ? JSON.stringify(this.props.finalValuePointColor) : this.props.finalValuePointColor,
        "x-range": Array.isArray(this.props.xRange) || this.props.xRange === Object(this.props.xRange) ? JSON.stringify(this.props.xRange) : this.props.xRange,
        "y-range": Array.isArray(this.props.yRange) || this.props.yRange === Object(this.props.yRange) ? JSON.stringify(this.props.yRange) : this.props.yRange,
        "no-data-point-text": Array.isArray(this.props.noDataPointText) || this.props.noDataPointText === Object(this.props.noDataPointText) ? JSON.stringify(this.props.noDataPointText) : this.props.noDataPointText,
        "chart-height": Array.isArray(this.props.chartHeight) || this.props.chartHeight === Object(this.props.chartHeight) ? JSON.stringify(this.props.chartHeight) : this.props.chartHeight,
        brand: Array.isArray(this.props.brand) || this.props.brand === Object(this.props.brand) ? JSON.stringify(this.props.brand) : this.props.brand,
        id: Array.isArray(this.props.id) || this.props.id === Object(this.props.id) ? JSON.stringify(this.props.id) : this.props.id,
        slot: Array.isArray(this.props.slot) || this.props.slot === Object(this.props.slot) ? JSON.stringify(this.props.slot) : this.props.slot,
        "data-points": Array.isArray(this.props.dataPoints) || this.props.dataPoints === Object(this.props.dataPoints) ? JSON.stringify(this.props.dataPoints) : this.props.dataPoints // Events
        // TODO: Currently, there is an issue passing event callback as props,
        // so for now, we use addEventListender for ALL events.
        //
        // Data attribs pass-through

      }, dataProps), {}, {
        children: this.props.children
      }));
    }
  }]);

  return MdsSparkline;
}(React.Component);
MdsSparkline.propTypes = {
  // Values
  accessibleName: PropTypes.string,
  accessibleDescription: PropTypes.string,
  lineColor: PropTypes.oneOf(["base", "gain", "loss", "brand"]),
  referenceLineValue: PropTypes.number,
  finalValuePoint: PropTypes.bool,
  finalValuePointColor: PropTypes.oneOf(["base", "gain", "loss", "brand"]),
  xRange: PropTypes.array,
  yRange: PropTypes.array,
  noDataPointText: PropTypes.string,
  chartHeight: CustomPropTypes.integer,
  brand: PropTypes.string,
  id: PropTypes.string,
  slot: PropTypes.string,
  dataPoints: PropTypes.arrayOf(CustomPropTypes.slot),
  // Events
  onClick: PropTypes.func,
  onMousedown: PropTypes.func,
  onMouseup: PropTypes.func,
  onMouseover: PropTypes.func,
  onMouseenter: PropTypes.func,
  onMouseout: PropTypes.func
};
MdsSparkline.defaultProps = {
  lineColor: "base",
  finalValuePointColor: "base",
  // Events
  onClick: null,
  onMousedown: null,
  onMouseup: null,
  onMouseover: null,
  onMouseenter: null,
  onMouseout: null
};

export { MdsAccordion, MdsAccordionItem, MdsAlert, MdsAreaChart, MdsAvatarBanner, MdsBadge, MdsBanner, MdsBannerForEmployeeMessaging, MdsBarChart, MdsBarChartSegmented, MdsBarChartSelectable, MdsBottomSheet, MdsBottomSheetDialog, MdsBrandBar, MdsBreadcrumb, MdsBulletChart, MdsButton, MdsCalendar, MdsCallout, MdsCarousel, MdsCashFlowChart, MdsChatBubble, MdsChatInput, MdsCheckbox, MdsComboButton, MdsCommerceTile, MdsComparisonTable, MdsDataTableActionBar, MdsDataTableForAccounts, MdsDataTableForChart, MdsDataTableForFiles, MdsDataTableForSecurities, MdsDataTableForTransactions, MdsDataTableSimple, MdsDateBadge, MdsDatepicker, MdsDefinitionLink, MdsDescriptionList, MdsDialog, MdsDocumentViewer, MdsDonutChart, MdsDropZone, MdsExpandableText, MdsFieldset, MdsFlyout, MdsGaugeChartLinear, MdsGaugeChartRadial, MdsHeroHeader, MdsIcon, MdsImage, MdsInlineForm, MdsInlineInput, MdsInlineSelect, MdsLineChart, MdsLink, MdsList, MdsListItem, MdsLoadMore, MdsLoadingBubble, MdsMap, MdsMapMarker, MdsMapStatic, MdsMenu, MdsMenuButton, MdsMessageDrawer, MdsMultiselect, MdsMultiselectOption, MdsNavigationBar, MdsNavigationBarBottom, MdsNavigationBarItem, MdsNavigationBarMenu, MdsNavigationBarMenuItem, MdsProgressBar, MdsProgressBarRadial, MdsProgressSpinner, MdsProgressSpinnerInline, MdsProgressSteps, MdsProjectionBarChart, MdsProjectionChart, MdsProjectionLineChart, MdsQuickActionBar, MdsQuickReplyBar, MdsQuickReplyButton, MdsRadioGroup, MdsRatingIndicator, MdsSearchBox, MdsSelect, MdsSelectOption, MdsSelectOptionGroup, MdsSelectableTile, MdsSkeletonLoader, MdsSkipLink, MdsSlideInPanel, MdsSlider, MdsSparkline, MdsStatusBlock, MdsStatusTracker, MdsStickyFooter, MdsSwitch, MdsTabBar, MdsTag, MdsTextInput, MdsTextInputSecure, MdsTile, MdsTileAccordion, MdsTileAccordionItem, MdsTooltip, MdsVerticalNavigation, MdsVerticalNavigationFooter, MdsVerticalNavigationItem, MdsVideoPlayer };
//# sourceMappingURL=index.esm.js.map
